import type { TranslationInterface } from './index';

// Arabic translations - satisfies the TranslationInterface type
const arabic: TranslationInterface = {
  hero: {
    title: 'تجربة عملاء ما شفت مثلها \nذكاء اصطناعي يعرفهم بالاسم',
    'Backed by': 'مدعوم من',
    'Used by': 'يستخدمه',
    'Start now': 'ابدأ الآن',
    'Automate 77% of customer support—inbound, outbound, voice, telephony, QA, VoC. Purpose built for the enterprise.':
      'Open يحل ٧٧٪ من محادثات عملائك على WhatsApp والموقع والإيميل والمكالمات. \nعلى طول، وبطابع شخصي.',
    'Get a demo →': 'احجز عرضك ←',
    'Outcome based pricing': 'تسعير حسب النتائج',
    'Only pay when the AI successfully resolves a ticket or automates a workflow.':
      'تدفع بس لمّا تنحل التذكرة. لا حل، لا رسوم.',
    'Works with your existing setup': 'يعمل فوق نظامك الحالي',
    'Works with existing tools': 'تكامل في دقائق',
    'Integrates with Zendesk, Intercom, Salesforce, and more in minutes or use it by itself for everything.':
      'يتكامل مع Zendesk وIntercom وSalesforce و٥٠+ أداة. أو استخدمه وحده.',
    'AI Omnichannel + inbound + outbound + insights': 'عتبات ثقة على كل إجابة',
    'All channels + AI': 'دقة مضبوطة بعتبات الثقة',
    'A complete platform handling voice, email, chat, and more.':
      'درجة ثقة واضحة، وصراحة في حدوده. يصعّد المحادثة إليك عند أول شك.',
    '1 super app': 'وكيل ذكي واحد لكل قنواتك',
    'Everything you need for customer support in one unified dashboard.':
      'الويب، المكالمات، الإيميل، الرسائل، Slack، والمزيد.',
  },
  announcement: {
    'Announcement - Open': 'أخبار - Open',
    'We just closed a new funding round.': 'أتمّمنا جولة تمويل جديدة.',
    'Building the': 'نبني',
    'Magic Factory': 'مستقبل دعم العملاء',
    'Building the Magic Factory': 'جمعنا ٢٦ مليون ⃁',
    "We're excited to share that we've raised $5M from YC, Shorooq, and Sadu.":
      'جمعنا ٢٦ مليون ⃁ بقيادة YC وX By Unifonic، ومعهم شروق وسادو.',
    'This marks our second funding milestone to date.':
      'وهذه ثاني جولة تمويل لنا حتى الآن.',
    "Exactly one year ago, we went live. Since then, we've seen real, measurable impact. We've onboarded some of the world's most recognizable brands, including MoneyGram, Mollie, Viva, TicketSwap, and many others.":
      'قبل سنة بالضبط أطلقنا المنتج، وبعدها شفنا أثر حقيقي تقدر تقيسه. وانضمت لنا أسماء عالمية معروفة مثل MoneyGram وMollie وViva وTicketSwap وغيرها.',
    'Our goal from day one was simple but ambitious: empower companies with the best AI customer support agent and engine in the world. From the beginning, we chose to focus on brands with high-complexity, high-stakes support and communication needs - the kinds of environments many other players shy away from. The results speak for themselves. On average, our customers now automate 77% of their customer interactions, one of the highest automation rates in the market.':
      'هدفنا من أول يوم كان واضح وطموح: نعطي الشركات أفضل ذكاء اصطناعي لخدمة العملاء. ومن البداية اخترنا نركّز على الشركات اللي دعمها معقّد وحسّاس — البيئات اللي يتجنبها كثير من غيرنا. والنتائج تتكلم عن نفسها: عملاؤنا اليوم يؤتمتون في المتوسط ٧٧٪ من تفاعلاتهم مع عملائهم، وهي من أعلى نسب الأتمتة في السوق.',
    'Open enables companies to serve their customers across any channel, in any language, at any time. Beyond resolution, we help teams truly understand their customers through insights drawn directly from conversations, and use those insights to build better products and proactively reach out when it matters most.':
      'Open يخلّي الشركات تخدم عملاءها على أي قناة، بأي لغة، في أي وقت. وما نتوقف عند حل المشكلة — نساعد الفرق تفهم عملاءها بعمق أكبر عبر رؤى يستخرجها Open من المحادثات نفسها، وتستخدمها في بناء منتجات أفضل وفي المبادرة بالتواصل في اللحظة اللي تفرق فعلاً.',
    "We're using this funding to go deeper. To make our AI engine better, faster, and available everywhere. And to move closer to our long-term vision: one super AI engine that powers the entire customer experience.":
      'نستخدم هذا التمويل عشان نتعمّق أكثر: محرك أقوى وأسرع ومتاح بكل مكان، ونقترب من رؤيتنا البعيدة — محرك ذكاء اصطناعي واحد يشغّل تجربة العميل كاملة.',
    'We envision a future where Open is the only software a team needs to communicate with their customers using AI. Phone, email, SMS, WhatsApp, web chat. Inbound or outbound. Support, sales, operations, or any other customer-facing use case. One system that understands context across channels, acts in real time, and continuously improves - without teams stitching together fragmented tools.':
      'نتصوّر مستقبلاً يكون فيه Open البرنامج الوحيد اللي يحتاجه أي فريق عشان يتواصل مع عملائه بالذكاء الاصطناعي. هاتف، إيميل، رسائل نصية، WhatsApp، دردشة على الويب. وارد أو صادر. دعم، مبيعات، عمليات، وأي حالة تمسّ العميل. نظام واحد يفهم السياق عبر كل القنوات، يتصرّف لحظياً، ويتحسّن باستمرار — بدون ما تضطر الفرق توصل أدوات متفرقة ببعضها.',
    'Today, customer communication is fragmented by necessity. Support agents answer tickets. QA teams review quality. Analysts extract insights. Specialists handle proactive outreach. Everyone is talking to customers, but the technology forces these roles apart.':
      'اليوم، التواصل مع العملاء مفتّت بحكم الضرورة. موظفو الدعم يردّون على التذاكر. وفرق الجودة تراجعها. والمحللون يستخرجون الرؤى. والمتخصصون يبادرون بالتواصل. الكل يتكلم مع نفس العميل، بس التقنية تفصل بين هذه الأدوار.',
    'That constraint is disappearing.': 'وهذا القيد يختفي الآن.',
    'AI can now do what once required multiple layers of human expertise: understand context, maintain quality, extract insights, and reach out proactively. Not in theory, but in practice, today.':
      'الذكاء الاصطناعي اليوم يقدر يتولّى شغل كان يحتاج طبقات من الخبرة البشرية: يفهم السياق، ويحافظ على الجودة، ويستخرج الرؤى، ويبادر بالتواصل. عملياً، اليوم — مو نظرياً.',
    'Open is what happens when you stop fragmenting customer communication and let it be what it should have been all along: one coherent system that learns, responds, and improves itself.':
      'Open هو اللي يصير لمّا تتوقف عن تفتيت التواصل مع العملاء وتتركه كما كان لازم يكون من البداية: نظام واحد يتعلّم، ويرد، ويطوّر نفسه.',
    "The surprising part isn't that AI can do this. It's that it does it with the empathy and nuance people once thought only humans could provide.":
      'والمفاجئ مو أن الذكاء الاصطناعي قادر على هذا، المفاجئ أنه يفعله بتعاطف ودقة كان الناس يظنونها حصراً على البشر.',
    "We're deeply grateful to our partners and investors for the trust and support, and to our customers for pushing us every day with real, complex problems. Building alongside teams operating at this level is what shapes the product and keeps us honest about what truly matters.":
      'نحن ممتنون لشركائنا ومستثمرينا على ثقتهم ودعمهم، ولعملائنا اللي يضعوننا على المحك كل يوم بمشكلات حقيقية ومعقّدة. البناء جنب فرق بهذا المستوى هو اللي يشكّل المنتج ويخلّينا صادقين مع أنفسنا في اللي يهم فعلاً.',
    'Mohammad, Founder & CEO': 'محمد، المؤسس والرئيس التنفيذي',
    'See what Open can do for you': 'شوف كيف Open يقدر يساعدك',
    'Request a Demo': 'احجز عرض توضيحي',
  },
  agent5: {
    'Agent 5': 'محرك الذكاء الاصطناعي',
    'The core shared AI engine': 'محرك واحد مشترك يشغّل كل القنوات',
    'The AI engine powering all your customer communications. Train once, deploy everywhere. Industry-leading 77% automation rate with 95%+ accuracy. Multi-step actions that actually solve problems.':
      'محرك الذكاء الاصطناعي اللي يشغّل كل تواصلك مع العملاء. درّبه مرة وحدة، وشغّله بكل مكان. معدل أتمتة ٧٧٪ الأعلى في السوق. وإجراءات متعددة الخطوات تحل المشاكل فعلياً.',
    'Agent 5 Capabilities': 'قدرات الذكاء الاصطناعي',
    'The AI engine behind everything': 'المحرك وراء كل شيء',
    'Train Once, Deploy Everywhere': 'درّب مرة، شغّل في كل مكان',
    'Train your AI once and deploy it across Voice, Chat, Email, WhatsApp, Social, and Slack. One training session, unlimited channels.':
      'درّب الذكاء الاصطناعي مرة واحدة وشغّله على المكالمات، الدردشة، الإيميل، WhatsApp، السوشيال ميديا، وSlack. جلسة تدريب واحدة، قنوات بلا حدود.',
    '77% Average Automation Rate': '٧٧٪ متوسط معدل الأتمتة',
    'State-of-the-art AI performance. Market-leading automation rate that resolves the majority of customer inquiries automatically.':
      'أداء في مقدمة السوق. معدل أتمتة رائد يحل أغلب استفسارات العملاء تلقائياً.',
    'Multi-step Actions': 'إجراءات متعددة الخطوات',
    'Agent 5 takes multiple actions to solve complex problems. Not just answering questions—actually resolving issues through API calls and workflows.':
      'يتخذ أكثر من إجراء لحل المشاكل المعقدة. مو بس يجاوب على الأسئلة—يحلّها فعلاً، عبر الـ APIs والأتمتة.',
    '95%+ Accuracy': 'دقة تثق فيها',
    'Maintains over 95% accuracy in responses. High precision, low error rate, reliable answers customers can trust.':
      'دقة عالية وأخطاء أقل، تضبطها عتبات الثقة. إجابات يثق فيها عميلك.',
    'Most AI agents are': 'أغلب أنظمة الذكاء الاصطناعي',
    chatbots: 'روبوتات دردشة',
    'with better marketing. They answer FAQs, follow scripts, break on edge cases.':
      'بس بتسويق أفضل. تجاوب على الأسئلة الشائعة، وتتبع نصوص جاهزة، وتتعطل عند أول حالة مو متوقعة.',
    'Agent 5 is different. It understands': 'نظامنا مختلف. يفهم',
    context: 'السياق',
    ', learns from mistakes, takes': '، يتعلم من الأخطاء، ويتخذ',
    actions: 'إجراءات',
    '. Built with': '. مبني على',
    observability: 'الشفافية',
    and: 'و',
    compliance: 'الامتثال',
    'from day one.': 'من اليوم الأول.',
    "We're not selling magic. We're building reliable AI that actually works—the kind you'd trust with your customers.":
      'لا نبيع سحراً. نبني ذكاء اصطناعي موثوقاً يعمل فعلياً—من النوع اللي تسلّمه عملاءك وأنت مطمئن.',
    'AI you can actually understand': 'ذكاء اصطناعي تقدر تفهمه',
    'Most AI is a black box. Agent 5 shows you everything—every decision, every confidence score, every mistake. Observability at scale.':
      'أغلب أنظمة الذكاء الاصطناعي صندوق أسود. نظامنا يريك كل شيء: كل قرار، كل درجة ثقة، كل خطأ. شفافية كاملة مهما كبر حجمك.',
    'Every Decision Explained': 'كل قرار مشروح',
    'See why Agent 5 made each decision. Full reasoning traces, confidence scores, and source citations for every response.':
      'شوف ليش أخذ النظام كل قرار: سلسلة التفكير كاملة، ودرجة الثقة، والمصدر وراء كل رد.',
    'Real-time Performance Metrics': 'مقاييس الأداء لحظة بلحظة',
    'Track resolution rates, accuracy, response times, and customer satisfaction in real-time. Know exactly how your AI is performing.':
      'تابع معدلات الحل، والدقة، وأوقات الرد، ورضا العملاء لحظة بلحظة. تعرف أداء نظامك بالضبط، لا بالتقدير.',
    'Conversation Replays': 'إعادة المحادثات',
    'Review any conversation in detail. See what Agent 5 saw, understood, and why it responded the way it did.':
      'راجع أي محادثة بالتفصيل: وش وصل للنظام، وكيف فهمه، وليش رد بهذي الطريقة.',
    'Error Detection & Alerts': 'كشف الأخطاء والتنبيهات',
    'Automatic detection of mistakes, edge cases, and areas for improvement. Get alerts when Agent 5 needs help.':
      'كشف تلقائي للأخطاء والحالات غير المتوقعة ومواضع التحسين. ينبّهك أول ما يحتاج النظام مساعدة.',
    'Evaluation Dashboard': 'لوحة التقييم',
    'Built-in evaluation tools show you where Agent 5 excels and where it needs training. Data-driven improvement, not guesswork.':
      'أدوات تقييم مدمجة تورّيك وين يتفوق النظام ووين يحتاج تدريب. تحسين مبني على بيانات، لا على تخمين.',
    'Complete API access': 'وصول كامل للـ API',
    'Build custom integrations, automate workflows, and extend Agent 5 with full API access. RESTful endpoints for every feature.':
      'اربط أنظمتك، أتمت عملياتك، ووسّع النظام بوصول كامل للـ API — نقاط REST لكل ميزة.',
    'Chat Sessions': 'جلسات المحادثة',
    'Create, manage, and monitor chat sessions across all channels':
      'أنشئ، أدر، وتابع جلسات المحادثة على كل القنوات',
    'AI Phone Agents': 'الوكلاء الأذكياء للهاتف',
    'Create and manage AI phone agents, make calls programmatically':
      'أنشئ وأدر وكلاء الهاتف الذكيين، وأطلق المكالمات برمجياً',
    'Email Automation': 'أتمتة الإيميل',
    'Send emails, manage custom domains, verify DNS settings':
      'أرسل إيميلات، أدر نطاقاتك، وتحقق من إعدادات DNS',
    WhatsApp: 'WhatsApp',
    'Send WhatsApp templates and messages via API':
      'أرسل قوالب ورسائل WhatsApp عبر الـ API',
    'AI Training': 'تدريب النظام',
    'Create custom training, generate scenarios from chat history':
      'أنشئ تدريباً مخصصاً، وولّد سيناريوهات من سجل محادثاتك',
    'Outbound Sequences': 'التسلسلات الصادرة',
    'Create, manage, and execute outbound messaging sequences':
      'أنشئ، أدر، ونفّذ تسلسلات الرسائل الصادرة',
    'Customer Insights': 'رؤى العملاء',
    'Get AI-powered insights, resolve and assign to teams':
      'استخرج رؤى بالذكاء الاصطناعي، وعالجها أو أسندها لفريقك',
    'CSAT & Feedback': 'رضا العملاء والتعليقات',
    'Track customer satisfaction scores and feedback':
      'تابع درجات رضا العملاء وتعليقاتهم',
    Webhooks: 'Webhooks',
    'Receive real-time events for all Agent 5 activities':
      'استقبل أحداث النظام كلها لحظة بلحظة',
    'View API Documentation': 'افتح وثائق الـ API',
    'Frequently asked questions': 'الأسئلة الشائعة',
    'Find answers to common questions about Agent 5.':
      'إجابات على أكثر الأسئلة تكراراً عن النظام.',
    'What is Agent 5?': 'وش هو النظام؟',
    "Agent 5 is the core AI engine that powers all customer communications. It's a multi-model AI with training, observability, compliance, and evaluation capabilities.":
      'محرك ذكاء اصطناعي متقدم يشغّل كل تواصلك مع العملاء. يجمع عدة نماذج مع أدوات تدريب وشفافية وامتثال وتقييم.',
    'How does train once, deploy everywhere work?':
      'كيف يشتغل "درّب مرة، شغّل في كل مكان"؟',
    'Train Agent 5 with your knowledge base once. It automatically works across all channels—Voice, Chat, Email, WhatsApp, Social, and Slack—with consistent responses.':
      'درّب النظام بقاعدة معرفتك مرة واحدة. سيعمل تلقائياً على كل القنوات—المكالمات، الدردشة، الإيميل، WhatsApp، السوشيال ميديا، وSlack—بردود متسقة.',
    'What does 77% automation rate mean?': 'وش يعني معدل أتمتة ٧٧٪؟',
    '77% of customer queries are fully resolved by Agent 5 without human intervention. This is the average across all customers and represents industry-leading performance.':
      '٧٧٪ من استفسارات العملاء تنحل بالكامل بدون تدخل بشري. هذا متوسط عملائنا كلهم، وهو الأعلى في السوق.',
    'Can Agent 5 take actions, not just answer questions?':
      'هل يقدر ياخذ إجراءات، مو بس يجاوب على الأسئلة؟',
    'Yes. Agent 5 can execute multi-step workflows, make API calls, update systems, and perform actions to actually solve customer issues.':
      'نعم. النظام ينفّذ عمليات متعددة الخطوات، يستخدم الـ APIs، يحدّث الأنظمة، ويتخذ إجراءات فعلية لحل مشاكل العملاء.',
    'How accurate is Agent 5?': 'كم دقة النظام؟',
    'Agent 5 maintains over 95% accuracy in responses. This is measured through evaluation metrics and customer feedback.':
      'نقيس الدقة باستمرار عبر مقاييس التقييم وتعليقات العملاء، مع عتبات ثقة تحوّل الإجابات غير المؤكدة لموظف بشري.',
    'What makes Agent 5 different from other AI agents?':
      'وش يخلي نظامنا مختلف عن الأنظمة الثانية؟',
    'Built-in training tools, full observability, compliance features, continuous learning, and evaluation capabilities. Not just an AI—a complete AI management system.':
      'أدوات تدريب مدمجة، شفافية كاملة، ميزات امتثال، تعلم مستمر، وقدرات تقييم. مو مجرد ذكاء اصطناعي—نظام كامل لإدارة الذكاء الاصطناعي.',
    'In Progress': 'قيد التنفيذ',
    Certified: 'معتمد',
    Live: 'مباشر',
  },
  logos: {
    "Used and trusted by the world's best companies":
      'أكبر شركات العالم تثق بنا',
    'Case Study': 'قصة نجاح',
    'Serving over 50 million people in 200+ countries and territories each year':
      '٥٠ مليون+ شخص في ٢٠٠+ دولة، كل سنة',
    'The First Tech Bank in Europe for Businesses':
      'أول بنك رقمي للشركات في أوروبا',
    '$6.5 billion payment processor': 'معالج مدفوعات بـ٦,٥ مليار دولار',
    'Selling over 34 million tickets': '٣٤ مليون+ تذكرة مباعة',
    '15 million users across 42 countries': '١٥ مليون مستخدم في ٤٢ دولة',
    'A Booking.com company with 16,000 customers':
      'تابعة لـ Booking.com، و١٦ ألف عميل',
    'A Booking Holdings company with 23,000+ operators':
      'تابعة لـ Booking Holdings، و+٢٣ ألف مشغّل',
    'Tebi raised a €30M Series B in June 2025':
      'جولة Series B بـ٣٠ مليون يورو في يونيو ٢٠٢٥',
    '$86M-funded car subscription platform in Mexico':
      'منصة اشتراك سيارات في المكسيك بتمويل ٨٦ مليون دولار',
    '61,180+ Google reviews': '٦١ ألف+ تقييم على Google',
    'Leading accounting software in Saudi Arabia':
      'برنامج محاسبة رائد في السعودية',
    'Technology solutions provider': 'مزود حلول تقنية',
    'Serving over 10,000 entrepreneurs across Europe':
      '١٠ آلاف+ رائد أعمال في أوروبا',
    'Over half a million customers served with nationwide booking ease':
      'نصف مليون+ عميل، وحجز سهل في كل أنحاء البلد',
    'Trusted by thousands of merchants worldwide': 'ثقة آلاف التجار حول العالم',
    '25,000 businesses trust Qoyod for accounting':
      '٢٥ ألف شركة تستخدم قيود للمحاسبة',
    "Portugal's No. 2 Price Comparison Champion":
      'ثاني أكبر موقع مقارنة أسعار في البرتغال',
    'One of the largest online pharmacies in the Netherlands':
      'من أكبر الصيدليات الإلكترونية في هولندا',
    'Largest online drugstore in the Netherlands':
      'أكبر صيدلية إلكترونية في هولندا',
    'Served over 1 million customers with 10,000+ curated kitchen products':
      'مليون+ عميل و١٠ آلاف+ منتج مطبخ منتقى',
  },
  feature224: {
    'Automate support &': 'أتمت الدعم و',
    communication: 'التواصل',
    'with AI': 'بالذكاء الاصطناعي',
    'See what we mean 👀': 'اعرف المزيد',
    'What do we mean by "communication"?': 'وش نقصد بـ"التواصل"؟',
    'Everything. Literally everything.': 'كل نقاط التواصل مع العملاء، موحدة.',
    'Remember when you needed a different tool for every single thing? Yeah, we got tired of that too.':
      'منصة واحدة تغنيك عن أدوات متفرقة في نظام الدعم.',
    'Inbound Support': 'الدعم الوارد',
    'Phone, chat, email, SMS—customers reach out, AI responds instantly. 24/7.':
      'جوال، دردشة، إيميل، رسائل—النظام يرد بدقة ثابتة. تغطية ٢٤/٧.',
    'Outbound Campaigns': 'الحملات الصادرة',
    'Proactive calls, follow-ups, surveys—at scale. No call center needed.':
      'مكالمات استباقية، متابعات، استبيانات—على نطاق واسع. يقلّل التكاليف التشغيلية.',
    'Text Messaging': 'الرسائل',
    'WhatsApp, SMS, social DMs. One platform, every conversation.':
      'WhatsApp، رسائل، رسايل خاصة على السوشيال. سجل محادثات موحّد عبر كل القنوات.',
    'Proactive Engagement': 'تفاعل استباقي',
    'Check-ins, renewals, upsells—AI that nurtures relationships.':
      'متابعات آلية، تجديدات، وتذكيرات بدون ما تفقد السياق.',
    'Complex Workflows': 'عمليات معقدة',
    'Multi-step sequences across channels. Set it and forget it.':
      'تسلسلات متعددة عبر القنوات. تنفيذ موثوق على نطاق واسع.',
    'All in One Place': 'منصة موحدة',
    "No juggling 5 different tools. Just Open. That's it.":
      'استبدل أدوات متعددة بمنصة واحدة متكاملة.',
    'Telephony tool + Email platform + Chat widget + SMS service + Outbound tool + Analytics + ...':
      'جوال + إيميل + دردشة + رسائل + حملات صادرة + تحليلات + ...',
    '= Just Open': '= منصة واحدة',
    'Always Available, Always Empathetic': 'متاح ٢٤/٧ بصوت علامتك التجارية',
    'Instant Support': 'دعم فوري',
    '24/7 support with your brand voice. No wait times. Instant help when customers need it.':
      'تغطية ٢٤/٧ بصوت علامتك. يقلل أوقات الانتظار ويحافظ على الجودة.',
    'Handle Complex Issues in Real-Time': 'يحل المشاكل المعقدة بالكامل',
    'Smart Resolution': 'حل ذكي',
    'Process returns, update subscriptions, solve problems instantly. Takes action across all your systems.':
      'معالجة مرتجعات، تحديث اشتراكات، تنفيذ استردادات. ياخذ إجراءات مع سجل تدقيق كامل.',
    'Safe, Secure, and Trustworthy': 'أمان وامتثال للمؤسسات',
    'Enterprise Security': 'أمان المؤسسات',
    'Enterprise-grade security. Stays on-brand, honest about limits, protects customer data.':
      'متوافق مع GDPR. حاصل على شهادة SOC 2. صريح بحدود الثقة. يحمي بيانات العملاء.',
    'One Agent, Every Channel': 'نظام واحد، كل القنوات',
    'Omnichannel Ready': 'جاهز لكل القنوات',
    'Build once, deploy everywhere. Consistent experience across chat, email, voice, and every channel.':
      'ابنِ مرة، انشر في كل مكان. جودة حل ثابتة عبر الدردشة والإيميل والمكالمات.',
    'Seamlessly Integrates with Your Stack': 'يتكامل مع نظامك الحالي',
    'Connected Ecosystem': 'نظام متصل',
    'Plugs into your existing tools. Smart routing, complete summaries, smooth escalations.':
      'يتصل بأدواتك. توجيه ذكي، ملخصات تسليم كاملة، مسارات تصعيد واضحة.',
    'Learn more': 'اعرف أكثر',
    'Open Product Suite': 'منتجات Open',
    'Automate any part of your support': 'وحّد دعمك وخلّيه آلي',
    'A single AI engine that is powerful, shared among any channel. Consistent and relied on by the most mission-critical enterprises in the world.':
      'محرك ذكاء اصطناعي واحد قوي، مشترك بين جميع القنوات. \nثابت وموثوق من قبل أهم المؤسسات في العالم.',
    'Replace multiple support tools with Open':
      'استبدل أدوات الدعم المتعددة بـ Open، المنصة الوحيدة المصممة لأتمتة دعم العملاء بالذكاء الاصطناعي—وجعل فريقك أسرع.',
    'AI Chat': 'الدردشة الذكية',
    'Automate chat support.': 'أتمتة دعم الدردشة.',
    'Automate inbound and outbound support on chat.':
      'أتمتة الدعم الوارد والصادر عبر الدردشة.',
    'AI Calls': 'المكالمات الذكية',
    'Automate phone support.': 'أتمتة دعم الهاتف.',
    'Automate inbound and outbound support on phone.':
      'أتمتة الدعم الوارد والصادر عبر الهاتف.',
    'AI Email': 'الإيميل الذكي',
    'Automate email support.': 'أتمتة دعم الإيميل.',
    'Automate inbound and outbound support on email.':
      'أتمتة الدعم الوارد والصادر عبر الإيميل.',
    'AI Social': 'السوشيال ميديا الذكية',
    'Automate social support.': 'أتمتة دعم السوشيال.',
    'Automate inbound and outbound support on social.':
      'أتمتة الدعم الوارد والصادر عبر السوشيال.',
    'Agentic Workflows': 'سير العمل الذكي',
    'Automate complex processes.': 'أتمتة العمليات المعقدة.',
    'Automate complex support processes.': 'أتمتة عمليات الدعم المعقدة.',
    'Connect with a Helpdesk': 'ربط مع نظام التذاكر',
    'Integrate existing tools.': 'تكامل مع أدواتك الحالية.',
    'Integrate with your existing tools.': 'تكامل مع أدواتك الحالية.',
    'Customer Insights': 'تحليلات العملاء',
    'Understand customers.': 'افهم عملائك.',
    'Understand what customers really need.': 'افهم احتياجات عملائك الحقيقية.',
    'Knowledge Gaps': 'الفجوات المعرفية',
    'Find missing answers.': 'اكتشف الإجابات الناقصة.',
    'Find and fix missing answers.': 'اكتشف وأصلح الإجابات الناقصة.',
    'New ticket arrives': 'تذكرة جديدة',
    'AI analyzes intent': 'الذكاء يحلل الطلب',
    'Route to right team': 'توجيه للفريق المناسب',
    'Auto-resolve or escalate': 'حل تلقائي أو تصعيد',
    'Where is my order?': 'وين طلبي؟',
    'Order #4521 arrives tomorrow by 5pm':
      'طلبك رقم ٤٥٢١ يوصل بكرة قبل ٥ العصر',
    'Can I change the address?': 'أقدر أغير العنوان؟',
    'Done! Updated to 123 Main St': 'تم! تحديث العنوان',
    'Resolved in Zendesk via OpenCX': 'تم الحل في Zendesk عبر OpenCX',
    'Customer Satisfaction': 'رضا العملاء',
    'Based on 847 responses': 'بناءً على ٨٤٧ رد',
    'How to cancel subscription?': 'كيف ألغي الاشتراك؟',
    'Refund policy for EU?': 'سياسة الاسترداد لأوروبا؟',
    'API rate limits?': 'حدود الـ API؟',
    'gaps detected this week': 'فجوتين اكتشفناها هالأسبوع',
    "It's 2 AM, is anyone there?": 'الساعة ٢ الفجر، في أحد؟',
    "I'm here! How can I help you?": 'موجود. كيف أقدر أساعدك؟',
    'Pending Action': 'إجراء معلق',
    'Processing Request': 'جاري معالجة الطلب',
    'Just now': 'الآن',
    'Refund Request': 'طلب استرداد',
    'Refund processed via Stripe': 'تم معالجة الاسترداد عبر Stripe',
    'System Status': 'حالة النظام',
    'Secure & Encrypted': 'آمن ومشفر',
    'SOC2 Compliant': 'حاصل على شهادة SOC2',
    'End-to-End Encryption': 'تشفير من طرف لطرف',
    'GDPR Ready': 'جاهز لـ GDPR',
    'Active Integrations': 'التكاملات النشطة',
    'Live Sync': 'مزامنة مباشرة',
    'Sync Paused': 'المزامنة متوقفة',
    'CRM Database': 'قاعدة بيانات CRM',
    'Payment Gateway': 'بوابة الدفع',
    'Analytics Pro': 'تحليلات متقدمة',
  },
  feature3: {
    'Set up this week.': 'إربط خلال ساعة',
    'Go live next week.': 'خلّك على نظامك الحالي\nوابدأ خلال أيام',
    'Works natively with your existing setup (integration <1 hour):':
      'يشتغل مع نظامك الحالي (التكامل أقل من ساعة):',
    'See all': 'عرض الكل',
    'Connect your helpdesk': 'اربط نظامك',
    'Works with Zendesk, HubSpot, Freshdesk, Intercom, Salesforce, and more.':
      'يشتغل مع Zendesk وHubSpot وFreshdesk وIntercom وSalesforce وغيرهم.',
    'Connect in minutes.': 'اربط في دقائق.',
    'Works with your existing helpdesk.': 'يشتغل مع نظام التذاكر الحالي.',
    'Read how Mollie integrated Open with their existing stack':
      'اقرأ كيف Mollie ربطت Open مع أنظمتها',
    'Add your training data': 'أضف بيانات التدريب',
    'Connect your documentation, wikis, guides, and knowledge base.':
      'اربط التوثيق والأدلة وقاعدة المعرفة حقتك.',
    'Train in hours.': 'درّبه في ساعات.',
    'Connect 27+ data sources.': 'اربط +27 مصدر بيانات.',
    'Read how MoneyGram trained AI on 200+ country policies':
      'اقرأ كيف MoneyGram درّبت النظام على سياسات أكثر من ٢٠٠ دولة',
    'Connect your systems': 'اربط أنظمتك',
    'Link your backoffice tools and APIs so the AI can take action.':
      'اربط أدوات الباك أوفيس والـ APIs حتى يقدر النظام ياخذ إجراءات.',
    'AI takes action.': 'الذكاء ينفذ.',
    'Updates orders, processes refunds, checks status.':
      'يحدّث طلبات، يعالج استردادات، يتأكد من الحالة.',
    'Read how More.com automates complex support workflows':
      'اقرأ كيف More.com تؤتمت عمليات الدعم المعقدة',
    'Monitor and improve': 'راقب وحسّن',
    'Track performance and refine the AI over time.':
      'تابع الأداء وطور النظام مع الوقت.',
    'Keep improving.': 'حسّن باستمرار.',
    'Track performance, review, adjust.': 'تتبع الأداء، راجع، عدّل.',
    'Read how TicketSwap hit all-time high CSAT score':
      'اقرأ كيف TicketSwap حققت أعلى درجة رضا',
    'Available on': 'متاح على',
    'Voice AI': 'المكالمات الهاتفية',
    Web: 'الويب',
    'Email AI': 'الإيميل',
    WhatsApp: 'WhatsApp',
    Social: 'وسائل التواصل الاجتماعي',
    Slack: 'Slack',
  },
  feature2: {
    'Market-leading 77% automation rate': 'معدل أتمتة ٧٧٪ الأفضل في السوق',
    'Handle more conversations, resolve issues faster, and delight customers—while your team focuses on what matters most':
      'تعامل مع محادثات أكثر، وحل المشاكل أسرع، وخلّ رضا العملاء عالي—وفريقك يركّز على الأصعب',
    'Your customers expect instant answers.': 'عملاءك يتوقعون ردود فورية.',
    'Give them what they want and watch your satisfaction scores hit all-time highs.':
      'عطهم ما يبون وشوف درجات الرضا توصل لأعلى مستوياتها.',
    'Read how TicketSwap hit all-time high CSAT score with Open':
      'اقرأ كيف TicketSwap حققت أعلى درجة رضا مع Open',
    'Security that keeps your legal team happy.': 'أمان يريّح فريقك القانوني.',
    'Enterprise-grade protection that is trusted by banks, healthcare, and governments.':
      'حماية قوية تثق فيها البنوك والمستشفيات والحكومات.',
    'Read how Mollie handles 250,000+ businesses with full compliance':
      'اقرأ كيف Mollie تتعامل مع أكثر من ٢٥٠ألف شركة بأمان كامل',
    'Be everywhere your customers are.': 'كن وين ما عملاءك موجودين.',
    'One unified platform for Email, Chat, SMS, Social, and Voice. No more switching tabs.':
      'منصة واحدة للإيميل والدردشة والرسائل والسوشيال والمكالمات. بدون تنقل بين التابات.',
    'Read how MoneyGram supports 55M customers across 200+ countries':
      'اقرأ كيف MoneyGram تدعم ٥٥ مليون عميل في أكثر من ٢٠٠ دولة',
    'Faster than humanly possible.': 'حلول على نطاق واسع.',
    'Respond in seconds, not hours. Provide 24/7 support without burning out your team.':
      'رد في ثواني مو ساعات. قدم دعم ٢٤/٧ بدون ما ترهق فريقك.',
    'Read how OTO automates 77% of support with +90% CSAT':
      'اقرأ كيف OTO تؤتمت ٧٧٪ من الدعم مع +٩٠٪ رضا العملاء',
    'It does the real work for you.': 'يسوي الشغل الحقيقي عنك.',
    "Don't just chat—automate refunds, account updates, and complex workflows instantly.":
      'مو بس دردشة—أتمت المرتجعات وتحديثات الحسابات والعمليات المعقدة فوراً.',
    'Read how Trunkrs automates complex logistics support':
      'اقرأ كيف Trunkrs تؤتمت دعم اللوجستيات المعقد',
  },
  feature135: {
    'One AI agent for the entire customer journey':
      'نظام ذكي واحد لكل رحلة العميل',
    'Our vision:': 'رؤيتنا:',
    "A single AI agent that understands every touchpoint, every channel, and every moment in your customer's journey. Train once, deploy everywhere with 77% automation rate and 95%+ accuracy.":
      'درّبه مرة وشغله في كل مكان. ٧٧٪ أتمتة.',
    'AI Phone Calling': 'المكالمات بالذكاء الاصطناعي',
    'Handle inbound/outbound calls 24/7 with natural AI conversations, instant answers, and seamless handoffs.':
      'تعامل مع المكالمات الواردة والصادرة ٢٤/٧ بمحادثات طبيعية وردود فورية.',
    'Text-Based Channels': 'القنوات النصية',
    'Automate email, SMS, WhatsApp, and chat. Respond instantly while maintaining your brand voice.':
      'أتمت الإيميل والرسائل وWhatsApp والدردشة. رد فوراً واحتفظ بصوت البراند.',
    'Bulk Outbound AI Calling': 'مكالمات جماعية ذكية',
    'Launch targeted campaigns at scale. Reach thousands with personalized, human-like AI conversations.':
      'أطلق حملات مستهدفة. وصّل لآلاف العملاء بمحادثات ذكية مخصصة.',
    'Bulk Outbound Text Campaigns': 'حملات رسائل جماعية',
    'Send personalized SMS, WhatsApp, or email at scale. Smart follow-ups turn outbound into real dialogue.':
      'أرسل رسائل نصية أو WhatsApp أو إيميل مخصص. متابعات ذكية تحول الرسايل لحوار حقيقي.',
    'AI Customer Insights': 'رؤى العملاء',
    'Analyze sentiment and trends automatically. Surface actionable insights from every conversation.':
      'حلل المشاعر والاتجاهات تلقائياً. استخرج رؤى من كل محادثة.',
    'Smart Ticketing & Inbox': 'صندوق وتذاكر ذكية',
    'AI handles routine tickets and routes complex cases. Keep your inbox organized and cut response times.':
      'النظام يتعامل مع التذاكر العادية ويحول الحالات المعقدة. صندوقك منظم ووقت الرد أقل.',
    'AI Quality Assurance': 'ضمان جودة ذكي',
    'Automate QA by reviewing every interaction. Ensure compliance and identify coaching needs automatically.':
      'أتمت ضمان الجودة بمراجعة كل تفاعل. تأكد من الأمان وحدد احتياجات التدريب.',
    'Agentic Workflows': 'أتمتة ذكية',
    'Build complex flows simply. Coordinate calls and messages across channels, mimicking human behavior at scale.':
      'ابني تدفقات معقدة ببساطة. نسق المكالمات والرسائل عبر القنوات زي البشر.',
    'Multilingual Support': 'دعم لغات متعددة',
    'Support 100+ languages with real-time translation. Remove barriers with culturally-aware global support.':
      'ادعم أكثر من ١٠٠ لغة بترجمة فورية. أزل الحواجز بدعم يفهم الثقافات.',
    'Smart Scheduling & Follow-ups': 'جدولة ومتابعات ذكية',
    'Automate check-ins and reminders. Nurture relationships on autopilot so you never miss a follow-up.':
      'أتمت المتابعات والتذكيرات تلقائياً حتى لا تفوت أي متابعة.',
    'Performance Analytics': 'تحليلات الأداء',
    'Track resolution rates and satisfaction in real-time. Optimize operations with clear performance insights.':
      'تابع معدلات الحل والرضا لحظياً. طور العمليات برؤى واضحة.',
    'Learn more': 'اعرف أكثر',
  },
  testimonials: {
    'Impacting the lives': 'نؤثر في حياة',
    'of millions of users.': 'ملايين المستخدمين.',
    'Companies using Open to automate customer communication at scale. 70%+ automation rates. All-time high satisfaction scores. 24/7 coverage in multiple languages.':
      'معدلات أتمتة فوق الـ٧٠٪. أعلى درجات رضا. تغطية ٢٤/٧ بعدة لغات.',
    'Read Customer Stories': 'اقرأ قصص العملاء',
    'Learn how Mollie scales support for 250,000+ businesses with Open':
      'اكتشف كيف توسّع Mollie الدعم لأكثر من ٢٥٠ألف شركة مع Open',
    'How Mollie supports 250,000+ businesses across Europe':
      'كيف Mollie تدعم أكثر من ٢٥٠ ألف شركة في أوروبا',
    'How TicketSwap mediates buyer-seller disputes in under 30 seconds?':
      'كيف TicketSwap تحل نزاعات البائع والمشتري في أقل من ٣٠ ثانية؟',
    'How TicketSwap automated 67% of 19 million user support operations':
      'كيف TicketSwap أتمتت ٧٨٪ من دعم ١٩ مليون مستخدم',
    'How MoneyGram supports 55M customers across 200+ countries?':
      'كيف MoneyGram تدعم ٥٥ مليون عميل في أكثر من ٢٠٠ دولة؟',
    'How MoneyGram supports 55M customers across 200+ countries':
      'كيف MoneyGram تدعم ٥٥ مليون عميل في أكثر من ٢٠٠ دولة',
    'How Trunkrs maintains 4.8/5 rating with 60K+ reviews?':
      'كيف Trunkrs تحافظ على تقييم ٤,٨/٥ مع أكثر من ٦٠ ألف تقييم؟',
    'How Trunkrs automates 80% of delivery support with 4.8/5 rating':
      'كيف Trunkrs تأتمت ٨٠٪ من دعم التوصيل مع تقييم ٤,٨/٥',
    'OTO is automating more than 77% of the support with +90% CSAT score':
      'OTO تأتمت أكثر من ٧٧٪ من الدعم مع رضا عملاء فوق الـ٩٠٪',
    'How OTO is Automating 77% of Support with Open':
      'كيف OTO تأتمت ٧٧٪ من الدعم مع Open',
    'OTO achieved 90%+ CSAT while automating 77% of their customer support with Open AI.':
      'OTO حققت رضا عملاء فوق الـ٩٠٪ مع أتمتة ٧٧٪ من الدعم باستخدام Open.',
    'OTO Success Story - Open': 'قصة نجاح OTO - Open',
    'How OTO is automating 77% of support with 90%+ CSAT score using Open.':
      'كيف OTO تأتمت ٧٧٪ من الدعم مع رضا فوق الـ٩٠٪ باستخدام Open.',
    'How More.com sold 30M tickets across European markets?':
      'كيف More.com باعت ٣٠ مليون تذكرة في الأسواق الأوروبية؟',
    'More.com is automating +67% with all-time high customer satisfaction':
      'More.com يؤتمتون ٨٠٪ مع أعلى رضا عملاء على الإطلاق',
    'How FareHarbor supports 20K+ operators with AI?':
      'كيف FareHarbor تدعم أكثر من ٢٠ ألف مشغل بالذكاء الاصطناعي؟',
    'How Qoyod automates 77% of support for 25,000+ businesses':
      'كيف قيود تأتمت ٨٥٪ من الدعم لأكثر من ٢٥ ألف شركة',
    'How OCN automates time-sensitive car subscriptions across Mexico?':
      'كيف OCN أتمتت اشتراكات السيارات عبر المكسيك؟',
    deonlinedrogist_hero_title:
      'كيف De Online Drogist يؤتمتون ٧٣٪ من الدعم مع ٢٥+ إجراء معقد',
    cookinglife_hero_title: 'كيف CookingLife يؤتمتون ٧٠٪ من الدعم لمليون+ عميل',
    'company value': 'قيمة الشركة',
    businesses: 'شركة',
    automation: 'أتمتة',
    users: 'مستخدم',
    'CSAT score': 'درجة الرضا',
    customers: 'عميل',
    CSAT: 'رضا',
    rating: 'تقييم',
    'min read': 'دقيقة قراءة',
    reviews: 'مراجعة',
    '8 languages': '٨ لغات',
    actions: 'إجراء',
    products: 'منتج',
    tickets: 'تذكرة',
    operators: 'مشغل',
    'in MENA': 'في الشرق الأوسط',
    vehicles: 'مركبة',
    'avg response': 'متوسط الرد',
  },
  nav: {
    Home: 'الرئيسية',
    About: 'من نحن',
    Features: 'المميزات',
    Pricing: 'الأسعار',
    Contact: 'تواصل معنا',
    Demo: 'عرض توضيحي',
    'Sign in': 'دخول',
    'Get started': 'ابدأ الآن',
    Channels: 'القنوات',
    Helpdesks: 'أنظمة الدعم',
    Industries: 'القطاعات',
    'Customer Stories': 'قصص العملاء',
    Resources: 'الموارد',
    Product: 'المنتج',
    Company: 'الشركة',
    Customers: 'العملاء',
    Login: 'دخول',
    'Get a demo': 'اعرف أكثر',
    'Automate everything™': 'أتمت كل شيء™',
    'Go back': 'ارجع',
    'We just closed a new funding round to build the super customer experience AI agent':
      'جديد من Open: أول SaaS يبني نفسه في العالم',
    'New funding round closed!': 'أول SaaS يبني نفسه',
    'Read more': 'التفاصيل',
    'The support AI-first communication and support channels.':
      'دعم بالـ AI على كل قناة.',
    'AI Voice': 'المكالمات',
    'AI Web (chat)': 'المحادثات',
    'AI Email': 'الإيميل',
    'AI WhatsApp': 'WhatsApp',
    'AI Social': 'السوشيال ميديا',
    'AI Slack': 'Slack',
    'Integrate with your existing helpdesk platform.':
      'يتكامل مع نظام الدعم اللي تستخدمه.',
    Open: 'Open',
    Intercom: 'Intercom',
    Zendesk: 'Zendesk',
    Salesforce: 'Salesforce',
    Freshdesk: 'Freshdesk',
    HubSpot: 'HubSpot',
    'Twilio Flex': 'Twilio Flex',
    'Agent 5': 'محرك AI',
    'The core shared AI engine.': 'محرك واحد يشغّل كل القنوات.',
    'AI Omnichannel + inbound + outbound + insights':
      'AI على كل القنوات — وارد وصادر ورؤى',
    Training: 'التدريب',
    Observability: 'الشفافية',
    Actions: 'الإجراءات',
    Compliance: 'الامتثال',
    Evals: 'التقييمات',
    Workflows: 'الأتمتة',
    'Automate and optimize your business processes.': 'أتمت وحسّن عملياتك.',
    'Agentic engine': 'محرك الأتمتة',
    'Outbound sequencing': 'التسلسلات الصادرة',
    'Customer insights': 'رؤى العملاء',
    'Knowledge gap detection': 'اكتشاف فجوات المعرفة',
    Templates: 'القوالب',
    'Introducing Agentic Workflows Templates': 'جديد: قوالب الأتمتة الذكية',
    'Discover now': 'اكتشف الآن',
    'Automate the un-automatable with 50+ pre-made templates for every use case.':
      'أتمت اللي تظن أنك ما تقدر تأتمته، مع أكثر من ٥٠ قالب جاهز لكل حالة.',
    'Developer Platform': 'منصة المطورين',
    Integrations: 'التكاملات',
    'API Reference': 'وثائق الـ API',
    'Tools & Resources': 'أدوات وموارد',
    'Free Tools': 'أدوات مجانية',
    'Open Academy': 'أكاديمية Open',
    'We want YOU': 'نريدك معنا',
    'Join the team and build the future of customer communication.':
      'انضم للفريق وابنِ مستقبل التواصل مع العملاء.',
    'About us': 'من نحن',
    'Learn about our mission and values.': 'تعرّف على رسالتنا وقيمنا.',
    'Success stories': 'قصص النجاح',
    'See how customers achieve their goals.': 'اكتشف كيف حقّق عملاؤنا أهدافهم.',
    Subprocessors: 'المعالجات الفرعية',
    'Third-party services we use.': 'خدمات خارجية نستخدمها.',
    GDPR: 'حماية البيانات GDPR',
    'Our commitment to data protection.': 'التزامنا بحماية بياناتك.',
    'Privacy Policy': 'سياسة الخصوصية',
    'How we handle your data.': 'كيف نتعامل مع بياناتك.',
    'Terms of Service': 'شروط الخدمة',
    'Terms and conditions of use.': 'شروط الاستخدام.',
    'Industries Overview': 'نظرة على القطاعات',
    'AI customer support across all sectors.': 'دعم عملاء ذكي لكل القطاعات.',
    'Financial Services': 'الخدمات المالية',
    'Compliant AI for sensitive inquiries.':
      'AI متوافق تنظيمياً للأسئلة الحسّاسة.',
    Healthcare: 'الرعاية الصحية',
    'HIPAA-ready AI for patient support.': 'AI متوافق مع HIPAA لدعم المرضى.',
    'Mobility & Transportation': 'التنقل والمواصلات',
    'Support for ride-sharing and car rentals.':
      'دعم تطبيقات مشاركة الرحلات وتأجير السيارات.',
    Technology: 'التقنية',
    'Faster onboarding, less churn.': 'تفعيل أسرع، وتسرّب عملاء أقل.',
    'Travel & Hospitality': 'السفر والضيافة',
    'Bookings and changes—automated.': 'حجوزات وتعديلات، كلها مؤتمتة.',
    'Learn more': 'اعرف أكثر',
    'Mollie - €6.5B Financial Services':
      'Mollie - خدمات مالية بقيمة ٦,٥ مليار يورو',
    'How a €6.5B company supports 250,000+ businesses with 70% automation across 8 languages.':
      'كيف تدعم شركة بقيمة ٦,٥ مليار يورو أكثر من +٢٥٠ ألف شركة بأتمتة ٧٠٪ عبر ٨ لغات.',
    'How a €6.5B company supports 250,000+ businesses with 60%+ automation across 8 languages.':
      'كيف تدعم شركة بقيمة ٦,٥ مليار يورو أكثر من +٢٥٠ ألف شركة بأتمتة ٧٠٪ عبر ٨ لغات.',
    'TicketSwap - 19M Users': 'TicketSwap - ١٩ مليون مستخدم',
    'Mediating disputes with all-time high CSAT.':
      'حل النزاعات مع أعلى رضا عملاء على الإطلاق.',
    MoneyGram: 'MoneyGram',
    '55M customers, 200+ countries, 70% automation.':
      '٥٥ مليون عميل، أكثر من ٢٠٠ دولة، أتمتة ٨٠٪.',
    'All Customer Stories': 'كل قصص العملاء',
    'Real companies. Real results.': 'شركات حقيقية. نتائج حقيقية.',
    // Product-menu titles and section headings. These render via
    // `t.nav[item.title]` with no NAV_AR fallback, so a missing key here shows
    // the raw English string in the dropdown.
    'AI Chat': 'المحادثات',
    'The AI Engine': 'محرك AI',
    Platform: 'المنصة',
    'Open Telephony': 'نظام الهاتف',
    'Outbound Sequencing': 'التسلسلات الصادرة',
    'Customer Insights': 'رؤى العملاء',
    'Knowledge Gap Detection': 'اكتشاف فجوات المعرفة',
    'App Builder': 'بنّاء التطبيقات',
    'White-label': 'العلامة البيضاء',
    Featured: 'مميّز',
  },
  common: {
    'Learn more': 'اعرف أكثر',
    'Read more': 'اقرأ المزيد',
    'View all': 'عرض الكل',
    'Get a demo': 'اعرف أكثر',
    'Start free trial': 'ابدأ تجربتك المجانية',
    'Contact us': 'تواصل معنا',
    'Back to home': 'ارجع للرئيسية',
    Loading: 'جارٍ التحميل',
    Error: 'خطأ',
    Success: 'تم',
    Cancel: 'إلغاء',
    Save: 'حفظ',
    Delete: 'حذف',
    Edit: 'تعديل',
    Close: 'إغلاق',
    Next: 'التالي',
    Previous: 'السابق',
    Submit: 'إرسال',
    Search: 'بحث',
    'Pause video': 'أوقف الفيديو',
    'Play video': 'شغّل الفيديو',
    'Previous slide': 'الشريحة السابقة',
    'Next slide': 'الشريحة التالية',
    'Free implementation by our experts!': 'تنفيذ مجاني من خبرائنا',
    'Book a demo': 'اعرف أكثر',
    Dismiss: 'إغلاق',
    'Want to train your AI on': 'تريد تدريب AI على',
    'Works with': 'يعمل مع',
    templates: 'القوالب',
    'View all templates': 'عرض كل القوالب',
    'Learn more about Open and book a demo':
      'اعرف أكثر عن Open واحجز عرضًا توضيحيًا',
    'We use cookies for analytics and marketing. You can accept all, reject all, or customize your choices.':
      'نستخدم ملفات تعريف الارتباط للتحليلات والتسويق. يمكنك قبول الكل أو رفض الكل أو تخصيص اختياراتك.',
    'Cookie preferences': 'تفضيلات ملفات تعريف الارتباط',
    'Cookie Policy': 'سياسة ملفات تعريف الارتباط',
    'Accept all': 'قبول الكل',
    'Reject all': 'رفض الكل',
    Customize: 'تخصيص',
    'Save preferences': 'حفظ التفضيلات',
    'Strictly necessary': 'ضرورية للغاية',
    'Always on': 'مفعّلة دائمًا',
    'Needed for the site to work — language, region, and your cookie choices.':
      'ضرورية لعمل الموقع — اللغة والمنطقة واختياراتك لملفات تعريف الارتباط.',
    Analytics: 'التحليلات',
    'Helps us understand how the site is used, including session replay.':
      'تساعدنا على فهم كيفية استخدام الموقع، بما في ذلك تسجيل الجلسات.',
    Marketing: 'التسويق',
    'Advertising and visitor identification by our marketing partners.':
      'الإعلانات وتحديد هوية الزوّار من قبل شركائنا التسويقيين.',
    'Cookie settings': 'إعدادات ملفات تعريف الارتباط',
    'Do Not Sell or Share My Personal Information':
      'عدم بيع أو مشاركة معلوماتي الشخصية',
  },
  footer: {
    month: 'شهر',
    year: 'سنة',
    'All rights reserved': 'جميع الحقوق محفوظة',
    'Privacy Policy': 'سياسة الخصوصية',
    'Terms of Service': 'شروط الخدمة',
    'Cookie Policy': 'سياسة ملفات تعريف الارتباط',
    'One AI agent for the entire customer experience':
      'AI واحد يحسّن تجربة عميلك كاملة',
    'Get Started': 'ابدأ الآن',
    Helpdesks: 'أنظمة الدعم',
    Product: 'المنتج',
    Channels: 'القنوات',
    Customers: 'العملاء',
    Company: 'الشركة',
    Legal: 'الشؤون القانونية',
    'Compliance & Legal': 'الامتثال والشؤون القانونية',
    Social: 'تابعنا',
    "Open is backed by Y Combinator and some of the world's best investors. We're building the future of customer support.":
      'Open مدعوم من Y Combinator ونخبة من أفضل المستثمرين في العالم. نبني مستقبل دعم العملاء.',
    'All systems operational': 'كل الأنظمة تعمل',
    Zendesk: 'Zendesk',
    Salesforce: 'Salesforce',
    Intercom: 'Intercom',
    HubSpot: 'HubSpot',
    Freshdesk: 'Freshdesk',
    'Twilio Flex': 'Twilio Flex',
    'Open Helpdesk': 'Open Helpdesk',
    'All Helpdesks': 'كل أنظمة الدعم',
    'Agent 5': 'محرك AI',
    'Open Telephony': 'نظام الهاتف',
    Workflows: 'الأتمتة',
    Integrations: 'التكاملات',
    'Customer Insights': 'رؤى العملاء',
    'Knowledge Gap Detection': 'اكتشاف فجوات المعرفة',
    'App Builder': 'بنّاء التطبيقات',
    'Outbound Sequencing': 'التسلسلات الصادرة',
    Templates: 'القوالب',
    'Use Cases': 'حالات الاستخدام',
    'White-label': 'العلامة البيضاء',
    Companion: 'Companion',
    Pricing: 'الأسعار',
    'Compare Platforms': 'مقارنة المنصّات',
    // Voice agent links
    'Voice Agents': 'الوكلاء الصوتيون',
    'AI Receptionist': 'موظف استقبال AI',
    'AI Answering Service': 'خدمة رد على المكالمات بالـ AI',
    'AI Call Center': 'مركز اتصال AI',
    'AI Voice Agent': 'وكيل صوتي AI',
    'AI Outbound Calling': 'اتصال صادر بالـ AI',
    'All Voice Use Cases': 'كل حالات الاستخدام',
    'Telephony Providers': 'مزوّدو الاتصالات',
    'Free Tools': 'أدوات مجانية',
    'ROI Calculator': 'حاسبة العائد على الاستثمار',
    'AI Readiness Assessment': 'تقييم الجاهزية للـ AI',
    'Team Size Calculator': 'حاسبة حجم الفريق',
    'Budget Planner': 'مخطط الميزانية',
    'Benchmark Tool': 'أداة المقارنة المرجعية',
    'AI Adoption Guide': 'دليل تبني AI',
    Mollie: 'Mollie',
    TicketSwap: 'TicketSwap',
    MoneyGram: 'MoneyGram',
    Trunkrs: 'Trunkrs',
    'More.com': 'More.com',
    FareHarbor: 'FareHarbor',
    Qoyod: 'قيود',
    'All Stories': 'كل القصص',
    'Voice AI': 'المكالمات',
    Chat: 'المحادثات',
    Email: 'الإيميل',
    WhatsApp: 'WhatsApp',
    Slack: 'Slack',
    'Social Media': 'السوشيال ميديا',
    Industries: 'القطاعات',
    'Financial Services': 'الخدمات المالية',
    Healthcare: 'الرعاية الصحية',
    Mobility: 'التنقل والمواصلات',
    Technology: 'التقنية',
    'Travel & Hospitality': 'السفر والضيافة',
    'All Industries': 'كل القطاعات',
    'About Us': 'من نحن',
    Careers: 'الوظائف',
    Blog: 'المدونة',
    News: 'الأخبار',
    Cheatsheet: 'المرجع السريع',
    Contact: 'تواصل معنا',
    GDPR: 'GDPR',
    Subprocessors: 'المعالجات الفرعية',
    Security: 'الأمان',
    Github: 'Github',
    LinkedIn: 'LinkedIn',
    Facebook: 'Facebook',
    Twitter: 'Twitter',
  },
  features: {
    'AI-Powered Support': 'دعم مدعوم بالـ AI',
    'Omnichannel Communication': 'اتصال متعدد القنوات',
    'Enterprise Security': 'أمان المؤسسات',
    'Real-time Analytics': 'تحليلات لحظية',
    '77% Automation Rate': 'معدل أتمتة ٧٧٪',
    '95%+ Accuracy': 'دقة مضبوطة بعتبات الثقة',
  },
  cheatsheet: {
    'Open Platform Cheatsheet': 'دليل منصة Open السريع',
    'Complete Quick Reference Guide | open.cx | Updated January 2026':
      'المرجع السريع الكامل | open.cx | تحديث يناير 2026',
    'Quick reference guide to all Open features, integrations, and capabilities':
      'دليل مرجعي سريع لجميع ميزات وتكاملات وقدرات Open',
    'Get Started': 'ابدأ الآن',
    'Save as PDF': 'حفظ كـ PDF',
    'About Open': 'عن Open',
    'Open is the complete AI customer support platform trusted by leading enterprises worldwide. We automate 60-80% of support interactions across phone, email, chat, WhatsApp, and more with 95%+ accuracy.':
      'Open منصة متكاملة لدعم العملاء بالـ AI، تثق بها كبرى الشركات حول العالم. نأتمت ٦٠-٨٠٪ من تفاعلات الدعم عبر الهاتف والإيميل والدردشة وWhatsApp وغيرها.',
    '77% avg automation rate': 'متوسط معدل الأتمتة ٧٧٪',
    '95%+ AI accuracy': 'دقة AI مضبوطة بعتبات الثقة',
    '100+ languages supported': 'دعم أكثر من ١٠٠ لغة',
    '99.9% uptime SLA': 'ضمان جاهزية ٩٩,٩٪',
    'Backed By': 'مدعوم من',
    'Trusted By': 'موثوق به من',
    'MoneyGram (55M customers), Mollie (€6.5B), TicketSwap (15M users), FareHarbor (Booking.com), Trunkrs, Qoyod, and more':
      'MoneyGram (٥٥ مليون عميل)، Mollie (٦,٥ مليار يورو)، TicketSwap (١٥ مليون مستخدم)، FareHarbor (Booking.com)، Trunkrs، قيود، والمزيد',
    Channels: 'القنوات',
    Integrations: 'التكاملات',
    Helpdesks: 'أنظمة الدعم',
    'End Users': 'المستخدمون النهائيون',
    'AI Communication Channels': 'قنوات الاتصال بالـ AI',
    'Deploy AI agents across all touchpoints':
      'نشر وكلاء AI عبر جميع نقاط الاتصال',
    'Natural phone conversations': 'محادثات هاتفية طبيعية',
    'Intelligent chat widget': 'أداة دردشة ذكية',
    'Automated email support': 'دعم إيميل آلي',
    'WhatsApp Business API': 'WhatsApp Business API',
    'Unified social support': 'دعم موحد للشبكات الاجتماعية',
    'Internal & external Slack': 'Slack داخلي وخارجي',
    'The AI Engine (Agent 5)': 'محرك AI (Agent 5)',
    'Core AI capabilities powering all agents':
      'قدرات AI الأساسية اللي تشغّل جميع الوكلاء',
    'Training Center': 'مركز التدريب',
    'Documents, FAQs, knowledge bases':
      'الوثائق والأسئلة الشائعة وقواعد المعرفة',
    Observability: 'الشفافية',
    'Real-time monitoring & analytics': 'مراقبة وتحليلات لحظية',
    'Actions & Integrations': 'الإجراءات والتكاملات',
    'Connect to any API or system': 'الربط بأي API أو نظام',
    'Compliance & Security': 'الامتثال والأمان',
    'GDPR, SOC 2, PII redaction': 'GDPR، SOC 2، إخفاء البيانات الشخصية',
    'Evaluations (Evals)': 'التقييمات',
    'Test AI quality & accuracy': 'اختبار جودة ودقة AI',
    'Agentic Workflows': 'الأتمتة الذكية',
    'Automate complex multi-step processes':
      'أتمتة العمليات المعقدة متعددة الخطوات',
    'Workflow Builder': 'منشئ الأتمتة',
    'Visual editor for automation': 'محرر مرئي للأتمتة',
    'Outbound Sequencing': 'التسلسلات الصادرة',
    'Proactive customer outreach': 'تواصل استباقي مع العميل',
    'Customer Insights': 'رؤى العملاء',
    'Extract actionable insights': 'استخراج رؤى قابلة للتنفيذ',
    'Knowledge Gap Detection': 'اكتشاف فجوات المعرفة',
    'App Builder': 'بنّاء التطبيقات',
    'Identify missing KB info': 'تحديد المعلومات المفقودة في قاعدة المعرفة',
    Templates: 'القوالب',
    '50+ pre-built workflows': 'أكثر من ٥٠ قالب جاهز',
    'Helpdesk Integrations': 'تكاملات أنظمة الدعم',
    'Native ticketing system integrations': 'تكاملات أصلية لأنظمة التذاكر',
    'Open Helpdesk': 'Open Helpdesk',
    'AI-native': 'مبني على الـ AI',
    'Ticket management': 'إدارة التذاكر',
    'Inbox routing': 'توجيه المحادثات الواردة',
    'Service Cloud': 'Service Cloud',
    'SLA management': 'إدارة اتفاقيات مستوى الخدمة',
    'Service Hub': 'Service Hub',
    'Contact center': 'مركز الاتصال',
    'AI Training Sources': 'مصادر تدريب AI',
    'Connect knowledge bases and data sources to train your AI':
      'ربط قواعد المعرفة ومصادر البيانات لتدريب AI',
    'Web Crawler': 'زاحف الويب',
    'Zendesk Help Center': 'مركز مساعدة Zendesk',
    'Intercom Articles': 'مقالات Intercom',
    'HubSpot KB': 'قاعدة معرفة HubSpot',
    'Google Sheets': 'جداول Google',
    MongoDB: 'MongoDB',
    Snowflake: 'Snowflake',
    BigQuery: 'BigQuery',
    Shopify: 'Shopify',
    Jira: 'Jira',
    Zapier: 'Zapier',
    Webhooks: 'Webhooks',
    'REST API': 'REST API',
    'View All Integrations': 'عرض جميع التكاملات',
    'Industry Solutions': 'حلول القطاعات',
    'Purpose-built for specific industries': 'مصممة خصيصاً لقطاعات محددة',
    'Financial Services': 'الخدمات المالية',
    'Compliant AI for banking': 'AI متوافق مع أنظمة البنوك',
    Healthcare: 'الرعاية الصحية',
    'HIPAA-compliant patient support': 'دعم المرضى المتوافق مع HIPAA',
    'Mobility & Transportation': 'التنقل والمواصلات',
    'Ride-sharing & logistics': 'النقل التشاركي واللوجستيات',
    'Technology & SaaS': 'التقنية وSaaS',
    'Reduce churn with AI': 'تقليل تسرّب العملاء بالـ AI',
    'Travel & Hospitality': 'السفر والضيافة',
    'Bookings & guest services': 'الحجوزات وخدمات الضيوف',
    'Proactive outreach with AI across channels':
      'تواصل استباقي بالـ AI عبر جميع القنوات',
    'Phone (AI Voice)': 'الهاتف (صوت ذكي)',
    'Automated outbound calls': 'مكالمات صادرة آلية',
    'Email (AI)': 'الإيميل (AI)',
    'Automated email campaigns': 'حملات إيميل آلية',
    'SMS (AI)': 'الرسائل النصية (AI)',
    'Text message sequences': 'تسلسلات الرسائل النصية',
    'WhatsApp (AI)': 'WhatsApp (AI)',
    'WhatsApp outbound messaging': 'رسائل WhatsApp الصادرة',
    'Web (AI Chat)': 'الويب (دردشة ذكية)',
    'Proactive chat outreach': 'تواصل استباقي عبر الدردشة',
    'Free Tools & Resources': 'أدوات وموارد مجانية',
    'Calculators and assessment tools': 'حاسبات وأدوات تقييم',
    'ROI Calculator': 'حاسبة العائد على الاستثمار',
    'Calculate cost savings': 'حساب التوفير في التكاليف',
    'AI Readiness Assessment': 'تقييم الجاهزية للـ AI',
    'Evaluate AI readiness': 'قياس جاهزية فريقك',
    'Team Size Calculator': 'حاسبة حجم الفريق',
    'Optimize team structure': 'تحسين هيكل الفريق',
    'Budget Planner': 'مخطط الميزانية',
    'Plan support operations budget': 'تخطيط ميزانية عمليات الدعم',
    'Benchmark Tool': 'أداة المقارنة المرجعية',
    'Compare to industry standards': 'المقارنة بمعايير القطاع',
    'Open Academy': 'أكاديمية Open',
    'Learn AI support best practices': 'تعلّم أفضل ممارسات الدعم بالـ AI',
    'Analytics & Insights': 'التحليلات والرؤى',
    'Extract actionable insights from conversations':
      'استخراج رؤى قابلة للتنفيذ من المحادثات',
    'Voice of customer analysis': 'تحليل صوت العميل',
    'Identify missing documentation': 'تحديد الوثائق المفقودة',
    'Smart Clustering': 'التجميع الذكي',
    'Group similar issues': 'تجميع المشكلات المتشابهة',
    'Root Cause Analysis': 'تحليل السبب الجذري',
    'Identify actual causes': 'تحديد الأسباب الفعلية',
    'Security & Compliance': 'الأمان والامتثال',
    'Enterprise-grade security standards': 'معايير أمان على مستوى المؤسسات',
    'GDPR Compliant': 'متوافق مع GDPR',
    'EU data residency': 'استضافة البيانات في الاتحاد الأوروبي',
    'SOC 2 Type II': 'SOC 2 من النوع الثاني',
    'In progress': 'قيد التنفيذ',
    'PII Redaction': 'إخفاء البيانات الشخصية',
    'Automatic data protection': 'الحماية التلقائية للبيانات',
    'Audit Logs': 'سجلات التدقيق',
    'Full activity tracking': 'التتبع الكامل للنشاط',
    'API & Developer Resources': 'موارد API والمطورين',
    'Build custom integrations and automations': 'بناء تكاملات وأتمتة مخصصة',
    'Complete API documentation': 'توثيق API كامل',
    'Event-driven integrations': 'تكاملات مدفوعة بالأحداث',
    'SDK Support': 'دعم SDK',
    'TypeScript, Python, more': 'TypeScript، Python، والمزيد',
    'White-label Embedding': 'التضمين بالعلامة البيضاء',
    'Custom branding options': 'خيارات العلامة التجارية المخصصة',
    'Customer Success Stories': 'قصص نجاح العملاء',
    'Leading companies automating support with Open':
      'شركات رائدة تؤتمت دعمها مع Open',
    '55M customers, 200+ countries': '٥٥ مليون عميل، أكثر من ٢٠٠ دولة',
    '€6.5B payment processor': 'معالج مدفوعات بقيمة ٦,٥ مليار يورو',
    '61K+ Google reviews': 'أكثر من ٦١ ألف تقييم على Google',
    '25K businesses': '٢٥ ألف شركة',
    '15M users, 42 countries': '١٥ مليون مستخدم، ٤٢ دولة',
    'Booking.com company': 'شركة Booking.com',
    '34M tickets sold': '٣٤ مليون تذكرة مباعة',
    '1M+ customers served': 'خدمة أكثر من مليون عميل',
    'Thousands of merchants': 'آلاف التجار',
    'Top online pharmacy NL': 'أفضل صيدلية إلكترونية في هولندا',
    '$86M-funded car subscription': 'اشتراك سيارات بتمويل ٨٦ مليون دولار',
    'View All Success Stories': 'عرض جميع قصص النجاح',
    '© 2026 Open. Y Combinator W24 • $7M Raised • Serving 55M+ end users globally':
      '© 2026 Open. Y Combinator W24 • جمع ٢٦ مليون ⃁ • خدمة أكثر من ٥٥ مليون مستخدم نهائي عالمياً',
  },
  meta: {
    'The AI engine powering all your customer communications. 77% automation rate. Works with Zendesk, Intercom, Salesforce, and more.':
      'المحرك الذكي اللي يشغّل كل تواصلك مع العملاء. معدل أتمتة ٧٧٪، ويشتغل مع Zendesk وIntercom وSalesforce وغيرها.',
    'The cookies and trackers Open uses, what they do, and how to control them.':
      'ملفات تعريف الارتباط وأدوات التتبّع اللي يستخدمها Open، وش تسوي، وكيف تتحكم فيها.',
    'Cookie Policy': 'سياسة ملفات تعريف الارتباط',
    'Agent 5 is the 24/7 tour desk: bookings, reschedules, cancellations and guest questions in 100+ languages. Trusted by RealNZ and Pacific Whale Foundation.':
      'Agent 5 هو مكتب الجولات اللي ما ينام، لمشغّلي الأنشطة والتجارب. يتولّى الحجوزات والتعديلات وإلغاءات الطقس وأسئلة الضيوف فوراً، بأكثر من ١٠٠ لغة. يعتمد عليه RealNZ، وPacific Whale Foundation، وFury، وFuturismo، وغيرهم.',
    'AI Customer Support for Tour & Activity Operators':
      'دعم عملاء بالذكاء الاصطناعي لمشغّلي الجولات والأنشطة',
    'Launch your own AI customer support product under your brand. FareHarbor, part of the Booking.com group, white-labels Open for thousands of its merchants.':
      'أطلق منتج دعم عملاء بالذكاء الاصطناعي تحت علامتك. Open يوفّر التقنية، وأنت تضيف خط منتج ومصدر دخل جديد. FareHarbor، وهي ضمن مجموعة Booking.com، تستخدم Open بعلامتها لآلاف التجّار.',
    'White-Label AI Customer Support for Partners':
      'دعم عملاء بعلامتك أنت — White-Label من Open',
    tickets: 'تذاكر',
    'Open - The unified AI customer support platform':
      'Open - منصة دعم العملاء الموحدة بالذكاء الاصطناعي',
    'Radically upgrade customer support and communication with AI.':
      'أتمتة ٧٧٪ من تذاكر دعم العملاء بدقة وأمان بمستوى المؤسسات، مع تصعيد سلس لفريقك.',
    'About Open - AI That Actually Works': 'عن Open - ذكاء اصطناعي يعمل فعلاً',
    'Agent 5 — The AI Engine for Customer Support':
      'Agent 5 — محرك الذكاء الاصطناعي لدعم العملاء',
    'Channels - AI Communication Platform':
      'القنوات - منصة التواصل بالذكاء الاصطناعي',
    'AI Phone Support That Sounds Human':
      'دعم هاتفي بالذكاء الاصطناعي يتكلم مثل البشر',
    'AI Web Chat for Customer Support':
      'دردشة ويب بالذكاء الاصطناعي لدعم العملاء',
    'AI Email Support on Your Own Domain':
      'دعم الإيميل بالذكاء الاصطناعي على نطاقك',
    'AI WhatsApp Support with Voice Notes and Images':
      'دعم WhatsApp بالذكاء الاصطناعي بالصوت والصور',
    'AI Support for Instagram and Messenger':
      'دعم Instagram و Messenger بالذكاء الاصطناعي',
    'Internal AI Support Inside Slack':
      'دعم داخلي بالذكاء الاصطناعي داخل Slack',
    'Customer Insights — What Customers Contact You About':
      'رؤى العملاء — على إيش يتواصلون معك',
    'Customer Stories': 'قصص العملاء',
    'Book a Demo — See Agent 5 on Your Own Tickets':
      'احجز عرضاً — شوف Agent 5 على تذاكرك أنت',
    'Helpdesks - AI Helpdesk Integration':
      'أنظمة الدعم - دمج الذكاء الاصطناعي في نظام الدعم عندك',
    Industries: 'القطاعات',
    'AI Customer Support for Financial Services':
      'دعم عملاء بالذكاء الاصطناعي للخدمات المالية',
    'AI Customer Support for Healthcare':
      'دعم عملاء بالذكاء الاصطناعي للرعاية الصحية',
    'AI Customer Support for Mobility and Transport':
      'دعم عملاء بالذكاء الاصطناعي لقطاع التنقل والنقل',
    'AI Customer Support for SaaS and Technology':
      'دعم عملاء بالذكاء الاصطناعي لشركات SaaS والتقنية',
    'AI Customer Support for Travel and Hospitality':
      'دعم عملاء بالذكاء الاصطناعي للسفر والضيافة',
    'Knowledge Gap Detection for Support Teams':
      'اكتشاف فجوات المعرفة لفرق الدعم',
    'AI Outbound Sequences for Proactive Support':
      'تسلسلات صادرة بالذكاء الاصطناعي للدعم الاستباقي',
    'Sub-processes — Reusable Steps Inside a Workflow':
      'العمليات الفرعية — خطوات قابلة لإعادة الاستخدام',
    'AI Workflow Templates for Support Teams': 'قوالب سير عمل جاهزة لفرق الدعم',
    'Tools - AI Support Tools': 'الأدوات - أدوات الدعم بالذكاء الاصطناعي',
    'AI Workflow Automation for Customer Support':
      'أتمتة سير العمل بالذكاء الاصطناعي لدعم العملاء',
    'Zendesk AI Agent': 'وكيل ذكاء اصطناعي لـ Zendesk',
    'AI Agent for HubSpot Service Hub': 'وكيل ذكي لـ HubSpot Service Hub',
    'Intercom AI Agent': 'وكيل ذكاء اصطناعي لـ Intercom',
    'AI Agent for Salesforce Service Cloud':
      'وكيل ذكي لـ Salesforce Service Cloud',
    'Freshdesk AI Agent': 'وكيل ذكاء اصطناعي لـ Freshdesk',
    'Twilio Flex AI Agent': 'وكيل ذكاء اصطناعي لـ Twilio Flex',
    'Open Helpdesk': 'نظام الدعم من Open',
    'Companion - A Senior Support Ops Expert In A Chat':
      'Companion - خبير عمليات دعم متمرّس داخل محادثة',
    'Cookinglife - 70% Support Automation with Open':
      'Cookinglife - أتمتة ٧٠٪ من الدعم مع Open',
    'De Online Drogist - 73% Automation with Open':
      'De Online Drogist - أتمتة ٧٣٪ مع Open',
    'Mollie - Scaling Support for 250K+ Businesses with Open':
      'Mollie - دعم يتوسّع لأكثر من ٢٥٠ ألف نشاط تجاري عبر Open',
    'MoneyGram - 70% Automation Across 200+ Countries':
      'MoneyGram - أتمتة ٨٠٪ في أكثر من ٢٠٠ دولة',
    'More.com - 67% Automation Across 30M Tickets':
      'More.com - أتمتة ٨٠٪ عبر ٣٠ مليون تذكرة',
    'OCN - Automating Car Subscription Support in Mexico':
      'OCN - أتمتة دعم اشتراكات السيارات في المكسيك',
    'OTO - 77% Automation with 90%+ CSAT': 'OTO - أتمتة ٧٧٪ مع رضا عملاء +٩٠٪',
    'Qoyod - 77% Automation for 25,000+ Businesses':
      'Qoyod - أتمتة ٨٥٪ لأكثر من ٢٥ ألف نشاط',
    'Snel Een Taxi - AI Support for On-Demand Mobility':
      'Snel Een Taxi - دعم بالذكاء الاصطناعي لخدمات التنقل حسب الطلب',
    'TicketSwap - 67% Automation Across 19M Users':
      'TicketSwap - أتمتة ٧٨٪ عبر ١٩ مليون مستخدم',
    'Trunkrs - 80% Automation with 4.8/5 Customer Rating':
      'Trunkrs - أتمتة ٨٠٪ مع تقييم عملاء ٤,٨/٥',
    'Open Telephony - The AI Phone System':
      'Open Telephony - نظام الهاتف بالذكاء الاصطناعي',
    'Use Open in Zendesk - No Migration Needed':
      'استخدم Open داخل Zendesk - بدون أي ترحيل',
    'Use Open in Intercom - No Migration Needed':
      'استخدم Open داخل Intercom - بدون أي ترحيل',
    'Use Open in Freshdesk - No Migration Needed':
      'استخدم Open داخل Freshdesk - بدون أي ترحيل',
    'AI Customer Support Cheatsheet':
      'المرجع السريع لدعم العملاء بالذكاء الاصطناعي',
    'Privacy Policy': 'سياسة الخصوصية',
    'Terms of Service': 'شروط الخدمة',
    'GDPR Compliance': 'الامتثال لـ GDPR',
    'Incentive Terms': 'شروط الحوافز',
    'Integrations - Connect Your Data Sources':
      'التكاملات - اربط مصادر بياناتك بالذكاء الاصطناعي',
    'Blog - AI Customer Support Insights':
      'المدونة - رؤى في دعم العملاء بالذكاء الاصطناعي',
    'Open Academy - AI Support Training':
      'أكاديمية Open - تدريب على الدعم بالذكاء الاصطناعي',
    'Announcing Our New Funding Round': 'نعلن عن جولة التمويل الجديدة',
    'AI Adoption Guide': 'دليل تبني الذكاء الاصطناعي',
    'AI Readiness Assessment': 'تقييم الجاهزية للذكاء الاصطناعي',
    'Support Benchmark Tool': 'أداة مقارنة مؤشرات الدعم',
    'AI ROI Calculator': 'حاسبة العائد على الاستثمار في الذكاء الاصطناعي',
    'Support Budget Calculator': 'حاسبة ميزانية الدعم',
    'Team Size Calculator': 'حاسبة حجم الفريق',
    'We make AI that actually works. Meet the team behind the AI customer support platform trusted by TicketSwap, Mollie, and MoneyGram.':
      'نبني ذكاءً اصطناعياً يعمل فعلاً. تعرّف على الفريق وراء منصة دعم العملاء اللي تثق بها TicketSwap وMollie وMoneyGram.',
    'The AI engine powering all your customer communications. 77% automation rate with 95%+ accuracy. Works with Zendesk, Intercom, Salesforce, and more.':
      'محرك الذكاء الاصطناعي اللي يشغّل كل تواصلك مع العملاء. أتمتة ٧٧٪. يتكامل مع Zendesk وIntercom وSalesforce وغيرها.',
    'AI-powered communication across all channels - voice, chat, email, WhatsApp, social, and Slack. One AI, every channel.':
      'تواصل بالذكاء الاصطناعي عبر كل القنوات: الهاتف والدردشة والإيميل وWhatsApp ووسائل التواصل وSlack. ذكاء واحد، كل القنوات.',
    'The agent answers on the first ring in the language the caller used, books and reschedules, resolves account questions, and hands to a person with full context.':
      'الوكيل يرد من أول رنة بلغة المتصل، يحجز ويعدّل المواعيد، يحل أسئلة الحساب، ويحوّل لإنسان ومعه السياق كامل.',
    'One embed on your site and the agent answers instantly — order status, account questions, policy answers — escalating to your team in the same thread when it should.':
      'كود واحد في موقعك والوكيل يجاوب فوراً: حالة الطلب، وأسئلة الحساب، والسياسات — ويصعّد لفريقك في نفس المحادثة لمّا يلزم.',
    'The agent reads, drafts and sends from your own support address, keeps the thread intact, and leaves anything it should not answer for a human to pick up.':
      'الوكيل يقرأ ويكتب ويرسل من عنوان الدعم حقك، يحافظ على الخيط كامل، ويترك اللي ما يفترض يجاوبه لإنسان.',
    'Customers send a voice note or a photo of the problem and get a real answer back on WhatsApp Business — same agent, same knowledge, no separate bot to maintain.':
      'العميل يرسل مقطع صوتي أو صورة للمشكلة ويجيه جواب فعلي على WhatsApp Business — نفس الوكيل، نفس المعرفة، بلا بوت منفصل تصونه.',
    'DMs and comment replies handled by the same agent that runs your other channels, so a question asked on Instagram gets the answer your help centre would give.':
      'الرسائل والتعليقات يتولاها نفس الوكيل اللي يشغّل قنواتك الثانية، فالسؤال على Instagram ياخذ نفس جواب مركز المساعدة.',
    'Your team asks in the channel they already use and gets the answer from your own documentation — instead of interrupting the two people who happen to know it.':
      'فريقك يسأل في نفس القناة اللي يستخدمها ويجيه الجواب من توثيقك أنت — بدل ما يقاطع الشخصين اللي يعرفون الجواب.',
    'The AI assistant inside Open: diagnose performance drops, rewrite AI instructions with inline diffs, debug any ticket, run live test sessions. 140+ tools.':
      'Companion هو المساعد الذكي داخل Open. يشخّص تراجع الأداء، يعيد كتابة تعليمات الذكاء الاصطناعي بفروقات واضحة، يفحص أي تذكرة، ويشغّل جلسات اختبار مباشرة — أكثر من ١٤٠ أداة مع سياق كامل لمساحة عملك.',
    'Every conversation grouped by what the customer actually wanted, so contact reasons come from your tickets rather than from a tagging scheme somebody guessed at.':
      'كل محادثة مجمّعة حسب اللي طلبه العميل فعلاً، فأسباب التواصل تطلع من تذاكرك، مو من نظام تصنيف خمّنه أحد.',
    'How leading companies use Open to transform customer support.':
      'كيف تستخدم كبرى الشركات Open لتطوير دعم العملاء.',
    'How Cookinglife serves 1M+ customers and automates 70% of support with Open.':
      'كيف تخدم Cookinglife أكثر من مليون عميل بأتمتة ٧٠٪ من الدعم مع Open.',
    'How De Online Drogist automates 73% of support and runs 25+ AI actions with Open.':
      'كيف وصلت De Online Drogist لأتمتة ٧٣٪ من الدعم مع أكثر من ٢٥ إجراء ذكي عبر Open.',
    'How Mollie supports 250,000+ businesses across Europe and automates 60%+ of support with Open.':
      'كيف تدعم Mollie أكثر من ٢٥٠ ألف نشاط في أوروبا بأتمتة ٧٠٪ من الدعم مع Open.',
    'How MoneyGram supports 55M customers across 200+ countries and automates 70% of support with Open.':
      'كيف تدعم MoneyGram ٥٥ مليون عميل في أكثر من ٢٠٠ دولة بأتمتة ٨٠٪ من الدعم مع Open.',
    'How More.com sold 30M tickets across Europe and automated 67% of support with Open.':
      'كيف باعت More.com ٣٠ مليون تذكرة عبر أوروبا وأتمتت ٨٠٪ من الدعم مع Open.',
    'How OCN automates 60% of support for 7.5K vehicles and Mexico car subscriptions with Open.':
      'كيف تؤتمت OCN ٦٠٪ من الدعم لـ ٧٥٠٠ مركبة واشتراكات السيارات في المكسيك مع Open.',
    'How OTO automates more than 77% of last-mile delivery support across MENA with 90%+ CSAT using Open.':
      'كيف تؤتمت OTO أكثر من ٧٧٪ من دعم توصيل الميل الأخير في MENA برضا عملاء +٩٠٪ باستخدام Open.',
    'How Qoyod automates 77% of support for 25,000+ businesses with Open.':
      'كيف تؤتمت Qoyod ٨٥٪ من الدعم لأكثر من ٢٥ ألف نشاط مع Open.',
    'How Snel Een Taxi automates customer support for its on-demand taxi service with Open.':
      'كيف تؤتمت Snel Een Taxi دعم العملاء لخدمة التاكسي حسب الطلب مع Open.',
    'How TicketSwap automated 67% of 19 million user support operations with Open.':
      'كيف أتمتت TicketSwap ٧٨٪ من عمليات دعم ١٩ مليون مستخدم مع Open.',
    'How Trunkrs automates 80% of delivery support with a 4.8/5 customer rating using Open.':
      'كيف تؤتمت Trunkrs ٨٠٪ من دعم التوصيل بتقييم عملاء ٤,٨/٥ باستخدام Open.',
    'A working session, not a slide deck. We connect your helpdesk, run the agent against your real tickets, and show you what it would and would not have resolved.':
      'جلسة شغل، مو عرض شرائح. نربط نظام الدعم حقك، ونشغّل الوكيل على تذاكرك الحقيقية، ونوريك وش كان بيحل ووش لا.',
    'Integrate AI with your existing helpdesk platform. Works with Zendesk, Intercom, Salesforce, HubSpot, Freshdesk, and Twilio Flex.':
      'اربط الذكاء الاصطناعي بنظام الدعم اللي تستخدمه. يعمل مع Zendesk وIntercom وSalesforce وHubSpot وFreshdesk وTwilio Flex.',
    'AI customer support solutions for every industry.':
      'حلول دعم عملاء بالذكاء الاصطناعي لكل قطاع.',
    'Card, payment and account questions resolved inside your existing controls — with anything touching fraud, sanctions or a regulated decision handed to a human.':
      'أسئلة البطاقات والمدفوعات والحسابات تُحل داخل ضوابطك الحالية، وأي شي يمس الاحتيال أو العقوبات أو قراراً تنظيمياً يروح لإنسان.',
    'Appointment changes, coverage questions and intake handled automatically, with clinical questions routed to a person and every escalation logged.':
      'تغيير المواعيد وأسئلة التغطية والاستقبال تتعالج تلقائياً، والأسئلة السريرية تروح لإنسان، وكل تصعيد مسجّل.',
    'Riders, drivers and fleet questions handled in one place — bookings, cancellations, fares and damage claims — in the language the customer wrote in.':
      'أسئلة الركاب والسائقين والأسطول في مكان واحد: الحجوزات، والإلغاءات، والأجرة، ومطالبات الضرر — وباللغة اللي كتب فيها العميل.',
    'Onboarding questions, API and billing tickets answered from your own docs, with reproducible bugs escalated to engineering carrying the full thread.':
      'أسئلة الإعداد وتذاكر الـ APIs والفوترة تُجاب من توثيقك أنت، والأخطاء القابلة لإعادة الإنتاج تتصعّد للهندسة ومعها الخيط كامل.',
    "Bookings, changes, cancellations and disruption handled around the clock in the guest's language, with the cases that need judgement passed to your team.":
      'الحجوزات والتعديلات والإلغاءات والاضطرابات تُعالج على مدار الساعة بلغة الضيف، والحالات اللي تحتاج حكماً تروح لفريقك.',
    'When the agent cannot answer, the question is logged as a gap, in the words the customer used — so you write the article that was missing, not the one you assumed.':
      'لمّا ما يقدر الوكيل يجاوب، يتسجّل السؤال كفجوة بنفس صياغة العميل — فتكتب المقال الناقص فعلاً، مو اللي افترضته.',
    'An AI-native business phone system: numbers in 100+ countries, IVR, routing, transcription, SMS, and a 24/7 AI receptionist. Works with 30+ providers.':
      'نظام هاتف كامل مبني على الذكاء الاصطناعي: أرقام في أكثر من ١٠٠ دولة، IVR، توجيه المكالمات، تسجيل، تفريغ نصي لحظي، SMS، تحليلات، وموظف استقبال ذكي يشتغل ٢٤/٧ يرد ويحل ويوجّه كل مكالمة. يتكامل مع Twilio وRingCentral وAircall وأكثر من ٣٠ مزوّداً.',
    'Reach customers before they contact you — delivery delays, renewals, failed payments, appointment reminders — across voice, WhatsApp and email, with replies handled.':
      'توصل للعميل قبل ما يتواصل معك: تأخّر شحنة، وتجديد، ودفعة فاشلة، وتذكير بموعد — عبر الصوت و WhatsApp والإيميل، والردود متكفّل فيها.',
    'Write a procedure once and call it from any workflow. Verification, refund eligibility, address changes — defined in one place, so fixing it once fixes it everywhere':
      'اكتب الإجراء مرة وحدة ونادِه من أي سير عمل. التحقق، وأهلية الاسترجاع، وتغيير العنوان — معرّفة في مكان واحد، فتصليحها مرة يصلحها في كل مكان.',
    'Ready-made automations for the tickets every support team gets — order tracking, refunds, password resets, appointment changes — editable before you switch them on.':
      'أتمتة جاهزة للتذاكر اللي تجي كل فريق دعم: تتبّع الطلب، والاسترجاع، وإعادة تعيين كلمة المرور، وتغيير المواعيد — وكلها تعدّلها قبل ما تشغّلها.',
    'AI-powered customer support tools.': 'أدوات دعم عملاء بالذكاء الاصطناعي.',
    'Build the steps your team repeats into workflows the agent runs itself — lookups, updates, refunds, escalations — with a human in the loop wherever you want one.':
      'حوّل الخطوات اللي يكررها فريقك إلى سير عمل ينفّذه الوكيل بنفسه: بحث وتحديث واسترجاع وتصعيد، مع إنسان في الحلقة وين ما تبي.',
    'Use Open right in your Zendesk helpdesk. No migration needed, effortless integration in under an hour, all features from day one.':
      'استخدم Open مباشرة داخل نظام Zendesk. بدون أي ترحيل، تكامل سهل في أقل من ساعة، وكل المزايا من أول يوم.',
    'AI agent for HubSpot Service Hub. Automate support tickets with enterprise-grade AI. No migration, works in your existing HubSpot.':
      'وكيل ذكي لـ HubSpot Service Hub. أتمت تذاكر الدعم بذكاء اصطناعي بمستوى المؤسسات. بدون ترحيل، ويعمل داخل HubSpot الحالي عندك.',
    'Use Open right in your Intercom helpdesk. No migration needed, effortless integration in under an hour, all features from day one. Better than Fin AI.':
      'استخدم Open مباشرة داخل نظام Intercom. بدون أي ترحيل، تكامل سهل في أقل من ساعة، وكل المزايا من أول يوم. أفضل من Fin AI.',
    'Enterprise case automation without a consulting engagement. Open runs inside Service Cloud, keeps it as the system of record, and integrates in under an hour.':
      'أتمتة حالات مؤسسية بلا مشروع استشاري. Open يشتغل داخل Service Cloud ويخليه سجلك الرسمي، ويتكامل في أقل من ساعة.',
    'Use Open right in your Freshdesk helpdesk. No migration needed, effortless integration in under an hour, all features from day one.':
      'استخدم Open مباشرة داخل نظام Freshdesk. بدون أي ترحيل، تكامل سهل في أقل من ساعة، وكل المزايا من أول يوم.',
    'AI agent for Twilio Flex contact center. The AI capabilities Twilio doesnt have. Works with your existing Flex setup.':
      'وكيل ذكي لمركز اتصال Twilio Flex. قدرات الذكاء الاصطناعي اللي ما توفرها Twilio. يعمل مع إعداد Flex الحالي عندك.',
    'The complete AI-first helpdesk platform. All channels, all AI features, built from the ground up for automation.':
      'منصة دعم متكاملة مبنية على الذكاء الاصطناعي. كل القنوات، كل مزايا الذكاء الاصطناعي، ومصمّمة من الأساس للأتمتة.',
    'The ultimate cheatsheet for AI-powered customer support. Best practices, metrics, and implementation guides.':
      'المرجع السريع الأشمل لدعم العملاء بالذكاء الاصطناعي. أفضل الممارسات والمؤشرات وأدلة التطبيق.',
    'Privacy policy for Open. Learn how we collect, use, and protect your data.':
      'سياسة الخصوصية لـ Open. تعرّف على كيفية جمع بياناتك واستخدامها وحمايتها.',
    'Terms of service for using Open AI customer support platform.':
      'شروط الخدمة لاستخدام منصة دعم العملاء بالذكاء الاصطناعي من Open.',
    'GDPR compliance information for Open. Enterprise-grade data protection and privacy.':
      'معلومات الامتثال لـ GDPR في Open. حماية بيانات وخصوصية بمستوى المؤسسات.',
    'Terms and conditions for Open incentive programs.':
      'الشروط والأحكام لبرامج الحوافز في Open.',
    'Connect Open to your existing tools. 27+ integrations including Notion, Confluence, Google Docs, Slack, and more.':
      'اربط Open بالأدوات اللي تستخدمها. أكثر من ٢٧ تكاملاً تشمل Notion وConfluence وGoogle Docs وSlack وغيرها.',
    'Insights, guides, and comparisons for AI-powered customer support. Learn from industry experts.':
      'رؤى وأدلة ومقارنات في دعم العملاء بالذكاء الاصطناعي، بأقلام خبراء القطاع.',
    'Free courses on AI customer support. Learn to build, deploy, and optimize AI agents.':
      'دورات مجانية في دعم العملاء بالذكاء الاصطناعي. تعلّم بناء وكلاء الذكاء الاصطناعي وإطلاقهم وتحسين أدائهم.',
    'Open announces new funding to accelerate AI customer support innovation.':
      'Open تعلن عن جولة تمويل جديدة لتسريع الابتكار في دعم العملاء بالذكاء الاصطناعي.',
    'Step-by-step guide to adopting AI in your customer support operations.':
      'دليل خطوة بخطوة لتبني الذكاء الاصطناعي في عمليات دعم العملاء عندك.',
    'Assess your organization readiness for AI customer support.':
      'قيّم جاهزية مؤسستك لدعم العملاء بالذكاء الاصطناعي.',
    'Benchmark your support metrics against industry standards.':
      'قارن مؤشرات الدعم في شركتك بمعايير القطاع.',
    'Calculate the ROI of implementing AI customer support.':
      'احسب العائد على الاستثمار من تطبيق دعم العملاء بالذكاء الاصطناعي.',
    'Plan and optimize your customer support budget.':
      'خطّط ميزانية دعم العملاء عندك وحسّنها.',
    'Calculate optimal support team size with AI automation.':
      'احسب الحجم الأمثل لفريق الدعم مع أتمتة الذكاء الاصطناعي.',
    'Legal & Compliance': 'الشؤون القانونية والامتثال',
    'Open legal and compliance center. Review our GDPR compliance, subprocessors, privacy policy, and terms of service.':
      'مركز Open للشؤون القانونية والامتثال. اطّلع على امتثالنا لـ GDPR، ومزوّدي المعالجة الفرعيين، وسياسة الخصوصية، وشروط الخدمة.',
  },
  demo: {
    'Let us know about yourself, and we will reach out to you soon!':
      'عرّفنا عن نفسك، ونتواصل معك قريباً.',
    "Share some details about your team and support needs. We'll get back to you with next steps.":
      'شاركنا تفاصيل عن فريقك واحتياجات الدعم عندك، ونعود إليك بالخطوات التالية.',
    'What you can expect:': 'وش تتوقّع:',
    'Live demo of AI automating actual support tickets':
      'عرض مباشر للنظام وهو يأتمت تذاكر دعم حقيقية',
    'See how it works with your existing helpdesk':
      'كيف يشتغل مع نظام الدعم اللي تستخدمه',
    'Get answers to your specific use case': 'إجابات مباشرة على حالتك بالتحديد',
    'Thank you!': 'شكراً',
    "We've received your request and will reach out to you soon.":
      'استلمنا طلبك، ونتواصل معك قريباً.',
    'Full name': 'الاسم الكامل',
    Company: 'الشركة',
    'Work email': 'إيميل العمل',
    'Phone number': 'رقم الجوال',
    smsConsent:
      'بتزويدنا برقم هاتفك فإنك توافق على استقبال رسائل نصية من Open بخصوص طلبك للعرض التوضيحي. يختلف عدد الرسائل، وقد تُطبَّق رسوم الرسائل والبيانات. ردّ بكلمة STOP لإلغاء الاشتراك أو HELP للمساعدة.',
    smsConsentTerms: 'شروط الخدمة.',
    smsConsentPrivacy: 'سياسة الخصوصية.',
    Optional: 'اختياري',
    'Company size': 'حجم الشركة',
    'Current helpdesk': 'نظام الدعم الحالي',
    'Select company size': 'اختر حجم الشركة',
    'Select your helpdesk': 'اختر نظام الدعم',
    '1-10 employees': '١-١٠ موظفين',
    '11-50 employees': '١١-٥٠ موظف',
    '51-200 employees': '٥١-٢٠٠ موظف',
    '201-500 employees': '٢٠١-٥٠٠ موظف',
    '501+ employees': '٥٠١+ موظف',
    Other: 'أخرى',
    None: 'لا يوجد',
    'Submitting...': 'جارٍ الإرسال...',
    'Loading...': 'جارٍ التحميل...',
    'Next: book a time': 'التالي: احجز وقتك',
    Submit: 'إرسال',
    'By submitting, you agree to our': 'بالإرسال، توافق على',
    'privacy policy': 'سياسة الخصوصية',
    'Please use your work email address, not a personal email.':
      'استخدم إيميل العمل، لا إيميلاً شخصياً.',
    'Form is still loading. Please try again in a moment.':
      'النموذج قيد التحميل. حاول بعد لحظة.',
    'Something went wrong. Please try again or email mo@open.cx directly.':
      'حدث خطأ. حاول مرة أخرى أو راسلنا على mo@open.cx مباشرة.',
    Name: 'الاسم',
    'Jane Doe': 'مثال: سارة القحطاني',
    'Please enter your name.': 'الاسم مطلوب.',
    'Please enter a valid work email.': 'اكتب إيميل عمل صحيح.',
    'Please use your work email, not a personal address.':
      'استخدم إيميل العمل، لا عنواناً شخصياً.',
    'Please enter a valid phone number.': 'اكتب رقم جوال صحيح.',
    'Too many attempts — please wait a few minutes and try again.':
      'محاولات كثيرة — انتظر بضع دقائق ثم حاول مرة أخرى.',
    'Something went wrong submitting the form. Please try again.':
      'حدث خطأ أثناء إرسال النموذج. حاول مرة أخرى.',
    'Network error. Please check your connection and try again.':
      'خطأ في الشبكة. تحقق من اتصالك وحاول مرة أخرى.',
    'Find a time to meet': 'اختر وقتاً يناسبك',
    'For information on how to unsubscribe, and our privacy practices, please review our':
      'لمعرفة طريقة إلغاء الاشتراك وممارساتنا في الخصوصية، راجع',
    'Privacy Policy': 'سياسة الخصوصية',
  },
  about: {
    "Building AI that doesn't disappoint": 'نبني AI ما يخيّب ظنك',
    '77% automation. 95%+ accuracy. Actually solves problems.':
      '٧٧٪ أتمتة. يحل المشاكل فعلياً.',
    'Join the team': 'انضم لفريقنا',
    "We're in the business of value delivery": 'شغلنا إننا نوصّل قيمة حقيقية',
    "Agent 5 doesn't just automate tickets. It handles the work that actually matters—resolving customer issues, maintaining quality, and delivering results that used to require entire teams.":
      'النظام مو بس يأتمت التذاكر. يتولى العمل اللي يهم فعلاً: يحل مشاكل العملاء، ويحافظ على الجودة، ويحقق نتائج كانت تحتاج فرقاً كاملة.',
    'See Agent 5 in Action': 'شوف النظام وهو يعمل',
    '77% Automation Rate': '٧٧٪ معدل أتمتة',
    'Industry leading': 'الأفضل في المجال',
    'Backed by top-tier investors': 'مدعوم من أفضل المستثمرين',
    'Avg automation rate': 'متوسط معدل الأتمتة',
    'All-time high CSAT': 'أعلى رضا على الإطلاق',
    'Softwares replaced': 'برامج استبدلناها',
    'Avg response time': 'متوسط وقت الرد',
    'Build the future of': 'ابنِ مستقبل',
    'customer communication': 'التواصل مع العملاء',
    'Learn more about our hiring process': 'تعرّف أكثر على طريقة التوظيف عندنا',
    'How we hire': 'كيف نوظف',
    Filter: 'فلتر',
    'All Departments': 'كل الأقسام',
    'Go-to-Market': 'التسويق والمبيعات',
    Engineering: 'الهندسة',
    'Research & Leadership': 'البحث والقيادة',
    'Operations & Support': 'العمليات والدعم',
    'Product & Design': 'المنتج والتصميم',
    Remote: 'عن بعد',
    'GTM Lead - Europe': 'مدير التسويق والمبيعات - أوروبا',
    'GTM Lead - MENA/GCC': 'مدير التسويق والمبيعات - الشرق الأوسط والخليج',
    'Sales Development Representative (SDR)': 'ممثل تطوير المبيعات',
    'Business Development Representative (BDR)': 'ممثل تطوير الأعمال',
    'Customer Success Manager': 'مدير نجاح العملاء',
    'Growth Marketing Lead': 'مدير تسويق النمو',
    'AI Agent Engineer': 'مهندس وكيل AI',
    'Product Engineer': 'مهندس منتج',
    'Forward Deployed Engineer': 'مهندس تنفيذ ميداني',
    'Founding Engineer': 'مهندس مؤسس',
    'Machine Learning Engineer': 'مهندس تعلم آلي',
    'DevOps Engineer': 'مهندس DevOps',
    'Applied AI Researcher': 'باحث AI تطبيقي',
    'Ex-Founder / Operator': 'مؤسس سابق / تنفيذي عمليات',
    'Head of Operations': 'رئيس العمليات',
    'Technical Support Engineer': 'مهندس دعم فني',
    'Implementation Specialist': 'أخصائي تنفيذ',
    'Product Designer': 'مصمم منتج',
    'Product Manager': 'مدير منتج',
    'Europe (Remote)': 'أوروبا (عن بعد)',
    'MENA/GCC (Remote)': 'الشرق الأوسط والخليج (عن بعد)',
    'Build and optimize AI agents for customer communication':
      'بناء وتحسين وكلاء AI للتواصل مع العملاء',
    'Early team member, shape the product':
      'من نواة الفريق، وتشكّل المنتج معنا',
    'Proven track record building products': 'سجل مثبت في بناء المنتجات',
    'Our Backers': 'داعمونا',
    'Backed by people who': 'مدعومين من ناس',
    'build for the long term': 'يبنون على المدى الطويل',
    "Supported by Y Combinator and world-class investors who've backed the most successful technology companies. They chose us because we're solving a real problem the right way.":
      'مدعومين من Y Combinator ومستثمرين عالميين دعموا أنجح شركات التقنية. اختارونا لأننا نحل مشكلة حقيقية، وبالطريقة الصح.',
    "The world's most prestigious startup accelerator, backing companies like Airbnb, Stripe, and Dropbox.":
      'أعرق مسرعة أعمال في العالم، دعمت شركات مثل Airbnb وStripe وDropbox.',
    'Leading MENA venture capital firm investing in transformative technology companies.':
      'شركة رأس مال جريء رائدة في الشرق الأوسط، تستثمر في شركات تقنية تغيّر قواعد اللعبة.',
    'Early-stage venture capital supporting visionary founders building the future.':
      'رأس مال جريء للمراحل المبكرة، يدعم المؤسسين أصحاب الرؤية اللي يبنون المستقبل.',
    'A global community and fund that discovers and supports exceptional founders.':
      'مجتمع وصندوق عالمي يكتشف ويدعم المؤسسين الاستثنائيين.',
    'Companies handle customer communication with specialized teams. Support agents answer tickets. QA teams check quality. Analysts extract insights. Specialists handle proactive outreach.':
      'الشركات تتعامل مع تواصل العملاء بفرق متخصصة. موظفو الدعم يردون على التذاكر. فرق الجودة تراجع الشغل. المحللون يستخرجون الرؤى. والمتخصصون يتولون التواصل الاستباقي.',
    "It's really just a necessity. Each role exists because the work was too hard for one person to do well. Everyone is doing the same thing—talking to customers—but the technology forced them apart.":
      'وهذا كان ضرورة، لا ترفاً. فكل دور موجود لأن العمل أكبر من أن ينجزه شخص واحد صح. الجميع يفعل الشيء نفسه — يتحدث مع العملاء — بس التقنية فرّقتهم.',
    'That constraint is disappearing. AI can now do what used to require different types of human expertise: understand context, maintain quality, extract insights, reach out proactively.':
      'هذا القيد بدأ يختفي. فالـ AI الآن يقدر يعمل اللي كان يحتاج خبرات بشرية مختلفة: يفهم السياق، ويحافظ على الجودة، ويستخرج الرؤى، ويتواصل قبل ما يطلب العميل.',
    'Not in theory—in practice, today. Open is what happens when you stop fragmenting customer communication and let it be what it should have been all along: one coherent system that learns, responds, and improves itself.':
      'مو نظرية — بل واقع، اليوم. Open هو اللي يصير لمّا تتوقف عن تجزئة تواصل العملاء وتجعله شيئاً واحداً، كما كان يجب أن يكون من البداية: نظام متماسك يتعلّم، ويرد، ويحسّن نفسه.',
    "The surprising part isn't that AI can do this. It's that it does it with the empathy and nuance people thought only humans could provide.":
      'المفاجئ مو أن الـ AI يفعل ذلك. المفاجئ أنه يفعله بتعاطف وحس مرهف كان الناس متأكدين أنه حكر على البشر.',
    CEO: 'الرئيس التنفيذي',
    'Mo Gharbat': 'محمد الغرابات',
  },
  channels: {
    'Choose your channel': 'اختر قناتك',
    'Agent 5 works across all communication channels. Pick where your customers reach out.':
      'كل القنوات على نفس النظام، وبنفس السياق. ابدأ من حيث يتواصل عملاؤك عادة.',
    'Learn more →': 'اعرف أكثر ←',
    'Voice AI': 'المكالمات',
    'Web Chat': 'الدردشة',
    Email: 'الإيميل',
    WhatsApp: 'WhatsApp',
    Social: 'السوشيال ميديا',
    Slack: 'Slack',
    'AI phone support that sounds human': 'دعم هاتفي بصوت ما تفرقه عن البشر',
    'Embeddable chat widget with instant AI':
      'سطر كود واحد، ودردشة ترد على زوارك فوراً',
    'Custom domain email automation': 'أتمتة الإيميل من نطاقك، لا من نطاقنا',
    'Voice notes, images, typing indicators':
      'يسمع الصوتيات ويقرأ الصور ويرد فوراً',
    'Instagram & Messenger support': 'Instagram، Messenger، وتعليقات المنشورات',
    'Internal knowledge amplified': 'إجابات فورية لفريقك من مستنداتك',
    'that sounds human': 'يبدو طبيعياً مثل البشر',
    "Agent 5 Voice handles your phone support with natural conversations, intelligent routing, and seamless handoffs to human agents. Your customers won't know they're talking to AI.":
      'النظام يرد على المكالمات بمحادثات طبيعية، ويحوّل للموظفين عند الحاجة. وعملاؤك ما يحسون أنهم يكلمون روبوت.',
    'Voice AI Features': 'مميزات المكالمات',
    'Natural conversations powered by advanced AI':
      'محادثات تمشي طبيعي، بـ AI متقدم',
    'International Numbers': 'أرقام دولية',
    'Get local phone numbers in 100+ countries. No international fees for your customers.':
      'رقم محلي في أكثر من ١٠٠ دولة. وعملاءك يتصلون بدون رسوم دولية.',
    'Custom Voices and Voice Cloning': 'أصوات مخصصة ونسخ الصوت',
    'Clone your brand voice or create custom voices using ElevenLabs. Your AI sounds exactly how you want.':
      'انسخ صوت براندك أو ابنِ صوت جديد عبر ElevenLabs. يتحدث بالضبط كما تريد.',
    'High Concurrency Levels': 'مكالمات متزامنة',
    'Handle up to 500 calls at once. No busy signals, no wait times, instant scaling.':
      'حتى ٥٠٠ مكالمة في نفس اللحظة. ولا خط مشغول، ولا انتظار، والتوسّع فوري.',
    'Multi-lingual Support': 'دعم لغات متعددة',
    'Speak to customers in their language. Supports 6+ languages with native pronunciation.':
      'يكلم كل عميل بلغته. أكثر من ٦ لغات، بنطق أهل اللغة.',
    'SIP Trunking and API First': 'SIP Trunking والـ API',
    'Connect via SIP trunking or API. Works with any phone system or build custom workflows.':
      'اربطه عبر SIP أو API. يعمل مع أي نظام هاتفي، وتبني عليه سير عملك الخاص.',
    'Voice AI that integrates with your existing phone system in minutes':
      'يتكامل مع نظامك الهاتفي بدقائق',
    'Frequently asked questions': 'أسئلة شائعة',
    'Find answers to common questions about Voice AI.':
      'أكثر الأسئلة اللي تجينا عن المكالمات.',
    'How natural does the voice sound?': 'إلى أي درجة يبدو الصوت طبيعياً؟',
    "Agent 5 Voice uses advanced text-to-speech with natural intonation, pauses, and speech patterns. Most customers can't tell they're talking to AI.":
      'يستخدم تقنية متقدمة لتحويل النص إلى كلام — نبرة، وقفات، وإيقاع طبيعي. أغلب العملاء ما يميزون إنهم يكلمون AI.',
    'Can it handle multiple languages?': 'يعمل بلغات متعددة؟',
    'Yes. Agent 5 Voice supports multiple languages with native pronunciation and cultural context understanding.':
      'نعم. لغات متعددة، بنطق أهل اللغة وفهم للسياق الثقافي.',
    "What happens if the AI can't answer?": 'وش يصير إذا ما عرف الجواب؟',
    'Agent 5 seamlessly transfers the call to a human agent with full conversation context, so your agent knows exactly what was discussed.':
      'ينقل المكالمة لموظف بشري مع كامل سياق المحادثة. الموظف يدخل وهو يعرف بالضبط ما قيل.',
    'Can it integrate with my phone system?': 'يتكامل مع نظامي الهاتفي؟',
    'Yes. Agent 5 Voice works with major phone systems and can be configured to handle inbound calls through your existing setup.':
      'نعم. يعمل مع أشهر أنظمة الهاتف، وتقدر تضبطه لاستقبال المكالمات الواردة من نظامك الحالي.',
    'How does it handle accents and background noise?':
      'كيف يتعامل مع اللهجات والضوضاء؟',
    'Agent 5 Voice is trained on diverse speech patterns and accents, with advanced noise cancellation to maintain clarity even in challenging audio conditions.':
      'مدرّب على لهجات وأنماط كلام متنوعة، وفيه إلغاء ضوضاء متقدم يحافظ على الوضوح حتى في أسوأ الظروف الصوتية.',
    'for your website': 'لموقعك',
    'Agent 5 Chat embeds directly on your website with a sleek widget. Natural conversations, instant answers, and seamless handoffs when your customers need a human.':
      'تضيف ودجت دردشة لموقعك. يرد على العملاء فوراً، ويحوّل لموظف عند الحاجة.',
    'Web Chat Features': 'مميزات الدردشة',
    'Embed AI support directly on your website': 'ضيف الدردشة لموقعك',
    'Embeddable Widget': 'ودجة جاهزة',
    'Drop a single line of code and have AI support live in minutes. Works with any website.':
      'أضف سطر كود واحد وتصبح عندك دردشة تعمل خلال دقائق. تعمل مع أي موقع.',
    'Customizable Appearance': 'مظهر قابل للتخصيص',
    'Match your brand with custom colors, fonts, and positioning. Your widget, your style.':
      'طابق البراند حقك بألوان وخطوط ومواضع مخصصة. ودجتك، ستايلك.',
    'Rich Media Support': 'دعم ملفات ووسائط',
    'Share images, files, and links. Perfect for visual troubleshooting and documentation.':
      'شارك صور وملفات وروابط. مثالي لحل المشاكل البصرية.',
    'Proactive Triggers': 'محفزات استباقية',
    'Engage visitors at the right moment with behavior-based triggers and personalized greetings.':
      'تفاعل مع الزوار في الوقت المناسب بمحفزات استباقية وترحيبات مخصصة.',
    'Mobile Optimized': 'محسّن للجوال',
    'Perfect experience on any device. Responsive design that works everywhere.':
      'تجربة ممتازة على أي جهاز. تصميم متجاوب يعمل على كل شيء.',
    'Web Chat that integrates with your website in one line of code':
      'تضيفها لموقعك بسطر كود واحد',
    'Find answers to common questions about Web Chat.':
      'أكثر الأسئلة اللي تجينا عن الدردشة.',
    'How easy is it to install?': 'كم سهل التركيب؟',
    'One line of code. Copy, paste, done. No technical expertise required.':
      'سطر كود واحد. انسخ، الصق، خلاص. ما يحتاج خبرة.',
    'Can I customize the look?': 'أقدر أخصص المظهر؟',
    'Yes. Full control over colors, fonts, positioning, and behavior. Make it match your brand perfectly.':
      'نعم. تحكم كامل بالألوان والخطوط والموقع. خله يطابق البراند حقك بالضبط.',
    'Does it work on mobile?': 'يعمل على الجوال؟',
    'Absolutely. The widget is fully responsive and optimized for mobile devices.':
      'نعم. الودجة متجاوبة ومحسنة للجوال.',
    'Can visitors upload files?': 'الزوار يقدرون يرفعون ملفات؟',
    'Yes. Images, documents, and other files can be shared directly in the chat for better context.':
      'نعم. يقدرون يشاركون صور ومستندات مباشرة في الدردشة.',
    'What about page-specific context?': 'وش عن سياق الصفحة؟',
    'Agent 5 Chat can read page context to provide more relevant answers based on what the visitor is looking at.':
      'النظام يقدر يقرأ سياق الصفحة ويعطي إجابات أدق بناءً على ما يراه الزائر.',
    'that actually replies': 'اللي فعلاً يرد',
    'Agent 5 Email handles your inbox with intelligent routing, natural responses, and perfect follow-ups. No more canned responses or endless queues.':
      'النظام يتعامل مع إيميلاتك بذكاء، يوجّهها بشكل صحيح، يرد بشكل طبيعي، ويتابع كما يجب. لا مزيد من الردود الجاهزة والطوابير اللي ما تنتهي.',
    'Email Features': 'مميزات الإيميل',
    'AI-powered email support that feels personal': 'دعم إيميل ذكي يحس شخصي',
    'Custom Domain': 'نطاقك الخاص',
    'Use your own domain for seamless brand experience. support@yourcompany.com works out of the box.':
      'استخدم نطاقك لتجربة سلسة. support@yourcompany.com يعمل من أول يوم.',
    'Thread Management': 'إدارة السلاسل',
    'Intelligent threading keeps conversations organized. Full context across every reply.':
      'تنظيم ذكي يبقي المحادثات مرتبة. سياق كامل في كل رد.',
    'Sentiment Analysis': 'تحليل المشاعر',
    'Detect urgency and sentiment to prioritize responses and route appropriately.':
      'اكتشف الاستعجال والمشاعر لترتيب الأولويات والتوجيه الصح.',
    'Attachment Handling': 'التعامل مع المرفقات',
    'Process and understand attachments. Extract information from PDFs, images, and documents.':
      'معالجة وفهم المرفقات. استخراج معلومات من ملفات PDF والصور والمستندات.',
    'Auto-Categorization': 'تصنيف تلقائي',
    'Automatically tag and categorize emails for better organization and reporting.':
      'تصنيف ووسم الإيميلات تلقائياً لتنظيم وتقارير أحسن.',
    'Email support that connects to your existing inbox':
      'دعم إيميل يتصل بصندوقك الحالي',
    'Find answers to common questions about Email support.':
      'أكثر الأسئلة اللي تجينا عن الإيميل.',
    'Can I use my existing email address?': 'أقدر أستخدم إيميلي الحالي؟',
    'Yes. Connect your existing email or use a custom domain. No migration needed.':
      'نعم. اربط إيميلك الحالي أو استخدم نطاقك. ما يحتاج نقل.',
    'How does it handle attachments?': 'كيف يتعامل مع المرفقات؟',
    'Agent 5 can read and extract information from PDFs, images, and common document formats.':
      'النظام يقدر يقرأ ويستخرج معلومات من ملفات PDF والصور والمستندات الشائعة.',
    'What about email threading?': 'وش عن سلاسل الإيميل؟',
    'Full thread context is maintained. The AI knows the entire conversation history when replying.':
      'السياق الكامل للسلسلة محفوظ. النظام يعرف كل تاريخ المحادثة لمّا يرد.',
    'Can it handle multiple email addresses?': 'يقدر يتعامل مع إيميلات متعددة؟',
    'Yes. Support multiple inboxes, departments, or brands from one dashboard.':
      'نعم. ادعم صناديق متعددة أو أقسام أو براندات من لوحة واحدة.',
    'Does it work with Gmail/Outlook?': 'يعمل مع Gmail/Outlook؟',
    'Yes. Direct integration with Gmail, Outlook, and any IMAP/SMTP email provider.':
      'نعم. تكامل مباشر مع Gmail وOutlook وأي مزود IMAP/SMTP.',
    'where your customers are': 'وين عملاءك',
    "Agent 5 WhatsApp meets customers on the world's most popular messaging app. Rich media, voice notes, and instant responses at scale.":
      'النظام يقابل عملاءك على أشهر تطبيق مراسلة بالعالم. يفهم الرسائل الصوتية والصور ويرد فوراً وبأي كمية.',
    'WhatsApp Features': 'المميزات',
    'Rich messaging on the platform your customers love':
      'مراسلة غنية على التطبيق اللي يحبه عملاؤك',
    'Voice Note Support': 'دعم الرسائل الصوتية',
    'Understand and respond to voice notes. Perfect for customers who prefer speaking.':
      'يفهم ويرد على الرسائل الصوتية. مثالي للعملاء اللي يفضلون الكلام.',
    'Image Recognition': 'فهم الصور',
    'Customers can share photos for visual support. AI understands and responds appropriately.':
      'العملاء يقدرون يشاركون صور. النظام يفهم ويرد بشكل مناسب.',
    'Typing Indicators': 'مؤشرات الكتابة',
    'Show typing indicators for a more human feel. Customers know help is on the way.':
      'يعرض مؤشرات الكتابة لإحساس طبيعي أكثر. العملاء يعرفون إن المساعدة جاية.',
    'Template Messages': 'رسائل جاهزة',
    'Pre-approved templates for proactive outreach. Perfect for updates and notifications.':
      'قوالب معتمدة للتواصل الاستباقي. مثالية للتحديثات والإشعارات.',
    'Business Verification': 'التوثيق',
    'Official WhatsApp Business API with green checkmark verification available.':
      'API WhatsApp للأعمال الرسمي مع العلامة الخضراء.',
    'WhatsApp support that connects to your business in minutes':
      'دعم WhatsApp يتصل بشغلك في دقائق',
    'Find answers to common questions about WhatsApp support.':
      'أكثر الأسئلة اللي تجينا عن WhatsApp.',
    'Do I need a WhatsApp Business account?': 'أحتاج حساب WhatsApp بزنس؟',
    "Yes. We help you set up and verify your WhatsApp Business account if you don't have one.":
      'نعم. نساعدك على إنشاء حسابك وتوثيقه إذا ما كان عندك.',
    'Can it understand voice notes?': 'يقدر يفهم الرسائل الصوتية؟',
    'Yes. Agent 5 transcribes and understands voice notes, responding appropriately.':
      'نعم. النظام يحول ويفهم الرسائل الصوتية ويرد بشكل مناسب.',
    'What about images and documents?': 'وش عن الصور والملفات؟',
    'Full media support. Share and receive images, documents, and location data.':
      'دعم كامل. شارك واستقبل صور وملفات ومواقع.',
    'Is it approved by WhatsApp?': 'هل معتمد من WhatsApp؟',
    'Yes. We use the official WhatsApp Business API and follow all platform guidelines.':
      'نعم. نستخدم الـ API الرسمي ونتبع كل القواعد.',
    'Can I send proactive messages?': 'أقدر أرسل رسائل استباقية؟',
    'Yes, using pre-approved template messages. Perfect for order updates and notifications.':
      'نعم، باستخدام قوالب معتمدة. مثالية لتحديثات الطلبات.',
    'Social Media': 'السوشيال ميديا',
    'on every platform': 'على كل منصة',
    'Agent 5 Social handles Instagram and Facebook Messenger. Same great AI, wherever your customers choose to reach out.':
      'النظام يرد على رسائل Instagram وMessenger. نفس النظام القوي، أينما يتواصل عملاؤك.',
    'Social Media Features': 'المميزات',
    'AI support on Instagram and Facebook Messenger':
      'AI يرد على Instagram وMessenger',
    'Instagram DMs': 'رسائل Instagram',
    'Handle Instagram Direct Messages automatically. Perfect for e-commerce and brand support.':
      'تعامل مع رسائل Instagram تلقائياً. مثالي للتجارة الإلكترونية ودعم البراند.',
    'Facebook Messenger': 'Messenger',
    'Integrate with your Facebook Page for instant Messenger support.':
      'اتصل بصفحتك على فيسبوك لدعم فوري على Messenger.',
    'Comment Monitoring': 'مراقبة التعليقات',
    'Monitor and respond to comments on posts. Turn engagement into support opportunities.':
      'راقب ورد على التعليقات. حول التفاعل لفرص دعم.',
    'Story Replies': 'ردود الستوري',
    'Handle replies to Instagram Stories automatically. Capture every customer touchpoint.':
      'تعامل مع ردود الستوري تلقائياً. اقتنص كل نقطة تواصل.',
    'Unified Inbox': 'صندوق موحد',
    'All social conversations in one place. No switching between platforms.':
      'كل محادثات السوشيال في مكان واحد. بدون تنقل بين المنصات.',
    'Social support that connects all your platforms':
      'دعم سوشيال يربط كل منصاتك',
    'Find answers to common questions about Social support.':
      'أكثر الأسئلة اللي تجينا عن السوشيال.',
    'Which platforms are supported?': 'وش المنصات المدعومة؟',
    'Instagram DMs, Facebook Messenger, and comment monitoring on both platforms.':
      'رسائل Instagram، Messenger، ومراقبة التعليقات على المنصتين.',
    'Can it handle Story replies?': 'يقدر يتعامل مع ردود الستوري؟',
    'Yes. Agent 5 automatically responds to Instagram Story replies and reactions.':
      'نعم. يرد تلقائياً على ردود وتفاعلات الستوري.',
    'What about public comments?': 'وش عن التعليقات العامة؟',
    'Monitor and respond to comments with appropriate public or private replies.':
      'راقب ورد على التعليقات بردود عامة أو خاصة.',
    'Do I need to connect multiple accounts?': 'أحتاج أربط حسابات متعددة؟',
    'Connect all your accounts once. Manage everything from a single dashboard.':
      'اربط كل حساباتك مرة وحدة. وأدر كل شيء من لوحة واحدة.',
    'Is it official Meta integration?': 'هل تكامل ميتا رسمي؟',
    "Yes. We use Meta's official APIs for Instagram and Facebook integration.":
      'نعم. نستخدم الـ APIs الرسمية من ميتا.',
    'for your team': 'لفريقك',
    'Agent 5 Slack brings AI support to your internal teams. Answer employee questions, surface documentation, and streamline internal operations.':
      'النظام في Slack يجاوب على أسئلة فريقك، ويساعدهم يلاقون المعلومات بسرعة، ويسهّل العمليات الداخلية.',
    'Slack Features': 'المميزات',
    'AI-powered internal support for your team':
      'يساعد فريقك يلاقون الإجابات بسرعة',
    'Channel Integration': 'تكامل القنوات',
    'Deploy in any Slack channel. @mention Agent 5 for instant answers.':
      'شغّله في أي قناة. @اذكر النظام لإجابات فورية.',
    'Knowledge Base': 'قاعدة المعرفة',
    'Connect your internal docs. Agent 5 learns from Notion, Confluence, and more.':
      'اربط مستنداتك. النظام يتعلم من Notion وConfluence وأكثر.',
    'Thread Support': 'دعم المواضيع',
    'Keep conversations organized with full thread support and context awareness.':
      'خلّي المحادثات منظمة بدعم كامل للمواضيع وفهم للسياق.',
    'Direct Messages': 'رسائل خاصة',
    'Private conversations with Agent 5 for sensitive questions.':
      'محادثات خاصة مع النظام للأسئلة الحساسة.',
    'Slash Commands': 'أوامر سريعة',
    'Quick actions with /agent5 commands. Fast access to common workflows.':
      'إجراءات سريعة بأوامر /agent5. وصول سريع لسير العمل.',
    'Slack support that integrates with your workspace':
      'دعم Slack يتكامل مع مساحة عملك',
    'Find answers to common questions about Slack support.':
      'أسئلة شائعة عن دعم Slack.',
    'How does it learn our internal knowledge?': 'كيف يتعلم معرفتنا الداخلية؟',
    'Connect your knowledge sources like Notion, Confluence, or Google Docs. Agent 5 indexes and understands your documentation.':
      'اربط مصادرك مثل Notion أو Confluence أو Google Docs. النظام يفهرس ويفهم توثيقك.',
    'Can anyone on the team use it?': 'أي واحد بالفريق يقدر يستخدمه؟',
    'Yes. Configure access per channel or make it available to your entire workspace.':
      'نعم. اضبط الوصول لكل قناة أو خله متاح للكل.',
    'Does it work in private channels?': 'يعمل في القنوات الخاصة؟',
    'Yes. Invite Agent 5 to any channel, public or private.':
      'نعم. ادعِ النظام لأي قناة، عامة أو خاصة.',
    'What about sensitive information?': 'وش عن المعلومات الحساسة؟',
    'Full control over what Agent 5 can access. Enterprise-grade security and permissions.':
      'تحكم كامل فيما يقدر النظام يوصله. أمان وصلاحيات قوية.',
    'Can it take actions in other tools?': 'يقدر ياخذ إجراءات في أدوات ثانية؟',
    'Yes. Connect to your tools and let Agent 5 perform actions like creating tickets or updating records.':
      'نعم. اربط أدواتك وخل النظام ينفذ إجراءات مثل إنشاء تذاكر أو تحديث سجلات.',
    'with instant AI answers': 'دردشة ذكية ترد فوراً على عملائك',
    'Add a chat widget to your website and let Agent 5 handle customer conversations in real-time. Instant responses, rich media support, and seamless handoffs to human agents when needed.':
      'أضف ودجة دردشة لموقعك ودع النظام يتعامل مع محادثات عملائك لحظياً. ردود فورية، ودعم وسائط، وانتقال سلس للموظفين عند الحاجة.',
    'Real-time AI conversations on your website':
      'محادثات ذكية لحظية، على نفس صفحة موقعك',
    'Add the chat widget with one line of code. Fully customizable to match your brand.':
      'سطر كود واحد وتعمل. وتخصصها بالكامل عشان تطابق براندك.',
    'AI Vision & Memory': 'يشوف ويتذكر',
    'Agent 5 can see and understand images shared in chat. Remembers entire conversation history for context-aware responses.':
      'يرى الصور اللي يشاركها العميل في الدردشة ويفهمها، ويتذكر المحادثة من أولها عشان يرد بسياق كامل.',
    'Handles Complex Requests': 'ينفّذ، مو بس يجاوب',
    'More than simple FAQs. Agent 5 processes returns, account updates, and multi-step workflows.':
      'أكثر من أسئلة شائعة: يعالج المرتجعات، يحدّث الحسابات، ويكمّل سير عمل من عدة خطوات.',
    'Share images, videos, files, and links. Agent 5 sends visual guides and interactive elements.':
      'صور، فيديو، ملفات، وروابط — في الاتجاهين. ويرد بأدلة مرئية وعناصر تفاعلية.',
    'Interactive UI Elements': 'عناصر تفاعلية',
    'Render buttons, forms, cards, and carousels in responses. Not just text.':
      'أزرار، ونماذج، وبطاقات، وكاروسيل داخل الرد نفسه. مو بس نص.',
    'User Authentication & Personalization': 'مصادقة وتخصيص',
    'Identify users and pass custom data. AI uses customer context for personalized responses.':
      'اعرف من هو المستخدم ومرّر بياناته. وتأتي الردود على مقاس كل عميل.',
    'Human + AI Collaboration': 'الموظف والنظام، يد واحدة',
    'Seamless handoff between AI and human agents. Smooth transitions invisible to customers.':
      'تسليم سلس بين النظام والموظف. العميل ما يلاحظ إن أحد تغيّر.',
    'Proactive Chat': 'دردشة استباقية',
    'Trigger messages based on user behavior. Offer help when customers need it most.':
      'رسائل تنطلق مع سلوك الزائر، وتعرض المساعدة في اللحظة اللي يحتاجها فيها.',
    'How do I add the chat widget to my website?':
      'كيف أضيف ودجة الدردشة لموقعي؟',
    'Copy one line of code and paste it before the closing body tag on your website. The widget appears automatically.':
      'انسخ سطر كود واحد والصقه قبل إغلاق وسم body في موقعك. الودجة تطلع تلقائياً.',
    'Can I customize the widget appearance?': 'أقدر أخصص مظهر الودجة؟',
    'Yes. Change colors, position, avatar, greeting message, and behavior through the dashboard. No coding required.':
      'نعم. الألوان، الموقع، الأفاتار، رسالة الترحيب، والسلوك — كلها من لوحة التحكم. بدون برمجة.',
    'Does it work on mobile devices?': 'يعمل على الجوال؟',
    'Yes. The chat widget is fully responsive and works on all devices—desktop, tablet, and mobile.':
      'نعم. متجاوبة بالكامل: كمبيوتر، تابلت، وجوال.',
    'Can customers attach files in the chat?':
      'العملاء يرفقون ملفات في الدردشة؟',
    'Yes. Customers can upload images, PDFs, and other files directly in the chat. Agent 5 can view and reference them.':
      'نعم. صور، ملفات PDF، وغيرها — يرفعونها داخل الدردشة، والنظام يشوفها ويرجع لها في رده.',
    'How does handoff to human agents work?': 'كيف يتم التسليم للموظفين؟',
    'Agent 5 transfers the conversation to a human agent with full chat history. The customer stays in the same chat window.':
      'ينقل المحادثة لموظف بكامل تاريخ الدردشة. والعميل ما يتحرك من نفس النافذة.',
    'Can I trigger proactive messages?': 'أقدر أفعّل رسائل استباقية؟',
    'Yes. Set up triggers based on time on page, scroll depth, exit intent, or custom events to engage visitors at the right moment.':
      'نعم. محفزات على مدة البقاء في الصفحة، عمق التمرير، نية الخروج، أو أي حدث تحدده. تتفاعل مع الزائر باللحظة المناسبة.',
    'Email Support': 'دعم الإيميل',
    'powered by AI': 'بالـ AI',
    'Agent 5 handles your email support with your custom domain, attachment processing, and seamless handoffs. Customers email your address, AI responds instantly, humans can take over anytime.':
      'النظام يرد على الإيميلات من نطاقك الخاص، يقرأ المرفقات، ويحوّل لموظفيك عند الحاجة. العملاء يراسلون عنوانك، والنظام يرد فوراً.',
    'Email AI Features': 'مميزات الإيميل',
    'Turn your inbox into a competitive advantage':
      'صندوق الوارد يصبح نقطة قوة، لا عبئاً',
    'Your Brand, Not Ours': 'براندك، لا براندنا',
    "AI responds from your domain. Customers never know it's AI—just perfect, instant support from your company.":
      'يرد من نطاقك. العميل لا يعرف أنه AI — كل ما يراه دعم فوري ودقيق من شركتك.',
    'Reads Attachments Like a Human': 'يقرأ المرفقات مثل البشر',
    'Screenshots, PDFs, invoices—Agent 5 sees and understands them. Then references them in replies.':
      'لقطة شاشة، فاتورة، ملف PDF — يفتحها، يفهمها، ويرجع لها في رده.',
    'Respond in Minutes, Not Days': 'رد في دقائق، لا أيام',
    'While competitors keep customers waiting 24+ hours, you respond in minutes. Every time.':
      'منافسك يترك العميل ينتظر أكثر من ٢٤ ساعة. أنت ترد في دقائق. كل مرة.',
    'Invisible AI-to-Human Handoffs': 'تسليم للموظف ما يبان',
    'Same thread. No forwarding. No "transferring you". Customer never notices the switch.':
      'نفس السلسلة. ولا تحويل، ولا "نحوّلك للقسم المختص". العميل ما يحس بالتبديل.',
    'Every Past Email Remembered': 'يتذكر كل إيميل سابق',
    'Agent 5 recalls entire email history. Customers never repeat themselves.':
      'يرجع لتاريخ إيميلاتك مع العميل كامل. والعميل ما يعيد قصته من أولها.',
    'One Dashboard, All Your Inboxes': 'لوحة واحدة، كل صناديقك',
    'Support@, sales@, billing@—monitor everything. Smart routing to the right team, automatically.':
      'support@، sales@، billing@ — كلها في مكان واحد. والتوجيه للفريق الصحيح يتم تلقائياً.',
    'Email AI that works with your domain and existing email infrastructure':
      'يعمل على نطاقك وبنية بريدك الحالية',
    'Can I use my own email domain?': 'أقدر أستخدم نطاقي؟',
    'Yes. Agent 5 responds from your domain (like support@yourcompany.com). We handle all DNS setup including SPF, DKIM, and DMARC.':
      'نعم. يرد من نطاقك (مثل support@yourcompany.com)، وإحنا نتولى كل إعدادات DNS من SPF وDKIM وDMARC.',
    'Can Agent 5 read attachments?': 'النظام يقرأ المرفقات؟',
    'Yes. Agent 5 can read PDFs, images, documents, and other attachments, then reference them in responses to provide accurate help.':
      'نعم. يقرأ ملفات PDF والصور والمستندات وغيرها، ويرجع إليها في رده عشان تكون الإجابة دقيقة.',
    'How do email handoffs to human agents work?':
      'كيف يتم التسليم للموظف في الإيميل؟',
    'The same email thread continues. When a human takes over, they reply in the same conversation with full context. The customer never knows a handoff happened.':
      'تستمر السلسلة نفسها. ولمّا يتولى الموظف، يرد في المحادثة نفسها وبكامل السياق. والعميل لا يشعر أن شيئاً تغيّر.',
    'Can I have multiple support email addresses?':
      'أقدر أشغّل أكثر من إيميل دعم؟',
    'Yes. Monitor sales@, support@, billing@, and any other addresses. Route them to different teams or workflows from one dashboard.':
      'نعم. sales@، support@، billing@، وأي عنوان ثاني. وجّه كل واحد لفريق أو سير عمل مختلف من لوحة واحدة.',
    'What are temporary email addresses for?': 'وش فايدة الإيميلات المؤقتة؟',
    'Use them for testing, specific campaigns, or time-limited initiatives. Create disposable addresses that expire when you no longer need them.':
      'للاختبار، أو حملة معينة، أو مبادرة لها وقت محدد. تنشئ عنواناً يخدمك، وينتهي لمّا تنتهي منه.',
    'How fast does Agent 5 respond to emails?':
      'خلال كم يرد النظام على الإيميل؟',
    'Agent 5 responds within seconds of receiving an email. Your customers get instant replies instead of waiting hours or days.':
      'يرد خلال ثوانٍ من وصول الإيميل. وعميلك يلقى رده جاهز بدل ما ينتظر ساعات أو أيام.',
    'WhatsApp Support': 'دعم WhatsApp',
    'with AI': 'بالـ AI',
    'Agent 5 handles WhatsApp conversations with voice note support, image recognition, and typing indicators. Your customers get instant help on their preferred messaging app.':
      'نظام WhatsApp يتعامل مع المحادثات بدعم الرسائل الصوتية، فهم الصور، ومؤشرات الكتابة. عملاءك يحصلون مساعدة فورية.',
    'WhatsApp AI Features': 'مميزات WhatsApp',
    'Meet customers where they already are':
      'قابل عملاءك في المكان اللي هم فيه أصلاً',
    'Hears Voice Notes, Types Back Instantly':
      'يسمع الرسائل الصوتية ويرد كتابة فوراً',
    'Customers speak. AI transcribes, understands, and replies in text. Multi-language support included.':
      'العميل يرسل صوت. يحوّله نص، يفهمه، ويرد كتابة — وبلغات متعددة.',
    'Sees Screenshots & Photos': 'يشوف اللقطات والصور',
    'Customer sends error screenshot? Product photo? Invoice? Agent 5 sees it, reads it, solves it.':
      'لقطة شاشة لخطأ؟ صورة منتج؟ فاتورة؟ يشوفها، يقرأها، ويحل المشكلة.',
    'Support on Their Favorite App': 'دعم على تطبيقهم المفضل',
    '2 billion people use WhatsApp daily. Be available where your customers already spend their time.':
      '٢ مليار شخص يفتحون WhatsApp كل يوم. كن موجوداً في المكان نفسه اللي يقضون فيه وقتهم.',
    'Proactive Outreach That Converts': 'تواصل استباقي يجيب نتيجة',
    'Send order updates, abandoned cart reminders, and personalized offers. 98% open rates on WhatsApp.':
      'تحديثات طلبات، تذكير بالسلة المتروكة، وعروض على مقاس العميل. ومعدل فتح ٩٨٪ على WhatsApp.',
    'Never Lose Conversation Context': 'السياق ما يضيع أبداً',
    'Full message history saved forever. Customer returns weeks later? AI remembers everything.':
      'تاريخ الرسائل محفوظ دائماً. يعود العميل بعد أسابيع؟ يكمل معه من حيث توقف.',
    'Human Takeovers Without Disruption': 'دخول الموظف بدون قطع',
    'Agent jumps in mid-conversation? Customer stays in same chat. Zero friction, total continuity.':
      'موظف يدخل في نص المحادثة؟ العميل يبقى في نفس الدردشة. ولا احتكاك، ولا انقطاع.',
    'WhatsApp AI that connects to your existing support workflow seamlessly':
      'يندمج بسلاسة مع سير عمل الدعم الحالي عندك',
    'How do WhatsApp handoffs to human agents work?':
      'كيف يتم التسليم للموظف في WhatsApp؟',
    'Can Agent 5 understand voice notes?': 'النظام يفهم الرسائل الصوتية؟',
    'Yes. Agent 5 transcribes and understands voice notes in multiple languages, then responds appropriately.':
      'نعم. يحوّلها نص، يفهمها بلغات متعددة، ويرد عليها بالشكل المناسب.',
    'Can it see images customers send?': 'يشوف الصور اللي يرسلها العملاء؟',
    'Yes. Agent 5 analyzes images, reads text from screenshots, and understands visual context to provide accurate help.':
      'نعم. يحلل الصورة، ويقرأ النص اللي فيها، ويفهم السياق البصري عشان يجيب صح.',
    'Does it show typing indicators?': 'يعرض مؤشرات الكتابة؟',
    'Yes. Customers see "typing..." while Agent 5 prepares responses, making the conversation feel natural.':
      'نعم. العميل يشوف "يكتب..." وهو يجهز الرد، فالمحادثة تحس طبيعية.',
    'Can human agents see old WhatsApp messages?':
      'الموظفين يشوفون رسائل WhatsApp القديمة؟',
    'Yes. Inbox WhatsApp mode shows agents the complete message history, not just recent messages. Full context from all past conversations.':
      'نعم. وضع WhatsApp في Inbox يعرض للموظف تاريخ الرسائل الكامل، مو بس الأخيرة. سياق كامل من كل المحادثات السابقة.',
    'Can I send outbound WhatsApp messages?': 'أقدر أرسل رسائل WhatsApp صادرة؟',
    'Yes. Send proactive messages, notifications, and updates to customers. Automate outreach and broadcast to segments.':
      'نعم. رسائل استباقية، إشعارات، وتحديثات — مع أتمتة التواصل والبث لشرائح محددة.',
    'The same WhatsApp thread continues. Human agents see full history and reply directly. Customer stays in the same conversation.':
      'نفس السلسلة تكمل. الموظف يشوف التاريخ الكامل ويرد مباشرة، والعميل يبقى في نفس المحادثة.',
    'Social Media AI Support': 'دعم السوشيال ميديا بالـ AI',
    'on Instagram & Messenger': 'على Instagram وMessenger',
    'Agent 5 handles customer conversations on Instagram DMs and Facebook Messenger. Instant responses, rich media, and unified inbox for all your social support.':
      'نظام السوشيال يتعامل مع محادثات العملاء على Instagram وMessenger. ردود فورية، وسائط، وصندوق موحد لكل دعمك.',
    'Social Media AI Features': 'مميزات السوشيال ميديا',
    'Support customers where they discover you':
      'ادعم عملاءك في نفس المكان اللي اكتشفوك فيه',
    'Instagram DM Automation': 'أتمتة رسائل Instagram',
    'Agent 5 responds to Instagram Direct Messages instantly. Handles story mentions, comment replies, and customer inquiries without leaving Instagram.':
      'يرد على رسائل Instagram في نفس اللحظة. إشارات الستوري، ردود التعليقات، واستفسارات العملاء — كلها بدون ما تطلع من Instagram.',
    'Facebook Messenger Support': 'دعم Messenger',
    'Instant AI responses on Messenger. Handle support and inquiries automatically with rich media and quick reply buttons.':
      'ردود فورية على Messenger. يتولّى الدعم والاستفسارات تلقائياً، مع وسائط وأزرار رد سريع.',
    'Unified Social Inbox': 'صندوق سوشيال موحد',
    'See Instagram and Messenger messages in one place. Manage all social conversations from a single dashboard.':
      'رسائل Instagram وMessenger معاً، لا كل منصة على حدة. أدر الجميع من لوحة واحدة.',
    'Rich Visual Responses': 'ردود مرئية',
    'Send images, videos, GIFs, and carousels in replies. Show products, guides, or visual answers that engage.':
      'صور، فيديو، GIFs، وكاروسيل داخل الرد. اعرض المنتج أو الخطوات بدل ما تشرحها بالنص.',
    'Story & Comment Monitoring': 'مراقبة الستوري والتعليقات',
    'Agent 5 monitors post comments and responds automatically. Can send private message follow-ups for complex questions.':
      'يراقب تعليقات المنشورات ويرد عليها تلقائياً. والأسئلة المعقدة ينقلها لرسالة خاصة.',
    'Seamless Human Handoffs': 'تسليم سلس للموظفين',
    'Transfer conversations to agents without disruption. Same thread, full context, invisible to customers.':
      'انقل المحادثة للموظف بدون انقطاع. نفس السلسلة، سياق كامل، والعميل ما يلاحظ.',
    'Social AI that handles Instagram and Messenger without changing your setup':
      'يتعامل مع Instagram وMessenger بدون ما تغيّر إعداداتك',
    'How do social media handoffs to human agents work?':
      'كيف يتم التسليم للموظف في السوشيال؟',
    'Does Agent 5 work with Instagram DMs?': 'النظام يعمل مع رسائل Instagram؟',
    'Yes. Agent 5 responds to Instagram Direct Messages automatically, handling customer inquiries and support requests.':
      'نعم. يرد على رسائل Instagram تلقائياً، ويتعامل مع الاستفسارات وطلبات الدعم.',
    'Can it reply to Facebook Messenger?': 'يرد على Messenger؟',
    'Yes. Agent 5 handles Facebook Messenger conversations, page messages, and customer inquiries with instant AI responses.':
      'نعم. محادثات Messenger، رسائل الصفحة، واستفسارات العملاء — كلها بردود فورية.',
    'Can I see all social messages in one place?':
      'أقدر أشوف كل رسائل السوشيال في مكان واحد؟',
    'Yes. The unified inbox shows Instagram and Messenger conversations together. Manage all social support from one dashboard.':
      'نعم. الصندوق الموحد يجمع محادثات Instagram وMessenger مع بعض. كل دعم السوشيال من لوحة واحدة.',
    'Can Agent 5 respond to comments on posts?':
      'النظام يرد على تعليقات المنشورات؟',
    'Yes. Agent 5 can monitor post comments and respond automatically. It can also send private message follow-ups for complex questions.':
      'نعم. يراقب التعليقات ويرد عليها تلقائياً. والسؤال اللي يحتاج تفصيلاً، يكمّله برسالة خاصة.',
    'Can it send images and videos?': 'يرسل صور وفيديوهات؟',
    'Yes. Agent 5 can send images, videos, GIFs, and product carousels (on Messenger) to provide visual answers and support.':
      'نعم. صور، فيديوهات، GIFs، وكاروسيل منتجات (على Messenger) — عشان يكون الجواب مرئياً.',
    'The same conversation thread continues. Human agents see full history and can reply directly in Instagram or Messenger.':
      'نفس السلسلة تكمل. الموظف يشوف التاريخ الكامل ويرد مباشرة من Instagram أو Messenger.',
    'Internal Knowledge': 'معرفة الفريق',
    'amplified with AI': 'معززة بالـ AI',
    'Agent 5 in Slack helps your team find answers instantly. @mention it in any channel, invite it to your workspace, or DM it privately. Your company knowledge, amplified.':
      'النظام في Slack يساعد فريقك يلاقي إجابات فوراً. @اذكره في أي قناة، ادعِه لمساحة عملك، أو راسله خاص. معرفة شركتك معززة.',
    'Slack AI Features': 'مميزات Slack',
    "Your team's AI-powered knowledge assistant":
      'مساعد المعرفة لفريقك، داخل Slack',
    'Just @mention for Instant Answers': 'منشنه، وتجيك الإجابة',
    '@mention Agent 5 anywhere in Slack. Instant answers from your knowledge base, docs, and past conversations.':
      'منشنه بـ @ في أي مكان في Slack. الجواب يجي من قاعدة معرفتك ومستنداتك ومحادثاتكم السابقة.',
    'Private DMs for Sensitive Questions': 'رسائل خاصة للأسئلة الحساسة',
    'Team members can ask confidential questions via direct message. No public channel needed.':
      'أي أحد بالفريق يسأل سؤال سري برسالة خاصة. بدون قناة عامة.',
    'Learns Your Company Knowledge': 'يتعلم معرفة شركتك',
    'Agent 5 indexes your docs, past Slack conversations, and team knowledge. Gets smarter with every interaction.':
      'يفهرس مستنداتك، ومحادثات Slack السابقة، ومعرفة الفريق. ويصير أذكى مع كل سؤال.',
    'Works in Every Channel & Thread': 'يعمل في كل قناة وموضوع',
    'Invite Agent 5 to any public or private channel. Works in threads without cluttering the main conversation.':
      'ادعِه لأي قناة، عامة أو خاصة. ويشتغل داخل المواضيع بدون ما يزحم المحادثة الرئيسية.',
    'Automated Alerts & Updates': 'تنبيهات وتحديثات تلقائية',
    'Schedule messages, set up triggers, broadcast announcements. All automated, zero manual work.':
      'جدول رسائل، اضبط محفزات، وبث إعلانات. كله تلقائي، وبدون شغل يدوي.',
    'Every Team Member Gets an AI Assistant': 'كل واحد بالفريق عنده مساعد ذكي',
    'Personal AI help for everyone on your team. No more waiting for responses or searching through docs.':
      'مساعد شخصي لكل واحد في الفريق. ولا انتظار رد، ولا تفتيش في المستندات.',
    "Slack AI that amplifies your team's knowledge without disrupting their workflow":
      'يعزز معرفة فريقك بدون ما يعطّل سير عملهم',
    'Find answers to common questions about Slack integration.':
      'أكثر الأسئلة اللي تجينا عن Slack.',
    'How do team members ask Agent 5 questions?': 'كيف يسأله الفريق؟',
    '@mention Agent 5 in any channel or message thread. Type your question and get an instant answer.':
      'منشنه بـ @ في أي قناة أو موضوع، اكتب سؤالك، والجواب يجي فوراً.',
    'Can I add Agent 5 to multiple channels?':
      'أقدر أضيف النظام لقنوات متعددة؟',
    'Yes. Invite Agent 5 to any number of public or private channels. Each team can have AI assistance in their workspace.':
      'نعم. ادعِه لأي عدد من القنوات، عامة أو خاصة. ويصبح عند كل فريق مساعد ذكي في مساحته.',
    'Can Agent 5 send automated messages?': 'النظام يرسل رسائل تلقائية؟',
    'Yes. Schedule messages, set up triggers, and broadcast updates to channels automatically.':
      'نعم. جدول رسائل، اضبط محفزات، وبث تحديثات للقنوات تلقائياً.',
    'Where does Agent 5 get its knowledge from?': 'من وين النظام يجيب معرفته؟',
    'Agent 5 learns from your company documentation, past Slack conversations, and team knowledge. It improves as your team uses it.':
      'يتعلم من توثيق شركتك، ومحادثات Slack السابقة، ومعرفة الفريق. ويتحسن كل ما استخدمه فريقك أكثر.',
    'Can I DM Agent 5 privately?': 'أقدر أراسل النظام خاص؟',
    'Yes. Send private direct messages to Agent 5 for confidential questions without asking in public channels.':
      'نعم. راسله خاص بالأسئلة السرية، بدون ما تطرحها في قناة عامة.',
    'Does it work in message threads?': 'يعمل داخل المواضيع؟',
    'Yes. @mention Agent 5 in any thread to get contextual answers without cluttering the main channel.':
      'نعم. منشنه داخل أي موضوع، ويجاوب في سياقه بدون ما يزحم القناة الرئيسية.',
  },
  customerStories: {
    'Success Stories': 'قصص النجاح',
    'Real results from real customers': 'نتائج حقيقية من عملاء حقيقيين',
    'Companies using Agent 5 to automate customer communication without compromising quality. No fluff. Just numbers.':
      'شركات أتمتت تواصلها مع عملائها بدون ما تتنازل عن الجودة. بلا كلام فارغ. أرقام بس.',
    'Read Story': 'اقرأ القصة',
    'How OTO achieved 90%+ CSAT with AI-first support':
      'كيف حققت OTO رضا عملاء فوق ٩٠٪ بدعم يبدأ بالـ AI',
    'How Mollie scales support for 250,000+ businesses':
      'كيف وسّعت Mollie دعمها لـ+٢٥٠ ألف شركة',
    'How TicketSwap serves 19 million users':
      'كيف تخدم TicketSwap ١٩ مليون مستخدم',
    'How MoneyGram supports 55M customers globally':
      'كيف تدعم MoneyGram ٥٥ مليون عميل حول العالم',
    'How Trunkrs maintains 4.8/5 rating with AI support':
      'كيف حافظت Trunkrs على تقييم ٤,٨/٥ بدعم ذكي',
    'How Trunkrs automates 80% of delivery support with 4.8/5 rating':
      'كيف أتمتت Trunkrs ٨٠٪ من دعم التوصيل بتقييم ٤,٨/٥',
    'How More.com sold 30M tickets across Europe':
      'كيف باعت More.com ٣٠ مليون تذكرة في أوروبا',
    'How FareHarbor powers 20K+ tour operators':
      'كيف تشغّل FareHarbor +٢٠ ألف مشغل سياحي',
    'How OCN automates car subscriptions in Mexico':
      'كيف أتمتت OCN اشتراكات السيارات في المكسيك',
    'CSAT score': 'رضا العملاء',
    automation: 'أتمتة',
    'company value': 'قيمة الشركة',
    users: 'مستخدم',
    customers: 'عميل',
    Businesses: 'شركة',
    Reviews: 'تقييم',
    'Google rating': 'تقييم قوقل',
    '60K+ reviews': '+٦٠ ألف تقييم',
    'tickets sold': 'تذكرة مباعة',
    operators: 'مشغل',
    'in MENA': 'في الشرق الأوسط',
    vehicles: 'مركبة',
    rating: 'تقييم',
    actions: 'إجراء',
    '40,000+ items covered': '+٤٠ ألف منتج',
    'Driver network': 'شبكة السائقين',
    '6,000+ supported': '+٦ آلاف سائق',
    Coverage: 'التغطية',
    '24/7 in Dutch': '٢٤/٧ بالهولندي',
    'All case studies': 'كل دراسات الحالة',
    'What we did': 'وش عملنا',
    'Automation rate': 'معدل الأتمتة',
    Company: 'الشركة',
    'Company size': 'حجم الشركة',
    Industry: 'المجال',
    Location: 'الموقع',
    Markets: 'الأسواق',
    'Market Position': 'المركز في السوق',
    'Parent Company': 'الشركة الأم',
    'Global Reach': 'الانتشار العالمي',
    Specialization: 'التخصص',
    Website: 'الموقع الإلكتروني',
    'Key Results': 'النتائج الرئيسية',
    Source: 'المصدر',
    'OTO is automating more than 77% of the support with +90% CSAT score':
      'OTO تؤتمت +٧٧٪ من الدعم ورضا العملاء فوق ٩٠٪',
    'How OTO is Automating 77% of Support with Open':
      'كيف أتمتت OTO ٧٧٪ من دعمها مع Open',
    'OTO achieved 90%+ CSAT while automating 77% of their customer support with Open AI.':
      'أتمتت OTO ٧٧٪ من دعم عملائها مع Open، ورضا العملاء فوق ٩٠٪.',
    'OTO Success Story - Open': 'قصة نجاح OTO - Open',
    'How OTO is automating 77% of support with 90%+ CSAT score using Open.':
      'كيف أتمتت OTO ٧٧٪ من الدعم ورضا العملاء فوق ٩٠٪ مع Open.',
    "Open's AI agent handles customer inquiries fully autonomously. Customers get instant answers while the support team focuses on what actually needs human judgment.":
      'نظام Open يتكفّل باستفسارات العملاء بنفسه بالكامل. التاجر يحصل على جوابه في ثوانٍ، وفريق الدعم يتفرغ للحالات اللي تحتاج حكماً بشرياً.',
    'Logistics / Technology': 'لوجستيات / تقنية',
    'Middle East': 'الشرق الأوسط',
    '• 77% automation rate': '• معدل أتمتة ٧٧٪',
    '• 90%+ CSAT score': '• رضا عملاء +٩٠٪',
    '• AI-first operating model': '• نموذج تشغيل يبدأ بالـ AI',
    'About OTO': 'عن OTO',
    'OTO is a logistics technology platform that helps e-commerce businesses across Saudi Arabia, UAE, and Turkey manage their entire shipping operations. The platform connects merchants with over 350 carriers and 30+ sales channels, handling everything from order management and tracking to returns and analytics.':
      'OTO منصة تقنية لوجستية تدير عمليات الشحن كاملة للمتاجر الإلكترونية في السعودية والإمارات وتركيا. تربط التاجر بـ+٣٥٠ شركة شحن و+٣٠ قناة بيع، وتغطي كل شيء: إدارة الطلبات، والتتبع، والمرتجعات، والتحليلات.',
    'Founded in 2019 by Mohamed Razaz, OTO has grown rapidly and raised $8M in Series A funding in 2024. With thousands of merchants relying on the platform daily, support volume was becoming a challenge.':
      'أسسها محمد الرزاز في ٢٠١٩، ونمت بسرعة وجمعت ٨ ملايين دولار في جولة Series A سنة ٢٠٢٤. آلاف التجار يعتمدون على المنصة كل يوم. وأصبح حجم الدعم تحدياً.',
    'The Support Challenge': 'تحدي الدعم',
    'When you power shipping for thousands of e-commerce businesses, support requests pile up fast. Merchants constantly need help with:':
      'لمّا تشغّل الشحن لآلاف المتاجر الإلكترونية، تتراكم طلبات الدعم بسرعة. والتجار يحتاجون دائماً مساعدة في:',
    'Tracking inquiries': 'استفسارات التتبع',
    '"Where is my shipment?" is the most common question in logistics':
      '"وين شحنتي؟" أشهر سؤال في اللوجستيات',
    'Shipping rate questions': 'أسئلة أسعار الشحن',
    'Merchants comparing rates across 350+ carriers':
      'تجار يقارنون الأسعار بين +٣٥٠ شركة شحن',
    'Return and refund requests': 'طلبات المرتجعات والاسترداد',
    'Managing reverse logistics across multiple carriers':
      'إدارة اللوجستيات العكسية عبر شركات شحن متعددة',
    'Integration troubleshooting': 'حل مشاكل الربط',
    'Connecting sales channels and carrier APIs':
      'ربط قنوات البيع بواجهات API لشركات الشحن',
    'Billing and invoice questions': 'أسئلة الفوترة والفواتير',
    'Understanding charges across different carriers':
      'فهم الرسوم بين شركات الشحن المختلفة',
    "Most of these questions are repetitive but time-sensitive. A merchant waiting for shipping help can't fulfill orders. The support team was spending most of their time on routine inquiries instead of helping merchants with complex operational challenges.":
      'أغلب هذه الأسئلة متكررة، بس ما تنتظر. فالتاجر اللي ينتظر جواباً عن شحنة ما ينفّذ طلباته. وفريق الدعم كان يستهلك وقته في الروتين بدل مساعدة التجار في تحدياتهم التشغيلية.',
    'How Open Helps': 'كيف يساعد Open',
    "OTO deployed Open's AI agent to handle the high-volume, routine support requests. The AI connects directly to OTO's systems and can:":
      'OTO شغّلت نظام Open الذكي على الطلبات الروتينية عالية الحجم. النظام متصل مباشرة بأنظمة OTO، ويسوي:',
    'Pull real-time tracking information from any carrier':
      'يجيب معلومات التتبع اللحظية من أي شركة شحن',
    'Compare shipping rates and recommend the best options':
      'يقارن أسعار الشحن ويوصي بأفضل خيار',
    'Process return requests and generate return labels':
      'يعالج المرتجعات ويطلّع ملصقات الإرجاع',
    'Guide merchants through integration setup':
      'يمشّي التاجر خطوة خطوة في إعداد الربط',
    'Answer billing questions with accurate invoice data':
      'يجاوب أسئلة الفوترة من الفاتورة نفسها',
    'We wanted AI to handle the routine so our team could focus on helping merchants grow their businesses. Not the other way around.':
      'بغينا الـ AI ياخذ الروتين عشان فريقنا يركّز على مساعدة التجار ينمّون تجارتهم. مو العكس.',
    'Mohamed Razaz, CEO at OTO': 'محمد الرزاز، الرئيس التنفيذي في OTO',
    'The Results': 'النتائج',
    'After implementing Open, OTO achieved:': 'بعد Open، حققت OTO:',
    Metric: 'المقياس',
    Impact: 'الأثر',
    'Support coverage': 'تغطية الدعم',
    'Channels covered': 'القنوات المغطاة',
    '24/7 in 8 languages': '٢٤/٧ بـ٨ لغات',
    'Under 30 seconds': 'أقل من ٣٠ ثانية',
    'Email and chat': 'الإيميل والدردشة',
    Result: 'النتيجة',
    '77% of inquiries handled by AI': '٧٧٪ من الاستفسارات يحلّها الـ AI',
    'Customer satisfaction': 'رضا العملاء',
    '90%+ CSAT maintained': 'رضا العملاء ثابت فوق ٩٠٪',
    'Response time': 'وقت الرد',
    'Instant for automated queries': 'فوري للاستفسارات المؤتمتة',
    'Team focus': 'تركيز الفريق',
    'Complex merchant issues only': 'بس مشاكل التجار المعقدة',
    'The 90%+ CSAT score is significant. It shows that merchants are happy with AI-powered support when it actually solves their problems instead of deflecting them to a queue.':
      'رضا فوق ٩٠٪ رقم مهم. فهو يعني أن التجار راضون عن الـ AI لمّا يحل مشكلتهم فعلاً، مو لمّا يحوّلهم لطابور انتظار.',
    'What Made It Work': 'وش اللي خلاها تنجح',
    "Three things made OTO's AI implementation successful:":
      'ثلاثة أشياء خلّت التطبيق ينجح عند OTO:',
    '1. Deep integration.': '١. ربط عميق.',
    "The AI connects to OTO's shipping data, carrier APIs, and billing systems. It doesn't just answer questions - it takes actions and provides real information.":
      'النظام متصل ببيانات شحن OTO وAPIs شركات الشحن وأنظمة الفوترة. لا يجيب فحسب — بل ينفّذ ويعود بمعلومة حقيقية.',
    '2. Clear escalation paths.': '٢. مسارات تصعيد واضحة.',
    'Complex issues like carrier disputes or custom integrations go straight to humans. The AI knows its limits.':
      'الحالات المعقدة مثل نزاعات شركات الشحن أو الربط المخصص تروح مباشرة للبشر. النظام يعرف حدوده.',
    '3. Continuous training.': '٣. تدريب مستمر.',
    "OTO's team regularly reviews AI conversations and updates the knowledge base. The system gets smarter over time.":
      'فريق OTO يراجع المحادثات بانتظام ويحدّث قاعدة المعرفة. ويصبح النظام أذكى مع الوقت.',
    'Looking Ahead': 'نظرة للمستقبل',
    'OTO is expanding to new markets and adding more carriers. With AI handling routine support, they can scale without proportionally growing the support team. The human agents focus on what they do best: helping merchants solve complex logistics challenges and grow their businesses.':
      'OTO تتوسع لأسواق جديدة وتضيف شركات شحن أكثر. وأصبح الدعم الروتيني على الـ AI، فتنمو بدون ما ينمو الفريق بنفس النسبة. والموظفون يركزون على اللي يجيدونه: حل تحديات لوجستية معقدة مع التجار، ومساعدتهم على النمو.',
    'OTO is a logistics technology platform connecting e-commerce businesses with 350+ carriers across Saudi Arabia, UAE, and Turkey.':
      'OTO منصة تقنية لوجستية تربط المتاجر الإلكترونية بـ+٣٥٠ شركة شحن في السعودية والإمارات وتركيا.',
    'How OCN automates time-sensitive car subscriptions across Mexico':
      'كيف أتمتت OCN ٦٠٪ من دعم اشتراكات السيارات العاجلة في المكسيك',
    "Open's AI handles complex, time-sensitive workflows across email, WhatsApp, and web chat—from credit approvals to vehicle delivery coordination—at scale.":
      'نظام Open يمشّي عمليات عاجلة ومعقدة عبر الإيميل وWhatsApp والدردشة: من موافقة التمويل حتى تنسيق تسليم السيارة.',
    'Vehicles deployed': 'سيارة في الخدمة',
    'Avg response time': 'متوسط الرد',
    'Fintech / Mobility': 'فنتك / تنقل',
    Mexico: 'المكسيك',
    'OneCar Now (OCN) is a Mexico-based fintech offering 100% online car subscriptions for gig economy workers, backed by $86M in Series A funding.':
      'OCN شركة فنتك مكسيكية تقدم اشتراكات سيارات عبر الإنترنت بالكامل لسائقي تطبيقات النقل، مدعومة بجولة Series A بـ٨٦ مليون دولار.',
    '• 60% automation rate': '• معدل أتمتة ٦٠٪',
    '• 90min average response time': '• متوسط رد ٩٠ دقيقة',
    '• 7,500 EVs managed at scale': '• إدارة ٧٥٠٠ سيارة كهربائية',
    '• Multi-channel automation (email, WhatsApp, web)':
      '• أتمتة متعددة القنوات (إيميل، WhatsApp، ويب)',
    ocn_intro:
      'OCN تغيّر الطريقة اللي يوصل بها سائق تطبيقات النقل لسيارته. جمعت ٨٦ مليون دولار، وخطتها نشر ٧٥٠٠ سيارة كهربائية. والتحدي؟ آلاف الطلبات العاجلة كل يوم، عبر قنوات مختلفة.',
    ocn_challenge_title: 'التحدي: طلبات كثيرة وعاجلة',
    ocn_challenge_p1:
      'اشتراك السيارات في OCN كله عبر الإنترنت — لا معارض ولا انتظار. السائق يقدّم، ويحصل على الموافقة، ويستلم سيارته في ٩٠ دقيقة. بس هذه السرعة تجلب تعقيداً:',
    'Document verification': 'التحقق من الأوراق',
    'that needs instant processing': 'يحتاج معالجة فورية',
    'Credit approvals': 'موافقات التمويل',
    'with strict time windows': 'بنوافذ زمنية ضيقة',
    'Vehicle delivery coordination': 'تنسيق توصيل السيارات',
    'across Mexico': 'في كل المكسيك',
    'Multi-channel support': 'دعم على كل القنوات',
    'via email, WhatsApp, and web chat': 'إيميل، WhatsApp، ودردشة',
    'Maintenance scheduling': 'حجز الصيانة',
    'for thousands of vehicles': 'لآلاف السيارات',
    ocn_challenge_p2:
      'كل طلب عاجل. وتأخر الرد يعني السائق يخسر دخل يومه، أو يروح للمنافس.',
    ocn_solution_title: 'الحل: AI ينفّذ، مو بس يرد',
    ocn_solution_p1:
      'OCN تعاونت مع Open وبنت نظاماً لا يرد فحسب — بل ينفّذ. وهذا ما يقوم به:',
    Channel: 'القناة',
    'Automated Actions': 'الإجراءات',
    Email: 'إيميل',
    WhatsApp: 'WhatsApp',
    'Document verification, application status updates':
      'يتحقق من الأوراق، يحدّث حالة الطلب',
    'Delivery scheduling, payment confirmations': 'يجدول التسليم، يأكد الدفع',
    'Web Chat': 'الدردشة',
    'Real-time application support, troubleshooting':
      'يساعد في الطلب لحظياً، يحل المشاكل',
    ocn_results_title: 'النتائج: ٦٠٪ أتمتة ورد في ٩٠ دقيقة',
    ocn_results_p1: 'بعد Open، الدعم تغير:',
    '60% of inquiries fully automated': '٦٠٪ من الطلبات تنحل آلياً',
    'across all channels': 'على كل القنوات',
    '90-minute average response time': '٩٠ دقيقة متوسط الرد',
    'down from several hours': 'بدل ساعات',
    '7,500 vehicles managed': '٧٥٠٠ سيارة تحت الإدارة',
    'with the same support team size': 'بنفس حجم الفريق',
    'Complex workflows automated': 'عمليات معقدة تنفّذ آلياً',
    'credit checks, delivery coordination, document processing':
      'فحص التمويل، تنسيق التوصيل، معالجة الأوراق',
    ocn_results_p2:
      'رضا العملاء بقي عالي مع إن الأتمتة زادت. السائقين يحبون الرد السريع والتوفّر طول الوقت.',
    ocn_why_title: 'ليش يفرق إن الـ AI ينفّذ؟',
    ocn_why_p1: 'أي بوت يقدر يجاوب "وش حالة طلبي؟". بس OCN احتاجت AI يقوم بـ:',
    "Process uploaded driver's licenses and insurance":
      'يعالج الرخص ووثائق التأمين المرفوعة',
    'Update credit approval status in real-time':
      'يحدّث حالة الموافقة على التمويل لحظياً',
    'Schedule vehicle pickups across different cities':
      'يجدول استلام السيارات في مدن مختلفة',
    'Send payment reminders via WhatsApp': 'يرسل تذكيرات الدفع بWhatsApp',
    'Coordinate maintenance appointments': 'ينسق مواعيد الصيانة',
    ocn_why_p2:
      'هذه مو أتمتة أسئلة شائعة. بل أتمتة عمليات كاملة، متصلة بأنظمة OCN، تنفّذ إجراءات حقيقية.',
    ocn_scaling_title: 'التوسع لـ٧٥٠٠ سيارة وأكثر',
    ocn_scaling_p1:
      'خطة OCN لنشر ٧٥٠٠ سيارة كهربائية ما كانت تنجح بدون دعم يتوسع معها. والبنية اللي بنتها مع Open تعطيها ميزة كلما دخلت سوقاً جديداً.',
    ocn_scaling_p2:
      'المنافسون يوظفون فرق دعم أكبر كلما نموا. أما OCN؟ فالدعم يتوسع تلقائياً. الـ AI يتولى العمل الروتيني، والبشر يركزون على الحالات الصعبة وبناء العلاقات.',
    ocn_future_title: 'المستقبل: تشغيل مبني على الـ AI',
    ocn_future_p1:
      'نجاح OCN مع Open بس البداية. فهي الآن تستكشف الـ AI في إدارة الأسطول، والصيانة الاستباقية، والاحتفاظ بالعملاء.',
    ocn_future_p2:
      'للشركات اللي تريد التوسع بدون ما تستنزف ميزانياتها على فرق الدعم، OCN مثال واضح: أتمت العمل العاجل والمتكرر، واترك للبشر العمل اللي يحتاج تفكيراً.',
    'How Mollie supports 250,000+ businesses across Europe':
      'كيف تدعم Mollie +٢٥٠ ألف شركة في أوروبا',
    'In 8 languages': 'بـ٨ لغات',
    'Businesses served': 'شركة',
    "Open's AI agent handles 60%+ of support volume across email and chat. Merchants get instant answers in their language. Complex issues escalate with full context.":
      'نظام Open يحل ٧٠٪ من الدعم عبر الإيميل والدردشة. التاجر يحصل على جوابه بلغته، فوراً. والمعقّد ينتقل للفريق مع كل السياق.',
    "Open's AI agent handles 70%+ of support volume across email and chat. Merchants get instant answers in their language. Complex issues escalate with full context.":
      'نظام Open يحل +٧٠٪ من الدعم عبر الإيميل والدردشة. التاجر يحصل على جوابه بلغته، فوراً. والمعقّد ينتقل للفريق مع كل السياق.',
    'Financial Services / Payments': 'الخدمات المالية / المدفوعات',
    'Amsterdam, Netherlands': 'أمستردام، هولندا',
    '500+ employees': '+٥٠٠ موظف',
    '1000+ employees': '+١٠٠٠ موظف',
    '• 70%+ automation rate': '• معدل أتمتة ٨٠٪',
    '• 70% automation rate (cookinglife)': '• معدل أتمتة ٧٠٪',
    '• 60%+ automation rate': '• معدل أتمتة ٧٠٪',
    '• 24/7 support in 8 languages': '• دعم على مدار الساعة بـ٨ لغات',
    '• Sub-30 second response time': '• رد بأقل من ٣٠ ثانية',
    '• All channels covered': '• تغطية كل القنوات',
    '• Email and chat covered': '• تغطية الإيميل والدردشة',
    '• Email, phone, and chat covered': '• تغطية الإيميل والهاتف والدردشة',
    'Email, phone, and chat': 'الإيميل والهاتف والدردشة',
    '• 85% automation rate': '• معدل أتمتة ٨٥٪',
    mollie_intro:
      'Mollie تعالج مليارات المدفوعات سنوياً لـ+٢٥٠ ألف شركة في أوروبا. كل عملية دفع مهمة. وكل سؤال يحتاج جواباً. وكل مشكلة تحتاج حلاً، بسرعة.',
    mollie_scale_title: 'دعم على مستوى أوروبا',
    mollie_scale_p1:
      'Mollie تخدم +٢٥٠ ألف شركة في أوروبا وبريطانيا، وتدعمهم بعدة لغات. والتاجر يتوقع رد سريع ودقيق، سواء كان يسأل عن حالة عملية دفع ولا يصارع ربط API معقد.',
    mollie_scale_p2:
      'التحدي عند Mollie مو بس الكمية. فدعم المدفوعات يحتاج معرفة عميقة بالتكاملات التقنية ومتطلبات الامتثال واللوائح المالية. وتعقيد بهذا المستوى ما يكفيه بوت أسئلة شائعة.',
    mollie_what_open_does: 'وش يعمله Open',
    mollie_open_p1:
      'اليوم، Open يحل ٧٠٪ من دعم Mollie عبر الإيميل والدردشة. ويجاوب بالهولندي والإنجليزي والألماني والفرنسي والإسباني والإيطالي والبرتغالي والبولندي.',
    mollie_open_p2:
      'النظام يتعامل مع حالة العمليات، وطلبات الاسترداد، والتحقق من الحسابات، والمدفوعات الفاشلة، وأسئلة التكامل. ولمّا يحتاج الموضوع حكماً بشرياً أو يخرج عن معرفته، يحوّله للفريق مع كل السياق.',
    mollie_open_p3:
      'التاجر يحصل رده في ثواني، أي وقت، بلغته. والفريق يركز على المشاكل المعقدة وتحسين المنتج من ملاحظات الدعم.',
    mollie_results_intro: 'اليوم، Open يشغل غالبية دعم عملاء Mollie:',
    mollie_results_p1:
      'دور فريق الدعم تغيّر: من الرد على أسئلة متكررة، إلى حل مشاكل التجار المعقدة، وكتابة توثيق أحسن، وتحسين مسارات المنتج من ملاحظات الدعم.',
    mollie_impact_title: 'الأثر',
    mollie_impact_p1:
      '٧٠٪ أتمتة عبر الإيميل والدردشة تتيح لـMollie توسيع الدعم بدون ما يكبر الفريق بنفس النسبة. وتغطية ٢٤/٧ بـ٨ لغات تعني أن التاجر يحصل على مساعدته وقت حاجته إليها، مهما كانت منطقته الزمنية أو لغته.',
    mollie_impact_p2:
      'تطوّر فريق الدعم. فبدل الرد على "وين فلوسي؟" للمرة الألف، يحلون مشاكل التجار المعقدة، ويحسّنون التوثيق، ويعملون مع فرق المنتج على أصل المشكلة.',
    mollie_impact_p3:
      'بالنسبة للتجار، الدعم يعمل ببساطة. الأسئلة تُجاب. والمشاكل تنحل. بلغتهم. في أي وقت. وهذا ما يهم.',
    mollie_company_description:
      'Mollie شركة تقنية مالية بقيمة ٦,٥ مليار يورو، تقدم حلول دفع لـ+٢٥٠ ألف شركة في أوروبا وبريطانيا.',
    'Mollie Success Story - Open': 'قصة نجاح Mollie - Open',
    'How Mollie scales payment support for 250,000+ businesses with 60%+ automation.':
      'كيف وسّعت Mollie دعم المدفوعات لـ+٢٥٠ ألف شركة بأتمتة ٧٠٪.',
    'How TicketSwap mediates 19M users with all-time high CSAT':
      'كيف توسّطت TicketSwap بين ١٩ مليون مستخدم وسجّلت أعلى رضا في تاريخها',
    'How TicketSwap automated 67% of 19 million user support operations':
      'كيف أتمتت TicketSwap ٧٨٪ من دعم ١٩ مليون مستخدم',
    "Open's AI agent investigates buyer and seller disputes, takes fair action, and resolves issues in under 30 seconds. Handles 10x volume spikes during events automatically.":
      'نظام Open يحقق في نزاع المشتري والبائع، ياخذ الإجراء العادل، ويقفل الحالة في أقل من ٣٠ ثانية. وطفرات الفعاليات اللي تصل إلى ١٠ أضعاف؟ يستوعبها بمفرده.',
    'Events & Ticketing': 'الفعاليات والتذاكر',
    '• All-time high CSAT score': '• أعلى رضا عملاء في تاريخها',
    '• 19 million users served': '• ١٩ مليون مستخدم',
    '• 67.7% automation rate': '• معدل أتمتة ٧٨٪',
    ticketswap_intro:
      'TicketSwap تربط ١٩ مليون مستخدم في أوروبا لإعادة بيع التذاكر بأمان. والمعاملات هنا ما تنتظر: المشتري غالباً يحتاج حل لمشكلة تذكرته وهو واقف على باب الحفلة.',
    ticketswap_marketplace_title: 'تحدي السوق ذو الطرفين',
    ticketswap_marketplace_p1:
      'TicketSwap سوق ذو طرفين، يتوسط بين المشتري والبائع في كل معاملة. ولمّا يبلّغ مشترٍ عن تذكرة مفقودة، لا بد أن يحقق أحد مع الطرفين، ويتأكد مما حدث، ويتخذ الإجراء المناسب — وغالباً بأقل من ساعة على الفعالية.',
    ticketswap_marketplace_p2:
      'المشاكل تتنوع: تذكرة عالقة في السبام، تحويل ناقص، دفعة محتجزة، أو احتيال محتمل. وكل حالة لها مسار مختلف — إعادة إرسال التذكرة، التحقق من الدفع، معالجة الاسترداد، أو رفع الحظر عن حساب.',
    ticketswap_marketplace_p3:
      'والوقت يزيد التعقيد. مرتجع التجارة الإلكترونية يقدر ينتظر أيام؛ الحفلة تبدأ في وقتها، انحلّت المشكلة أو ما انحلّت.',
    ticketswap_marketplace_p4:
      'والفعاليات الكبيرة تولّد طفرات ترفع الاستفسارات ١٠ أضعاف في ساعات. والفريق التقليدي، في هذه الذروة، يخسر إما السرعة أو الجودة.',
    ticketswap_solution_title: 'كيف يساعد Open',
    ticketswap_solution_p1:
      'نظام Open يحقق مع الطرفين بنفسه. ولمّا يقول مشترٍ إن تذكرته مفقودة، يفحص سجل تحويلات البائع، وسجلات تسليم الإيميل، وحالة المعاملة — عشان يعرف ما حدث فعلاً.',
    ticketswap_solution_p2:
      'وبناءً على التحقيق، يتخذ الإجراء: يعيد إرسال التذاكر العالقة في السبام، وينبّه البائع لإكمال التحويل، ويعالج الاسترداد عند اللزوم، أو يصعّد النشاط المشبوه لمراجعة بشرية.',
    ticketswap_solution_p3:
      'نزاعات الدفع تتبع النمط نفسه. يتحقق مع مزود الدفع، ويحدد وين المبلغ محتجز، ويشرح الوقت المتوقع للطرفين — أو يبدأ الحل فوراً.',
    ticketswap_solution_p4:
      'يعمل ٢٤/٧ عبر الإيميل والدردشة، ويستقبل الطفرات تلقائياً بنفس سرعة الرد ونفس جودة الحل.',
    ticketswap_results_intro:
      'Open الآن يتعامل مع غالبية دعم عملاء TicketSwap:',
    'All-time high': 'أعلى مستوى',
    ticketswap_results_p1:
      'أعلى رضا في تاريخ المنصة يعكس سرعة الحل. فلمّا يستلم المعجب تذكرته في ثوانٍ بدل الوقوف في طابور، يرتفع الرضا. والإجراء الفوري — إعادة إرسال التذكرة أو معالجة الاسترداد — يعطي نتيجة أفضل من شرح خطوات ينفّذها العميل بنفسه.',
    ticketswap_impact_title: 'الأثر',
    ticketswap_impact_p1:
      '٧٨٪ أتمتة عبر الإيميل والدردشة تتيح لـTicketSwap استيعاب طفرات الفعاليات بدون ما يكبر الفريق بنفس النسبة. ولمّا يُفتح حجز مهرجان كبير أو يصدر إعلان حفلة، يتوسع النظام بمفرده.',
    ticketswap_impact_p2:
      'وفريق الدعم الآن يركز على منع الاحتيال، وحل مشاكل الحسابات المعقدة، وتحسين المنصة بناءً على الأنماط اللي تظهر من بيانات الدعم.',
    ticketswap_impact_p3:
      'للمستخدم، التجربة واضحة: بلّغ، استلم التحقيق والحل في ثوانٍ، وادخل الحفلة. هذه الموثوقية هي اللي رفعت الرضا لأعلى مستوى في تاريخ المنصة.',
    ticketswap_company_description:
      'TicketSwap منصة موثوقة لشراء وبيع تذاكر الفعاليات، تخدم ١٩ مليون مستخدم في أوروبا.',
    'TicketSwap Success Story - Open': 'قصة نجاح TicketSwap - Open',
    'How TicketSwap serves 19 million users with 67.7% automated support.':
      'كيف تخدم TicketSwap ١٩ مليون مستخدم بأتمتة ٧٨٪.',
    'How MoneyGram supports 55M customers across 200+ countries':
      'كيف تدعم MoneyGram ٥٥ مليون عميل في +٢٠٠ دولة',
    "Open's AI agent handles 70%+ of support across email and chat for 200+ countries in multiple languages. Customers get instant answers about transfers, payments, and compliance, 24/7.":
      'نظام Open يحل ٨٠٪ من الدعم عبر الإيميل والهاتف والدردشة، في +٢٠٠ دولة وبلغات متعددة. سؤال عن حوالة أو دفعة أو متطلب تنظيمي؟ الجواب فوري، أي ساعة.',
    'Financial Services / Remittance': 'الخدمات المالية / الحوالات',
    '200+ countries and territories': '+٢٠٠ دولة ومنطقة',
    '• 200+ countries, 24/7 support': '• دعم على مدار الساعة في +٢٠٠ دولة',
    moneygram_company_description:
      'MoneyGram شركة رائدة عالمياً في الحوالات والمدفوعات بين الأفراد عبر الحدود، تخدم ٥٥ مليون عميل في +٢٠٠ دولة ومنطقة.',
    moneygram_intro:
      'MoneyGram تحوّل الفلوس عبر الحدود لـ٥٥ مليون عميل حول العالم. وراء كل حوالة حاجة حقيقية: مصروف عائلة في الخارج، أو دفعة عمل لا تنتظر. والعميل يريد جواباً فورياً ودقيقاً عن حوالته.',
    moneygram_scale_title: 'حجم عالمي، ولا مجال للخطأ',
    moneygram_scale_p1:
      'MoneyGram تعمل في +٢٠٠ دولة. العملاء يتكلمون مئات اللغات ويرسلون استفساراتهم من كل منطقة زمنية. عميل في كينيا يسأل عن حوالة متأخرة الساعة ٢ الفجر بتوقيته، لا ينتظر ساعات العمل الأمريكية — فالحوالة قد تكون إيجاراً أو علاجاً أو حالة طارئة.',
    moneygram_scale_p2:
      'والاستفسارات معقدة: تتبع الحوالة عبر الأنظمة البنكية الدولية، التحقق من متطلبات كل دولة، حساب سعر الصرف، الحماية من الاحتيال، واسترجاع الأموال عبر الحدود. وكل دولة لها متطلباتها التنظيمية.',
    moneygram_scale_p3:
      'الطريقة التقليدية؟ وظّف موظف لكل لغة ولكل منطقة زمنية. التكاليف ترتفع بسرعة والجودة تبقى متفاوتة. وتدريب موظف على قوانين الحوالات الدولية في +٢٠٠ سوق يحتاج شهور.',
    moneygram_solution_title: 'نظام Open الذكي',
    moneygram_solution_p1:
      'النظام يتعامل مع الدعم عبر الإيميل والدردشة في كل المناطق واللغات. ولمّا يسأل عميل عن حوالة لنيجيريا، يتحقق من حالة المعاملة، ويراجع الشركاء المحليين، ويعطي وقت وصول دقيق — بالإنجليزية أو الإسبانية أو الفرنسية أو العربية أو أي لغة يريدها.',
    moneygram_solution_p2:
      'وأسئلة الالتزام تحصل جواب دقيق حسب كل دولة. النظام يعرف الوثائق المطلوبة لكل وجهة، وإجراءات التحقق من الهوية، وحدود المعاملات، والقيود التنظيمية.',
    moneygram_solution_p3:
      'ولمّا تقع مشكلة — حوالة متأخرة، أو دفعة محتجزة، أو سؤال تنظيمي — يبدأ التحقيق فوراً. يتتبع المعاملة عبر الشبكات البنكية الدولية، ويحدد وين توقفت، ويشرح السبب، ويعطي وقت الحل. والحالات المعقدة تنتقل لموظف بشري مع كل المعلومات.',
    moneygram_solution_p4:
      'النظام مو بس يجاوب، بل ينفّذ: يتتبع الحوالات، يرسل الإيصالات، يعالج الاسترجاعات، يتحقق من الهويات، ويشرح القوانين. وهو يخدم ٥٥ مليون عميل في +٢٠٠ دولة، كل واحد بلغته.',
    moneygram_results_intro:
      'نظام Open الآن يشغل دعم العملاء العالمي في MoneyGram:',
    '200+ countries, 24/7': '+٢٠٠ دولة، ٢٤/٧',
    moneygram_results_p1:
      'أعلى رضا عملاء في تاريخ الشركة جا من السرعة والدقة الثابتة. عميل في المكسيك يوصله رد فوري عن حوالته لغواتيمالا، بالإسباني، بتفاصيل دقيقة — الرضا يرتفع. ولما النظام يشرح المتطلبات التنظيمية في +٢٠٠ دولة بدقة، الثقة تزيد.',
    moneygram_impact_title: 'الأثر',
    moneygram_impact_p1:
      '٨٠٪ أتمتة في الدعم العالمي تتيح لـMoneyGram خدمة ٥٥ مليون عميل بلا توظيف بنفس النسبة مع كل دولة أو لغة جديدة. والنظام يتوسّع عبر اللغات والمناطق الزمنية والأنظمة التنظيمية بمفرده.',
    moneygram_impact_p2:
      'وانتقل فريق الدعم للعمل عالي القيمة. فبدل الرد على أسئلة حالة الحوالة بلغات مختلفة، يحلون مشاكل معقدة عبر الحدود، وينسّقون مع شركاء البنوك على الحوالات العالقة، ويتعاملون مع الحالات الاستثنائية اللي تحتاج حكماً بشرياً.',
    moneygram_impact_p3:
      'للعميل اللي يرسل مالاً لأهله، الدعم يشتغل ببساطة. فسؤال عن حوالة في منتصف الليل يحصل على رد فوري بلغته، بمعلومة دقيقة عن معاملته هو. وهذه الموثوقية هي اللي رفعت الرضا لأعلى مستوى في تاريخ الشركة.',
    "Open's AI agent handles 80% of support across email and chat for Trunkrs' delivery operations. Customers get instant tracking updates, delivery changes, and issue resolution.":
      'نظام Open يحل ٨٠٪ من دعم توصيلات Trunkrs عبر الإيميل والدردشة. تتبع فوري، تغيير موعد التوصيل، وحل المشكلة — كله في نفس المحادثة.',
    'Logistics / Delivery Services': 'اللوجستيات / خدمات التوصيل',
    'Fresh & Frozen product delivery': 'توصيل منتجات طازجة ومجمدة',
    '• 4.8/5 rating (60K+ reviews)': '• تقييم ٤,٨/٥ من +٦٠ ألف تقييم',
    '• 80% automation rate': '• معدل أتمتة ٨٠٪',
    trunkrs_company_description:
      'Trunkrs الأولى في هولندا في توصيل الطازج والمجمّد، وتخدم المتاجر الإلكترونية في اللوجستيات اللي ما تنتظر.',
    trunkrs_intro:
      'Trunkrs الأولى في هولندا في توصيل الطازج والمجمّد. آلاف التوصيلات كل يوم، وكلها ما تنتظر: أكل طازج، منتجات مجمدة، ومستلزمات رعاية صحية. ولمّا ما يصل التوصيل في وقته، يريد العميل جواباً فورياً.',
    trunkrs_scale_title: 'دعم التوصيل على نطاق واسع',
    trunkrs_scale_p1:
      'دعم اللوجستيات مختلف. فكل استفسار عليه ساعة تجري. عميل يسأل عن توصيله الساعة ٥ العصر يريد الجواب قبل العشاء. وطلب مجمد متأخر يفسد خطة طعام الأسبوع. وتأخير توصيل صحي يعني أن أحدهم ما حصل على دوائه.',
    trunkrs_scale_p2:
      'والاستفسارات متنوعة: تحديث تتبع، تغيير موعد، عنصر ناقص، قلق على درجة حرارة المجمدات، وطلب إعادة جدولة. وكلها عاجلة عند من يقف في انتظار طرده.',
    trunkrs_scale_p3:
      'Trunkrs تستقبل هذا الحجم عبر الإيميل والدردشة. مع +٦٠ ألف تقييم على قوقل وتقييم ٤,٨/٥، العميل يتوقع رد سريع ودقيق. وفي ساعات الذروة الحجم يقفز. الفريق كان محتاج يكبر بدون ما ينزل مستواه.',
    trunkrs_solution_title: 'نظام Open الذكي',
    trunkrs_solution_p1:
      'النظام يتعامل مع الدعم عبر الإيميل والدردشة. ولمّا يسأل عميل عن توصيله، يفتح نظام التتبع، ويحدد موقع الطرد، ويعطي وقت الوصول بالدقيقة، لحظياً.',
    trunkrs_solution_p2:
      'وللتوصيلات المتأخرة، يتحقق من السبب، ويشرح ما حدث، ويعرض إعادة جدولة في الوقت اللي يناسب العميل. وإذا ما كان العميل في المنزل، يرتب توصيلاً للجار أو يؤجله للغد.',
    trunkrs_solution_p3:
      'والقلق على درجة حرارة المجمدات يفعّل فحص البروتوكول والتحقق من الجدول الزمني، ويصعّد للفريق التشغيلي عند اللزوم. وللعناصر الناقصة، يراجع الطلب، ويتحقق مع المستودع، ويبدأ الحل.',
    trunkrs_solution_p4:
      'ويتصرف أبعد من التتبع: يعيد جدولة التوصيلات، ويحدّث تفضيلات العملاء، ويعالج مطالبات التعويض، وينسق مع السائقين. كل ما يقوم به موظف الدعم، ينفّذه فوراً عبر الإيميل والدردشة، وفي أعلى ساعات الذروة.',
    trunkrs_results_intro:
      'نظام Open الذكي الآن يتعامل مع معظم دعم عملاء Trunkrs:',
    trunkrs_results_p1:
      'تقييم ٤,٨/٥ من +٦٠ ألف تقييم هو نتيجة جعل سرعة الدعم تواكب سرعة التوصيل. فلمّا يحصل العميل على جوابه عن توصيله فوراً، بدل انتظار ساعات لرد إيميل، يبقى الرضا عالياً.',
    trunkrs_quote_p1:
      'أكثر شي يعجبني إن الشغل مع Open سهل. دايماً فيه خط مباشر مع مهندس، فإذا نقص شي أو ما اشتغل، الطريق قصير والموضوع ينمسك فعلاً.',
    trunkrs_quote_p2:
      'الإعداد مرّ بلا وجع راس، ووصلنا لنسبة أتمتة ٧٥–٨٠٪ بسرعة. وعبر الـ MCP اللي ناخذه من Open عندنا رؤية واضحة وين نقدر نتحسن، بدل ما نخمّن.',
    trunkrs_quote_p3:
      'وأنتم مستمرين في إطلاق ميزات جديدة بإيقاع أفضل وأسرع من المنصات القديمة اللي كنا نستخدمها.',
    trunkrs_quote_attribution: 'ميلفن، Trunkrs',
    trunkrs_impact_title: 'الأثر',
    trunkrs_impact_p1:
      '٨٠٪ أتمتة عبر الإيميل والدردشة تتيح لـTrunkrs استيعاب استفسارات التوصيل على نطاق واسع بدون ما يكبر الفريق بنفس النسبة. وفي ساعات الذروة، يتوسّع النظام بمفرده بقدر الطلب.',
    trunkrs_impact_p2:
      'وللعميل اللي ينتظر توصيله، الدعم يشتغل ببساطة. فرسالة الساعة ٦ مساءً عن توصيل الليلة نفسها تحصل على تحديث تتبع في ٣٠ ثانية. وهذه السرعة هي اللي تحافظ على ٤,٨/٥ عبر ٦٠ ألف تقييم.',
    'How More.com sold 30M tickets with all-time high CSAT':
      'كيف باعت More.com ٣٠ مليون تذكرة وسجّلت أعلى رضا',
    'More.com is automating +67% with all-time high customer satisfaction':
      'More.com تؤتمت ٨٠٪ من دعمها، ورضا العملاء في أعلى مستوى بتاريخها',
    "Open's AI agent automates 67%+ of support across email and chat for More.com's multi-market ticketing operations. Customers get instant help with bookings, changes, and inquiries across European markets.":
      'نظام Open يأتمت ٨٠٪ من دعم More.com عبر الإيميل والدردشة، في كل أسواقها. حجز، تغيير تذكرة، استرجاع — بلغة العميل، فوراً.',
    'Multiple European markets': 'أسواق أوروبية متعددة',
    '30 million tickets sold': '٣٠ مليون تذكرة مباعة',
    '• 67%+ automation rate': '• معدل أتمتة ٨٠٪',
    '• 30 million tickets sold': '• ٣٠ مليون تذكرة مباعة',
    '• Multi-market operations': '• عمليات في أسواق متعددة',
    more_company_description:
      'More.com منصة تذاكر تعمل في أسواق أوروبية متعددة، وباعت ٣٠ مليون تذكرة.',
    more_intro:
      'More.com تشغّل منصات تذاكر في أسواق أوروبية متعددة، و٣٠ مليون تذكرة مباعة. كل سوق بلغته وطرق دفعه وتوقعات عميله. وكل مشكلة حجز تحتاج حلاً سريعاً بلغة صاحبها.',
    more_scale_title: 'عمليات متعددة الأسواق',
    more_scale_p1:
      'العمل في أوروبا يعني دعم عملاء بلغات كثيرة في اللحظة نفسها. أحدهم يسأل عن حجزه، وآخر يريد تغيير تذكرته، وثالث يطلب استرجاعاً — وكلهم يتوقعون الجواب بلغتهم.',
    more_scale_p2:
      'ودعم التذاكر معقّد: تغيير حجز بسياسة إلغاء تختلف من سوق لسوق، مشكلة دفع عبر أنظمة بنكية مختلفة، سؤال خاص بفعالية حسب المكان والدولة، وطلب استرجاع يخضع لقوانين كل سوق.',
    more_scale_p3:
      'الدعم التقليدي كان يعني توظيف متحدث أصلي لكل سوق وتدريبه على أنظمة الحجز والسياسات والقوانين. وكل سوق جديد يجي معه فاتورة جديدة كاملة.',
    more_solution_title: 'نظام Open الذكي',
    more_solution_p1:
      'النظام يتعامل مع الدعم بلغات أوروبية متعددة عبر الإيميل والدردشة. سؤال عن حالة حجز باليوناني؟ يفتح نظام الحجز ويرد باليوناني. طلب استرجاع بالهولندي؟ يطبّق سياسة السوق الهولندي.',
    more_solution_p2:
      'وتغييرات الحجز تتم بشكل صحيح حسب كل سوق. فالنظام يعرف أي سوق يسمح بتغيير مجاني، وأيها يفرض رسوماً، وأيها فيه قيود. يعدّل الحجز، ويشرح الخيارات، وينفّذ التغيير تلقائياً.',
    more_solution_p3:
      'ومشاكل الدفع تتعامل حسب كل سوق. النظام يفهم طرق الدفع المحلية، يتحقق من حالة الدفع مع كل مزود، ويعرف مواعيد الاسترجاع في نظام بنوك كل دولة. والمعقّد يصعّد مع كل السياق.',
    more_results_intro:
      'نظام Open الذكي الآن يشغل دعم العملاء متعدد الأسواق في More.com:',
    'Markets covered': 'الأسواق المغطاة',
    more_results_p1:
      'أعلى رضا في تاريخ المنصة جاء من الاتساق بين الأسواق. نفس جودة الدعم بلغة العميل الأم، وتغيير الحجز يتم فوراً بدل انتظار وردية الدعم باللغة المناسبة.',
    more_impact_title: 'الأثر',
    more_impact_p1:
      '٨٠٪ أتمتة عبر كل الأسواق واللغات تتيح لـMore.com توسيع دعمها في أوروبا بلا توظيف بنفس النسبة مع كل منطقة جديدة. والنظام يتعامل مع لغات وأنظمة دفع وأنظمة تنظيمية متعددة في نفس الوقت.',
    more_impact_p2:
      'وللعميل اللي يشتري تذكرة في أوروبا، الدعم يشتغل ببساطة. فسؤاله يحصل على جواب بلغته، ووفق قوانين سوقه، في أي وقت. وهذا الاتساق هو اللي رفع الرضا لأعلى مستوى في تاريخ المنصة.',
    'How FareHarbor powers billions of experiences with AI support':
      'كيف تشغّل FareHarbor مليارات التجارب بدعم ذكي',
    "Open's AI agent handles support across email, chat, and voice for FareHarbor's booking platform. Tour operators and activity providers get instant help with reservations, payments, and technical issues.":
      'نظام Open يتولّى دعم FareHarbor عبر الإيميل والدردشة والمكالمات. مشغّل الجولات يحصل مساعدة فورية في الحجز والدفع والمشاكل التقنية.',
    'Travel & Tourism / Booking Software': 'السفر والسياحة / برمجيات حجز',
    'Denver, CO, USA': 'دنفر، كولورادو، أمريكا',
    'Capterra rating': 'تقييم كابتيرا',
    '• 20,000+ companies served': '• +٢٠ ألف شركة',
    '• 4.8/5 rating (1000+ reviews)': '• تقييم ٤,٨/٥ من +١٠٠٠ تقييم',
    '• Email, chat, voice support': '• دعم إيميل ودردشة ومكالمات',
    'Operators served': 'مشغّلون يستخدمونها',
    'Countries reached': 'دولة نصل إليها',
    'Email, chat, and voice': 'إيميل ودردشة ومكالمات',
    '• 23,000+ operators served': '• +٢٣ ألف مشغّل يستخدمونها',
    '• 115 countries reached': '• ١١٥ دولة نصل إليها',
    '• Email, chat, and voice covered': '• تغطية الإيميل والدردشة والمكالمات',
    '• 87% automation rate': '• أتمتة ٨٧٪',
    fareharbor_hero_title: 'كيف تؤتمت FareHarbor ٨٧٪ من دعم +٢٣ ألف مشغّل',
    fareharbor_what_we_did:
      'وكيل Open الذكي يتولّى ٨٧٪ من الدعم على الإيميل والدردشة والمكالمات لمنصة حجز FareHarbor. المشغّل يحصل على جوابه قبل موعد رحلته القادمة. والتكاملات المخصّصة ونزاعات الدفع تذهب لفريق FareHarbor ومعها السياق كاملاً.',

    'Businesses served (Viva)': 'شركة تستخدمها',
    '• 100,000+ businesses served': '• +١٠٠ ألف شركة تستخدمها',
    '• 23 European markets': '• ٢٣ سوقاً أوروبية',
    'European markets': 'سوق أوروبية',
    'Payments / Banking': 'المدفوعات / الخدمات المصرفية',
    'Athens, Greece': 'أثينا، اليونان',
    '• 62% automation rate': '• أتمتة ٦٢٪',
    '• Web chat and email covered': '• تغطية دردشة الويب والإيميل',
    'Tickets resolved': 'تذاكر محلولة',
    'Web chat and email': 'دردشة الويب والإيميل',
    viva_company_description:
      'Viva.com بنك تقني أوروبي للشركات، يوفّر التحصيل المحلي في ٢٣ دولة أوروبية وأكثر من ٣٠ وسيلة دفع لأكثر من ١٠٠ ألف تاجر.',
    viva_hero_title: 'كيف تؤتمت Viva.com ٦٢٪ من دعم التجار في ٢٣ سوقاً أوروبية',
    viva_what_we_did:
      'وكيل Open الذكي يتولّى ٦٢٪ من الدعم على الدردشة والإيميل لمنصة مدفوعات Viva.com. التاجر يحصل على جواب في التسويات والأجهزة والنزاعات بلغته. والحالات اللي تحتاج حكماً تنظيمياً تذهب إلى [TK: escalation team].',
    viva_intro:
      'Viva.com بنك تقني أوروبي للشركات، تأسس في أثينا عام ٢٠١١ ويعمل اليوم في ٢٤ سوقاً، مع تحصيل محلي في ٢٣ دولة أوروبية. يحمل رخصة نقود إلكترونية على مستوى المنطقة الاقتصادية الأوروبية ورخصة مصرفية، ويتيح للتجار أكثر من ٣٠ وسيلة دفع. وحين يعجز التاجر عن قبول بطاقة، فهو لا ينتظر تذكرة دعم. هو يردّ زبائنه من عند الصندوق.',
    viva_scale_title: 'Payments Support Has a Business Day, Not an SLA',
    viva_scale_p1:
      'جهاز يرفض البطاقات ظهر السبت يكلّف المطعم كل طاولة ما يقدر يجلّس عليها زبائن. والتاجر ما يفتح تذكرة وينتظر الاثنين. يتصل، وإن ما وصله الجواب، يضع لافتة «نقداً فقط» عند الصندوق ويبدأ صباح الاثنين بالسؤال عن بديل.',
    viva_scale_p2:
      'والتسوية ساعة أخرى. فالتاجر اللي يتحقق من وصول مبيعات أمس يتحقق عادةً لأن الرواتب أو البضاعة أو الإيجار معلّقة عليها. و«قيد المعالجة» مو جواب على هذا السؤال. التاريخ هو الجواب.',
    viva_scale_p3:
      'ثم تأتي الطبقة التنظيمية. التحصيل المحلي في ٢٣ دولة يعني ٢٣ مجموعة من القواعد حول فحوص فتح الحساب، والتقارير الضريبية، ومعالجة الاسترجاع، ووش يجب إبلاغ التاجر به ومتى. فمطعم في تسالونيكي ومتجر في كراكوف يسألان السؤال نفسه ويستحقّان جوابين مختلفين. ومواعيد نزاعات شبكات البطاقات تسير على تقويمها الخاص، لا يعنيها ازدحام الدعم في ذلك الأسبوع.',
    viva_scale_p4:
      'وكل هذا يجري بكل اللغات في وقت واحد. فأسواق Viva الأساسية وحدها — اليونان وإسبانيا وإيطاليا والبرتغال وبولندا ورومانيا — تعني أن التاجر يتوقّع جواباً بلغته في اللحظة اللي يرفض فيها جهازه البطاقات.',
    viva_solution_title: 'Open’s AI Agent',
    viva_solution_p1:
      'الوكيل الذكي يتولّى الدعم على الدردشة والإيميل، وبـ [TK: language count] لغة. ولمّا يبلّغ تاجر أن جهازه يرفض البطاقات، يفحص الوكيل حالة الجهاز ومسار التحصيل، ويحدد ما إذا كان المنع على البطاقة أو الجهاز أو الحساب، ويقول أيّها — بدل ما يفتح تحقيقاً.',
    viva_solution_p2:
      'وفي أسئلة التسوية، يبحث الوكيل عن الدفعة، ويحدد وين هي في الدورة، ويعطي تاريخاً. وإن كانت محتجزة، يذكر السبب ووش يفكّها.',
    viva_solution_p3:
      'وأبعد من الإجابة، الوكيل [TK: confirm each of these actions] يعيد إصدار بيانات الجهاز، ويحدّث حساب التاجر البنكي بعد التحقق، ويقدّم أدلة النزاع قبل موعد الشبكة، ويتابع فحوص فتح الحساب، ويصدر كشوف تسوية لأي فترة مطلوبة.',
    viva_solution_p4:
      'أما الحالات اللي تحتاج حكماً تنظيمياً — أسئلة التراخيص، ومراجعة العقوبات وغسل الأموال، وتحكيم النزاعات، وأي شيء يمسّ علاقة التاجر المصرفية — فتذهب إلى [TK: escalation team] ومعها الخيط كاملاً وسياق حساب التاجر.',
    viva_results_intro:
      'Open’s AI agent now handles Viva.com’s merchant support:',
    viva_results_p1:
      '٦٢٪ من تواصل التجار يُحلّ بلا تدخل بشري، وباللغة اللي كتب بها التاجر. والمقياس اللي يهم في المدفوعات هو: هل يقدر التاجر يقبل البطاقة التالية، وكم انتظر عشان يعرف.',
    viva_impact_title: 'The Impact',
    viva_impact_p1:
      'أتمتة ٦٢٪ على الدردشة والإيميل تتيح لـ Viva.com أن تدعم أكثر من ١٠٠ ألف شركة في ٢٣ دولة بلا توسيع الفريق بالتناسب مع كل سوق جديدة. فالسوق الجديدة تضيف قواعد تنظيمية، لا فريق دعم.',
    viva_impact_p2:
      'ومتخصصو Viva انتقلوا للعمل اللي يحتاجهم: نزاعات الشبكات، والملفات التنظيمية، وعلاقات التجار اللي تقرر إن كان النشاط سينمو على المنصة أو يغادرها. أما بالنسبة للتاجر فالأمر أضيق من ذلك: الجهاز يشتغل، أو يخبره أحدهم متى سيعمل بالضبط، بلغته، والطابور ما زال واقفاً.',
    'Weekly tickets': 'تذكرة أسبوعياً',
    Depots: 'موقع استلام',
    'Handoff destination': 'وجهة التحويل',
    'Tickets handled': 'تذاكر تولّاها',
    'Web chat, email, and WhatsApp': 'دردشة الويب والإيميل وWhatsApp',
    'Indie Campers agents in Zendesk': 'موظفو Indie Campers داخل Zendesk',
    '• 44% automation rate': '• أتمتة ٤٤٪',
    '• Read-only by design': '• قراءة بس، بقرار من العميل',
    '• Web chat, email, and WhatsApp': '• دردشة الويب والإيميل وWhatsApp',
    '• Layered onto Zendesk, no migration': '• فوق Zendesk، بلا ترحيل',
    'RV Rental / Travel': 'تأجير المنازل المتنقلة / السفر',
    'Porto, Portugal': 'بورتو، البرتغال',
    indiecampers_company_description:
      'Indie Campers منصة أوروبية لتأجير المنازل المتنقلة، تشغّل أسطولها في أوروبا وأمريكا الشمالية وأوقيانوسيا من نحو ١٠٠ موقع استلام.',
    indiecampers_hero_title:
      'كيف تؤتمت Indie Campers ٤٤٪ من الدعم بوكيل لا يكتب شيئاً، عن قصد',
    indiecampers_what_we_did:
      'وكيل Open الذكي يتولّى ٤٤٪ من الدعم على دردشة الويب والإيميل وWhatsApp، فوق Zendesk. يجيب، ويجمع البيانات، ويغلق التذكرة — بس بقرار من العميل نفسه ما يمسّ الحجز أبداً. وكل ما يلامس حجزاً يذهب لموظف بشري.',
    indiecampers_intro:
      'Indie Campers تؤجّر منازل متنقلة في أوروبا وأمريكا الشمالية وأوقيانوسيا من نحو ١٠٠ موقع استلام. وعملاؤها نادراً ما يكونون خلف مكتب. هم عند نقطة الاستلام لحظة التسليم، أو في اليوم الثالث من رحلتهم ومعهم سؤال عن المركبة، يكتبون من جوّالهم في بلد مو اللي انطلقوا منه.',
    indiecampers_scale_title: 'الدعم يمشي مع الرحلة',
    indiecampers_scale_p1:
      'التأجير مو عملية تنتهي عند الدفع. يمتد أياماً، ويعبر الحدود، والأسئلة تصل طوال الطريق: متى يعود مبلغ التأمين، وأي الدول يُسمح لهذه المركبة بدخولها، ووش يعمل العميل بشيء في المركبة الساعة التاسعة ليلاً.',
    indiecampers_scale_p2:
      'والقواعد نفسها مو واحدة. شروط Indie Campers موزّعة على تسع وثائق منفصلة بحسب المنطقة ونوع التأجير، فالجواب الصحيح على السؤال الواحد يختلف فعلاً باختلاف مكان الاستلام ونوع ما استأجره العميل.',
    indiecampers_scale_p3:
      'ومعظم تواصل أثناء الرحلة يصل على WhatsApp، وهو ما يشبه طابور التذاكر. الجلسات تنتهي، والمحادثات تُفتح من جديد، والعميل الواحد قد يخلّف تذاكر متفرقة على مدى تأجيرة واحدة.',
    indiecampers_solution_title: 'وكيل يجيب ولا يمسّ الحجز',
    indiecampers_solution_p1:
      'Open يعمل على دردشة الويب والإيميل وWhatsApp، أمام Zendesk. وقد اتخذت Indie Campers قراراً مبكراً يحكم كل ما بعده: الوكيل يقرأ من نظام الحجوزات ولا يكتب فيه. لا يغيّر حجزاً، ولا يبدّل مركبة، ولا يحرّك مبلغاً.',
    indiecampers_solution_p2:
      'وهذا موقف أمني، مو ثغرة ما انسدّت. فالعميل يُعرَّف برمز الحجز والإيميل بس، ورأت الشركة أن هذا أضعف من أن يُبنى عليه تعديل حجز قائم. فالوكيل يجيب، ويوجّه العميل لمنطقته الخاصة الموثّقة في كل ما يمسّ حسابه.',
    indiecampers_solution_p3:
      'أما ما يكتبه فعلاً فهو في Zendesk. يحلّ التذكرة وينشر الجواب تعليقاً عليها — قرابة ١٦٠٠ إغلاق تذكرة في يوم واحد — ويجمع الإيميل والاسم ورمز الحجز اللي سيحتاجها الموظف البشري، ويرفق ملخّص المحادثة، ويرسل استبيان الرضا.',
    indiecampers_solution_p4:
      'وتغييرات الحجز وتبديل المركبات تبقى بشرية دائماً، بسياسة العميل لا بحدود القدرة. تذهب لموظفي Indie Campers داخل Zendesk والمعلومات مجموعة سلفاً، فيبدأ التحويل من المعلومة بدل ما يبدأ بطلبها.',
    indiecampers_results_intro:
      'وكيل Open الذكي يتولّى الآن حصة كبيرة من دعم Indie Campers:',
    indiecampers_results_p1:
      'نسبة الـ ٤٤٪ محدّدة النطاق: نحو ٧٠٠٠ تذكرة من ١٧ ألف خلال نافذة سبعة أيام واحدة. وهي تتحرّك من أسبوع إلى آخر، وتقف أمام نشر مُنع عمداً من تنفيذ الإجراءات اللي كانت سترفعها. القراءة بس سقف اختارته الشركة بنفسها.',
    indiecampers_impact_title: 'الأثر',
    indiecampers_impact_p1:
      'أتمتة ٤٤٪ على دردشة الويب والإيميل وWhatsApp تتيح لفريق من أربعة عشر موظفاً أن يحمل سبعة عشر ألف تذكرة أسبوعياً بلا توسيع الفريق بالتناسب مع الأسطول. وZendesk بقي مكانه؛ ما ترحّل شي.',
    indiecampers_impact_p2:
      'وما يبقى للفريق هو العمل اللي يحتاج إنساناً: تغيير الحجز، وتبديل المركبة، والحالة اللي يتوقف جوابها على أي من الاتفاقيات التسع ينطبق. أما العميل الواقف عند نقطة الاستلام، فالفرق عنده أن السؤال الروتيني يكون قد أُجيب قبل ما يُحتاج الموظف أصلاً.',
    'Accounting SaaS / E-invoicing': 'محاسبة سحابية / فوترة إلكترونية',
    'Riyadh, Saudi Arabia': 'الرياض، السعودية',
    'Support agents': 'موظف دعم',
    'Tickets resolved (90 days)': 'تذاكر محلولة (٩٠ يوم)',
    'WhatsApp and web chat': 'WhatsApp ودردشة الويب',
    'Reviewed in Zendesk': 'تُراجَع في Zendesk',
    '• Arabic-first support': '• دعم بالعربية أولاً',
    '• WhatsApp and web chat': '• WhatsApp ودردشة الويب',
    '• Every resolution auditable': '• كل حل قابل للمراجعة',
    wafeq_company_description:
      'وافِق منصة محاسبة وفوترة إلكترونية سحابية للشركات في الخليج، تغطي الدفاتر وضريبة القيمة المضافة والامتثال لـ ZATCA والفوترة والتقارير المالية.',
    wafeq_hero_title: 'كيف تؤتمت وافِق ٧٣٪ من دعم محاسبي بالعربية أولاً',
    wafeq_what_we_did:
      'وكيل Open الذكي يتولّى ٧٣٪ من الدعم الوارد على WhatsApp ودردشة الويب، بالعربية أولاً. وكل محادثة يحلّها تعود وتسجّل نفسها في Zendesk ومعها ملخّص ونص المحادثة كاملاً، عشان يراجع الموظف ما جرى.',
    wafeq_intro:
      'وافِق تمسك دفاتر شركات في السعودية والإمارات: الفوترة، وضريبة القيمة المضافة، والامتثال للفوترة الإلكترونية في ZATCA، والتقارير المالية. وعملاؤها يكتبون بالعربية، على WhatsApp، وغالباً عن شيء له موعد إقرار.',
    wafeq_scale_title: 'السؤال المحاسبي لا يحتمل جواباً تقريبياً',
    wafeq_scale_p1:
      'دعم تطبيق مدفوعات يحتمل أن يكون صحيحاً تقريباً. أما دعم البرنامج اللي تقدّم الشركة إقرارها الضريبي من خلاله فما يحتمل. الجواب الخاطئ عن معالجة ضريبية ما يزعج العميل، بل يعرّض إقراراً للخطر.',
    wafeq_scale_p2:
      'والقواعد تختلف باختلاف الدولة. متطلبات الفوترة الإلكترونية في هيئة الزكاة والضريبة والجمارك مو متطلبات الإمارات، ووافِق تخدم السوقين من المنتج نفسه، وبرقم WhatsApp للأعمال على كل جانب من الحدود.',
    wafeq_scale_p3:
      'وكل هذا يجري بالعربية. مركز مساعدة وافِق عربي أولاً، وعملاؤها يكتبون بالعربية، والجواب الفصيح غير الدقيق في المحاسبة أسوأ من لا جواب.',
    wafeq_solution_title: 'وكيل يوثّق عمله بنفسه',
    wafeq_solution_p1:
      'Open يعمل على WhatsApp ودردشة الويب، أمام Zendesk، ويجيب من محتوى أكاديمية وافِق بالعربية والإنجليزية.',
    wafeq_solution_p2:
      'وما يهم الفريق المحاسبي هو ما يحدث بعد الجواب. فكل محادثة يحلّها الوكيل تكتب تذكرة في Zendesk تحمل ملخّص AI ونص المحادثة كاملاً، موسومة ومفتوحة. لا شيء يُغلق بصمت.',
    wafeq_solution_p3:
      'ثم يسلّم الوكيل تحكّم المحادثة لـ Zendesk، فيُحلّ التذكرة ويسجّل سبب الإغلاق على الجلسة. ويُرسل استبيان الرضا على المُشغّل نفسه.',
    wafeq_solution_p4:
      'وموظفو وافِق يعملون على تلك التذاكر: يراجعون ما حلّه الـ AI، ويكملون الحقول اللي تعتمد عليها تقاريرهم. وحلقة المراجعة هذه هي المقصد، لا عبء إضافي: ففي منتج امتثال، الجواب المؤتمت اللي ما يقدر أحد يراجعه مو مكسب.',
    wafeq_results_intro:
      'وكيل Open الذكي يتولّى الآن معظم الدعم الوارد لوافِق:',
    wafeq_results_p1:
      'نسبة الـ ٧٣٪ محدّدة النطاق: ٩٨٨٣ تذكرة واردة محلولة من ١٣٤٧٧ على القنوات المدمجة حينها، خلال نافذة تسعين يوماً. وتغطي WhatsApp ودردشة الويب. أما المكالمات فتعمل خارج Open ولا تدخل في هذا الرقم.',
    wafeq_impact_title: 'الأثر',
    wafeq_impact_p1:
      'أتمتة ٧٣٪ على WhatsApp ودردشة الويب تتيح لفريق من ثلاثة عشر موظفاً أن يخدم شركات في دولتين بلا توسيع الفريق بالتناسب مع قاعدة العملاء. وZendesk بقي مكانه؛ ما ترحّل شي.',
    wafeq_impact_p2:
      'أما صاحب العمل وهو في منتصف إقراره، فالفرق عنده أن سؤالاً بالعربية على WhatsApp الساعة التاسعة ليلاً يلقى جواباً دقيقاً، والجواب مسجّل عشان يراجعه أحد في وافِق صباحاً.',
    'Driver chats (3 months)': 'محادثة سائق (٣ أشهر)',
    'Live market': 'السوق التشغيلية',
    'In-app chat': 'دردشة داخل التطبيق',
    'Snoonu live ops': 'فرق عمليات Snoonu',
    'Handoff rate': 'نسبة التحويل لموظف',
    Qatar: 'قطر',
    'Q-Commerce / Delivery': 'تجارة سريعة / توصيل',
    'Doha, Qatar': 'الدوحة، قطر',
    '• 14,581 driver chats in a quarter': '• ١٤٬٥٨١ محادثة سائق في ربع سنة',
    '• Order release automated end to end':
      '• تحرير الطلب مؤتمت من أوله إلى آخره',
    '• English, Arabic, and Roman Urdu':
      '• الإنجليزية والعربية والأردية بالحروف اللاتينية',
    '• Every handoff cause measured': '• كل سبب تحويل مقيس',
    Languages: 'لغات',
    /* SYARAH — الاسم التجاري يطابق الاسم العام للسيارة، ويُكتب بلا علامات
     * اقتباس. حيث يلتبس بالمركبة يُسبق بكلمة «منصة» بدل التنصيص: «كيف تدير
     * سيارة» وحدها تُقرأ قيادة مركبة، لا إدارة شركة. */
    'Used cars': 'سيارات مستعملة',
    Category: 'القطاع',
    'Automotive / Marketplace': 'سيارات / سوق إلكتروني',
    syarah_company_description:
      'سيارة سوق سعودي إلكتروني لبيع وشراء السيارات المستعملة، يغطي الفحص والتمويل ونقل الملكية والتوصيل لباب المشتري.',
    syarah_hero_title: 'كيف تدير منصة سيارة دعم عملائها مع Open',
    syarah_what_we_did:
      'فريق سيارة يتكلم بنفسه عن دخول Open في منظومة الدعم عندهم.',
    syarah_intro:
      'شراء سيارة مستعملة أكبر عملية شراء يسويها أغلب الناس بعد البيت، وفي منصة سيارة تصير بلا زيارة معرض. الطلب الواحد يمرّ على الفحص، والموافقة على التمويل، ونقل الملكية، والتوصيل — أربعة مسارات، كل واحد له وقته، والمشتري يبي يعرف وين وصلت الأربعة كلها.',
    /* المتحدثون في الفيلم يتكلمون بلهجة شامية؛ نصّ الصفحة يبقى بصوت Open
     * النجدي. المضمون من كلامهم، والصياغة من لهجة البيت. */
    'Customers who prefer Arabic': 'من العملاء يفضّلون العربية',
    syarah_challenge_title: 'البديل كان مضاعفة الفريق',
    syarah_challenge_p1:
      'سيارة كانت تبي تخدم عملاء أكثر وبسرعة أكبر، والشركة حاطة لها هدف تضاعف مبيعاتها. والفريق دوّر على طريقة ما تمرّ عبر التوظيف. والبديل اللي كان على الطاولة، بكلامهم هم، إنهم يضاعفون عدد موظفي الدعم — وهذا ما شافوه حلاً عملياً.',
    syarah_challenge_p2:
      'وهذي أول مرة الشركة تبني فيها شي على الذكاء الاصطناعي. والقلق مو إذا كانت التقنية تشتغل بشكل عام، بل أضيق من كذا وأصعب: هل الوكيل بيفهم العميل السعودي فعلاً — اللهجة، والسياق اللي وراء السؤال — بدل ما يطابق كلمات فيه؟',
    syarah_challenge_p3:
      'وهذا القلق مو نظري هنا. سيارة تبيع في السعودية بس، وعملاؤها سعوديون، وقرابة ٩٥٪ منهم يفضّلون المحادثة بالعربي. والوكيل اللي يتعامل مع العربية بالتقريب، يتعامل مع كل محادثة تقريباً بالتقريب.',
    syarah_solution_title: 'العربية هي اللي فرّقت بين المزوّدين',
    syarah_solution_p1:
      'سيارة مرّت على قائمة طويلة من مزوّدي الذكاء الاصطناعي قبل ما تستقر على واحد. واللي حسم الموضوع مو العرض التجريبي، بل أي وكيل يصمد بالعربية، لأنها اللغة اللي يكتب فيها جلّ عملائها.',
    syarah_solution_p2:
      'والعامل الثاني إن الشراكة ما كانت تشبه شراء شات بوت. فريق سيارة يشير للعلاقة نفسها إنها اللي خلّت الشغل ينجح — فريقين يبنون مع بعض، ومرونة تكفي عشان يتغيّر اللي مو صح، واجتماعات بقيت بنفس الحماس بعد توقيع العقد.',
    syarah_solution_p3:
      'والبناء على المنصة كان أسهل من اللي شافوه عند غيرها. الفريق قيّم مزوّدين تركيب الوكيل عندهم عملية معقّدة؛ هنا ما كانت كذا، وهذا جزء كبير من سبب وقوفهم وراء الشراكة.',
    syarah_solution_p4:
      'والإطلاق كان تدريجياً عن قصد. سيارة بدت بنطاق ضيّق، وراقبت جودة المحادثات اللي يتولّاها الوكيل، ووسّعت نطاقه كل ما ثبتت النتائج. وكل شي يحتاج إنساناً فعلاً يوصل لإنسان — وشغل فريق العناية بالعملاء صار الحالات اللي تستدعي حكماً بشرياً.',
    syarah_results_intro: 'وش تغيّر بعد ما اشتغل الوكيل، بكلام الفريق نفسه:',
    'Response speed': 'سرعة الرد',
    'Faster than hiring would have reached': 'أسرع من اللي يوصله التوظيف',
    Rollout: 'الإطلاق',
    'Gradual — widened each time quality held':
      'تدريجي — يتوسّع كل ما ثبتت الجودة',
    'Customer language': 'لغة العملاء',
    'Arabic — about 95% of customers': 'العربية — قرابة ٩٥٪ من العملاء',
    'Escalation path': 'مسار التحويل',
    'Cases that need human judgment': 'الحالات اللي تستدعي حكماً بشرياً',
    syarah_results_p1:
      'سرعة الرد هي الرقم اللي تدير عليه منظومة الدعم في سيارة، وهي أول شي يشيرون له. وقراءتهم إن نفس النتيجة ما كانت متاحة بتكبير الفريق — إن السرعة اللي يشتغلون عليها اليوم مو مستوى يوصله التوظيف.',
    syarah_impact_title: 'الأثر',
    syarah_impact_p1:
      'سرعة الرد غيّرت سلوك العميل، مو بس سرعة خدمته. المحادثات اللي كانت تقف عند عدد محدود من الردود بين العميل والموظف صارت تمتد أكثر، والمشتري يسأل كل الأسئلة اللي عنده بدل السؤال الوحيد اللي كان مستعد ينتظر عليه. والتذاكر نفسها تطلع أقصر.',
    syarah_impact_p2:
      'ولشركة تبيع لواحد سيارة ما بيشوفها في معرض، هذا التفاعل هو الثقة نفسها. فريق سيارة يوصف النتيجة إنها أهداف كانوا حاطينها بس ما توقعوا توصل لهذا النجاح، ويوصف الذكاء الاصطناعي إنه صار فعلاً جزءاً من رحلة العميل، مو طبقة قدامها.',
    snoonu_company_description:
      'Snoonu تطبيق قطري شامل للطعام والبقالة والتوصيل عند الطلب. وOpen يعمل داخل تطبيق السائقين، يدعم السائقين أنفسهم لا العملاء.',
    snoonu_hero_title:
      'كيف تتولّى Snoonu ١٤٬٥٨١ محادثة سائق في ربع سنة داخل تطبيق سائقيها',
    snoonu_what_we_did:
      'وكيل Open الذكي مدمج في تطبيق سائقي Snoonu في قطر، يجيبهم بالإنجليزية والعربية والأردية بالحروف اللاتينية. يحرّرهم من الطلبات المتعثّرة بنفسه، وكل حالة ما يقدر يغلقها تُقاس وتُصنّف بدل ما تسقط بهدوء.',
    snoonu_intro:
      'Snoonu توصّل في أنحاء قطر، ومن يدعمهم Open مو العملاء اللي يطلبون. هم السائقون. والسائق اللي يراسل الدعم واقف بجانب دراجته وأمامه طلب ما يتحرّك، وكل دقيقة تكلّفه الطلب التالي.',
    snoonu_scale_title: 'دعم يقف فيه المستخدم على خسارة',
    snoonu_scale_p1:
      'أكثر ما يكتب عنه السائقون هو طلب ما خلّص التاجر تجهيزه. وهذه رسالة سائق بنصّها: «Now order not ready». وهذه الحالة وحدها تمثّل ١٥٩١ تحويلاً في إحصاء ثلاثة أشهر — قرابة ربع كل ما وصل لموظف بشري.',
    snoonu_scale_p2:
      'والمخاطر مو متساوية. فتحرير السائق من طلب قبل الاستلام تصحيح روتيني. أما تحريره بعد الاستلام فيعني طلباً غير مسلَّم في النظام، وعميلاً ينتظر طعاماً ما أحد يحمله.',
    snoonu_scale_p3:
      'وهم ما يكتبون بلغة واحدة. سائقو Snoonu يراسلون بالإنجليزية والعربية والأردية بالحروف اللاتينية، وكثيراً ما ينتقلون بين اللغات داخل المحادثة الواحدة.',
    snoonu_solution_title: 'وكيل يحرّر الطلبات، ضمن ضوابط',
    snoonu_solution_p1:
      'Open مدمج كواجهة داخل تطبيق سائقي Snoonu، تسنده خدمة تقرأ حالة الطلب والسائق لحظياً. وانطلق على مسارات تحرير الطلب في يونيو.',
    snoonu_solution_p2:
      'والتحرير نفسه محسوم لا حواري. يتحقق الوكيل من حالة الطلب عبر الـ API ولا يحرّر إلا قبل الاستلام. أما التحرير بعد الاستلام فممنوع تماماً ويذهب لموظف بشري، ومثله أي طلب دخل مرحلة التوصيل.',
    snoonu_solution_p3:
      'وحين يعجز السائق فعلاً عن المتابعة — عطل في المركبة، أو انتهاء وردية، أو وعكة صحية — يقدر الوكيل يوقفه عن العمل. أما الحوادث وبلاغات السلوك وكل ما هو محل خلاف فلا يُفعّل ذلك تلقائياً أبداً، بل يذهب لمراجعة المشرف.',
    snoonu_solution_p4:
      'وكل اللي ما يقدر يحلّه يرفعه الوكيل تصعيداً منظّماً لفريق العمليات المسؤول في Snoonu، فيصل تأخّر التاجر لفريق التجار، وتصل مشكلة السائق لفريق التشغيل، بدل ما يبتلعهما طابور واحد.',
    snoonu_results_intro:
      'مقيساً على إحصاء كامل لثلاثة أشهر في منظومة دعم السائقين:',
    snoonu_results_p1:
      'ما خمّن Open الفجوة، بل عدّها. قُرئت جميع التحويلات البالغة ٦٧٢٣ على مدى ثلاثة أشهر وصُنّفت: قرابة ثلاثة أرباعها وقعت لأن تعليمة أمرت بالتحويل، ونحو الربع لأن الأداة اللازمة للإجراء اللي طلبه السائق مو موجودة. وهذه خارطة طريق، لا تقييم.',
    snoonu_impact_title: 'الأثر',
    snoonu_impact_p1:
      'خط دعم للسائقين يعمل بثلاث لغات داخل التطبيق المفتوح أصلاً بين يدي السائق، وتحرير الطلب فيه مؤتمت من أوله إلى آخره، وحدوده مرسومة عن قصد لا مكتشفة في الإنتاج.',
    snoonu_impact_p2:
      'أما السائق الواقف عند الكاونتر وأمامه طلب ما يجي، فالفرق عنده أن التحرير يتم داخل المحادثة، فيعود للطريق بدل ما ينتظر من يرد عليه.',
    'AI-resolved weekly': 'جلسة يحلّها الذكاء أسبوعياً',
    Helpdesk: 'نظام الدعم',
    'Lebanon and Iraq': 'لبنان والعراق',
    'Toters agents in Flex': 'موظفو Toters داخل Flex',
    'Q-Commerce / Grocery Delivery': 'تجارة سريعة / توصيل بقالة',
    'Beirut, Lebanon': 'بيروت، لبنان',
    '• 6,000+ AI-resolved sessions a week':
      '• +٦٠٠٠ جلسة يحلّها الذكاء أسبوعياً',
    '• Live in Lebanon and Iraq': '• تعمل في لبنان والعراق',
    '• Runs inside Twilio Flex': '• تعمل داخل Twilio Flex',
    '• Live ETA on the first reply': '• وقت وصول محدّث من أول رد',
    toters_company_description:
      'Toters تطبيق توصيل وتجارة سريعة يعمل في لبنان والعراق، ويغطي البقالة والطعام والتجزئة عند الطلب.',
    toters_hero_title:
      'كيف تحلّ Toters أكثر من ٦٠٠٠ محادثة توصيل أسبوعياً في لبنان والعراق',
    toters_what_we_did:
      'وكيل Open الذكي يشتغل داخل Twilio Flex على دردشة تطبيق Toters، ويحلّ أكثر من ٦٠٠٠ جلسة أسبوعياً في دولتين. يجيب على السؤال اللي يفتح به كل عميل توصيل محادثته، ببيانات الطلب الحيّة لا برسالة انتظار.',
    toters_intro:
      'Toters توصّل البقالة والطعام في لبنان والعراق. وإذا شفت اللي يكتبه العملاء فعلاً لمّا يفتحون محادثة دعم، ما تلقى تنوّعاً يُذكر: الرسالة الأولى هي، حرفياً وبتكرار، «وين طلبي؟».',
    toters_scale_title: 'سؤال واحد، عشرات الآلاف من المرات',
    toters_scale_p1:
      'في التوصيل، سبب التواصل الأكثر شيوعاً مو شكوى. هو استعلام عن الحالة من شخص جائع يراقب خريطة توقفت عن الحركة. يصل في اللحظة اللي يتأخر فيها الموعد المتوقع، والجواب الصادق وقت، لا اعتذار.',
    toters_scale_p2:
      'والرد العام يزيد الأمر سوءاً. فمن يُقال له «نحن نتابع الموضوع» يسأل مرة أخرى بعد أربع دقائق، فيتحوّل الطلب الواحد لثلاث محادثات.',
    toters_scale_p3:
      'وToters تدير هذا في دولتين بعمليتين منفصلتين — عملية في لبنان ومركز اتصال في العراق — على المنصة نفسها ومركز الاتصال نفسه.',
    toters_solution_title: 'الجواب بالطلب نفسه، لا عن الطلب',
    toters_solution_p1:
      'Open يعمل داخل Twilio Flex، مركز اتصال Toters، على دردشة التطبيق. وحين يسأل العميل عن طلبه، يستدعي الوكيل خدمة الطلبات عند Toters ويرد بحالته الفعلية ووقت الوصول المتوقع — وقت يقدر العميل يتصرّف على أساسه.',
    toters_solution_p2:
      'ويكتب في Flex كذلك. فالمحادثات المحلولة تُغلق مهمة Flex بسبب مسجّل، واللي ما يقدر الوكيل ينهيه، توجيه Flex يسنده لموظف بشري بدل ما يبقى في الطابور.',
    toters_solution_p3:
      'والحدود ترسمها الإجراءات الموصولة فعلاً، وToters صريحة في ذلك. إلغاء الطلب، وإصدار استرجاع أو رصيد، وتغيير عنوان التوصيل، والوصول إلى المتسوّق مباشرة — لا شيء من ذلك مؤتمت، لأن نقاط الكتابة ما تفتّحت بعد. كلها تذهب لموظف بشري.',
    toters_solution_p4:
      'وهناك حالتان تفرضان التحويل مهما كان بوسع الوكيل قوله: تأخّر وقت الوصول عن الموعد، وعميل باديةٌ عليه الضيق. كلتاهما تُعامَل كلحظة بشرية بحكم السياسة.',
    toters_results_intro: 'مقيساً على منظومتي الإنتاج، لبنان والعراق معاً:',
    toters_results_p1:
      'أكثر من ستة آلاف جلسة أسبوعياً تنحلّ بلا تدخل بشري، على قناة يكاد السؤال فيها يكون واحداً. وما تبقّى مو لغز: هو متركّز في الإجراءات اللي ما توصّلت بعد، وهذه قائمة بناء لا حدّ في قدرة الإجابة.',
    toters_impact_title: 'الأثر',
    toters_impact_p1:
      'ستة آلاف جلسة يحلّها الذكاء أسبوعياً في دولتين، داخل مركز الاتصال اللي تشغّله Toters أصلاً، بلا توسيع الفريق بالتناسب مع حجم الطلبات. وTwilio Flex بقي مكانه؛ ما ترحّل شي.',
    toters_impact_p2:
      'أما العميل اللي يراقب طلباً متأخراً، فالفرق عنده وقت وصول محدّد في أول رد بدل رقم في الطابور — وأما الموظفون، فأرضية عمل ما بقي معظمها أشخاصاً يسألون السؤال نفسه.',
    'Tickets AI-resolved (90 days)': 'تذاكر حلّها الذكاء (٩٠ يوم)',
    'Email and web chat': 'الإيميل ودردشة الويب',
    'Sunday agents in Zendesk': 'موظفو Sunday داخل Zendesk',
    'E-commerce / Supplements': 'تجارة إلكترونية / مكمّلات',
    'Berlin, Germany': 'برلين، ألمانيا',
    '• 31% automation rate': '• أتمتة ٣١٪',
    '• 30,309 tickets AI-resolved in 90 days':
      '• ٣٠٬٣٠٩ تذكرة حلّها الذكاء في ٩٠ يوم',
    '• Order cancellation automated in Magento':
      '• إلغاء الطلب مؤتمت داخل Magento',
    '• Medical questions always human': '• الأسئلة الطبية بشرية دائماً',
    sundaynatural_company_description:
      'Sunday Natural متجر ألماني للمكمّلات ومنتجات الصحة الطبيعية، يبيع تركيبات متميّزة مباشرة للمستهلك في أوروبا.',
    sundaynatural_hero_title:
      'كيف تؤتمت Sunday Natural ٣١٪ من الدعم بدون ما تقدّم نصيحة طبية',
    sundaynatural_what_we_did:
      'وكيل Open الذكي يتولّى ٣١٪ من الدعم الوارد على الإيميل ودردشة الويب، أمام Zendesk. يلغي الطلبات مباشرة في Magento — ويحوّل كل سؤال صحي لموظف بشري، لأن هذا في ألمانيا هو الجواب المشروع الوحيد.',
    sundaynatural_intro:
      'Sunday Natural تبيع المكمّلات ومنتجات الصحة الطبيعية من برلين. وعملاؤها ما يكتبون عن مواعيد التوصيل بقدر ما يكتبون عن المنتج نفسه: وش فيه، وكيف صُنع، وهل يناسبهم أصلاً.',
    sundaynatural_scale_title: 'الأسئلة اللي ما يجوز لمتجر مكمّلات يجيب عنها',
    sundaynatural_scale_p1:
      'نحو واحد من كل سبعة تواصلات سؤال عن المنتج، وهي أسئلة تغوص عميقاً: أحجام الجزيئات، ومصادر المواد الخام، وتفاصيل التركيبة. والإجابة الجيدة عنها تحتاج الكتالوج، لا نصاً جاهزاً.',
    sundaynatural_scale_p2:
      'وحصة معتبرة تذهب أبعد من ذلك: الحمل، والرضاعة، ونتائج تحاليل الدم. وهذه مو أسئلة صعبة الإجابة، بل أسئلة ما يُسمح لمتجر بالإجابة عنها: فالقواعد الألمانية تمنع Sunday Natural من تقديم نصيحة طبية، والجواب الصحيح تحويل لطبيب.',
    sundaynatural_scale_p3:
      'فالقيد مو في القدرة. القيد أن تعرف بالضبط أي الأسئلة يجب ألّا تُجاب آلياً أبداً، مهما بدا النظام واثقاً من صياغة رده.',
    sundaynatural_solution_title: 'واثق في المنتج، صامت عن الصحة بقرار',
    sundaynatural_solution_p1:
      'Open يشتغل على الإيميل ودردشة الويب أمام Zendesk، حيث يواصل موظفو Sunday Natural العمل على تذاكرهم. ما تغيّر شي في طريقة عملهم.',
    sundaynatural_solution_p2:
      'وفي الطلبات، الوكيل ينفّذ لا ينصح: إلغاء الطلب يُنفَّذ مباشرة على نظام Magento عند Sunday Natural، موثّقاً ومكتملاً داخل المحادثة نفسها.',
    sundaynatural_solution_p3:
      'أما الأسئلة الصحية فتسلك المسار المعاكس عن قصد. فكل ما يمسّ الحمل أو الرضاعة أو نتائج التحاليل يحوّله الوكيل لموظف بشري، بلا أي محاولة آلية للإجابة. وطلبات الوصول إلى الحساب لها مسار تحويل خاص بها.',
    sundaynatural_solution_p4:
      'وبين هذا وذاك تقف أسئلة المنتج والملاحظات والاستفسارات العامة: الوكيل يكتب المسودة، ويُحتجز الرد عشان يتدخّل موظف قبل إرساله. أما الاسترجاعات والقسائم فتبقى يدوية حتى تتوفّر الواجهات البرمجية اللازمة.',
    sundaynatural_results_intro: 'مقيساً على القنوات المدمجة وقت أخذ اللقطة:',
    sundaynatural_results_p1:
      'نسبة الـ ٣١٪ محدّدة النطاق: تغطي القنوات المدمجة حينها، والإيميل أساساً، مقابل ٩٨٬٧٧٢ تذكرة، منها ٣٠٬٣٠٩ حلّها الذكاء خلال تسعين يوماً. والأتمتة على الدردشة أقل منها على الإيميل، والسقف معروف: الاسترجاعات والقسائم وتغييرات النشرة البريدية كلها تنتظر واجهات برمجية غير موجودة بعد.',
    sundaynatural_impact_title: 'الأثر',
    sundaynatural_impact_p1:
      'أتمتة ٣١٪ على الإيميل والدردشة تتيح لفريق من سبعة موظفين أن يحمل كتالوجاً بهذا العمق التقني بلا توسيع الفريق بالتناسب مع حجم الطلبات. وZendesk بقي مكانه؛ ما ترحّل شي.',
    sundaynatural_impact_p2:
      'وما يبقى للفريق هو العمل اللي يحتاجهم فعلاً: السؤال الصحي اللي يجب أن يصل لإنسان، والاسترجاع الجزئي اللي يُحسب يدوياً، وسؤال المنتج اللي يبلغ من العمق حدّاً يستحق معه العميل خبيراً لا جواباً سريعاً.',
    'Human-approved sends': 'إرسال بموافقة بشرية',
    'Live track': 'المسار التشغيلي',
    'System of record': 'نظام السجلات',
    Admissions: 'القبول',
    'Salesforce case comments': 'تعليقات الحالات في Salesforce',
    'IU department teams': 'فرق أقسام IU',
    'Higher Education': 'التعليم العالي',
    'Erfurt, Germany': 'إرفورت، ألمانيا',
    '• Every reply human-approved before send':
      '• كل رد يوافق عليه إنسان قبل إرساله',
    '• Runs inside Salesforce': '• يعمل داخل Salesforce',
    '• Built for EU AI Act constraints':
      '• مبني على قيود قانون الذكاء الاصطناعي الأوروبي',
    '• German-language admissions flows': '• مسارات قبول بالألمانية',
    iu_company_description:
      'IU Internationale Hochschule من أكبر الجامعات في أوروبا، ويعمل فيها نحو ٤٠٠٠ موظف. وOpen يعمل داخل بيئة Salesforce عندها على ملفات القبول.',
    iu_hero_title: 'كيف تؤتمت IU دعم القبول مع موافقة بشرية على كل إرسال',
    iu_what_we_did:
      'وكيل Open الذكي يعمل على حالات القبول عند IU داخل Salesforce: يكتب المسودات، ويعيد إسناد الحالات، ويغلق ما يقدر يغلقه. وكل رسالة صادرة يوافق عليها إنسان أولاً — لا احتياطاً، بل لأن قانون الذكاء الاصطناعي الأوروبي يوجب ذلك.',
    iu_intro:
      'IU Internationale Hochschule تسجّل طلاباً بحجم قلّ أن تبلغه جامعة. وفرق القبول وخدمات الطلاب عندها تعمل داخل Salesforce، بالألمانية، على حالات يقرّر جوابها إن كان الطالب سيبدأ دراسته هذا الفصل أم ينتظر اللي يليه.',
    iu_scale_title: 'لمّا تكون الأتمتة فعلاً منظَّماً بالقانون',
    iu_scale_p1:
      'يرسل طالب شهادته ويكتب «anbei mein Zeugnis» — أي «مرفق شهادتي» — بدون ما يكون له طلب مسجّل. والمعالجة الصحيحة مو رد لطيف، بل إدراك أن الحالة تخصّ فريق معادلة الشهادات ونقلها إليه.',
    iu_scale_p2:
      'وحالات أخرى يحكمها تاريخ. فالطالب اللي يسأل متى تُعلن درجته يقع داخل النطاق ما دامت نافذة التصحيح مفتوحة، وخارجه في اللحظة اللي تُغلق فيها، والحالتان تحتاجان مخرجين مختلفين.',
    iu_scale_p3:
      'وبعضها محلّ نزاع فعلاً. فالـ Widerspruch — الاعتراض الرسمي على قرار معادلة — يصعب تمييزه بالألمانية عن مجرد إبداء عدم الرضا، والخطأ في ذلك له أثر على الطالب.',
    iu_scale_p4:
      'وفوق هذا كله يقف قانون الذكاء الاصطناعي الأوروبي. فالقرارات اللي تمسّ الوصول إلى التعليم تقع في فئة عالية المخاطر، وما كان وكيل يرسل قرارات قبول من تلقاء نفسه خياراً مطروحاً أصلاً. الموافقة البشرية هنا التزام قانوني، لا إعداد يُضبط.',
    iu_solution_title: 'يكتب داخل Salesforce، ولا يرسل وحده',
    iu_solution_p1:
      'Open يعمل على حالات IU داخل Salesforce. يقرأ مستندات المتقدّم عند الحاجة، ويكتب جوابه مسودةً، ويعرضها في الواجهة عشان يوافق عليها الموظف قبل ما يصل شيء للطالب.',
    iu_solution_p2:
      'ولمّا يكون الصواب توجيهاً لا رداً، يوجّه. فحالة المعادلة اللي تصل ومعها مستندات يعيد إسنادها لفريق المعادلة مع ضبط المالك والنوع والموضوع، وبلا إرسال أي رسالة — لأن الرد هنا هو التصرّف الخاطئ.',
    iu_solution_p3:
      'ويغلق ما انتهى فعلاً: استفسار درجة داخل نافذة التصحيح، أو طالب وجّهه لبوابة التقديم الإلكترونية. ويقدر يرسل نموذج المعادلة نفسه، ومعه المرفقات.',
    iu_solution_p4:
      'وما يسلّمه للبشر محدَّد سلفاً لا مكتشَف لاحقاً. فالمستندات اللي تحتاج حكماً أكاديمياً فردياً، واستفسارات الدرجات بعد انتهاء موعد التصحيح، وكل ما يقع في الفئات عالية المخاطر بحسب القانون، تذهب لفريق القسم المعني بالاسم.',
    iu_results_intro: 'يشتغل الآن على مسار القبول، في الإنتاج وفي مرحلة الضبط:',
    iu_results_p1:
      'المقياس هنا مو نسبة تفادٍ. المقياس أن يفتح الموظف الحالة وقد كُتبت مسودتها ووُجّهت وجهتها الصحيحة وقُرئت مستنداتها — وأن يكون الرد اللي يصل الطالب في النهاية قد وافق عليه إنسان. وهناك مسار ثانٍ يغطي المعادلات والشؤون المالية والامتحانات ومكتب الطلاب، مبني ويشتغل في بيئة الاختبار، وفي نطاقه نحو ١٢٠ ألف طلب سنوياً.',
    iu_impact_title: 'الأثر',
    iu_impact_p1:
      'دعم قبول يكتب ويوجّه ويغلق داخل النظام اللي تشغّله IU أصلاً، بلا إرسال تلقائي واحد في أي موضع منه. وSalesforce بقي مكانه؛ ما ترحّل شي.',
    iu_impact_p2:
      'أما المتقدّم فالفرق عنده أن الرد يصل أبكر ويقع عند الفريق الصحيح من أول مرة. وأما IU فأتمتة تناسب عملية منظَّمة بالقانون، بدل ما تطلب من العملية أن تتزحزح.',
    Cities: 'مدينة',
    Students: 'طالب',
    Vehicles: 'مركبة',
    'Driver chats': 'محادثة سائق',
    'Tickets automated': 'تذكرة مؤتمتة',
    Conversations: 'محادثة',
    fareharbor_company_description:
      'FareHarbor منصة الحجز والإيرادات اللي يعتمد عليها +٢٣ ألف مشغّل جولات وأنشطة ومعالم حول العالم، وهي جزء من Booking Holdings منذ ٢٠١٨.',
    fareharbor_intro:
      'FareHarbor تشغّل محرك الحجز لأكثر من ٢٣ ألف مشغّل جولات وأنشطة ومعالم: رحلات مشاهدة الحيتان في هونولولو، وجولات القنوات في أمستردام، ورحلات التسلّق في كولورادو. وحين يعجز أحدهم عن استقبال حجز، فهو لا يخسر عملية بيع تأتي لاحقاً. يخسر الرحلة نفسها.',
    fareharbor_scale_title: 'دعم على موعد الإقلاع',
    fareharbor_scale_p1:
      'أغلب الدعم البرمجي يحتمل الانتظار ساعة. ودعم FareHarbor ما يحتمل. فالمشغّل اللي يكتشف خللاً في صفحة الدفع الساعة السابعة صباحاً أمامه حتى التاسعة، موعد الانطلاق، والمقاعد على متن ذلك القارب ما تُباع مرة أخرى بعد ما يغادر الميناء. الساعة هنا يضبطها الجدول، لا اتفاقية مستوى الخدمة.',
    fareharbor_scale_p2:
      'المشغّلون أعمال صغيرة، ومن يتواصل مع الدعم عادةً هو المالك نفسه — بين جولة وأخرى، واقفاً على الرصيف، من جواله، وأمامه مجموعة تنتظر. مو جالس إلى مكتب يكتب تذكرة. ليش رحلة التاسعة ما تظهر متاحة؟ وليش ما نفذ ذلك الحجز؟',
    fareharbor_scale_p3:
      'الطلب موسمي وجغرافي في آنٍ واحد. فذروة مشغّل التزلّج في كولورادو تبعد ستة أشهر عن ذروة مشغّل الشعاب في سيدني، وFareHarbor تعمل من ستة مكاتب — دنفر وأمستردام وبوسطن وهونولولو وسان فرانسيسكو وسيدني — تغطي جميع المناطق الزمنية تقريباً. فذروة صباح هونولولو هي وردية ليل أمستردام.',
    fareharbor_scale_p4:
      'ثم يأتي الطقس. عاصفة واحدة تلغي رحلات يوم كامل، فيحتاج المشغّل إعادة جدولة عشرات الحجوزات أو استرجاعها دفعة واحدة، قبل ما يبدأ عملاؤه بالاتصال به.',
    fareharbor_solution_title: 'وكيل Open الذكي',
    fareharbor_solution_p1:
      'الوكيل الذكي يتولّى الدعم على الإيميل والدردشة والمكالمات. والمكالمات هنا أثقل وزناً منها في أي قطاع آخر: فالمشغّل الواقف على الرصيف ومجموعته تصعد للقارب يتصل ويحصل على جواب، وهذا ما لا يقدر عليه نموذج تذكرة.',
    fareharbor_solution_p2:
      'في مشكلات الحجز، يفتح الوكيل الحجز، ويحدد ما إذا كان السبب في التوفّر أو التسعير أو إعداد في صفحة الدفع، ثم يصحّحه. وفي المدفوعات، يتحقق من العملية، ويوضّح وين يقف المبلغ المدفوع أو المسترد، وينفّذ اللي يقدر ينفّذه.',
    fareharbor_solution_p3:
      'إلغاءات الطقس تُعالَج دفعة واحدة، لا رسالة رسالة. يمرّ الوكيل على الرحلات المتأثرة، ويطبّق سياسة الإلغاء الخاصة بالمشغّل نفسه، ثم ينفّذ إعادة الجدولة أو الاسترجاع.',
    fareharbor_solution_p4:
      'أسئلة الإعداد — قواعد التوفّر، والتسعير الموسمي، وتوزيع الموارد، ودمج مسار الحجز داخل موقع المشغّل — تُجاب انطلاقاً من إعداد ذلك المشغّل فعلياً، لا من مقال مساعدة عام. أما التكاملات المخصّصة عبر الـ APIs وأسئلة العقود ونزاعات الدفع فتذهب لفريق FareHarbor ومعها الخيط كاملاً.',
    fareharbor_results_intro:
      'وكيل Open الذكي يتولّى الآن دعم مشغّلي FareHarbor:',
    fareharbor_results_p1:
      'ما يهم هو وصول الجواب داخل نافذة التشغيل. فالمشغّل اللي تُصلَح صفحة الدفع عنده قبل انطلاق التاسعة يحتفظ بإيراد تلك الرحلة. ومن يصله الرد بعد الظهر ما يحتفظ به.',
    fareharbor_impact_title: 'الأثر',
    fareharbor_impact_p1:
      'أتمتة ٨٧٪ على الإيميل والدردشة والمكالمات تتيح لـ FareHarbor أن تحمل +٢٣ ألف مشغّل عبر ذروات المواسم بلا توسيع الفريق بالتناسب. وحين تدخل منطقة موسمها المرتفع، ينتقل الحمل إليها تلقائياً.',
    fareharbor_impact_p2:
      'وفريق FareHarbor انتقل للعمل اللي يحتاجه فعلاً: التكاملات المعقّدة للمشغّلين الكبار، والتحسينات اللي تخرج مما يراه الدعم متكرراً. وعبر التكامل مع Booking.com، يصل المشغّلون اللي تخدمهم لمسافرين في ١١٥ دولة وأكثر من ٥٠٠٠ مدينة.',
    'How Qoyod automates 77% of support for 25,000+ businesses':
      'كيف أتمتت قيود ٨٥٪ من الدعم لـ+٢٥ ألف شركة',
    'Open fully replaced HubSpot and handles 77% of support across email, chat, WhatsApp, and voice. Businesses get instant help with invoicing, VAT compliance, and financial reporting.':
      'Open حلّ محل HubSpot بالكامل، ويتعامل مع ٨٥٪ من الدعم عبر الإيميل والدردشة. سؤال عن فاتورة أو حساب ضريبة أو تقرير مالي؟ الجواب فوري.',
    'SaaS / Accounting Software': 'برمجيات كخدمة / برامج محاسبة',
    channels: 'قنوات',
    '• 25,000+ businesses served': '• +٢٥ ألف شركة',
    '• Fully replaced HubSpot': '• بديل كامل لـHubSpot',
    '• Email, chat, WhatsApp, voice': '• إيميل، دردشة، WhatsApp، مكالمات',
    'Email, chat, WhatsApp, voice': 'إيميل، دردشة، WhatsApp، مكالمات',
    'Previous solution': 'النظام السابق',
    'Fully replaced HubSpot': 'HubSpot — استبدله Open بالكامل',
    qoyod_company_description:
      'قيود منصة محاسبة سحابية تخدم +٢٥ ألف شركة في الفوترة والمخزون والضريبة وإدارة المالية.',
    qoyod_intro:
      'قيود تخدم +٢٥ ألف شركة ببرنامج محاسبة للفوترة والمخزون والضريبة والتقارير المالية. ولمّا يريد صاحب شركة أن يفهم حساب الضريبة قبل تقديم الإقرار، فهو لا ينتظر إلى الغد.',
    qoyod_scale_title: 'دعم محاسبي على نطاق واسع',
    qoyod_scale_p1:
      'دعم برامج المحاسبة يتطلب دقة. صاحب شركة يجهّز تقارير نهاية الشهر يريد يعرف ليش ما تتطابق الأرقام. وتاجر يعدّ إقراراً ضريبياً يريد يفهم من وين جاء الرقم. ومتجر إلكتروني يريد تصحيح قالب فاتورة قبل إرسالها لعميله.',
    qoyod_scale_p2:
      'ولا بد أن يعمل الدعم بالعربية والإنجليزية. فقوانين الضريبة تختلف من دولة إلى أخرى، وطريقة العمل تختلف بين السعودية والإمارات وباقي الأسواق. والبرنامج يتعامل مع العملة المحلية وقواعد الضريبة المحلية وطريقة عمل كل سوق.',
    qoyod_scale_p3:
      'قبل Open، كانت قيود على HubSpot. الردود بطيئة، والشركات ما تحصل مساعدة فورية على أسئلة محاسبة ما تنتظر.',
    qoyod_solution_title: 'Open استبدل HubSpot',
    qoyod_solution_p1:
      'Open استبدل HubSpot بالكامل ويتعامل مع الدعم عبر الإيميل والدردشة. صاحب شركة يسأل عن حساب الضريبة بالعربي؟ النظام يفتح الفاتورة، يشرح تفاصيل الضريبة، ويتأكد إن الحساب صحيح. فوراً.',
    qoyod_solution_p2:
      'والأسئلة التقنية تحصل جواب دقيق: قالب فاتورة مخصص، فرق في المخزون، تقرير مالي معيّن. النظام يفهم مميزات قيود، يمشّي المستخدم خطوة خطوة، ويحل المشكلة لحظياً.',
    qoyod_solution_p3:
      'والالتزام بالأنظمة المحلية يتم بشكل صحيح من أول مرة. النظام يفهم قوانين الضريبة في كل دولة، ومتطلبات الفوترة الإلكترونية، واللوائح المحلية. والحالات المعقدة تصعّد مع كل السياق.',
    qoyod_results_intro: 'Open الآن يشغل دعم عملاء قيود:',
    qoyod_results_p1:
      '٨٥٪ أتمتة عبر الإيميل والدردشة. صاحب الشركة يحصل جوابه عن حساب الضريبة فوراً، بدل ما ينتظر يوم العمل التالي. والنظام يتعامل مع العربي والإنجليزي بنفس الدقة.',
    qoyod_impact_title: 'الأثر',
    qoyod_impact_p1:
      '٨٥٪ أتمتة عبر الإيميل والدردشة. قيود تخدم +٢٥ ألف شركة بدون ما يكبر الدعم بنفس النسبة. والنظام يتعامل مع أسئلة المحاسبة التقنية والالتزام الضريبي ومشاكل البرنامج في نفس الوقت.',
    qoyod_impact_p2:
      'ولصاحب الشركة اللي يدير ماليته، الدعم يشتغل ببساطة. فسؤال عن الإقرار الضريبي يحصل على رد في ٣٠ ثانية. بالعربية أو الإنجليزية. ويقدّم إقراره في وقته.',
    'How CookingLife serves 1M+ customers with AI-powered support':
      'كيف تخدم CookingLife +مليون عميل بالـ AI',
    'Customers served': 'عميل',
    'Products in catalog': 'منتج',
    "Open's AI agent handles 70%+ of support inquiries across order tracking, product questions, returns, and delivery issues. Customers get instant answers while the team focuses on complex cases.":
      'نظام Open يرد على +٧٠٪ من الاستفسارات: تتبع الطلب، أسئلة المنتجات، الإرجاع، ومشاكل التوصيل. العميل يحصل رده فوراً، والفريق يتفرغ للحالات المعقدة.',
    'E-commerce / Retail': 'تجارة إلكترونية / تجزئة',
    Netherlands: 'هولندا',
    '• Under 1 minute response time': '• رد بأقل من دقيقة',
    '• 60% reduction in support costs': '• انخفاض ٦٠٪ في تكاليف الدعم',
    '• 1M+ customers served': '• +مليون عميل',
    '• 10,000+ products covered': '• +١٠ آلاف منتج',
    cookinglife_hero_title: 'كيف أتمتت CookingLife ٧٠٪ من الدعم لـ+مليون عميل',
    cookinglife_what_we_did:
      'نظام Open يتعامل مع +٧٠٪ من استفسارات الدعم: تتبع الطلبات، أسئلة المنتجات، الإرجاع، ومشاكل التوصيل. العميل يحصل رده فوراً، والفريق يتفرغ للحالات المعقدة.',
    cookinglife_company_description:
      'CookingLife متجر هولندي رائد لأدوات المطبخ، يقدم +١٠ آلاف منتج لـ+مليون عميل.',
    cookinglife_intro:
      'CookingLife من أكبر متاجر أدوات المطبخ الإلكترونية في هولندا، تخدم +مليون عميل بتشكيلة مختارة من +١٠ آلاف منتج من علامات فاخرة مثل Le Creuset وKitchenAid وZwilling.',
    cookinglife_challenge_title: 'تحدي التجارة الإلكترونية',
    cookinglife_challenge_p1:
      'تشغيل تجارة إلكترونية بهذا الحجم يعني آلاف الاستفسارات كل يوم. وين طلبي؟ أقدر أرجّع هذا؟ هذا القدر يشتغل على موقد الحث عندي؟ وش الفرق بين طقمي السكاكين هذين؟',
    cookinglife_challenge_p2:
      'كل سؤال يحتاج جواباً. وكل مشكلة طلب تحتاج حلاً. وفي التجزئة الإلكترونية، تنعكس سرعة الرد مباشرة على رضا العميل وعلى عودته للشراء مرة أخرى.',
    cookinglife_solution_title: 'وش يعمله Open',
    cookinglife_solution_p1:
      'اليوم، Open يتعامل مع +٧٠٪ من دعم CookingLife. النظام مدرّب على كتالوج المنتجات كامل، وسياسات الشحن، وإجراءات الإرجاع، ومعرفة كل علامة تجارية.',
    cookinglife_solution_p2:
      'يرد على أسئلة المنتجات بخبرة فعلية: يعرف الفرق بين الستانلس ستيل والتفلون، وأي قدور تعمل على مواقد الحث، وأي سكين يناسب أي طريقة طبخ.',
    cookinglife_solution_p3:
      'ولاستفسارات الطلبات، Open متصل بأنظمة CookingLife: يعطي تتبع لحظي، يعالج طلبات الإرجاع، ويحل مشاكل التوصيل تلقائياً.',
    cookinglife_automation_title: 'أتمتة تعمل فعلاً',
    cookinglife_automation_intro: 'التنفيذ ركّز على ثلاثة مجالات:',
    cookinglife_automation_orders: 'تتبع آلي وتحديثات توصيل ومعالجة الإرجاع',
    cookinglife_automation_products:
      'نظام مدرّب على +١٠ آلاف منتج بمواصفاتها التفصيلية',
    'Inventory Integration': 'تكامل المخزون:',
    cookinglife_automation_inventory:
      'فحص المخزون الفوري وإشعارات إعادة التخزين',
    cookinglife_automation_escalation:
      'ولما السؤال يحتاج حكم بشري — مطالبة ضمان أو منتج واصل تالف — Open يصعّد مع السياق الكامل، والتسليم يمر بدون ما يحس العميل.',
    cookinglife_results_intro: 'الأتمتة حققت أثراً واضحاً وقابلاً للقياس:',
    prets_hero_title: 'كيف تدير Prêts كل محادثة مع صاحب المنزل من منصتها هي',
    prets_what_we_did:
      'Prêts تشغّل Open من منصتها للتمويل الأخضر، فصاحب المنزل ياخذ جواب كامل على أي قناة وأي ساعة — ومعه سياق طلبه كامل، و Salesforce تبقى المصدر الأساسي.',
    prets_company_description:
      'Prêts تدمج التمويل الأخضر داخل صفحة الدفع لترقيات الطاقة المنزلية، وتساعد أصحاب المنازل في هولندا يعرفون هل الترقية مجدية مالياً وكيف يمولونها.',
    prets_industry: 'تقنية مالية / تمويل أخضر',
    prets_location: 'هولندا',
    prets_key_result_1: '• الوارد والصادر على نظام واحد',
    prets_key_result_2: '• WhatsApp و الإيميل و الويب مغطّاة',
    prets_key_result_3: '• Salesforce تبقى المصدر الأساسي',
    prets_key_result_4: '• المسارات تُبنى وتُطوَّر داخلياً',
    prets_intro:
      'صاحب المنزل اللي يفكر يعزل السقف أو يركّب مضخة حرارية ياخذ قرارين بنفس اللحظة: هل الترقية تستاهل، وكيف يدفع ثمنها. Prêts موجودة داخل صفحة الدفع عند المركّب وتجاوب على الاثنين. وهذا يحط فريقها في وسط طلب تمويل، مو سؤال عن منتج — وطلبات التمويل ما تلتزم بدوام.',
    prets_challenge_title: 'طلب التمويل مو تذكرة دعم',
    prets_challenge_p1:
      'كل محادثة بين Prêts وصاحب المنزل مربوطة بملف واقف عند مرحلة من الطلب: تسعير، أو تقديم، أو انتظار مستندات، أو موافقة. والجواب اللي يتجاهل وين واقف الملف أسوأ من لا جواب، لأن صاحب المنزل يتصرّف بناءً عليه.',
    prets_challenge_p2:
      'و Prêts ما تملك لحظة التواصل أصلاً. الاهتمام يبدأ عند صفحة الدفع للمركّب، يعني مساءً وفي الإجازات — بالضبط الوقت اللي ما فيه فريق دعم. المحادثات كانت في Intercom، ورسائل دورة الحياة في Customer.io، والملف نفسه في Salesforce. ثلاثة أنظمة، وثلاث صور لنفس الشخص.',
    prets_challenge_p3:
      'و Prêts فريق منتج، مو فريق أدوات دعم. فاللي يشغّل المحادثة لازم يقدرون يغيّرونه بأنفسهم، على دورة إصدارهم هم، بدون ما يرفعون طلب لمزوّد.',
    prets_solution_title: 'وش يسوي Open',
    prets_solution_p1:
      'Prêts استبدلت Intercom و Customer.io بـ Open، وخلّت Salesforce المصدر الأساسي. Open يتزامن مع Salesforce بدل ما ينافسه، فيبقى الملف في المكان اللي يشتغل فيه فريق العمليات أصلاً.',
    prets_solution_p2:
      'Open يُشغَّل من منصة Prêts، مو من لوحة دعم منفصلة. لمّا المنصة تشوف الطلب غيّر حالته، تطلق المحادثة — وارد أو صادر، على WhatsApp أو الإيميل أو الويب — والوكيل يجاوب والملف معه.',
    prets_solution_p3:
      'التحويل صار قناة قناة، مو دفعة وحدة: كل مسار ينتقل بعد ما يتأكدون منه في Open. WhatsApp راح أول، ومعه الرسائل الصادرة، وبعده الإيميل.',
    prets_solution_p4:
      'و Prêts تبني هذي المسارات وتطوّرها بنفسها. وفريق العمليات يبقى العنصر البشري في أي شي يحتاج حكم — مستند ما يطابق، أو طلب يحتاج قرار — ويستلمه من Salesforce، حتى خارج الدوام.',
    prets_quote_p1:
      'Open يشتغل كمحرك تواصل متكامل مع العملاء، بس نحن اللي نوجهه ونشغّله من منصتنا. وهذا يعطينا قدرة نوصل لكل مستهلك على أي قناة، وارد أو صادر، من نظام واحد، ونخدمه بشكل وكيلي.',
    prets_quote_p2:
      'ونبني هذي المسارات ونطوّرها بأنفسنا، فنطلق اللي يحتاجه المستهلك فعلاً. أصحاب المنازل يتحركون على إيقاعهم، أي ساعة، وياخذون أجوبة كاملة ومعها سياق ملفهم كامل.',
    prets_quote_p3:
      'ولأن Open موصول بـ Salesforce، قسم العمليات عندنا عنده مكان واحد يشتغل منه كعنصر بشري ويمسك كل ملف، حتى خارج أوقات الدوام.',
    prets_quote_attribution: 'ياسبر، نيابة عن كوين فيسخر، Prêts',
    prets_impact_title: 'الأثر',
    prets_impact_p1:
      'أصحاب المنازل يتحركون على إيقاعهم. واللي يقارن عروض مضخات حرارية الساعة ١١ بالليل ياخذ جواب كامل ومعه ملفه، بدل نموذج ووعد برد يوم الاثنين.',
    prets_impact_p2:
      'Prêts لسه في بداية التشغيل وما تنشر أرقام حل أو أزمنة رد إلى الآن. نسبة الحل، وأزمنة الرد، والطلبات اللي تكتمل خارج الدوام تُقاس الحين، وهذي القصة بتحملها لمّا تكون Prêts جاهزة تشاركها.',
    cookinglife_quote_p1:
      'من يوم ما اشتغل الوكيل Charlie، صار ٧٠٪ من استفسارات عملائنا ينحل أوتوماتيكي.',
    cookinglife_quote_p2:
      'وهذا يعطي فريقنا وقت أكثر للأسئلة المعقدة اللي نقصد نتعامل معها بنفسنا.',
    cookinglife_quote_p3:
      'وأحلى شي؟ Charlie يحقق ٩١٪ رضا عملاء. تعاون ذكي مع OpenCX رفع خدمة العملاء لمستوى ثاني.',
    cookinglife_quote_attribution:
      'ديفي، أخصائي دعم العملاء وتقنية المعلومات في CookingLife',
    cookinglife_impact_title: 'الأثر',
    cookinglife_impact_p1:
      '٧٠٪ أتمتة تعني CookingLife تكبّر قاعدة عملائها بدون ما يكبر فريق الدعم بنفس النسبة. والعميل يحصل رده أي ساعة، سواء يسأل عن قدر في نص الليل أو يتتبع توصيل صبح الأحد.',
    cookinglife_impact_p2:
      'وفريق الدعم تطوّر: من الرد على الأسئلة الروتينية، إلى علاقات العملاء المعقدة، وخبرة المنتجات، وتحسين تجربة الشراء كاملة.',
    cookinglife_impact_p3:
      'لمتجر يخدم +مليون عميل بـ+١٠ آلاف منتج، هذا الفرق بين إنك تغرق في التذاكر وإنك تقدم خدمة استثنائية على نطاق واسع.',
    'How Snel Een Taxi competes with Uber & Bolt using AI support':
      'كيف تنافس Snel Een Taxi عمالقة مثل Uber وBolt بدعم ذكي',
    'Drivers nationwide': 'سائق في كل البلاد',
    "Open's AI agent handles 70%+ of support inquiries for ride bookings, driver questions, and trip issues. Customers and drivers get instant responses 24/7 in Dutch.":
      'نظام Open يرد على +٧٠٪ من الاستفسارات: الحجز، أسئلة السائقين، ومشاكل الرحلات. العميل والسائق يحصلون رد فوري ٢٤/٧، بالهولندي.',
    'Transportation / Ride-Hailing': 'نقل / طلب سيارات',
    'Utrecht, Netherlands': 'أوتريخت، هولندا',
    '• 6,000+ drivers supported': '• +٦ آلاف سائق',
    '• 24/7 Dutch support': '• دعم ٢٤/٧ بالهولندي',
    '• Nationwide coverage': '• تغطية كل البلاد',
    '• 75%+ automation rate': '• معدل أتمتة +٧٥٪',
    sneleentaxi_hero_title:
      'كيف تنافس Snel Een Taxi عمالقة مثل Uber وBolt بدعم ذكي',
    sneleentaxi_what_we_did:
      'نظام Open يرد على +٧٥٪ من الاستفسارات: الحجز، أسئلة السائقين، ومشاكل الرحلات. العميل والسائق يحصلون رد فوري ٢٤/٧، بالهولندي.',
    sneleentaxi_company_description:
      'Snel Een Taxi منصة هولندية لطلب السيارات بـ+٦ آلاف سائق، تقدم خدمات التاكسي والنقل الصحي في كل البلاد.',
    sneleentaxi_intro:
      'Snel Een Taxi شركة هولندية لطلب السيارات، تأسست في ٢٠١٥ في أوتريخت. بـ+٦ آلاف سائق وتغطية كل البلاد، صاروا البديل المحلي للعمالقة مثل Uber وBolt.',
    sneleentaxi_competing_title: 'المنافسة مع العمالقة',
    sneleentaxi_competing_p1:
      'Uber وBolt ياخذون العناوين. فكيف تنافس شركة هولندية؟ Snel Een Taxi لقوا جوابهم: خبرة محلية، وتغطية من المدن لأصغر قرية، وخدمة عملاء تتكلم هولندي فعلاً.',
    sneleentaxi_competing_p2:
      'بس توسيع الدعم لمئات آلاف الرحلات مع الحفاظ على نفس اللمسة الشخصية؟ هنا احتاجوا مساعدة. كل سؤال حجز، وكل مشكلة سائق، وكل خلل في رحلة — كلها تحتاج معالجة سريعة.',
    sneleentaxi_solution_title: 'وش يعمله Open',
    sneleentaxi_solution_p1:
      'اليوم، Open يتعامل مع +٧٥٪ من دعم Snel Een Taxi. النظام يدير حالة الرحلات، تعديل الحجوزات، أسئلة تسجيل السائقين، مشاكل الدفع، ونزاعات الرحلات — كلها بالهولندي.',
    sneleentaxi_solution_p2:
      'للعميل، تعني رداً فورياً عن رحلته. وين تاكسيي؟ أقدر أغيّر وقت الاستلام؟ وش صار لحجزي؟ كلها تنحل في ثوانٍ، في أي وقت.',
    sneleentaxi_solution_p3:
      'وللسائق، معناها مساعدة سريعة في التطبيق والدفع ومشاكل الطريق. شبكة الـ+٦ آلاف سائق تحصل دعمها بدون انتظار، وتبقى على الطريق تكسب.',
    sneleentaxi_scaling_title: 'التوسع للمنافسة',
    sneleentaxi_scaling_intro: 'التنفيذ غطى ثلاثة مجالات حرجة:',
    'Customer Support': 'دعم العملاء:',
    sneleentaxi_scaling_customer:
      'تتبع الرحلة، تغيير الحجز، ومشاكل الرحلة — تنحل فوراً',
    'Driver Support': 'دعم السائقين:',
    sneleentaxi_scaling_driver:
      'مساعدة في التطبيق، أسئلة الدفع، وتسجيل السائقين',
    'Healthcare Transport': 'النقل الصحي:',
    sneleentaxi_scaling_healthcare: 'دعم متخصص لحجوزات النقل الطبي',
    sneleentaxi_scaling_escalation:
      'ولما المشكلة تحتاج حكم بشري — نزاع معقد أو طلب ترتيبات خاصة — Open يصعّدها مع كل السياق للفريق الهولندي.',
    sneleentaxi_results_intro: 'الأتمتة غيرت طريقة عمل Snel Een Taxi:',
    sneleentaxi_quote_p1:
      'إعداد قاعدة المعرفة كان مباشر، ولأننا نشوف المنطق ورا قرارات Lisa، صار سهل نعرف وين تحتاج القاعدة تعديل ونضبطها.',
    sneleentaxi_quote_p2:
      'وقدرنا نصيغ شخصية Lisa بطريقة تحسها بشرية فعلاً، لدرجة إن العميل أحياناً ما يدري إنه يكلم وكيل AI. وترد بخفة دم على الرسائل الغريبة، وهذا يضحّك فريقنا باستمرار.',
    sneleentaxi_quote_p3:
      'Lisa أثبتت قيمتها في فترة كان فيها فريق الدعم ناقص. لمّا خطأ من عندنا عطّل المسارات اللي تعتمد عليها، رجعنا نزحم مثل الأيام القديمة. ما تحل كل شي بشكل مثالي، بس لمّا تغيب نحس فيها.',
    sneleentaxi_quote_attribution: 'طارق أزواغ، مدير التسويق في Snel Een Taxi',
    sneleentaxi_impact_title: 'الأثر',
    sneleentaxi_impact_p1:
      '٧٥٪ أتمتة تعني Snel Een Taxi تستقبل حجم دعم ينافس شركات أكبر منها بمراحل. والعميل والسائق يحصلون مساعدة فورية بلغتهم، أي ساعة، في أمستردام أو في قرية صغيرة.',
    sneleentaxi_impact_p2:
      'وفريق الدعم انتقل من الرد على "وين تاكسيي؟" ألف مرة، إلى الحالات المعقدة، وبناء علاقات مع السائقين، وتحسين الخدمة من ملاحظات الدعم.',
    sneleentaxi_impact_p3:
      'لشركة هولندية تنافس عمالقة طلب السيارات، هذا الفرق بين إنك تلحق وإنك تفوز فعلاً على أرضك.',
    'How De Online Drogist handles 65%+ of support via WhatsApp':
      'كيف تحل De Online Drogist +٦٥٪ من الدعم عبر WhatsApp',
    'WhatsApp automation': 'أتمتة WhatsApp',
    Products: 'منتج',
    'Award winner': 'فوز بالجائزة',
    "Open's AI agent handles 65%+ of support via WhatsApp—order tracking, product questions, and health advice. Customers get instant answers in Dutch, 24/7.":
      'نظام Open يرد على +٦٥٪ من الاستفسارات عبر WhatsApp: تتبع الطلبات، أسئلة المنتجات، ونصائح صحية. العميل يحصل رده فوراً، ٢٤/٧، بالهولندي.',
    'E-commerce / Healthcare': 'تجارة إلكترونية / صحة',
    '• 65%+ WhatsApp automation': '• أتمتة WhatsApp +٦٥٪',
    '• 40,000+ products covered': '• +٤٠ ألف منتج',
    '• 5x Shopping Award winner': '• فوز بجائزة التسوق ٥ مرات',
    deonlinedrogist_hero_title:
      'كيف أتمتت De Online Drogist ٧٣٪ من الدعم بـ+٢٥ إجراء معقد',
    'Complex actions': 'إجراء معقد',
    deonlinedrogist_what_we_did:
      'نظام Open يتعامل مع ٧٣٪ من الدعم عبر +٢٥ إجراء معقد: تتبع الطلبات، الإرجاع، توصيات المنتجات، والنصائح الصحية. العميل يحصل رده فوراً، ٢٤/٧، بأي لغة.',
    deonlinedrogist_company_description:
      'De Online Drogist أكبر صيدلية إلكترونية في هولندا، تقدم +٤٠ ألف منتج للصحة والعناية الشخصية والعافية.',
    deonlinedrogist_intro:
      'De Online Drogist أكبر صيدلية إلكترونية في هولندا. تأسست في ٢٠٠٧، ونمت لتقدم +٤٠ ألف منتج في الصحة والعناية الشخصية والمكملات ورعاية الأطفال والجمال — وفازت بجائزة التسوق الهولندية خمس مرات.',
    deonlinedrogist_challenge_title: 'تحدي التجارة الإلكترونية',
    deonlinedrogist_challenge_p1:
      'تشغيل تجارة إلكترونية بـ+٤٠ ألف منتج يعني حجم استفسارات ضخم. من تتبع طلب، إلى توصية بمنتج، إلى نصيحة صحية.',
    deonlinedrogist_challenge_p2:
      'والعميل يتوقع رداً فورياً على أي قناة وبأي لغة. ومع كتالوج بهذا الحجم، المعرفة المطلوبة ضخمة — ولا بد أن يشعر العميل في كل رد بأنه شخصي ومفيد.',
    deonlinedrogist_solution_title: 'وش يعمله Open',
    deonlinedrogist_solution_p1:
      'اليوم، Open يتعامل مع ٧٣٪ من دعم De Online Drogist عبر +٢٥ إجراء معقد متصل بأنظمتهم. النظام مدرّب على الكتالوج كامل، وسياسات الشحن، والإرشادات الصحية.',
    deonlinedrogist_solution_p2:
      'لاستفسارات الطلبات، Open يعطي تتبع لحظي، يعالج الإرجاع والاسترداد، يعدّل الطلب، ويحل مشاكل التوصيل تلقائياً. ولأسئلة المنتجات، يوصي بناءً على حاجة العميل واعتباراته الصحية.',
    deonlinedrogist_solution_p3:
      'ولما السؤال يحتاج حكم مهني — نصيحة صحية معقدة أو استفسار عن وصفة — Open يصعّد لفريق الصيادلة المؤهلين مع سياق المحادثة كامل.',
    deonlinedrogist_actions_title: 'أتمتة التجارة الشاملة',
    deonlinedrogist_actions_intro:
      'النظام متصل مباشرة بأنظمتهم، وينفّذ +٢٥ إجراء معقد:',
    'Order Management': 'إدارة الطلبات:',
    deonlinedrogist_action_orders:
      'تتبع، تعديل، إلغاء الطلبات، ومعالجة الإرجاع من أوله لآخره',
    'Product Expertise': 'خبرة المنتجات:',
    deonlinedrogist_action_products:
      'نظام مدرّب على +٤٠ ألف منتج مع الإرشادات الصحية والتوصيات',
    'Returns & Refunds': 'الإرجاع والاسترداد:',
    deonlinedrogist_action_returns:
      'معالجة الإرجاع، إصدار الملصقات، وإرجاع الفلوس تلقائياً',
    'Multilingual Support': 'دعم متعدد اللغات:',
    deonlinedrogist_action_multilingual: 'خدمة العملاء بأي لغة، ٢٤/٧',
    deonlinedrogist_results_intro: 'الأتمتة حققت أثراً كبيراً:',
    '24/7 multilingual': '٢٤/٧ بكل اللغات',
    deonlinedrogist_quote_p1:
      'موظفونا كانوا يقضون يومهم على «وين طلبي؟» و«هل أقدر آخذ هذين المكملين مع بعض؟». اليوم يوصلهم اللي يحتاج بشر فعلاً: أسئلة الأدوية، والشكاوى، وأي شي فيه تفاصيل حساسة. جودة الوظيفة ارتفعت، مو بس كلفة التواصل.',
    deonlinedrogist_quote_p2:
      'والجودة ما نزلت. هذا كان همي الأكبر قبل ما نبدأ. CSAT ثبت، والتحويل يوصل بالسياق الكامل، فالعميل ما يعيد كلامه لمّا يستلم موظف.',
    deonlinedrogist_quote_p3:
      'وهو مفتوح فعلاً. إننا نقدر نوصل لـ OpenCX عبر MCP يعني بيانات الدعم عندنا في نفس المكان اللي فيه بيانات التحليلات والـ SEO والتسعير. أقدر أسأل سؤال واحد يمر عليها كلها. أغلب المزودين في هذا المجال صندوق مغلق مركّب عليه لوحة. OpenCX مو كذا.',
    deonlinedrogist_quote_attribution: 'يواخيم دي بور، De Online Drogist',
    deonlinedrogist_impact_title: 'الأثر',
    deonlinedrogist_impact_p1:
      '٧٣٪ أتمتة عبر +٢٥ إجراء معقد تعني De Online Drogist تدير تجارتها من أولها لآخرها بدون ما يكبر فريق الدعم بنفس النسبة. والعميل يحصل مساعدة فورية في الطلب والإرجاع وأسئلة المنتجات، بأي لغة.',
    deonlinedrogist_impact_p2:
      'وفريق الصيادلة المؤهلين صار على الاستشارات الصحية المعقدة، وعلاقات العملاء، وتنسيق توصيات المنتجات. فازوا بجائزة التسوق خمس مرات، ورضا العملاء لا يزال يرتفع.',
    deonlinedrogist_impact_p3:
      'لأكبر صيدلية إلكترونية في هولندا، هذا الفرق بين خدمة عملاء زينة وتجربة عملاء تفوز بجوائز.',
    '• 73% automation rate': '• معدل أتمتة ٧٣٪',
    '• 25+ complex actions': '• +٢٥ إجراء معقد',
    '• End-to-end commerce': '• تجارة شاملة',
    '• 24/7 multilingual support': '• دعم متعدد اللغات ٢٤/٧',

    'customer stories': 'قصة نجاح',
    'Help articles synced': 'مقال مساعدة متزامن',
    'Channels in one thread': 'قنوات في محادثة واحدة',
    'Countries served': 'دولة مخدومة',
    'Systems in one product': 'أنظمة في منتج واحد',
    'Instructions written by the AI': 'تعليمة كتبها الوكيل',
    'Watch the story': 'شوف القصة',
    fareharbor_video_headline:
      'شوف كيف وسّعت FareHarbor دعم منظمي الرحلات حول العالم',
    ticketswap_video_headline:
      'شوف كيف أتمتت TicketSwap ٧٨٪ من دعم ١٩ مليون مستخدم',
    moneygram_video_headline:
      'شوف كيف تدعم MoneyGram ٥٥ مليون عميل في +٢٠٠ دولة',
    qoyod_video_headline: 'شوف كيف أتمتت قيود ٨٥٪ من دعم +٢٥ ألف شركة',
    oto_video_headline: 'شوف كيف أتمتت OTO ٧٧٪ من دعمها ورضا فوق ٩٠٪',
    syarah_video_headline: 'شوف كيف تخدم سيارة الـ٩٥٪ اللي يفضّلون العربية',
    'Now playing': 'يُعرض الآن',
    'Play next': 'التالي',
    fareharbor_video_title:
      'كيف وسّعت FareHarbor دعم منظمي الرحلات عالمياً مع Open',
    ticketswap_video_title: 'كيف وصلت TicketSwap لأعلى رضا عملاء مع Open',
    mollie_video_title: 'كيف تدير Mollie +٢٥٠ ألف شركة بامتثال كامل',
    moneygram_video_title: 'كيف تدعم MoneyGram ٥٥ مليون عميل في +٢٠٠ دولة',
    qoyod_video_title: 'كيف أتمتت قيود ٨٥٪ من دعم +٢٥ ألف شركة',
    oto_video_title: 'كيف أتمتت OTO ٧٧٪ من دعمها مع Open',
    syarah_video_title: 'كيف تدير منصة سيارة دعم عملائها مع Open',

    /* BANQY */
    banqy_hero_title:
      'كيف تخلي Banqy محادثة التمويل العقاري مستمرة عبر الأيام والقنوات',
    banqy_what_we_did:
      'وكيل يحمل طلب تمويل ناقصاً من واتساب لشات الموقع بدون ما يطلب من المتقدّم يبدأ من جديد.',
    banqy_company_description:
      'Banqy منصة تمويل عقاري في الإمارات تاخذ مشتري المنزل من أول استفسار للأهلية للطلب.',
    banqy_industry: 'تمويل عقاري وتقنية مالية',
    banqy_location: 'الإمارات العربية المتحدة',
    banqy_key_result_1: 'مباشر على واتساب وشات الموقع بالعربية والإنجليزية',
    banqy_key_result_2:
      'تقييم الأهلية مدرّب داخل الوكيل، والتقدّم محفوظ بين المحادثات',
    banqy_key_result_3:
      'واتساب وشات وإيميل ورسائل وهاتف وسوشيال في سجل محادثة واحد',
    banqy_key_result_4: 'الوكيل يتوقف لما يدخل زميل، ويكمّل لما يطلع',
    banqy_intro:
      'ما أحد يقدّم على تمويل عقاري بجلسة وحدة. يسأل وش ممكن يستحق، ويروح يدوّر على كشف راتب، ويرجع بعد يومين من جهاز ثاني، ويتوقع المحادثة تكمّل من وين وقفت. وBanqy هي المنصة الإماراتية اللي لازم تخلي هذا كله يحس كمحادثة وحدة.',
    banqy_challenge_title: 'طلب واحد، موزّع على ست قنوات',
    banqy_challenge_p1:
      'الاستفسارات كانت توصل عبر واتساب وشات الموقع والإيميل والرسائل والهاتف والسوشيال، وكل قناة تتصرف كجزيرة لحالها. نفس المتقدّم ممكن يكون موجوداً ست مرات، وقصته الناقصة موزّعة عليهم كلهم.',
    banqy_challenge_p2:
      'وأسئلة التمويل العقاري ما تنجاوب بشكل عام. استحقاق الشخص يعتمد على دخله ووضعه والعقار، والجواب المشجّع اللي ما يقول شيئاً يضيّع وقت الجميع — وقته ووقت المستشار.',
    banqy_challenge_p3:
      'والشغل المكلف يقعد في آخر المسار. إنشاء حساب وجمع مستندات لشخص ما كان مستحقاً أصلاً يكلّف Banqy وقتاً حقيقياً، وعشان كذا التأهيل المبكر أهم من سرعة الرد.',
    banqy_solution_title: 'وش يسوي Open',
    banqy_solution_p1:
      'كل قناة تتوحّد في محادثة وحدة بذاكرة وحدة، فالمتقدّم اللي بدأ على واتساب ورجع على شات الموقع هو نفس الشخص عند الوكيل، في منتصف طلبه مو في أوله.',
    banqy_solution_p2:
      'وتقييم الأهلية عند Banqy مدرّب داخل الوكيل مع حفظ نقاط التقدّم، وهذا هو الجزء المهم في عملية تقاس بالأيام: التقدّم يبقى محفوظاً بين المحادثات بدل ما يتصفّر كل ما سكّر أحد التطبيق.',
    banqy_solution_p3:
      'والوكيل يرد بالعربية والإنجليزية، بأي وحدة فيهما فتح المتقدّم، وهو موجّه لإثبات الأهلية والاهتمام الحقيقي قبل ما ينطلب من أحد ينشئ حساباً أو يرفع مستنداً.',
    banqy_solution_p4:
      'ولما يدخل زميل على محادثة، الوكيل يتوقف، ولما يطلع يكمّل — فتدخّل الإنسان ما يعني صوتين يردون على نفس الشخص، والتسليم الراجع ما يعني بداية سلسلة جديدة.',
    banqy_impact_title: 'الأثر',
    banqy_impact_p1:
      'المتقدّم يتأهّل قبل ما تبدأ الأوراق، والمستشارون يصرفون وقتهم على الطلبات اللي تقدر فعلاً تكتمل.',
    banqy_impact_p2:
      'Banqy ما تنشر أرقام حل أو أتمتة لين الآن. الأرقام التشغيلية الأولى لسه تحت التنظيف — ترتيب الصندوق ومعالجة السبام يغيّران معنى المقام أصلاً — وهذي القصة بتحمل الأرقام لما تستقر وتكون Banqy جاهزة تشاركها.',

    /* FOODICS */
    foodics_hero_title: 'كيف تدعم Foodics مطاعم ما تقدر توقف الخدمة',
    foodics_what_we_did:
      'دعم لمنصة مطاعم، عميلها في نص الخدمة، والكاشير هو المنتج، والرد البطيء يعني طابوراً على الكاونتر.',
    foodics_company_description:
      'Foodics منصة نقاط بيع وإدارة مطاعم سحابية، تأسست في الرياض سنة ٢٠١٤ وتخدم قطاع الأغذية والمشروبات في أكثر من ٣٥ دولة.',
    foodics_industry: 'تقنية مطاعم ومدفوعات',
    foodics_location: 'السعودية',
    foodics_key_result_1: 'دعم في أكثر من ٣٥ دولة',
    foodics_key_result_2: 'عربي وإنجليزي',
    foodics_key_result_3: 'أسئلة نقاط البيع تنجاوب والخدمة شغالة',
    foodics_key_result_4: 'مسائل المدفوعات والتسويات تروح للبشر',
    foodics_intro:
      'Foodics هي الكاشير وشاشة المطبخ وجهاز الدفع لمطاعم في المنطقة وخارجها. عالجت مليارات الطلبات من ٢٠١٤، وهذي طريقة ثانية تقول إنه لما يوقف شي، فيه أحد واقف على الكاونتر ينتظر.',
    foodics_challenge_title: 'العميل في نص ذروة العشاء',
    foodics_challenge_p1:
      'دعم المطاعم عليه ساعة ما هي على أغلب دعم البرمجيات. سؤال عن طابعة ما تطبع، أو صنف ما ينحفظ، أو جهاز ما يسوّي تسوية، مو تذكرة يقراها أحد بكرة — هذي مشكلة تصير قدام زبائن يدفعون.',
    foodics_challenge_p2:
      'واللي يسألون مو موظفو تقنية. مدراء وكاشيرية في نص الوردية، يوصفون العرض مو السبب، وغالباً بيد وحدة فاضية.',
    foodics_challenge_p3:
      'وFoodics تشتغل في أكثر من خمس وثلاثين دولة، فنفس السؤال عن المنتج يوصل بلغات مختلفة، وعلى أنظمة دفع مختلفة، وقواعد محلية مختلفة.',
    foodics_solution_title: 'وش يسوي Open',
    foodics_solution_p1:
      'الوكيل ياخذ الأسئلة اللي تتكرر عبر آلاف المطاعم — إعداد الأجهزة، تهيئة القوائم والمنتجات، الطباعة، صلاحيات المستخدمين، الإعدادات اللي غيّرها أحد الأسبوع الماضي — ويجاوبها بالعربي أو الإنجليزي، فوراً، في الساعات اللي تشتغل فيها المطاعم فعلاً.',
    foodics_solution_p2:
      'والرد في هذي الساعات هو معظم القيمة. المساء ونهاية الأسبوع ذروة للمطعم ووقت خارج الدوام لمكتب الدعم، وهذي بالضبط الفجوة اللي وُجد عشانها وكيل ما عنده دوام.',
    foodics_solution_p3:
      'والفلوس تروح للبشر. أي شي يمس دفعة أو تسوية أو فرقاً في مستحقات مطعم يتحوّل بدل ما ينأتمت، لأن السرعة ما تسوى شيئاً هناك إذا كان الجواب غلط.',
    foodics_impact_title: 'الأثر',
    foodics_impact_p1:
      'الأسئلة التشغيلية الروتينية تبطّل تقف في الطابور خلف العاجلة، وفريق دعم مبني لسوق وحدة ما يصير هو القيد على خدمة خمس وثلاثين.',
    foodics_impact_p2:
      'Foodics ما تنشر أرقام حل أو أوقات رد لين الآن. هذي القصة بتحملها لما توجد وتكون Foodics جاهزة تشاركها.',

    /* ZEN HR */
    zenhr_hero_title: 'كيف ترد ZenHR على أسئلة الرواتب اللي ما تنتظر يوم الصرف',
    zenhr_what_we_did:
      'دعم لمنصة موارد بشرية، أسئلتها توصل من اتجاهين: فريق الموارد اللي يدير الرواتب، والموظفون اللي يستلمونها.',
    zenhr_company_description:
      'ZenHR منصة موارد بشرية ورواتب تستخدمها شركات في الشرق الأوسط وشمال أفريقيا.',
    zenhr_industry: 'برمجيات موارد بشرية ورواتب',
    zenhr_location: 'الأردن',
    zenhr_key_result_1: 'دعم بالعربية والإنجليزية',
    zenhr_key_result_2: 'مسؤولو الموارد البشرية والموظفون من مكتب واحد',
    zenhr_key_result_3: 'الطلب متركّز في الأيام حول صرف الرواتب',
    zenhr_key_result_4: 'أي شي يمس راتب شخص معيّن يتولاه البشر',
    zenhr_intro:
      'ZenHR تدير الرواتب والإجازات وشؤون الموظفين لشركات في المنطقة. برنامجها يُستخدم في الأيام العادية لما يحجز أحد إجازة، وفي أيام محددة كل شهر تتوقع فيها شركة كاملة إنها تنصرف صح.',
    zenhr_challenge_title: 'دعم الرواتب مو موزّعاً بالتساوي',
    zenhr_challenge_p1:
      'منصة موارد بشرية عندها أسابيع هادية وبعدين ذروة، لأن الرواتب تمشي على تقويم. الأيام حول تاريخ الصرف تكدّس إلحاح شهر كامل في ساعات، وولا وحدة منها تنأجل.',
    zenhr_challenge_p2:
      'والأسئلة توصل من اتجاهين. مسؤول الموارد يسأل كيف يضبط حساب نهاية الخدمة أو يقفل دورة رواتب؛ والموظف يسأل ليش كشف راتبه طلع كذا. نفس المنصة، ومحادثتان مختلفتان تماماً.',
    zenhr_challenge_p3:
      'والمنطقة مو كتاب قواعد واحداً. نظام العمل ومستحقات نهاية الخدمة وممارسات الرواتب تختلف بين دولة وثانية، فالجواب العام الواثق غالباً يكون جواباً محلياً غلط.',
    zenhr_solution_title: 'وش يسوي Open',
    zenhr_solution_p1:
      'الوكيل ياخذ طبقة «كيف أسوي» في منصة الموارد البشرية — أرصدة الإجازات وطلباتها، أسئلة الملف والمستندات، الموافقات، وخطوات الإعداد اللي يعيدها المسؤول كل دورة — بالعربي أو الإنجليزي.',
    zenhr_solution_p2:
      'وهذي الطبقة هي معظم الحجم وتقريباً ولا شي من المخاطرة، وهذا اللي يخليها تستاهل الأتمتة أول: هي الطابور اللي يقف بين مختص الرواتب والشغل اللي ما يقدر عليه غيره.',
    zenhr_solution_p3:
      'وأي شي عن راتب شخص بعينه يروح لمختص. خصم متنازع عليه، أو تسوية نهاية خدمة، أو كشف راتب يبيّن غلط، هذي معيشة أحد وسؤال قانوني في نفس الوقت، وولا وحدة منهما مرشحة للأتمتة.',
    zenhr_impact_title: 'الأثر',
    zenhr_impact_p1:
      'ذروة الرواتب تبطّل تكون الأسبوع اللي ما ينجاوب فيه شي ثاني، والمختصون يصرفونه على الحالات اللي تحتاجهم فعلاً.',
    zenhr_impact_p2:
      'ZenHR ما تنشر أرقام حل أو أوقات رد لين الآن. هذي القصة بتحملها لما توجد وتكون ZenHR جاهزة تشاركها.',

    /* REWAA */
    rewaa_hero_title: 'كيف تدعم رواء تجاراً يديرون متجرهم كله من نظام واحد',
    rewaa_what_we_did:
      'دعم لمنصة هي الكاشير والجرد والدفاتر والفوترة الإلكترونية في نفس الوقت — والسؤال الواحد نادراً يخص وحدة منها بس.',
    rewaa_company_description:
      'رواء تجمع نقاط البيع والمحاسبة وإدارة المخزون والفوترة الإلكترونية في نظام واحد للتجار.',
    rewaa_industry: 'برمجيات تجزئة ونقاط بيع',
    rewaa_location: 'السعودية',
    rewaa_key_result_1: 'نقاط بيع ومخزون ومحاسبة وفوترة إلكترونية في منتج واحد',
    rewaa_key_result_2: 'دعم عربي أولاً',
    rewaa_key_result_3: 'حملات واتساب الصادرة تنتقل على Open',
    rewaa_key_result_4: 'أسئلة الفوترة الحساسة للامتثال تروح للبشر',
    rewaa_intro:
      'رواء هي اللي يشتغل عليها المتجر فعلاً: الكاشير قدام، والجرد وراء، والحسابات تحت، والفوترة الإلكترونية اللي تتوقعها هيئة الزكاة والضريبة. وبالنسبة للتاجر اللي يستخدمها، هذي مو أربعة منتجات. هذي يوم ثلاثاء واحد.',
    rewaa_challenge_title: 'سؤال واحد، أربعة أنظمة',
    rewaa_challenge_p1:
      'لما يكون كل شي في منصة وحدة، أسئلة الدعم تبطّل تحترم الحدود بين أجزائها. جرد يبيّن غلط ممكن يكون خطأ استلام، أو إعداد مرتجعات، أو عملية بيع ما انسجلت — والتاجر اللي يسأل ما عنده سبب يعرف أيها.',
    rewaa_challenge_p2:
      'والفوترة الإلكترونية ترفع كلفة الجواب الغامض. الفوترة الإلكترونية في السعودية التزام امتثال له صيغة وموعد، مو تفضيلاً، فجملة «المفروض تشتغل الحين» مو حلاً مقبولاً.',
    rewaa_challenge_p3:
      'ودعم التجزئة يوصل ذروته بالضبط لما يكون المتجر أزحم — المساء، ونهاية الأسبوع، وآخر الشهر — وهي نفسها الأوقات اللي يكون فيها مكتب الدعم أقل عدداً.',
    rewaa_solution_title: 'وش يسوي Open',
    rewaa_solution_p1:
      'الوكيل يرد بالعربية، بنفس مفردات المنتج، وعلى المساحة كلها مو على وحدة من وحداتها — فما يحتاج التاجر يطلّع أي جزء من نظامه يخص سؤاله قبل ما يقدر يسأله.',
    rewaa_solution_p2:
      'ورواء تنقل كذلك حملات واتساب الصادرة على Open، عشان الرسائل اللي ترسلها الشركة والمحادثات اللي تستقبلها يبطّلون يعيشون في أداتين منفصلتين بسجلين منفصلين لنفس العميل.',
    rewaa_solution_p3:
      'وأسئلة الامتثال تبقى مع البشر. أي شي لازم تقبله الهيئة كفاتورة هو سؤال له جواب صح وله عاقبة، ويروح لأحد يقدر يأكده.',
    rewaa_impact_title: 'الأثر',
    rewaa_impact_p1:
      'التاجر ياخذ جواباً في الساعة اللي يكون فيها فعلاً وراء الكاونتر، والمختصون يمسكون الحالات اللي يكلّف الغلط فيها العميل مشكلة امتثال.',
    rewaa_impact_p2:
      'رواء ما تنشر أرقام حل أو أوقات رد لين الآن. هذي القصة بتحملها لما توجد وتكون رواء جاهزة تشاركها.',

    /* WEFACT — معلّقة، غير منشورة. */
    wefact_hero_title: 'كيف ترد WeFact على أسئلة عن دفاتر العميل نفسه',
    wefact_what_we_did:
      'دعم لمنصة فوترة، أغلب أسئلتها عن سجل محاسبي محدد — تنجاوب من بيانات WeFact نفسها مو من صفحة مساعدة عامة.',
    wefact_company_description:
      'WeFact تعطي أصحاب الأعمال في هولندا مكاناً واحداً يرسلون منه الفواتير ويجهزون العروض ويعالجون فواتير المشتريات.',
    wefact_industry: 'برمجيات فوترة ومحاسبة للشركات',
    wefact_location: 'هولندا',
    wefact_key_result_1: 'دعم باللغة الهولندية لمنتج محاسبي',
    wefact_key_result_2: 'مبني على REST API كمصدر معرفة، مو مركز مساعدة ثابت',
    wefact_key_result_3: 'إجابات مبنية على السجل المحاسبي للعميل نفسه',
    wefact_key_result_4: 'فريق دعم صغير يغطي منصة كاملة',
    wefact_intro:
      'WeFact هي المكان اللي ترسل منه الشركة الهولندية فواتيرها. العروض تطلع منها، وفواتير المشتريات تدخل عبرها، والأرقام اللي تطلعها هي اللي توصل للمحاسب. يستخدمها ناس يديرون شركة، مو ناس يديرون طابور دعم.',
    wefact_challenge_title: 'ما أحد يسأل سؤالاً عاماً عن فاتورته هو',
    wefact_challenge_p1:
      'دعم المحاسبة محدد بشكل غير عادي. تقريباً ما يوصل شي كسؤال عن المنتج بالمجرد — يوصل كسؤال عن هذي الفاتورة، وهذا بند الضريبة، وهذا التذكير اللي راح لهذا العميل الثلاثاء الماضي.',
    wefact_challenge_p2:
      'وهذا يخلي مركز المساعدة التقليدي نص مفيد. يقدر يشرح كيف تشتغل التذكيرات؛ ما يقدر يقول ليش هذا التذكير ما طلع. الجواب موجود في سجل العميل نفسه، مو في مقال.',
    wefact_challenge_p3:
      'والأسئلة توصل ومعها موعد نهائي. فاتورة ما طلعت يعني فلوس ما وصلت، وإقرار ضريبي ما يتأجل لأن الدعم مشغول.',
    wefact_solution_title: 'وش يسوي Open',
    wefact_solution_p1:
      'الوكيل يرد بالهولندية، وبنفس المفردات اللي يستخدمها المنتج — factuur وofferte وherinnering — بدل ترجمة نص دعم مكتوب في مكان ثاني.',
    wefact_solution_p2:
      'التكامل مبني على REST API كمصدر معرفة بدل مركز مساعدة ثابت، فيقدر الوكيل يشتغل على بيانات WeFact الحية كسياق، بدل ما يطابق سؤال العميل مع مقالات ما تشوف حسابه أصلاً.',
    wefact_solution_p3:
      'وهذا الفرق هو بيت القصيد لمنتج مثل هذا. «كيف أرسل تذكير» مقال. و«ليش هذا التذكير ما طلع» بحث في البيانات، وواحد بس من الاثنين هو اللي يسأله العملاء فعلاً.',
    wefact_impact_title: 'الأثر',
    wefact_impact_p1:
      'فريق صغير يدعم منصة فوترة كاملة. كل سؤال ياخذه الوكيل من أوله لآخره هو سؤال ما يحتاج شخص يقراه ويعيد كتابته ويدوّر عليه — واللي يوصل لشخص يوصل بدون ما يشرح العميل نفسه مرتين.',
    wefact_impact_p2:
      'WeFact ما تنشر أرقام حل أو أوقات رد لين الآن. هذي القصة بتحملها لما توجد وتكون WeFact جاهزة تشاركها.',

    /* TRUSTOO — معلّقة، غير منشورة. */
    trustoo_hero_title: 'كيف تدعم Trustoo طرفَي سوق الخدمات المحلية',
    trustoo_what_we_did:
      'وكيل واحد يرد على المستهلكين اللي يدوّرون محترفاً وعلى المحترفين اللي يدفعون عشان يلقونهم — جمهوران أسئلتهم ما تتقاطع تقريباً.',
    trustoo_company_description:
      'Trustoo تساعد الناس يلقون محترفي خدمات محليين، ويقارنون التقييمات والأسعار في مكان واحد.',
    trustoo_industry: 'سوق خدمات محلية',
    trustoo_location: 'هولندا',
    trustoo_key_result_1: 'يشتغل داخل HubSpot، حيث يشتغل فريق الدعم',
    trustoo_key_result_2: 'وكيل واحد يخدم المستهلكين ومحترفي الخدمات',
    trustoo_key_result_3: 'دعم باللغة الهولندية',
    trustoo_key_result_4: 'أسئلة التقييمات والإدراج تنجاوب من المنصة نفسها',
    trustoo_intro:
      'واحد يحتاج دهّاناً أو سبّاكاً أو فنّي أسطح، وما يبي يختار واحداً عشوائياً. Trustoo تدرج المحترفين المحليين، وتحمل التقييمات والأسعار، وتوصل الطرفين. وهذا يعني صندوق دعم فيه شخصان مختلفان تماماً.',
    trustoo_challenge_title: 'عميلان ما يسألون نفس السؤال أبداً',
    trustoo_challenge_p1:
      'المستهلك يبي يعرف إذا العرض معقول، وإذا التقييم حقيقي، ووش يصير إذا الشغل طلع غلط. والمحترف يبي يعرف ليش العميل المحتمل سكت، وكيف يترتب إدراجه، ووش يدفع مقابله بالضبط.',
    trustoo_challenge_p2:
      'والاثنان مو نسختين من سؤال واحد. يحتاجون معرفة مختلفة، ونبرة مختلفة، وغالباً نتائج مختلفة من نفس المحادثة — والجواب المكتوب لواحد منهم ينزل ثقيلاً على الثاني.',
    trustoo_challenge_p3:
      'والتقييمات ترفع المخاطرة أكثر. السؤال عن تقييم نادراً ما يكون عن التقييم بس: يكون عن رزق محترف أو عن يوم سيئ لمستهلك، وهذا نوع الرسائل اللي لازم تنقرا بتركيز قبل ما تنجاوب بسرعة.',
    trustoo_solution_title: 'وش يسوي Open',
    trustoo_solution_p1:
      'الوكيل يشتغل داخل HubSpot، حيث يشتغل فريق الدعم أصلاً، ويرد داخل نفس المحادثة اللي بدأها العميل بدل ما يفتح مساراً موازياً.',
    trustoo_solution_p2:
      'يرد بالهولندية، ويرد من المنصة مو من نص عام — الأسئلة اللي تتكرر في سوق كهذا عن الإدراج والتقييمات ووش الخطوة الجاية، وهذي لها إجابات حقيقية.',
    trustoo_solution_p3:
      'وقرارات التقدير تبقى للبشر. تقييم متنازع عليه، شغل طلع غلط، محترف يعترض على اللي انحسب عليه — هذي محادثات تكون فيها السرعة أقل قيمة من الصح.',
    trustoo_impact_title: 'الأثر',
    trustoo_impact_p1:
      'طرفا السوق ينجاوبون من صندوق واحد بدون ما يظل الفريق ماسكاً نصّين في راسه.',
    trustoo_impact_p2:
      'Trustoo ما تنشر أرقام حل أو أوقات رد لين الآن. هذي القصة بتحملها لما توجد وتكون Trustoo جاهزة تشاركها.',

    /* BONO — معلّقة، غير منشورة. */
    bono_hero_title: 'كيف تدعم BONO ١٥ متجراً إلكترونياً في ٢١ سوقاً أوروبية',
    bono_what_we_did:
      'أسئلة المكمّلات الغذائية تنجاوب عبر خمسة عشر متجراً محلياً وبوابة للشركات، والجواب الصح يتغيّر بتغيّر السوق اللي انسأل فيه.',
    bono_company_description:
      'BONO تبيع مكمّلات غذائية عبر خمسة عشر متجراً إلكترونياً محلياً وبوابة للشركات في إحدى وعشرين سوقاً أوروبية.',
    bono_industry: 'صحة ومكمّلات غذائية',
    bono_location: 'هولندا',
    bono_key_result_1: 'خمسة عشر متجراً محلياً من عملية دعم واحدة',
    bono_key_result_2: 'إحدى وعشرون سوقاً أوروبية',
    bono_key_result_3: 'متاجر المستهلكين وبوابة الشركات في نفس الصندوق',
    bono_key_result_4: 'أسئلة المنتجات مفصولة عن الادعاءات الصحية المنظّمة',
    bono_intro:
      'BONO تبيع مكمّلات غذائية، وما تبيعها بنفس الطريقة مرتين. خمسة عشر متجراً محلياً تخدم إحدى وعشرين سوقاً أوروبية، ومعها بوابة للشركات اللي تشتري بالجملة. الكتالوج متشابه عبر الحدود؛ وتقريباً ولا شي غيره متشابه.',
    bono_challenge_title: 'خمسة عشر متجراً وواحد وعشرون كتاب قواعد',
    bono_challenge_p1:
      'متجر لكل سوق يضاعف كل شي. أوقات الشحن ونوافذ الإرجاع وطرق الدفع وشركات التوصيل كلها تختلف، فنفس السؤال عن نفس المنتج له جواب صحيح مختلف حسب المتجر اللي انسأل فيه.',
    bono_challenge_p2:
      'والمكمّلات تضيف طبقة ثانية. اللي يُقال عن المنتج منظّم، والقواعد مو موحّدة في أوروبا. جملة مفيدة في سوق تصير مشكلة امتثال في السوق اللي بعدها، وهذا يخلي «جاوب السؤال وخلاص» غريزة غلط.',
    bono_challenge_p3:
      'ونوعان من العملاء يتشاركون الصندوق. مستهلك يسأل إذا يأخذ المنتج مع الأكل مو نفس المحادثة مع تاجر تجزئة يتابع طلبية بالجملة أو فاتورة أو موعد توصيل.',
    bono_solution_title: 'وش يسوي Open',
    bono_solution_p1:
      'وكيل واحد يغطي المتاجر بدل خمسة عشر إعداداً منفصلاً، يرد بلغة السوق ومن واقع الشحن والإرجاع والدفع في هذاك السوق بالذات.',
    bono_solution_p2:
      'والحجم الاعتيادي لصندوق تجارة إلكترونية — وين الطلب، وش نافذة الإرجاع، ليش فشلت الدفعة، متى يرجع المنتج للمخزون — هو الشغل اللي وُجد الوكيل عشان ياخذه، على كل المتاجر في نفس الوقت.',
    bono_solution_p3:
      'وأي شي يقترب من نصيحة صحية يروح لشخص. السؤال عن الجرعة، أو عن تداخل، أو إذا المنتج مناسب لحالة معينة، مو سؤال للأتمتة، والمحافظة على هذا الخط واضحاً هي اللي تخلي أتمتة الباقي آمنة.',
    bono_impact_title: 'الأثر',
    bono_impact_p1:
      'التوسّع لسوق جديدة يبطّل يعني عبء دعم إضافي بنفس حجم الأول. المتجر جديد؛ وعملية الدعم وراه هي نفسها الموجودة أصلاً.',
    bono_impact_p2:
      'BONO ما تنشر أرقام حل أو أوقات رد لين الآن. هذي القصة بتحملها لما توجد وتكون BONO جاهزة تشاركها.',

    /* TRAVIS — معلّقة، غير منشورة. */
    travis_hero_title: 'كيف علّمت TRAVIS وكيلها الذكي من فريق الدعم نفسه',
    travis_what_we_did:
      'ثلاثون يوماً من متابعة شغل الموظفين طلّعت نحو ٢٠٠ تعليمة مكتوبة يجاوب منها الوكيل — وكل تغيير في قاعدة البيانات يبقى للبشر، بقاعدة من TRAVIS نفسها.',
    travis_company_description:
      'TRAVIS تخلي مشغّلي الأساطيل يلقون ويحجزون ويدفعون لغسيل الشاحنات وتنظيف الخزانات ومواقف الشاحنات وخدمات الإصلاح في أوروبا من حساب واحد.',
    travis_industry: 'لوجستيات وخدمات أساطيل',
    travis_location: 'هولندا',
    travis_key_result_1:
      'نحو ٢٠٠ تعليمة كتبها الوكيل من إجابات موظفي الدعم نفسهم',
    travis_key_result_2:
      'يشتغل على HubSpot عبر الشات والإيميل، وكل رد يمكن فحص منطقه',
    travis_key_result_3: 'أي شي يغيّر قاعدة البيانات يروح لإنسان، عن قصد',
    travis_key_result_4:
      'لغة التذكرة تنملى تلقائياً عند التحويل، فالتوجيه يوصل للفريق الصح',
    travis_intro:
      'الشاحنة ما تنتظر. لما يحتاج السائق مغسلة أو موقفاً أو إصلاحاً على طريق في أوروبا، TRAVIS هي الحساب اللي يلقاه ويحجزه ويدفع له. والدعم يقعد بين السائق على الطريق ومكتب الأسطول اللي يدفع الفاتورة، والاثنين مستعجلين.',
    travis_challenge_title: 'المعرفة كانت في رؤوس الناس مو في المستندات',
    travis_challenge_p1:
      'عند TRAVIS سنوات من الإجابات الجيدة، وتقريباً ولا وحدة منها مكتوبة. الفريق يعرف أي إيميلات التحقق من بطاقات الوقود روتينية، وأي سؤال عن المواقف يحتاج بحثاً عن موقع، وأي طلب هو في الحقيقة نزاع فوترة بلبس ثاني. وولا شي من هذا كان موجوداً في مكان يقدر وكيل ذكي يقراه.',
    travis_challenge_p2:
      'والفريق يشتغل بأكثر من لغة. الشات كان يبدأ بسؤال العميل يختار لغة، بس عشان المحادثة تتوجّه لزميل يتكلمها — سؤال ما أحد يبي يجاوبه قبل ما يسأل سؤاله الحقيقي.',
    travis_challenge_p3:
      'ودخلت TRAVIS بقاعدتين ما فيهما نقاش: لا تشارك بيانات ما يفترض تنشارك، ولا ترسل جواباً واثقاً وهو غلط. ومدير التطوير عندهم كان واضحاً إنه ما يسلّم صلاحية كتابة لأي شي قبل ما يثبت الاثنين.',
    travis_solution_title: 'وش يسوي Open',
    travis_solution_p1:
      'أول ثلاثين يوم كان الوكيل يراقب. يقرا وش يسأل العميل ووش يجاوب الموظف، ويكتب النمط — نحو ٢٠٠ تعليمة فريدة، مولّدة من سلوك الفريق نفسه مو من مستند ما كتبه أحد. ومسؤولة الدعم تراجعها في Companion وتنشر أو تسحب كل وحدة، فغلطة إنسان ما تصير درساً دائماً.',
    travis_solution_p2:
      'وهذي التعليمات تنادي إجراءات حقيقية. السؤال عن وين يقدر السائق يوقف ينجاوب من بحث مباشر عن المواقع، مو من وصف عام للشبكة، وإيميلات التحقق من بطاقات DKV — اللي عنوانها دايماً صيغة من «طلب تحقق، سائق أضاف بطاقة رئيسية جديدة» — تنجاوب على الأوتوبايلت كموضوع مستقل.',
    travis_solution_p3:
      'وكل رد يمكن تفتحه. عرض المنطق يبيّن الخطوات اللي مشاها الوكيل، وصفحة التعليمات اللي اتبعها، والـAPI اللي ناداه، وهذا اللي طمّن TRAVIS إن الجواب آمن قبل ما يطلع.',
    travis_solution_p4:
      'وقاعدة التحويل قاعدتهم هم مو قاعدتنا: إذا كان الطلب بيغيّر شيئاً في قاعدة البيانات — إلغاء حجز، تعديل معاملة، فك ربط بطاقة وقود — يروح لشخص. الوكيل يقرا، والبشر يكتبون. وOpen حدّدت أي من هذي الحالات ممكن تنأتمت بدون صلاحية كتابة، وتركت الباقي لين تجهز TRAVIS.',
    travis_impact_title: 'الأثر',
    travis_impact_p1:
      'سؤال اللغة في طريقه للخروج من الشات. الوكيل يملي خانة لغة التذكرة بنفسه عند التحويل أو الإغلاق، فالمحادثة توصل للزميل الصح بدون ما ينطلب من العميل يرتّب نفسه أول.',
    travis_impact_p2:
      'TRAVIS ما تنشر نسبة أتمتة لين الآن. التجربة كانت مرسومة عشان تنكتب المعرفة أول، ويثبت إن الوكيل يستاهل الثقة بصلاحية قراءة قبل أي شي ثاني، وهذي القصة بتحمل أرقام الحل لما تصير عند TRAVIS وتكون جاهزة تشاركها.',

    /* NATUURHUISJE — معلّقة، غير منشورة. نفس مجموعة المفاتيح الإنجليزية. */
    natuurhuisje_hero_title:
      'كيف ترد Nature House على الضيوف والملاك بأربع لغات',
    natuurhuisje_what_we_did:
      'وكيل واحد على ثلاث علامات، يرد على إيميلات الضيوف والملاك باللغة اللي وصلت فيها — والإلغاءات والاسترجاعات وأي شي مالي تبقى للبشر عن قصد.',
    natuurhuisje_company_description:
      'Nature House تؤجّر بيوت عطلات وبيوت صغيرة وأماكن للمجموعات، كلها وسط الطبيعة، وجزء من كل حجز يرجع لمشاريع طبيعة محلية.',
    natuurhuisje_industry: 'منصة سفر وضيافة',
    natuurhuisje_location: 'هولندا',
    natuurhuisje_key_result_1:
      'وكيل واحد يغطي Natuurhuisje وNaturhauschen وMaison Nature',
    natuurhuisje_key_result_2:
      'الردود تتبع لغة الضيف — هولندية وألمانية وفرنسية وإنجليزية وإيطالية',
    natuurhuisje_key_result_3:
      'الاطلاع على الحجز للقراءة فقط، والإلغاءات والاسترجاعات تبقى مع الفريق',
    natuurhuisje_key_result_4: 'يشتغل داخل HubSpot، حيث يشتغل فريق الدعم أصلاً',
    natuurhuisje_intro:
      'Nature House تعرض أكواخاً وبيوتاً صغيرة وأماكن للمجموعات يجمعها شي واحد: كلها وسط الطبيعة، وجزء من اللي يدفعه الضيف يرجع لمشاريع طبيعة محلية. نفس الشركة تشتغل باسم Natuurhuisje في هولندا، وNaturhauschen في ألمانيا، وMaison Nature في فرنسا، ودعم الثلاثة يوصل لمكان واحد.',
    natuurhuisje_challenge_title: 'جمهوران وثلاث علامات وصندوق وارد واحد',
    natuurhuisje_challenge_p1:
      'منصة تأجير العطلات ترد على شخصين مختلفين من نفس الصندوق. الضيف يبي يعرف إذا الكوخ فيه مدفأة حطب، وإذا الكلب مسموح، ومتى يقدر يوصل. المالك يبي يعرف ليش الحجز ما تحوّل له لين الآن، وكيف يقفل أسبوع في التقويم. الأسئلة ما تتقاطع تقريباً، والجواب المكتوب لواحد منهم غلط للثاني.',
    natuurhuisje_challenge_p2:
      'وبعدين اللغة. ضيف ألماني يحجز كوخاً هولندياً يكتب بالألماني، والمالك يرد بالهولندي، ولازم السلسلة تبقى مفهومة للاثنين. عبر الواجهات الثلاث الفريق يستقبل هولندية وألمانية وفرنسية وإنجليزية وإيطالية.',
    natuurhuisje_challenge_p3:
      'والضغط مو موزّع على السنة بالتساوي. تأجير الطبيعة يوصل ذروته في الصيف، وهو بالضبط الوقت اللي ما تقدر توسّع فيه الفريق، وبالضبط الوقت اللي يكلّف فيه جواب غلط عن إلغاء أكثر شي.',
    natuurhuisje_solution_title: 'وش يسوي Open',
    natuurhuisje_solution_p1:
      'الوكيل يشتغل داخل HubSpot، حيث يشتغل فريق الدعم أصلاً. التذاكر توصله عبر workflow، ولما يرجّع تذكرة تبقى مفتوحة عشان يلتقطها زميل، بدل ما تنقفل وتبدأ سلسلة جديدة.',
    natuurhuisje_solution_p2:
      'يقرأ الحجوزات الحقيقية. الاطلاع على الحجز موصول بنظام الحجز، فالسؤال عن وقت الوصول أو عن أي عقار تخص الدفعة ينجاوب من السجل نفسه مو برد عام. وهذا الاطلاع للقراءة فقط باختيار Nature House نفسها: الوكيل يشوف الحجز، ما يقدر يعدّله أو يلغيه.',
    natuurhuisje_solution_p3:
      'قاعدة المعرفة مفصولة بين الضيوف والملاك، فكل جمهور ينجاوب من مادته. والردود تتبع لغة الضيف، وإفصاح المساعدة بالذكاء الاصطناعي الأوروبي مضبوط على العلامات الثلاث.',
    natuurhuisje_solution_p4:
      'الإلغاءات والاسترجاعات وأي شي مالي مستثناة من الأتمتة وتروح للفريق، عن قصد، طول موسم الذروة. والإطلاق كان بنفس التدرج — أول شي وضع المساعدة، الوكيل يكتب اقتراحات يراجعها إنسان قبل ما يوصل أي شي للعميل، وبعدها الأوتوبايلت يتوسّع خطوة خطوة.',
    natuurhuisje_impact_title: 'الأثر',
    natuurhuisje_impact_p1:
      'ضيف يكتب الساعة ١١ بالليل بالألماني يوصله جواب عن حجزه هو، بالألماني، بدون ما ينتظر مكتباً هولندياً يفتح. والتذاكر اللي فيها فلوس أو عطلة ملغية تبقى توصل لشخص.',
    natuurhuisje_impact_p2:
      'Nature House لسه في بداية الإطلاق وما تنشر أرقام حل أو أوقات رد لين الآن. نسبة الأتمتة وأسباب التحويل والفرق بين «محلولة» و«يُفترض أنها محلولة» تتقاس الحين على لوحة يومية تتطابق مع HubSpot، وهذي القصة بتحمل الأرقام لما تكون Nature House جاهزة تشاركها.',

    /* AQQO — معلّقة، غير منشورة. */
    aqqo_hero_title:
      'كيف نقلت Aqqo ٦١ ألف تذكرة وأعادت بناء مكتب دعمها في ٣٠ يوماً',
    aqqo_what_we_did:
      'ترحيل كامل لمكتب الدعم بتاريخه — علامتان و١٤٨ مقالاً في قاعدة المعرفة وقواعد الـSLA اللي معها — داخل تجربة مدتها ٣٠ يوماً.',
    aqqo_company_description:
      'Aqqo تدير دعم العملاء باللغة الهولندية عبر علامتين، Aqqo وLVP.',
    aqqo_industry: 'تجارة إلكترونية',
    aqqo_location: 'هولندا',
    aqqo_key_result_1: 'نحو ٦١ ألف تذكرة مرحّلة بتاريخ المحادثات كاملاً',
    aqqo_key_result_2: 'نحو ٢٨ ألف جهة اتصال مرحّلة ومطابَقة',
    aqqo_key_result_3: '١٤٨ مقالاً منشوراً مستورداً ويبقى متزامناً',
    aqqo_key_result_4:
      'الفِرق ومستويات الـSLA والحالات والحقول المخصصة أُعيد بناؤها',
    aqqo_intro:
      'Aqqo تتولى الدعم باللغة الهولندية لعلامتين، Aqqo وLVP، من مكتب واحد. ونقل هذا المكتب يعني نقل كل شي متعلق فيه — مو بس التذاكر المفتوحة، بل سنوات من التذاكر المقفلة اللي يحتاجها الموظف لما يقول العميل «كتبت لكم عن هذا السنة الماضية».',
    aqqo_challenge_title: 'ترحيل ما أحد يتحمّل يغلط فيه',
    aqqo_challenge_p1:
      'تغيير مكتب الدعم مو مجرد تبديل برنامج. كل محادثة مقفلة سياق ممكن يحتاجه الموظف بكرة، وكل مستوى SLA وعد مقطوع أصلاً، وكل حقل مخصص قطعة من إجراء بناها أحد لسبب.',
    aqqo_challenge_p2:
      'إذا تركت التاريخ وراك، الفريق يبدأ مع كل عميل راجع من الصفر. وإذا أعدت بناء الإعدادات يدوياً، تبدأ القواعد تنحرف بهدوء عن اللي تشتغل عليه الشركة فعلاً.',
    aqqo_challenge_p3:
      'Aqqo حددت تجربة ٣٠ يوماً عشان تعرف إذا النقلة ممكنة أصلاً، ومعها علامتان لازم تبقى كل وحدة منفصلة طول الطريق.',
    aqqo_solution_title: 'وش يسوي Open',
    aqqo_solution_p1:
      'نحو ٦١ ألف تذكرة انتقلت بتاريخ محادثاتها كاملاً، ونحو ٢٨ ألف جهة اتصال انترحّلت وانطابقت — فالعميل الراجع يوصل ومعه كل اللي كتبه لـAqqo من قبل.',
    aqqo_solution_p2:
      'الإعدادات المرجعية أُعيد بناؤها مو تقريبها: الفِرق ومستويات الـSLA والحالات والحقول المخصصة، ومعها workflows الحالات وتوجيه العلامات وقواعد الـSLA اللي تحدد أي علامة من الاثنتين تخص الرسالة وكم بسرعة لازم تنجاوب.',
    aqqo_solution_p3:
      'الـ١٤٨ مقالاً المنشورة انستوردت وتبقى متزامنة تلقائياً، فالإجابات اللي يعتمد عليها الوكيل هي نفسها اللي يشوفها العميل في مركز المساعدة.',
    aqqo_solution_p4:
      'قنوات الإيميل الواردة انوصلت، والاختبار الكامل انسوى مع فريق Aqqo نفسه، ونقطة المزامنة الراجعة لنظامهم الرئيسي موصولة — وتقارير الـSLA وسجلات الهاتف جاهزة توصل أول ما تنشارك البيانات.',
    aqqo_impact_title: 'الأثر',
    aqqo_impact_p1:
      'في اليوم السابع والعشرين من تجربة ثلاثين يوماً كان البناء مكتملاً تقريباً، والانطلاق على حركة حقيقية في التحضير النهائي. الفريق غيّر مكتبه بدون ما يترك عقداً من تاريخ العملاء وراه.',
    aqqo_impact_p2:
      'Aqqo ما رفعت أرقام حركة حقيقية لين الآن — التجربة كانت مرسومة عشان تثبت الترحيل، مو عشان تنشر نسبة أتمتة. هذي القصة بتحمل أرقام الحل وأوقات الرد لما توجد وتكون Aqqo جاهزة تشاركها.',
  },
  helpdesk: {
    'The missing AI agent for': 'الموظف الذكي الناقص في',
    'AI that understands context, delivers accurate responses, and gets better over time. Works natively in':
      'AI يفهم السياق، يرد بدقّة، ويتحسّن كل يوم. يعمل من داخل',
    'Get started in minutes': 'ابدأ في دقائق',
    'Get started free': 'ابدأ مجاناً',
    'your helpdesk': 'نظام دعمك',
    '<1h to setup with our implementation experts':
      'إعداد بأقل من ساعة مع خبراء التنفيذ عندنا',
    '#1 in AI benchmarks': 'رقم ١ في اختبارات AI',
    'The deepest native integration on the market': 'أعمق تكامل في السوق',
    'Learn more about our onboarding': 'شوف كيف يمشي الإعداد',
    'High-Touch Onboarding': 'إعداد على يد فريقنا',
    'Every customer gets white-glove implementation support':
      'كل عميل يمرّ على نفس الإعداد المتكامل. بدون استثناء.',
    'Kick-off Call': 'مكالمة البداية',
    '45 min': '٤٥ دقيقة',
    'We assess your AI readiness and connect Open with':
      'نقيس جاهزيتك للـ AI، ونربط Open مع',
    'Training Step': 'التدريب',
    '2 weeks': 'أسبوعين',
    'We train the AI on your knowledge base, workflows, and brand voice':
      'ندرّبه على قاعدة معرفتك، وسير عملك، ونبرة علامتك.',
    'Managed Go-Live': 'الإطلاق بإشرافنا',
    'We monitor performance and fine-tune until you hit your automation targets':
      'نراقب الأداء، ونضبّط، ونعيد الضبط—حتى تصل لأهداف الأتمتة اللي حددتها.',
    'Dedicated team': 'فريق مخصص',
    'You get a dedicated engineer and a dedicated success specialist. Every onboarding is high-touch.':
      'مهندس ومتخصص نجاح، الاثنين لك وحدك. كل إعداد عندنا على نفس المستوى.',
    'Simple setup, powerful results. Your AI agent works alongside your team in':
      'إعداد بسيط، ونتائج قوية. الموظف الذكي يعمل إلى جانب فريقك داخل',
    'Automate the manual tasks, not just the answers':
      'أتمت المهام اليدوية، مو بس الإجابات',
    'In addition to fully resolving support tickets, Open automates the manual tasks that slow down your team—routing, tagging, QA, and more.':
      'Open ما يتوقف عند حل التذاكر. يوجّه، يصنّف، يراجع الجودة، ويرفع عن فريقك كل العمل اليدوي اللي يبطّئه.',
    'Frequently asked questions': 'أسئلة شائعة',
    'Integrate AI with your': 'الـ AI داخل',
    'Automation Rate': 'معدل الأتمتة',
    'Industry-leading performance': 'الأعلى في السوق',
    Both: 'كلاهما',
    Metric: 'المقياس',
    Feature: 'الميزة',
    '(Open)': '(Open)',
    'Zendesk Ultimate AI': 'Zendesk Ultimate AI',
    'Create the AI agent in Zendesk': 'أنشئ الموظف الذكي في Zendesk',
    'Our AI integrates directly into your Zendesk instance as a native agent.':
      'ذكاء Open يندمج داخل Zendesk ويعمل مثل أي موظف في فريقك.',
    'Set the routing rules': 'اضبط قواعد التوجيه',
    "Route 100% or 10% of your support — it's really up to you.":
      'وجّه له ١٠٠٪ من دعمك، أو ١٠٪. أنت من يقرر.',
    'Monitor and iterate': 'راقب وطوّر',
    'Because your new AI works within Zendesk, all of your reporting and analytics remain intact. Continuously improve with feedback and training.':
      'لأنه يعمل داخل Zendesk، تبقى تقاريرك وتحليلاتك كما هي. حسّنه بالملاحظات والتدريب باستمرار.',
    "See how Open's Agent 5 engine compares to Zendesk's built-in AI solution.":
      'شوف وين يتوقف ذكاء Zendesk المدمج، ووين يبدأ نظامنا.',
    'How long does it take to set up Agent 5 with Zendesk?':
      'كم ياخذ الإعداد مع Zendesk؟',
    'Agent 5 can be set up in under an hour. It connects directly to your Zendesk instance via API and starts resolving queries on day one using your existing help center content.':
      'أقل من ساعة. يتصل بـ Zendesk عبر الـ API ويبدأ يحل الاستفسارات من محتوى مركز مساعدتك، من أول يوم.',
    'Do I need to migrate away from Zendesk?': 'لازم أترك Zendesk؟',
    "No migration required. Agent 5 connects via API and works seamlessly within your existing Zendesk setup. There's no disruption to your workflows—just faster, higher-quality support.":
      'ولا تذكرة تتحرك من مكانها. نتصل عبر الـ API ونعمل داخل Zendesk نفسه—بدون توقف، وبدون سير عمل جديد تتعلمه. لا شيء سوى دعم أسرع وأدق.',
    'Which Zendesk channels does Agent 5 support?':
      'وش قنوات Zendesk المدعومة؟',
    'Agent 5 works across all Zendesk channels including tickets, live chat, email, voice, messaging (web, mobile, WhatsApp, Facebook), and social media—delivering personalized support everywhere your customers reach out.':
      'كلها. التذاكر، الدردشة، الإيميل، الصوت، المراسلة (ويب، جوال، WhatsApp، فيسبوك)، والسوشيال. دعم مخصص أينما وصلك عميلك.',
    'How does Agent 5 integrate with my existing Zendesk workflows?':
      'كيف يتكامل مع سير عملي في Zendesk؟',
    'Agent 5 syncs customer data, brand settings, and automation rules from Zendesk. It follows your existing support logic, routes conversations to the right team, and personalizes answers based on your configuration.':
      'يسحب بيانات العملاء، وإعدادات علامتك، وقواعد الأتمتة من Zendesk. يتبع منطق الدعم عندك، يوجّه كل محادثة للفريق المناسب، ويخصّص الإجابة حسب إعدادك.',
    'Can I control what percentage of tickets Agent 5 handles?':
      'أقدر أحدد نسبة التذاكر اللي يتعامل معها؟',
    'Yes. You have full control over routing rules. You can set Agent 5 to handle 100%, 10%, or any percentage of your support tickets based on your preferences and support strategy.':
      'نعم، والتحكم كله بيدك. ١٠٠٪، ١٠٪، أو أي نسبة بينهما—قواعد التوجيه تحددها أنت.',
    'How does Agent 5 hand off to human agents?': 'كيف يسلّم المحادثة للموظف؟',
    'Agent 5 updates Zendesk tickets, adds AI-generated summaries, and seamlessly hands off to human agents when needed—giving them full context to respond faster without frustrating back-and-forth.':
      'يحدّث التذكرة في Zendesk، ويكتب ملخصاً، ويسلّمها لموظف عند اللزوم—مع السياق كاملاً، فيرد فوراً بدون لف ودوران.',
    'Can I see how Agent 5 is performing in my Zendesk reports?':
      'أقدر أشوف أداءه في تقارير Zendesk؟',
    'Yes. Since Agent 5 works as a native Zendesk user, all your existing reporting tools work perfectly. You can track performance, see resolution rates, and monitor behavior just like any other agent.':
      'نعم. هو مستخدم Zendesk أصلي، فتقاريرك تنطبق عليه كما تنطبق على أي موظف—الأداء، ومعدل الحل، والتصرف، كلها ظاهرة.',
    'How does Agent 5 learn and improve over time?':
      'كيف يتعلم ويتحسّن مع الوقت؟',
    "Agent 5 features continuous learning capabilities with built-in evaluation tools. It learns from your team's feedback, analyzes historical tickets, and improves accuracy over time with observability tools that provide full transparency.":
      'يتعلم من ملاحظات فريقك، يقرأ تذاكرك القديمة، ويرفع دقته أسبوع بعد أسبوع—وكل هذا أمام عينك بأدوات تقييم ورصد مدمجة.',
    'What channels can Agent 5 handle simultaneously?':
      'وش القنوات اللي يعمل عليها في نفس الوقت؟',
    'Agent 5 is omnichannel and works across Zendesk tickets, live chat, email, voice, WhatsApp, Facebook Messenger, and other messaging channels—all from one unified AI engine.':
      'كل القنوات، وبمحرك واحد: التذاكر، الدردشة، الإيميل، المكالمات، WhatsApp، Messenger، وغيرها.',
    'Can I configure Agent 5 for different brands or customer tiers?':
      'أقدر أضبطه لعلامات أو فئات عملاء مختلفة؟',
    'Yes. Agent 5 uses synced Zendesk data to configure responses for each segment. Answers and handoffs automatically adjust by brand, customer tier, or support queue.':
      'نعم. يقرأ بيانات Zendesk المتزامنة ويضبط الردود لكل شريحة—الإجابة والتحويل يتغيّرون تلقائياً حسب العلامة، فئة العميل، أو طابور الدعم.',
    'What kind of queries can Agent 5 resolve?':
      'وش نوع الاستفسارات اللي يحلها؟',
    'Agent 5 is designed to handle complex queries with accuracy and reliability. It can resolve a wide range of customer questions, from simple FAQs to intricate technical issues, using your knowledge base and documentation.':
      'مصمم للاستفسارات المعقدة، مو بس الأسئلة الشائعة. من سؤال وين طلبي؟ إلى المشاكل التقنية المتشعبة—يحلها من قاعدة معرفتك وتوثيقك.',
    'Does Agent 5 require changes to my current setup?':
      'لازم أغيّر إعدادي الحالي؟',
    'No. Agent 5 connects via API with no migration required. It works within your existing workflows, follows your assignment rules, and requires zero disruption to your current Zendesk configuration.':
      'لا. اتصال عبر الـ API، وبدون ترحيل. يعمل داخل سير عملك الحالي، ويتبع قواعد التعيين عندك، ولا يمسّ إعدادك.',
    "Find answers to common questions about our Zendesk AI agent. Can't find what you're looking for? Contact our support team.":
      'أسئلة شائعة عن Open داخل Zendesk. ما لقيت ما تبيه؟ كلّمنا.',
    'Setup Time': 'وقت الإعداد',
    Integration: 'التكامل',
    Reporting: 'التقارير',
    'AI Quality': 'جودة AI',
    'Learning Capability': 'قدرة التعلم',
    'Routing Control': 'التحكم في التوجيه',
    Training: 'التدريب',
    Observability: 'الرصد والشفافية',
    '5 minutes': '٥ دقائق',
    '2-3 days': '٢-٣ أيام',
    '+3 months': '+٣ شهور',
    'Native Zendesk user': 'مستخدم أصلي في Zendesk',
    'Separate system': 'نظام منفصل',
    'Built-in ZD reports': 'تقارير Zendesk المدمجة',
    'Custom dashboard': 'لوحة تحكم مخصصة',
    'Multi-model engine': 'محرك متعدد النماذج',
    'Single model': 'نموذج واحد',
    Continuous: 'مستمر',
    'Manual updates': 'تحديثات يدوية',
    'Full flexibility': 'مرونة كاملة',
    'Limited options': 'خيارات محدودة',
    'Built-in with evals': 'مدمج مع التقييمات',
    'Basic training': 'تدريب أساسي',
    'Full transparency': 'شفافية كاملة',
    'Limited visibility': 'رؤية محدودة',
    'Use Open right in your': 'استخدم Open مباشرة في',
    'No migration needed. Effortless integration in under an hour. All features available from day one—not months later.':
      'ولا تذكرة تتحرك من مكانها. تكامل في أقل من ساعة. وكل الميزات من أول يوم—لا بعد شهور.',
    "See how Open's AI engine compares to Zendesk's built-in AI solution.":
      'شوف وين يتوقف ذكاء Zendesk المدمج، ووين يبدأ Open.',
    'Under 1 hour': 'أقل من ساعة',
    'Built-in automatic QA': 'ضمان جودة تلقائي مدمج',
    'Manual QA or add-on': 'ضمان جودة يدوي أو إضافة',
    'Drag-and-drop builder': 'محرر سحب وإفلات',
    'Limited triggers': 'محفزات محدودة',
    'Auto-detects & suggests content': 'اكتشاف واقتراح محتوى تلقائي',
    'Manual identification': 'تحديد يدوي',
    'Customer Insights': 'رؤى العملاء',
    'Auto Jira tickets, trends': 'تذاكر Jira تلقائية، واتجاهات',
    'Basic reporting': 'تقارير أساسية',
    'WhatsApp, Phone, Email, SMS': 'WhatsApp، هاتف، إيميل، رسائل',
    'Outcome-based': 'بناءً على النتائج',
    'Per-agent + add-ons': 'لكل موظف + إضافات',
    'How long does it take to set up Open with Zendesk?':
      'كم ياخذ إعداد Open مع Zendesk؟',
    'Open can be set up in under an hour. It connects directly to your Zendesk instance via API and starts resolving queries on day one using your existing help center content.':
      'أقل من ساعة. Open يتصل مباشرة بـ Zendesk عبر الـ API ويبدأ يحل الاستفسارات من محتوى مركز مساعدتك، من أول يوم.',
    'Which Zendesk channels does Open support?':
      'وش قنوات Zendesk اللي يدعمها Open؟',
    'Open works across all Zendesk channels including tickets, live chat, email, voice, messaging (web, mobile, WhatsApp, Facebook), and social media—delivering personalized support everywhere your customers reach out.':
      'كلها. التذاكر، الدردشة، الإيميل، الصوت، المراسلة، والسوشيال—دعم مخصص أينما وصلك عميلك.',
    'Can I test Open and Zendesk AI at the same time?':
      'أقدر أجرب Open وذكاء Zendesk في نفس الوقت؟',
    'Yes! We can set up Open for you in a way where you can run an A/B test and decide for yourself. Try it risk-free for 1 month.':
      'نعم. نجهزه لك بحيث تشغّل اختبار A/B وتقرر بنفسك. شهر كامل بدون مخاطرة.',
    'Absolutely. You can try Open risk-free for a month with free implementation. Our team will help you get set up and see results before you commit.':
      'نعم. شهر بدون مخاطرة، والتنفيذ مجاني. فريقنا يجهّزك، وترى النتائج قبل أي التزام.',
    'How does Open integrate with my existing Zendesk workflows?':
      'كيف يتكامل Open مع سير عملي في Zendesk؟',
    'Open works as a native Zendesk user, respecting your existing triggers, automations, and macros. It follows your assignment rules, updates custom fields, and integrates with your current workflows without any changes required.':
      'Open مستخدم Zendesk أصلي: يحترم المحفزات والأتمتة والماكروز عندك، يتبع قواعد التعيين، ويحدّث حقولك المخصصة. بدون أي تغيير من طرفك.',
    "No migration required. Open connects via API and works seamlessly within your existing Zendesk setup. There's no disruption to your workflows—just faster, higher-quality support.":
      'ولا تذكرة تتحرك من مكانها. Open يتصل عبر الـ API ويعمل داخل Zendesk نفسه—بدون توقف، وبدون سير عمل جديد تتعلمه. لا شيء سوى دعم أسرع وأدق.',
    'Can I control what percentage of tickets Open handles?':
      'أقدر أحدد نسبة التذاكر اللي يتعامل معها Open؟',
    'Yes. You have full control over routing rules. You can set Open to handle 100%, 10%, or any percentage of your support tickets based on your preferences and support strategy.':
      'نعم، والتحكم كله بيدك. ١٠٠٪، ١٠٪، أو أي نسبة بينهما—قواعد التوجيه تحددها أنت.',
    'How does Open hand off to human agents?':
      'كيف يسلّم Open المحادثة للموظف؟',
    'Open updates Zendesk tickets, adds AI-generated summaries, and seamlessly hands off to human agents when needed—giving them full context to respond faster without frustrating back-and-forth.':
      'يحدّث التذكرة في Zendesk، ويكتب ملخصاً، ويسلّمها لموظف عند اللزوم—مع السياق كاملاً، فيرد فوراً بدون لف ودوران.',
    'Can I see how Open is performing in my Zendesk reports?':
      'أقدر أشوف أداء Open في تقارير Zendesk؟',
    'Yes. Since Open works as a native Zendesk user, all your existing reporting tools work perfectly. You can track performance, see resolution rates, and monitor behavior just like any other agent.':
      'نعم. Open مستخدم Zendesk أصلي، فتقاريرك تنطبق عليه كما تنطبق على أي موظف—الأداء، ومعدل الحل، والتصرف، كلها ظاهرة.',
    'How does Open learn and improve over time?':
      'كيف يتعلم Open ويتحسّن مع الوقت؟',
    "Open features continuous learning capabilities with built-in evaluation tools. It learns from your team's feedback, analyzes historical tickets, and improves accuracy over time with observability tools that provide full transparency.":
      'يتعلم من ملاحظات فريقك، يقرأ تذاكرك القديمة، ويرفع دقته أسبوع بعد أسبوع—وكل هذا أمام عينك بأدوات تقييم ورصد مدمجة.',
    'What channels can Open handle simultaneously?':
      'وش القنوات اللي يعمل عليها Open في نفس الوقت؟',
    'Open is omnichannel and works across Zendesk tickets, live chat, email, voice, WhatsApp, Facebook Messenger, and other messaging channels—all from one unified AI engine.':
      'كل القنوات، وبمحرك واحد: التذاكر، الدردشة، الإيميل، المكالمات، WhatsApp، Messenger، وغيرها.',
    'Can I configure Open for different brands or customer tiers?':
      'أقدر أضبط Open لعلامات أو فئات عملاء مختلفة؟',
    'Yes. Open uses synced Zendesk data to configure responses for each segment. Answers and handoffs automatically adjust by brand, customer tier, or support queue.':
      'نعم. يقرأ بيانات Zendesk المتزامنة ويضبط الردود لكل شريحة—الإجابة والتحويل يتغيّرون تلقائياً حسب العلامة، فئة العميل، أو طابور الدعم.',
    'What kind of queries can Open resolve?':
      'وش نوع الاستفسارات اللي يحلها Open؟',
    'Open is designed to handle complex queries with accuracy and reliability. It can resolve a wide range of customer questions, from simple FAQs to intricate technical issues, using your knowledge base and documentation.':
      'مصمم للاستفسارات المعقدة، مو بس الأسئلة الشائعة. من سؤال وين طلبي؟ إلى المشاكل التقنية المتشعبة—يحلها من قاعدة معرفتك وتوثيقك.',
    'Does Open require changes to my current setup?':
      'لازم أغيّر إعدادي الحالي لتشغيل Open؟',
    'No. Open connects via API with no migration required. It works within your existing workflows, follows your assignment rules, and requires zero disruption to your current Zendesk configuration.':
      'لا. اتصال عبر الـ API، وبدون ترحيل. Open يعمل داخل سير عملك الحالي، ويتبع قواعد التعيين عندك، ولا يمسّ إعدادك.',
    'Enterprise-grade AI for': 'AI بمستوى المؤسسات لـ',
    'at any tier': 'في أي باقة',
    'Enterprise-grade AI at any tier. No premium plan required, no feature limits—powerful AI from day one.':
      'ذكاء بمستوى المؤسسات، في أي باقة. بدون ترقية، بدون حدود ميزات—قوة كاملة من أول يوم.',
    'Create a new user in HubSpot': 'أنشئ مستخدم جديد في HubSpot',
    'Our AI will work like any other teammate in your HubSpot workspace.':
      'سيعمل مثل أي زميل في فريقك داخل HubSpot.',
    'Because your new AI works within HubSpot, all of your reporting and analytics remain intact. Continuously improve with feedback and training.':
      'لأنه يعمل داخل HubSpot، تبقى تقاريرك وتحليلاتك كما هي. حسّنه بالملاحظات والتدريب باستمرار.',
    "See how Open's Agent 5 delivers enterprise AI without the enterprise pricing.":
      'اكتشف كيف تحصل على ذكاء بمستوى المؤسسات، بدون فاتورة المؤسسات.',
    'HubSpot AI': 'HubSpot AI',
    'Do I need the full HubSpot suite to use Agent 5?':
      'لازم حزمة HubSpot الكاملة؟',
    "No. Unlike HubSpot's AI features which require expensive tier upgrades and the full suite, Agent 5 works standalone with your HubSpot Service Hub at any tier level.":
      'لا. ميزات HubSpot AI تتطلب ترقية مكلفة والحزمة الكاملة. نظامنا يعمل بمفرده مع HubSpot Service Hub عندك، بأي باقة.',
    'How does Agent 5 pricing compare to HubSpot AI features?':
      'كيف يقارن سعرنا بميزات HubSpot AI؟',
    'Agent 5 costs $0.75-$0.90 per resolution with transparent pricing. HubSpot locks AI features behind premium tiers that can cost thousands per month, making Agent 5 significantly more affordable.':
      '٢-٣ ⃁ لكل حل. تسعير واضح، بدون مفاجآت. HubSpot يقفل ذكاءه خلف باقات مميزة تكلف آلاف شهرياً—فالفرق بالحساب كبير.',
    'Does Agent 5 work with HubSpot conversations and tickets?':
      'يعمل مع محادثات وتذاكر HubSpot؟',
    'Yes. Agent 5 integrates with HubSpot conversations, tickets, live chat, and email channels. It works within your existing HubSpot Service Hub setup without requiring any changes.':
      'نعم—المحادثات، التذاكر، الدردشة، والإيميل. يعمل داخل HubSpot Service Hub عندك بدون تغيير سطر واحد في إعدادك.',
    "Can I use Agent 5 with HubSpot's free tier?":
      'يعمل مع باقة HubSpot المجانية؟',
    "Yes. Agent 5 works with any HubSpot tier, including the free tier. You don't need to upgrade your HubSpot subscription to access advanced AI capabilities.":
      'نعم. أي باقة HubSpot، حتى المجانية. لا تحتاج ترقية للوصول إلى قدرات ذكاء متقدمة.',
    'How long does it take to set up Agent 5 with HubSpot?':
      'كم ياخذ الإعداد مع HubSpot؟',
    'Agent 5 can be set up in under an hour. It connects via API to your HubSpot instance and starts resolving customer queries on day one using your existing knowledge base.':
      'أقل من ساعة. يتصل بـ HubSpot عبر الـ API ويبدأ يحل الاستفسارات من قاعدة معرفتك، من أول يوم.',
    'Can I see Agent 5 performance in HubSpot reports?':
      'أقدر أشوف أداءه في تقارير HubSpot؟',
    'Yes. Agent 5 works as a native HubSpot agent, so all your existing dashboards, reports, and analytics continue to work. Track AI performance alongside your human agents in HubSpot.':
      'نعم. هو مستخدم HubSpot أصلي، فتبقى لوحاتك وتقاريرك وتحليلاتك كما هي. تابع أداءه إلى جانب موظفيك.',
    "Find answers to common questions about our HubSpot AI agent. Can't find what you're looking for? Contact our support team.":
      'أسئلة شائعة عن Open داخل HubSpot. ما لقيت ما تبيه؟ كلّمنا.',
    'Native HubSpot user': 'مستخدم أصلي في HubSpot',
    'Leading accounting software in the Middle East':
      'برنامج محاسبة رائد في الشرق الأوسط',
    'chose Open over HubSpot AI. They did it because Open works better for them.':
      'اختاروا Open بدل HubSpot AI—لأن Open يحقق لهم نتائج أفضل.',
    'No tier upgrades, no suite requirements—just results.':
      'بلا ترقيات، بلا متطلبات باقات—نتائج بس.',
    "See how Open's AI engine delivers enterprise AI without the enterprise pricing.":
      'شوف كيف يعطيك Open ذكاء بمستوى المؤسسات، بدون فاتورة المؤسسات.',
    'How long does it take to set up Open with HubSpot?':
      'كم ياخذ إعداد Open مع HubSpot؟',
    'Open can be set up in under an hour. It connects directly to your HubSpot Service Hub via API and starts resolving queries on day one using your existing help center content.':
      'أقل من ساعة. Open يتصل مباشرة بـ HubSpot Service Hub عبر الـ API، ويبدأ يحل الاستفسارات من محتوى مركز مساعدتك من أول يوم.',
    'Do I need the full HubSpot suite to use Open?':
      'لازم حزمة HubSpot الكاملة لاستخدام Open؟',
    "No. Unlike HubSpot's AI features which require expensive tier upgrades and the full suite, Open works standalone with your HubSpot Service Hub at any tier level.":
      'لا. ميزات HubSpot AI تتطلب ترقية مكلفة والحزمة الكاملة. Open يعمل بمفرده مع HubSpot Service Hub، بأي باقة.',
    'Does Open work with HubSpot conversations and tickets?':
      'Open يعمل مع محادثات وتذاكر HubSpot؟',
    'Yes. Open integrates with HubSpot conversations, tickets, live chat, and email channels. It works within your existing HubSpot Service Hub setup without requiring any changes.':
      'نعم—المحادثات، التذاكر، الدردشة، والإيميل. يعمل داخل HubSpot Service Hub عندك بدون أي تغيير في الإعداد.',
    'Can I test Open and HubSpot AI at the same time?':
      'أقدر أجرب Open وHubSpot AI في نفس الوقت؟',
    "Can I use Open with HubSpot's free tier?":
      'Open يعمل مع باقة HubSpot المجانية؟',
    "Yes. Open works with any HubSpot tier, including the free tier. You don't need to upgrade your HubSpot subscription to access advanced AI capabilities.":
      'نعم. أي باقة HubSpot، حتى المجانية. لا تحتاج ترقية اشتراكك للوصول إلى القدرات المتقدمة.',
    'How does Open pricing compare to HubSpot AI features?':
      'كيف يقارن سعر Open بميزات HubSpot AI؟',
    'Open costs $0.75-$0.90 per resolution with transparent pricing. HubSpot locks AI features behind premium tiers that can cost thousands per month, making Open significantly more affordable.':
      'Open يكلف ٢-٣ ⃁ لكل حل. تسعير واضح، بدون مفاجآت. HubSpot يقفل ذكاءه خلف باقات مميزة تكلف آلاف شهرياً—فـ Open أرخص بوايد.',
    'Can I see how Open is performing in HubSpot reports?':
      'أقدر أشوف أداء Open في تقارير HubSpot؟',
    'Yes. Open works as a native HubSpot agent, so all your existing dashboards, reports, and analytics continue to work. Track AI performance alongside your human agents in HubSpot.':
      'نعم. Open مستخدم HubSpot أصلي، فتبقى لوحاتك وتقاريرك وتحليلاتك كما هي. تابع أداءه إلى جانب موظفيك.',
    'Open updates HubSpot tickets, adds AI-generated summaries, and seamlessly hands off to human agents when needed—giving them full context to respond faster.':
      'Open يحدّث تذكرة HubSpot، ويكتب ملخصاً، ويسلّمها لموظف عند اللزوم—مع السياق كاملاً فيرد أسرع.',
    'What channels can Open handle with HubSpot?':
      'وش القنوات اللي يعمل عليها Open مع HubSpot؟',
    'Open is omnichannel and works across HubSpot conversations, tickets, live chat, email, voice, WhatsApp, and other messaging channels—all from one unified AI engine.':
      'كل القنوات، وبمحرك واحد: المحادثات، التذاكر، الدردشة، الإيميل، المكالمات، WhatsApp، وغيرها.',
    'Does Open require changes to my current HubSpot setup?':
      'لازم أغيّر إعدادات HubSpot الحالية؟',
    'No. Open connects via API with no migration required. It works within your existing workflows, follows your assignment rules, and requires zero disruption to your current HubSpot configuration.':
      'لا. اتصال عبر الـ API، وبدون ترحيل. Open يعمل داخل سير عملك الحالي، ويتبع قواعد التعيين عندك، ولا يمسّ إعدادك.',
    'The Intercom AI you were promised': 'ذكاء Intercom اللي وعدوك به',
    The: 'ذكاء',
    'AI you were promised': 'اللي وعدوك به',
    'Full features from day one, not months later. Complete control over training and behavior. Transparent performance you can actually trust. Everything Intercom promised, delivered immediately.':
      'كل الميزات من أول يوم، لا بعد شهور. تحكم كامل في التدريب والتصرف. وأداء شفاف تثق فيه فعلاً. كل ما وعدك به Intercom—تحصل عليه فوراً.',
    'Full features from day one. Complete control over training. Transparent performance you can trust.':
      'كل الميزات من أول يوم. تحكم كامل في التدريب. وأداء شفاف تثق فيه.',
    'Create the AI teammate in Intercom': 'أنشئ الزميل الذكي في Intercom',
    'Our AI will work like any other teammate in your Intercom workspace.':
      'سيعمل مثل أي زميل في فريقك داخل Intercom.',
    'Because your new AI is just another teammate in Intercom, all of your reporting is intact. Continuously improve with feedback and training.':
      'لأنه زميل عادي داخل Intercom، تبقى تقاريرك كما هي. حسّنه بالملاحظات والتدريب باستمرار.',
    "See how Open's Agent 5 delivers better AI at a better price than Intercom's Fin.":
      'شوف كيف يتفوّق نظامنا على Fin—بالجودة وبالسعر.',
    "See how Open's AI engine delivers better results at a better price than Intercom's Fin.":
      'شوف كيف يعطي نظامنا نتائج أحسن من Fin، وبسعر أقل.',
    "See how our AI engine delivers better results at a better price than Intercom's Fin.":
      'شوف كيف يعطي نظامنا نتائج أحسن من Fin، وبسعر أقل.',
    'Trusted by companies who switched from Intercom':
      'شركات تركت Intercom وصارت معنا',
    'Intercom Fin AI': 'Intercom Fin AI',
    "Open's AI": 'ذكاء Open',
    'Our AI': 'نظامنا',
    'How long does it take to set up Agent 5 with Intercom?':
      'كم ياخذ الإعداد مع Intercom؟',
    "How long does it take to set up Open's AI with Intercom?":
      'كم ياخذ إعداد ذكاء Open مع Intercom؟',
    'How long does it take to set up the platform with Intercom?':
      'كم ياخذ الإعداد مع Intercom؟',
    'Agent 5 can be set up in under an hour. It connects directly to your Intercom instance via API and starts resolving queries on day one using your existing help center content.':
      'أقل من ساعة. يتصل مباشرة بـ Intercom عبر الـ API ويبدأ يحل الاستفسارات من محتوى مركز مساعدتك، من أول يوم.',
    "Open's AI can be set up in under an hour. It connects directly to your Intercom instance via API and starts resolving queries on day one using your existing help center content.":
      'أقل من ساعة. يتصل مباشرة بـ Intercom عبر الـ API ويبدأ يحل الاستفسارات من محتوى مركز مساعدتك، من أول يوم.',
    'Our AI can be set up in under an hour. It connects directly to your Intercom instance via API and starts resolving queries on day one using your existing help center content.':
      'أقل من ساعة، وخلصنا. يتصل مباشرة بـ Intercom عبر الـ API ويبدأ يحل الاستفسارات من محتوى مركز مساعدتك من أول يوم.',
    'How is Agent 5 better than Intercom Fin?':
      'وش يميّز نظامنا عن Intercom Fin؟',
    "How is Open's AI better than Intercom Fin?":
      'وش يميّز ذكاء Open عن Intercom Fin؟',
    'How is our AI better than Intercom Fin?':
      'وش يميّز نظامنا عن Intercom Fin؟',
    'Agent 5 delivers superior AI quality from day one with no waiting period. You get all features immediately, transparent pricing with no seat fees, and a multi-model AI engine that outperforms Fin.':
      'جودة أعلى من أول يوم، بدون فترة انتظار. كل الميزات فوراً، تسعير واضح بدون رسوم مقاعد، ومحرك متعدد النماذج يتفوّق على Fin.',
    "Open's AI delivers superior quality from day one with no waiting period. You get all features immediately, transparent pricing with no seat fees, and a multi-model AI engine that outperforms Fin.":
      'جودة أعلى من أول يوم، بدون فترة انتظار. كل الميزات فوراً، تسعير واضح بدون رسوم مقاعد، ومحرك متعدد النماذج يتفوّق على Fin.',
    'Our AI delivers superior quality from day one with no waiting period. You get all features immediately, transparent pricing with no seat fees, and a multi-model AI engine that outperforms Fin.':
      'جودة أعلى من أول يوم، بدون فترة انتظار. كل الميزات فوراً، تسعير واضح بدون رسوم مقاعد، ومحرك متعدد النماذج يتفوّق على Fin.',
    'Why is Agent 5 cheaper than Fin?': 'ليش نظامنا أرخص من Fin؟',
    "Why is Open's AI cheaper than Fin?": 'ليش ذكاء Open أرخص من Fin؟',
    'Why is our AI cheaper than Fin?': 'ليش نظامنا أرخص من Fin؟',
    'Agent 5 costs $0.75-$0.90 per resolution with no additional seat fees or hidden costs. Intercom charges $0.99 per resolution plus additional seat fees, making our solution significantly more affordable.':
      'نظامنا ٢-٣ ⃁ لكل حل، وبس—بدون رسوم مقاعد ولا تكاليف مخفية. Intercom ٠,٩٩ دولار لكل حل + رسوم مقاعد. فنظامنا أرخص بوايد.',
    "Open's AI costs $0.75-$0.90 per resolution with no additional seat fees or hidden costs. Intercom charges $0.99 per resolution plus additional seat fees, making our solution significantly more affordable.":
      'ذكاء Open ٢-٣ ⃁ لكل حل، وبس—بدون رسوم مقاعد ولا تكاليف مخفية. Intercom ٠,٩٩ دولار لكل حل + رسوم مقاعد. فنظامنا أرخص بوايد.',
    'Our AI costs $0.75-$0.90 per resolution with no additional seat fees or hidden costs. Intercom charges $0.99 per resolution plus additional seat fees, making our solution significantly more affordable.':
      'نظامنا ٢-٣ ⃁ لكل حل، وبس—بدون رسوم مقاعد ولا تكاليف مخفية. Intercom ٠,٩٩ دولار لكل حل + رسوم مقاعد. فنظامنا أرخص بوايد.',
    'Do I get all features on day one with Agent 5?':
      'أحصل على كل الميزات من أول يوم؟',
    "Do I get all features on day one with Open's AI?":
      'أحصل على كل الميزات من أول يوم مع ذكاء Open؟',
    'Do I get all features on day one?': 'أحصل على كل الميزات من أول يوم؟',
    'Yes. Unlike Intercom which gradually rolls out features over months, Agent 5 gives you access to all features from day one. No waiting, no phased rollouts.':
      'نعم. Intercom يفتح لك الميزات على مراحل، على مدى شهور. نظامنا يفتحها كلها من أول يوم—بدون انتظار، وبدون إطلاق تدريجي.',
    "Yes. Unlike Intercom which gradually rolls out features over months, Open's AI gives you access to all features from day one. No waiting, no phased rollouts.":
      'نعم. Intercom يفتح لك الميزات على مراحل، على مدى شهور. ذكاء Open يفتحها كلها من أول يوم—بدون انتظار، وبدون إطلاق تدريجي.',
    'Yes. Unlike Intercom which gradually rolls out features over months, our platform gives you access to all features from day one. No waiting, no phased rollouts.':
      'نعم. Intercom يفتح لك الميزات على مراحل، على مدى شهور. نظامنا يفتحها كلها من أول يوم—بدون انتظار، وبدون إطلاق تدريجي.',
    'Can I control what percentage of tickets the AI handles?':
      'أقدر أحدد نسبة التذاكر اللي يتعامل معها؟',
    'Yes. You have full control over routing rules. You can set the AI to handle 100%, 10%, or any percentage of your support tickets based on your preferences and support strategy.':
      'نعم، والتحكم كله بيدك. ١٠٠٪، ١٠٪، أو أي نسبة بينهما—قواعد التوجيه تحددها أنت.',
    'How does Agent 5 integrate with Intercom?': 'كيف يتكامل مع Intercom؟',
    "How does Open's AI integrate with Intercom?":
      'كيف يتكامل ذكاء Open مع Intercom؟',
    'How does the platform integrate with Intercom?': 'كيف يتكامل مع Intercom؟',
    'Agent 5 connects via API and works as a native Intercom teammate. It syncs customer data, follows your workflows, and integrates seamlessly with your existing setup.':
      'يتصل عبر الـ API ويعمل كزميل أصلي في Intercom—يزامن بيانات العملاء، يتبع سير عملك، ويندمج مع إعدادك الحالي بدون احتكاك.',
    "Open's AI connects via API and works as a native Intercom teammate. It syncs customer data, follows your workflows, and integrates seamlessly with your existing setup.":
      'ذكاء Open يتصل عبر الـ API ويعمل كزميل أصلي في Intercom—يزامن بيانات العملاء، يتبع سير عملك، ويندمج مع إعدادك الحالي بدون احتكاك.',
    'Our AI connects via API and works as a native Intercom teammate. It syncs customer data, follows your workflows, and integrates seamlessly with your existing setup.':
      'نظامنا يتصل عبر الـ API ويعمل كزميل أصلي في Intercom—يزامن بيانات العملاء، يتبع سير عملك، ويندمج مع إعدادك الحالي بدون احتكاك.',
    'Can I test Open and Fin at the same time?':
      'أقدر أجرب Open وFin في نفس الوقت؟',
    'Yes! We can set up Open for you in a way where you can run A/B tests between Open and Fin, and decide for yourself which performs better. Try it risk-free for 1 month.':
      'نعم. نجهزه لك بحيث تشغّل اختبار A/B بين Open وFin، وتشوف الأرقام بعينك. شهر كامل بدون مخاطرة.',
    'Can I try Open risk-free?': 'أقدر أجرب Open بدون مخاطرة؟',
    "Absolutely. You can try Open risk-free for a full month with free implementation. Our team will set everything up for you at no cost, and you only pay if you're satisfied with the results.":
      'نعم. شهر كامل بدون مخاطرة، والتنفيذ علينا. فريقنا يجهّز لك كل شيء بدون تكلفة، ولا تدفع إلا إذا أعجبتك النتائج.',
    "Find answers to common questions about our Intercom AI agent. Can't find what you're looking for? Contact our support team.":
      'أسئلة شائعة عن Open داخل Intercom. ما لقيت ما تبيه؟ كلّمنا.',
    "Finally, AI for Salesforce that doesn't require a consultant":
      'أخيراً، AI لـ Salesforce بدون مستشارين',
    'Finally, AI for': 'أخيراً، AI لـ',
    "that doesn't require a consultant": 'بدون مستشارين',
    'Enterprise-grade AI in minutes, not months. No consultants, no weeks of setup, no Salesforce expertise required.':
      'ذكاء بمستوى المؤسسات في دقائق، لا شهور. بدون مستشارين، بدون أسابيع إعداد، وبدون خبرة في Salesforce.',
    'Create the AI agent in Salesforce': 'أنشئ الموظف الذكي في Salesforce',
    'Our AI integrates directly into your Salesforce Service Cloud as a native agent.':
      'يندمج مباشرة داخل Salesforce Service Cloud، ويعمل كموظف أصلي في فريقك.',
    'Because your new AI works within Salesforce, all of your reporting dashboards continue to work seamlessly. Continuously improve with feedback and training.':
      'لأنه يشتغل داخل Salesforce، تواصل لوحات تقاريرك عملها بدون ما تلمس شي. حسّنه بالملاحظات والتدريب باستمرار.',
    "See how Open's Agent 5 eliminates Salesforce's complexity and cost.":
      'شوف كيف يشيل نظامنا تعقيد Salesforce وتكلفته.',
    'Salesforce Einstein AI': 'Salesforce Einstein AI',
    'Do I need Salesforce consultants to set up Agent 5?':
      'أحتاج مستشاري Salesforce لإعداده؟',
    'No. Unlike Salesforce Einstein which often requires consultant setup, Agent 5 can be deployed in under an hour without any external help or Salesforce expertise.':
      'لا. Salesforce Einstein غالباً يتطلب مستشاراً لإعداده. نظامنا يعمل في أقل من ساعة، بدون مساعدة خارجية وبدون خبرة في Salesforce.',
    'Does Agent 5 support Salesforce Email-to-Case?':
      'يدعم Salesforce Email-to-Case؟',
    'Yes. Agent 5 fully supports Salesforce Email-to-Case and can automatically respond to customer emails that create cases in your Salesforce Service Cloud.':
      'نعم، بالكامل. يرد تلقائياً على إيميلات العملاء اللي تفتح حالات في Salesforce Service Cloud.',
    'Does Agent 5 work with Salesforce MIAW (Messaging in App Window)?':
      'يعمل مع Salesforce MIAW (المراسلة في نافذة التطبيق)؟',
    'Yes. Agent 5 integrates seamlessly with Salesforce MIAW (Messaging in App Window), also known as Salesforce chat. Your customers can get instant AI-powered support through the Salesforce chat interface.':
      'نعم. يتكامل مع Salesforce MIAW (المراسلة في نافذة التطبيق)، المعروف بدردشة Salesforce. عميلك ياخذ دعم فوري بالـ AI من نفس واجهة الدردشة.',
    'Is Agent 5 easier to use than Salesforce Einstein?':
      'نظامنا أسهل من Salesforce Einstein؟',
    'Absolutely. While Salesforce Einstein requires deep Salesforce knowledge and complex configuration, Agent 5 is designed for simplicity with an intuitive interface and zero learning curve.':
      'نعم. Einstein يتطلب خبرة عميقة في Salesforce وإعدادات معقدة. نظامنا واجهة بديهية، تتقنها من أول جلسة.',
    'Can I see Agent 5 performance in Salesforce reports?':
      'أقدر أشوف أداءه في تقارير Salesforce؟',
    'Yes. Agent 5 works as a native Salesforce agent, so all your existing dashboards, reports, and analytics continue to work perfectly. Track AI performance alongside your human agents.':
      'نعم. هو مستخدم Salesforce أصلي، فتبقى لوحاتك وتقاريرك وتحليلاتك كما هي. تابع أداءه إلى جانب موظفيك.',
    'How does Agent 5 handle Salesforce workflows?':
      'كيف يتعامل مع سير عمل Salesforce؟',
    'Agent 5 respects your existing Salesforce workflows, assignment rules, and escalation paths. It works within your current setup without requiring workflow redesign.':
      'يحترم سير عملك في Salesforce، وقواعد التعيين، ومسارات التصعيد. ويعمل داخل إعدادك الحالي بدون إعادة تصميم.',
    "Find answers to common questions about our Salesforce AI agent. Can't find what you're looking for? Contact our support team.":
      'أسئلة شائعة عن Open داخل Salesforce. ما لقيت ما تبيه؟ كلّمنا.',
    "Hey, I'm Mo, founder of Open.": 'هلا، أنا Mo، مؤسس Open.',
    "Don't take my word for it—companies like": 'لا تصدّقني وبس—شركات مثل',
    'chose Open over Salesforce Einstein. They did it because Open works better for them.':
      'اختاروا Open بدل Salesforce Einstein—لأن Open يحقق لهم نتائج أفضل.',
    'No consultants, no months of setup—just results.':
      'بلا مستشارين، بلا شهور إعداد—نتائج بس.',
    'Global money transfer company': 'شركة تحويل أموال عالمية',
    'automation with Open': 'أتمتة مع Open',
    'Founder & CEO, Open': 'المؤسس والرئيس التنفيذي، Open',
    'Native Salesforce user': 'مستخدم أصلي في Salesforce',
    'How long does it take to set up Open with Salesforce?':
      'كم ياخذ إعداد Open مع Salesforce؟',
    'Open can be set up in under an hour. It connects directly to your Salesforce Service Cloud via API and starts resolving queries on day one using your existing help center content.':
      'أقل من ساعة. Open يتصل مباشرة بـ Salesforce Service Cloud عبر الـ API ويبدأ يحل الاستفسارات من محتوى مركز مساعدتك، من أول يوم.',
    'Do I need Salesforce consultants to set up Open?':
      'أحتاج مستشاري Salesforce لإعداد Open؟',
    'No. Unlike Salesforce Einstein which often requires consultant setup, Open can be deployed in under an hour without any external help or Salesforce expertise.':
      'لا. Salesforce Einstein غالباً يلزمه مستشار. Open تشغّله بأقل من ساعة، بدون مساعدة خارجية وبدون خبرة في Salesforce.',
    'Does Open support Salesforce Email-to-Case?':
      'Open يدعم Salesforce Email-to-Case؟',
    'Yes. Open fully supports Salesforce Email-to-Case and can automatically respond to customer emails that create cases in your Salesforce Service Cloud.':
      'نعم، بالكامل. يرد تلقائياً على إيميلات العملاء اللي تفتح حالات في Salesforce Service Cloud.',
    'Can I test Open and Salesforce Einstein at the same time?':
      'أقدر أجرب Open وSalesforce Einstein في نفس الوقت؟',
    'Does Open work with Salesforce MIAW (Messaging in App Window)?':
      'Open يعمل مع Salesforce MIAW (المراسلة في نافذة التطبيق)؟',
    'Yes. Open integrates seamlessly with Salesforce MIAW (Messaging in App Window), also known as Salesforce chat. Your customers can get instant AI-powered support through the Salesforce chat interface.':
      'نعم. Open يتكامل مع Salesforce MIAW، المعروف بدردشة Salesforce. عميلك ياخذ دعم فوري بالـ AI من نفس الواجهة.',
    'Is Open easier to use than Salesforce Einstein?':
      'Open أسهل من Salesforce Einstein؟',
    'Absolutely. While Salesforce Einstein requires deep Salesforce knowledge and complex configuration, Open is designed for simplicity with an intuitive interface and zero learning curve.':
      'نعم. Einstein يتطلب خبرة عميقة في Salesforce وإعدادات معقدة. Open واجهة بديهية، تتقنها من أول جلسة.',
    'Can I see how Open is performing in Salesforce reports?':
      'أقدر أشوف أداء Open في تقارير Salesforce؟',
    'Yes. Open works as a native Salesforce agent, so all your existing dashboards, reports, and analytics continue to work perfectly. Track AI performance alongside your human agents.':
      'نعم. Open مستخدم Salesforce أصلي، فتبقى لوحاتك وتقاريرك وتحليلاتك كما هي. تابع أداءه إلى جانب موظفيك.',
    'How does Open handle Salesforce workflows?':
      'كيف يتعامل Open مع سير عمل Salesforce؟',
    'Open respects your existing Salesforce workflows, assignment rules, and escalation paths. It works within your current setup without requiring workflow redesign.':
      'Open يحترم سير عملك في Salesforce، وقواعد التعيين، ومسارات التصعيد. ويعمل داخل إعدادك الحالي بدون إعادة تصميم.',
    'Open updates Salesforce cases, adds AI-generated summaries, and seamlessly hands off to human agents when needed—giving them full context to respond faster.':
      'Open يحدّث حالة Salesforce، ويكتب ملخصاً، ويسلّمها لموظف عند اللزوم—مع السياق كاملاً فيرد أسرع.',
    "Open features continuous learning capabilities with built-in evaluation tools. It learns from your team's feedback, analyzes historical cases, and improves accuracy over time with observability tools that provide full transparency.":
      'Open يتعلم من ملاحظات فريقك، يقرأ حالاتك القديمة، ويرفع دقته مع الوقت—وكل هذا أمام عينك بأدوات تقييم ورصد مدمجة.',
    'What channels can Open handle with Salesforce?':
      'وش القنوات اللي يعمل عليها Open مع Salesforce؟',
    'Open is omnichannel and works across Salesforce cases, Email-to-Case, MIAW chat, voice, WhatsApp, and other messaging channels—all from one unified AI engine.':
      'كل القنوات، وبمحرك واحد: الحالات، Email-to-Case، دردشة MIAW، المكالمات، WhatsApp، وغيرها.',
    'Does Open require changes to my current Salesforce setup?':
      'لازم أغيّر إعدادات Salesforce الحالية؟',
    'No. Open connects via API with no migration required. It works within your existing workflows, follows your assignment rules, and requires zero disruption to your current Salesforce configuration.':
      'لا. اتصال عبر الـ API، وبدون ترحيل. Open يعمل داخل سير عملك الحالي، ويتبع قواعد التعيين عندك، ولا يمسّ إعدادك.',
    'Advanced AI for Freshdesk (because Freddy is too simple)':
      'AI متقدم لـ Freshdesk (لأن Freddy بسيط زيادة)',
    "Sophisticated AI that handles complex queries and technical issues. Goes beyond Freddy's basic capabilities.":
      'AI يحل الاستفسارات المعقدة والمشاكل التقنية. أبعد بكثير من حدود Freddy.',
    'Create a new user in Freshdesk': 'أنشئ مستخدم جديد في Freshdesk',
    'Our AI will work like any other teammate in your Freshdesk workspace.':
      'سيعمل مثل أي زميل في فريقك داخل Freshdesk.',
    'Because your new AI works within Freshdesk, all of your reporting and analytics remain intact. Continuously improve with feedback and training.':
      'لأنه يعمل داخل Freshdesk، تبقى تقاريرك وتحليلاتك كما هي. حسّنه بالملاحظات والتدريب باستمرار.',
    "See how Open's Agent 5 delivers sophisticated AI that goes beyond Freddy's basic capabilities.":
      'شوف وين يتوقف Freddy، ووين يبدأ نظامنا.',
    "See how Open's AI engine delivers sophisticated AI that goes beyond Freddy's basic capabilities.":
      'شوف وين يتوقف Freddy، ووين يبدأ ذكاء Open.',
    'Freddy AI': 'Freddy AI',
    'Why is Agent 5 better than Freddy AI?': 'ليش نظامنا أفضل من Freddy AI؟',
    'Why is Open better than Freddy AI?': 'ليش Open أفضل من Freddy AI؟',
    'Freddy AI is limited to simple, pattern-based responses. Agent 5 uses advanced multi-model AI that understands context, handles complex technical queries, and provides nuanced answers that feel human.':
      'Freddy محدود بردود جاهزة مبنية على أنماط. نظامنا متعدد النماذج: يفهم السياق، يحل الاستفسارات التقنية المعقدة، ويعطي إجابات تحس إن بشر كتبها.',
    'Freddy AI is limited to simple, pattern-based responses. Open uses advanced multi-model AI that understands context, handles complex technical queries, and provides nuanced answers that feel human.':
      'Freddy محدود بردود جاهزة مبنية على أنماط. Open متعدد النماذج: يفهم السياق، يحل الاستفسارات التقنية المعقدة، ويعطي إجابات تحس إن بشر كتبها.',
    'Can Agent 5 handle complex customer queries?':
      'يتعامل مع الاستفسارات المعقدة؟',
    'Can Open handle complex customer queries?':
      'Open يتعامل مع الاستفسارات المعقدة؟',
    'Yes. Unlike Freddy which struggles with anything beyond simple FAQs, Agent 5 excels at complex, multi-turn conversations, technical troubleshooting, and nuanced customer issues.':
      'نعم. Freddy يتعثّر مع أي شيء أعقد من سؤال شائع. نظامنا يواصل محادثات طويلة، ويحل مشاكل تقنية، ويتعامل مع الحالات الدقيقة.',
    'Yes. Unlike Freddy which struggles with anything beyond simple FAQs, Open excels at complex, multi-turn conversations, technical troubleshooting, and nuanced customer issues.':
      'نعم. Freddy يتعثّر مع أي شيء أعقد من سؤال شائع. Open يواصل محادثات طويلة، ويحل مشاكل تقنية، ويتعامل مع الحالات الدقيقة.',
    'Can I test Open and Freddy AI at the same time?':
      'أقدر أجرب Open وFreddy AI في نفس الوقت؟',
    'How long does it take to set up Agent 5 with Freshdesk?':
      'كم ياخذ الإعداد مع Freshdesk؟',
    'Agent 5 can be set up in under an hour. It connects directly to your Freshdesk instance via API and starts resolving queries on day one using your existing help center content.':
      'أقل من ساعة. يتصل مباشرة بـ Freshdesk عبر الـ API ويبدأ يحل الاستفسارات من محتوى مركز مساعدتك، من أول يوم.',
    'Does Agent 5 work with Freshdesk email and chat channels?':
      'يعمل مع قنوات الإيميل والدردشة في Freshdesk؟',
    'Yes. Agent 5 works across all Freshdesk channels including email tickets, live chat, phone support, and messaging—providing sophisticated AI support everywhere your customers reach out.':
      'نعم، على كل قنوات Freshdesk: تذاكر الإيميل، الدردشة، المكالمات، والمراسلة. دعم متقدم أينما وصلك عميلك.',
    'Can I see how Agent 5 is performing in Freshdesk?':
      'أقدر أشوف أداءه في Freshdesk؟',
    'Yes. Since Agent 5 works as a native Freshdesk agent, all your existing reporting, analytics, and dashboards continue to work. Track AI performance alongside your human agents.':
      'نعم. هو موظف Freshdesk أصلي، فتبقى تقاريرك وتحليلاتك ولوحاتك كما هي. تابع أداءه إلى جانب موظفيك.',
    'Does Agent 5 integrate with my Freshdesk workflows?':
      'يتكامل مع سير عمل Freshdesk عندي؟',
    'Yes. Agent 5 respects your existing Freshdesk automation rules, SLA policies, and escalation workflows. It works within your current setup without requiring reconfiguration.':
      'نعم. يحترم قواعد الأتمتة عندك، وسياسات SLA، ومسارات التصعيد. ويعمل داخل إعدادك الحالي بدون إعادة ضبط.',
    'How long does it take to set up Open with Freshdesk?':
      'كم ياخذ إعداد Open مع Freshdesk؟',
    'Open can be set up in under an hour. It connects directly to your Freshdesk instance via API and starts resolving queries on day one using your existing help center content.':
      'أقل من ساعة. Open يتصل مباشرة بـ Freshdesk عبر الـ API ويبدأ يحل الاستفسارات من محتوى مركز مساعدتك، من أول يوم.',
    'Does Open work with Freshdesk email and chat channels?':
      'Open يعمل مع قنوات الإيميل والدردشة في Freshdesk؟',
    'Yes. Open works across all Freshdesk channels including email tickets, live chat, phone support, and messaging—providing sophisticated AI support everywhere your customers reach out.':
      'نعم، على كل قنوات Freshdesk: تذاكر الإيميل، الدردشة، المكالمات، والمراسلة. دعم متقدم أينما وصلك عميلك.',
    'Can I see how Open is performing in Freshdesk?':
      'أقدر أشوف أداء Open في Freshdesk؟',
    'Yes. Since Open works as a native Freshdesk agent, all your existing reporting, analytics, and dashboards continue to work. Track AI performance alongside your human agents.':
      'نعم. Open موظف Freshdesk أصلي، فتبقى تقاريرك وتحليلاتك ولوحاتك كما هي. تابع أداءه إلى جانب موظفيك.',
    'Does Open integrate with my Freshdesk workflows?':
      'Open يتكامل مع سير عمل Freshdesk عندي؟',
    'Yes. Open respects your existing Freshdesk automation rules, SLA policies, and escalation workflows. It works within your current setup without requiring reconfiguration.':
      'نعم. Open يحترم قواعد الأتمتة عندك، وسياسات SLA، ومسارات التصعيد. ويعمل داخل إعدادك الحالي بدون إعادة ضبط.',
    'Text only': 'بس نص',
    'Manual QA': 'ضمان جودة يدوي',
    "Find answers to common questions about our Freshdesk AI agent. Can't find what you're looking for? Contact our support team.":
      'أسئلة شائعة عن Open داخل Freshdesk. ما لقيت ما تبيه؟ كلّمنا.',
    "The AI agent Twilio Flex doesn't have":
      'الموظف الذكي اللي ما عنده Twilio Flex',
    'Production-ready AI that integrates in minutes. No building from scratch, no developers, no months of work.':
      'AI جاهز للإنتاج، يتكامل في دقائق. بدون بناء من الصفر، بدون مطورين، بدون شهور عمل.',
    'Create the AI agent in Twilio Flex': 'أنشئ الموظف الذكي في Twilio Flex',
    'Our AI integrates directly into your Twilio Flex contact center as a production-ready agent.':
      'يندمج مباشرة في مركز اتصال Twilio Flex عندك، كموظف جاهز للإنتاج من أول دقيقة.',
    'Seamlessly integrate with your existing technology stack, with comprehensive summaries and intelligent routing. Continuously improve with feedback.':
      'يندمج مع أنظمتك الحالية، يكتب ملخصات شاملة، ويوجّه بذكاء. حسّنه بالملاحظات باستمرار.',
    'See how Agent 5 saves you months of development and gives you production-ready AI instantly.':
      'شوف كيف يوفر لك شهور تطوير، ويعطيك AI جاهز للإنتاج من اليوم.',
    'Building Your Own': 'بناء نظامك الخاص',
    'Custom Build on Flex': 'بناء مخصص على Flex',
    'Does Twilio Flex have built-in AI agents?':
      'Twilio Flex فيها موظفين AI مدمجين؟',
    "No. Twilio Flex is a powerful contact center platform but doesn't include native AI agents. You'd need to build and maintain your own AI solution, which requires significant development resources.":
      'لا. Twilio Flex منصة مركز اتصال قوية، بس بدون موظفين AI أصليين. أي أنك تبني الحل بنفسك وتصونه بنفسك—وهذا يتطلب موارد تطوير كبيرة.',
    'How does Agent 5 integrate with Twilio Flex?':
      'كيف يتكامل مع Twilio Flex؟',
    'Agent 5 connects to Twilio Flex via API and works as a virtual agent in your contact center. It handles voice, chat, and messaging channels while integrating with your existing Flex workflows.':
      'يتصل بـ Twilio Flex عبر الـ API ويعمل كموظف افتراضي في مركز الاتصال—يرد على المكالمات، والدردشة، والرسائل، ويلتزم بسير عمل Flex عندك.',
    'Do I need developers to set up Agent 5 with Twilio Flex?':
      'أحتاج مطورين لإعداده مع Twilio Flex؟',
    'No. Unlike building your own AI solution for Flex which requires a development team, Agent 5 is production-ready and can be deployed in under an hour without any coding.':
      'لا. لو بنيته بنفسك على Flex، تحتاج فريق تطوير. نظامنا جاهز للإنتاج، وتشغّله بأقل من ساعة بدون سطر كود.',
    'What channels does Agent 5 support with Twilio Flex?':
      'وش القنوات المدعومة مع Twilio Flex؟',
    'Agent 5 works across all Twilio Flex channels including voice, SMS, WhatsApp, chat, and email. It provides consistent AI support across your entire contact center.':
      'كل قنوات Twilio Flex: المكالمات، SMS، WhatsApp، الدردشة، والإيميل. دعم موحّد على مركز الاتصال كامل.',
    'Can I see Agent 5 performance in Twilio Flex dashboards?':
      'أقدر أشوف أداءه في لوحات Twilio Flex؟',
    'Yes. Agent 5 appears as an agent in your Twilio Flex analytics, allowing you to track performance, monitor conversations, and measure AI effectiveness alongside your human agents.':
      'نعم. يظهر كموظف في تحليلات Twilio Flex عندك—تتبع أداءه، وتراقب محادثاته، وتقيس فعاليته إلى جانب موظفيك.',
    'How is Agent 5 maintained and updated?': 'مين يصونه ويحدّثه؟',
    'Agent 5 is fully managed by us. You get automatic updates, continuous improvements, and the latest AI capabilities without any maintenance work—unlike a custom-built solution that requires ongoing development.':
      'نحن. مدار بالكامل من عندنا: تحديثات تلقائية، وتحسينات مستمرة، وأحدث القدرات—بدون أي أعمال صيانة عليك. بخلاف النظام المبني خصيصاً اللي يتطلب تطويراً مستمراً.',
    "Find answers to common questions about our Twilio Flex AI agent. Can't find what you're looking for? Contact our support team.":
      'أسئلة شائعة عن Open داخل Twilio Flex. ما لقيت ما تبيه؟ كلّمنا.',
    'The super AI communication app': 'تطبيق التواصل الشامل بالـ AI',
    'Modern helpdesk, Agent 5, workflows, observability—all built-in. No integrations, no add-ons, no complexity.':
      'نظام دعم حديث، موظف ذكي، مسارات عمل، ورصد كامل—كلها مدمجة. بدون تكاملات، بدون إضافات، بدون تعقيد.',
    'See comparison': 'شوف المقارنة',
    'Built-in Helpdesk': 'نظام دعم مدمج',
    'Everything you need, built-in': 'كل ما تحتاجه، مدمج',
    'Helpdesk, AI agent, workflows—all in one super app.':
      'نظام دعم، موظف ذكي، ومسارات عمل—في تطبيق واحد.',
    'Complete platform, no integrations': 'منصة كاملة، بدون تكاملات',
    'Built-in helpdesk, Agent 5 AI engine, workflows, and observability. Everything you need in one place.':
      'نظام دعم مدمج، محرك AI، مسارات عمل، ورصد كامل. بلا أدوات متفرقة.',
    'Set up in minutes': 'جهّز في دقائق',
    'No complex integrations, no setup headaches. Just start using it.':
      'بدون تكاملات معقدة، بدون صداع إعداد. ابدأ استخدامه مباشرة.',
    'Scale with confidence': 'توسع بثقة',
    'From startup to enterprise, Open grows with you. All the features you need, no vendor lock-in.':
      'من الشركات الناشئة للمؤسسات الكبرى، Open يكبر معك. كل الميزات اللي تحتاجها، وبدون قفل مع مورد.',
    'Open vs Fragmented Tools': 'Open مقابل أدوات مبعثرة',
    "See how Open's all-in-one platform compares to piecing together multiple tools.":
      'شوف الفرق بين منصة واحدة كاملة، وكومة أدوات تلزقها مع بعض.',
    'Open (All-in-One)': 'Open (الكل في واحد)',
    'Multiple Tools': 'أدوات متعددة',
    'What is Open?': 'وش هو Open؟',
    "Open is the super AI communication app—a complete platform that combines a modern helpdesk, Agent 5 (the world's best AI agent), intelligent workflows, observability tools, and powerful automation in one unified system.":
      'Open تطبيق التواصل الشامل بالـ AI—يجمع نظام دعم حديث، موظف ذكي، مسارات عمل ذكية، أدوات رصد، وأتمتة قوية في نظام واحد.',
    'What makes Open different from other helpdesks?':
      'وش يفرّق Open عن أنظمة الدعم الثانية؟',
    "Open is built AI-first. While other platforms bolt on AI as an afterthought, Open is designed from the ground up with Agent 5 at its core, providing seamless AI-human collaboration that others can't match.":
      'المنصات الثانية لزقت الـ AI فوق نظام قديم. Open مبني من الصفر والـ AI في قلبه—فالتعاون بين الذكاء والبشر يمشي بسلاسة ما يوصلها غيره.',
    'What are workflows in Open?': 'وش هو سير العمل في Open؟',
    'Open workflows include an agentic engine for intelligent routing, outbound sequencing for proactive engagement, customer insights for data-driven decisions, and knowledge gap detection to continuously improve your support quality.':
      'محرك وكيل يوجّه بذكاء، تواصل صادر متسلسل يسبق العميل، رؤى تجعل قراراتك مبنية على أرقام، واكتشاف فجوات معرفة يرفع جودة دعمك أسبوع بعد أسبوع.',
    'Do I need to integrate multiple tools with Open?':
      'لازم أدمج أدوات كثيرة مع Open؟',
    'No. Open is an all-in-one platform. Everything—helpdesk, AI agent, workflows, training, observability, and compliance—is built-in and works together seamlessly. No third-party integrations needed.':
      'لا. كل شيء داخل Open—نظام الدعم، الموظف الذكي، سير العمل، التدريب، الرصد، والامتثال—مدمج ويعمل معاً. ولا تكامل طرف ثالث واحد.',
    'What observability features does Open provide?':
      'وش يعطيني Open من أدوات رصد؟',
    "Open provides full transparency into your AI agent's performance with real-time observability, detailed analytics, conversation insights, and evaluation metrics—so you always know how your AI is behaving.":
      'شفافية كاملة على أداء الموظف الذكي: رصد لحظي، وتحليلات مفصلة، ورؤى من المحادثات، ومقاييس تقييم. تعرف في كل لحظة وش يعمل وليش.',
    'Can I use Open if I already have a helpdesk?':
      'أقدر أستخدم Open وعندي نظام دعم أصلاً؟',
    'Yes. While Open is a complete platform, you can also use Agent 5 with your existing helpdesk (Zendesk, Intercom, Salesforce, etc.). But experiencing everything together in Open gives you the best results.':
      'نعم. Open منصة كاملة، ومع ذلك تشغّل الموظف الذكي فوق نظام الدعم الحالي عندك (Zendesk، Intercom، Salesforce، وغيرها). بس لمّا تجرب كل شيء معاً داخل Open، تشوف الفرق.',
    "Find answers to common questions about Open. Can't find what you're looking for? Contact our support team.":
      'أسئلة شائعة عن Open. ما لقيت ما تبيه؟ كلّمنا.',
    'Pricing Model': 'نموذج التسعير',
    'Suite Requirement': 'متطلبات الحزمة',
    'AI Access': 'الوصول للـ AI',
    'Feature Limitations': 'حدود الميزات',
    'Total Cost': 'التكلفة الإجمالية',
    '$0.99/resolution': '٠,٩٩ دولار لكل حل',
    'Locked in tiers': 'مقفل في الباقات',
    Standalone: 'مستقل',
    'Full HubSpot suite': 'حزمة HubSpot الكاملة',
    Immediate: 'فوري',
    'Premium tiers only': 'بس الباقات المميزة',
    'Complex config': 'إعدادات معقدة',
    'ChatSpot AI': 'ChatSpot AI',
    'No limitations': 'لا توجد قيود',
    'Tier-based limits': 'حدود حسب الباقة',
    'Basic automation': 'أتمتة أساسية',
    'Pay per use': 'الدفع حسب الاستخدام',
    'High monthly fees': 'رسوم شهرية عالية',
    Pricing: 'التسعير',
    'Supported Helpdesks': 'أنظمة الدعم المدعومة',
    'AI Availability': 'توفر AI',
    'Value for Money': 'القيمة مقابل السعر',
    'Per outcome only': 'بس لكل نتيجة',
    'Per seat + per outcome': 'لكل مقعد + لكل نتيجة',
    'Zendesk, Salesforce, Intercom, HubSpot, Freshdesk, Twilio Flex +more':
      'Zendesk، Salesforce، Intercom، HubSpot، Freshdesk، Twilio Flex وأكثر',
    'Intercom only': 'بس Intercom',
    'Intercom + Zendesk': 'Intercom + Zendesk',
    'Day one': 'من اليوم الأول',
    'After months': 'بعد أشهر',
    'Fin AI': 'Fin AI',
    'Gradual rollout': 'إطلاق تدريجي',
    'All features day 1': 'كل الميزات في اليوم الأول',
    'Gradual unlock': 'فتح تدريجي',
    'Limited control': 'تحكم محدود',
    'Best ROI': 'أفضل عائد على الاستثمار',
    'Higher total cost': 'تكلفة إجمالية أعلى',
    'Avg Automation Rate': 'معدل الأتمتة',
    '77% (complex B2B)': '٧٧٪ (دعم B2B معقّد)',
    '~50-67%': '~٥٠-٦٧٪',
    'Multi-modal AI': 'ذكاء متعدد الوسائط',
    'Voice, Vision, Text, Files': 'صوت، رؤية، نص، ملفات',
    'Text only (rest gated)': 'بس نص (الباقي مقفل)',
    'Agentic Workflows': 'مسارات عمل ذكية',
    '15 triggers, 25+ actions': '١٥ محفز، +٢٥ إجراء',
    'Not available': 'مو متوفر',
    'AI Quality Assurance': 'ضمان جودة AI',
    'Built-in auto QA': 'فحص جودة تلقائي مدمج',
    'Manual review only': 'بس مراجعة يدوية',
    'Outbound Sequencing': 'التسلسلات الصادرة',
    'AI Outbound Sequencing': 'تواصل صادر بالـ AI',
    'WhatsApp, Phone, SMS, Email': 'WhatsApp، هاتف، رسائل، بريد',
    Limited: 'محدود',
    'Knowledge Gap Detection': 'اكتشاف فجوات المعرفة',
    'Auto-detect & suggest': 'اكتشاف واقتراح تلقائي',
    'Setup Complexity': 'تعقيد الإعداد',
    'Customization Required': 'التخصيص المطلوب',
    Cost: 'التكلفة',
    'Ease of Use': 'سهولة الاستخدام',
    'Time to Value': 'وقت أول نتيجة',
    Flexibility: 'المرونة',
    'Weeks of setup': 'أسابيع من الإعداد',
    'Zero config': 'بدون إعدادات',
    'Extensive setup': 'إعداد مكثف',
    'High licensing fees': 'رسوم ترخيص عالية',
    'Einstein AI': 'Einstein AI',
    'Simple & intuitive': 'بسيط وبديهي',
    'Complex UI': 'واجهة معقدة',
    Months: 'أشهر',
    'Requires consultants': 'يتطلب مستشارين',
    'Full control': 'تحكم كامل',
    'Rigid workflows': 'مسارات عمل جامدة',
    'AI Sophistication': 'مستوى AI',
    'Complex Query Handling': 'التعامل مع الاستفسارات المعقدة',
    'Context Understanding': 'فهم السياق',
    'Answer Quality': 'جودة الإجابة',
    'Multi-language Support': 'دعم متعدد اللغات',
    'Integration Depth': 'عمق التكامل',
    'Advanced multi-model': 'متعدد النماذج متقدم',
    'Basic Freddy AI': 'Freddy AI أساسي',
    Excellent: 'ممتاز',
    'Hours of training': 'ساعات من التدريب',
    'Deep context': 'سياق عميق',
    'Simple patterns': 'أنماط بسيطة',
    'Continuous learning': 'تعلم مستمر',
    'Manual training': 'تدريب يدوي',
    'Nuanced & accurate': 'دقيق ومفصل',
    'Template-based': 'قائم على القوالب',
    'Native support': 'تكامل مباشر',
    'Full API access': 'وصول كامل للـ API',
    'Basic integration': 'تكامل أساسي',
    'Built-in AI Agent': 'موظف ذكي مدمج',
    'AI Capabilities': 'قدرات AI',
    'Developer Required': 'الحاجة لمطور',
    'Time to Deploy': 'وقت التشغيل',
    Maintenance: 'الصيانة',
    'Ready to Use': 'جاهز للاستخدام',
    'Yes - Full featured': 'نعم - كامل الميزات',
    'No native AI': 'لا يوجد AI مدمج',
    'Build from scratch': 'بناء من الصفر',
    'Requires custom build': 'يلزمه بناء مخصص',
    No: 'لا',
    Yes: 'نعم',
    'Same day': 'في نفس اليوم',
    'Weeks/months': 'أسابيع/أشهر',
    'Fully managed': 'مدار بالكامل',
    'Self-maintained': 'صيانته عليك',
    'DIY implementation': 'تنفيذ ذاتي',
    'Out of the box': 'جاهز فوراً',
    'Custom development': 'تطوير مخصص',
    'Helpdesk Included': 'نظام الدعم متضمن',
    'AI Agent': 'موظف ذكي',
    Workflows: 'سير العمل',
    'All-in-One': 'الكل في واحد',
    'Integration Needed': 'التكامل مطلوب',
    'Built-in': 'مدمج',
    'Separate purchase': 'شراء منفصل',
    'Agent 5 (best in class)': 'الموظف الذكي (الأفضل في فئته)',
    'Limited or none': 'محدود أو معدوم',
    'Native automation': 'أتمتة مدمجة',
    'Third-party tools': 'أدوات طرف ثالث',
    'Complete platform': 'منصة كاملة',
    'Multiple tools': 'أدوات متعددة',
    'Days/weeks': 'أيام/أسابيع',
    'Limited insights': 'رؤى محدودة',
    'Manual or none': 'يدوي أو معدوم',
    None: 'لا يوجد',
    'Multiple integrations': 'تكاملات متعددة',
    'Feature Access': 'الوصول للميزات',
    'AI Training': 'تدريب AI',
    'communication app': 'تطبيق التواصل',
    'What is Agent 5?': 'وش هو الموظف الذكي في Open؟',
    "Agent 5 is the core AI engine powering Open. It's a multi-model AI agent with advanced training, observability, compliance features, and continuous learning capabilities—designed to handle complex customer conversations with human-level understanding.":
      'هو محرك الـ AI اللي يشغّل Open. متعدد النماذج، مع تدريب متقدم، رصد كامل، ميزات امتثال، وتعلّم مستمر—مصمم للتعامل مع محادثات العملاء المعقدة بفهم بمستوى بشري.',
    'What channels does Open support?': 'وش القنوات اللي يدعمها Open؟',
    'Open supports all communication channels: Voice AI, web chat, email, WhatsApp, social media, SMS, and Slack. Your customers can reach you anywhere, and Agent 5 responds consistently across all channels.':
      'كلها: الذكاء الصوتي، دردشة الويب، الإيميل، WhatsApp، السوشيال، الرسائل، وSlack. عميلك يصل إليك من أي قناة يختارها، والرد بنفس الجودة على كل قناة.',
    'Simple setup, powerful results. Your AI agent works alongside your team in Intercom.':
      'إعداد بسيط، ونتائج قوية. الموظف الذكي يعمل إلى جانب فريقك داخل Intercom.',
    'Simple setup, powerful AI. No suite required, no tier limits.':
      'إعداد بسيط، وAI قوي. ما يلزم حزمة، ولا حدود للباقات.',
    'Simple setup, powerful AI. No complex training required.':
      'إعداد بسيط، وAI قوي. ما يحتاج تدريب معقد.',
    'Simple setup, powerful results. No consultants, no complex workflows, no endless customization.':
      'إعداد بسيط، ونتائج قوية. بدون مستشارين، بدون سير عمل معقد، بدون تخصيص ما يخلص.',
    'No developers, no custom code, no months of building. Just AI that works.':
      'بدون مطورين، بدون كود مخصص، بدون شهور بناء. AI يعمل فحسب.',
    'The AI agent': 'الموظف الذكي اللي',
    "doesn't have": 'ما عنده',
  },
  industry: {
    'AI customer support for': 'دعم عملاء بالـ AI',
    'What Matters in': 'وش يهم في قطاع',
    'Why companies choose Agent 5': 'ليش الشركات تختار النظام',
    'Trusted by': 'تثق فيه',
    'leading brands.': 'أبرز العلامات التجارية.',
    'tech platforms.': 'أبرز منصات التقنية.',
    'Questions from compliance teams': 'أسئلة من فرق الامتثال',
    'Questions from product teams': 'أسئلة من فرق المنتج',
    'Questions from operators': 'أسئلة من المشغلين',
    'Traditional Solutions': 'الحلول التقليدية',
    'Traditional Support': 'الدعم التقليدي',
    'Agent 5': 'النظام',
    'Accuracy Rate': 'معدل الدقة',
    'for financial institutions': 'للمؤسسات المالية',
    'Your customers trust you with their money. They deserve accurate, secure support. Agent 5 handles sensitive inquiries with the compliance and accuracy financial services demand—without the risk of traditional automation.':
      'عميلك سلّمك أمواله، ويستحق دعماً بنفس مستوى الثقة: دقيق وآمن. النظام يتعامل مع الاستفسارات الحساسة بما تفرضه الخدمات المالية من دقة وامتثال، بدون مخاطر الأتمتة التقليدية.',
    'See how it works for finance': 'شوف كيف يعمل للقطاع المالي',
    'Support your customers better, stay compliant':
      'ادعم عملاءك أحسن، وما تفرّط في الامتثال',
    'Handle the support issues that matter most—with the security financial services require.':
      'عالج أهم مشاكل الدعم، بالأمان اللي تفرضه الخدمات المالية.',
    'Account inquiries and balance checks': 'استفسارات الحساب وفحص الرصيد',
    'Customers ask about balances, recent transactions, and account status. Agent 5 verifies identity, retrieves information securely, and responds instantly—24/7.':
      'كم رصيدي؟ ما هذه العملية؟ حسابي مفعّل؟ النظام يتحقق من الهوية، ويجلب المعلومة بأمان، ويرد فوراً — ٢٤/٧.',
    'Card replacements and fraud reports': 'استبدال البطاقات وتقارير الاحتيال',
    'Lost cards, suspicious charges, unauthorized transactions—Agent 5 handles reports, blocks cards, and initiates replacements while following your exact security protocols.':
      'بطاقة مفقودة، رسم مشبوه، عملية ما صدرت من العميل. النظام يستلم البلاغ، ويوقف البطاقة، ويبدأ الاستبدال — كله وفق بروتوكولات الأمان عندك.',
    'Payment and transfer questions': 'أسئلة الدفع والتحويل',
    'Why was I charged? When will my transfer complete? Agent 5 explains fees, timelines, and payment status clearly—reducing confusion and calls to your team.':
      'ليش خُصم هذا المبلغ؟ متى يصل التحويل؟ النظام يشرح الرسوم والمدد وحالة الدفع بوضوح — ارتباك أقل، ومكالمات أقل على فريقك.',
    'Login help and account access': 'مساعدة الدخول والوصول للحساب',
    'Forgot password? Locked out? Need to update contact info? Agent 5 guides customers through authentication, resets, and access issues—without compromising security.':
      'نسيت كلمة المرور؟ الحساب مقفل؟ تريد تحديث بيانات التواصل؟ النظام يرشد العميل خطوة بخطوة في التحقق وإعادة التعيين وفتح الوصول — بدون أي تهاون في الأمان.',
    'Product recommendations that make sense': 'توصيات منتجات تنفع فعلاً',
    'Which savings account? Should I upgrade my card? Agent 5 helps customers understand their options based on their needs—personalized guidance, not pushy sales.':
      'أي حساب توفير يناسبني؟ هل أرقّي بطاقتي؟ النظام يشرح الخيارات بناءً على وضع العميل نفسه — إرشاد، لا بيع بالضغط.',
    'Transaction disputes and chargebacks': 'نزاعات المعاملات والاستردادات',
    'Customers report disputed charges, request refunds, or ask about chargeback status. Agent 5 collects details, initiates investigations, and keeps customers informed throughout.':
      'رسم متنازع عليه، طلب استرداد، سؤال عن حالة المطالبة. النظام يجمع التفاصيل، يفتح التحقيق، ويخلّي العميل على اطلاع من أول خطوة لآخرها.',
    'Compliance built-in, not bolted on':
      'امتثال مدمج بالتصميم، لا إضافة لاحقة',
    "Agent 5 won't share sensitive data inappropriately, give financial advice, or violate regulations. It verifies identity, logs every action, and escalates when needed. Your compliance team controls everything.":
      'لا يشارك النظام بيانات حساسة في غير موضعها، ولا يقدّم نصائح مالية، ولا يخالف الأنظمة. يتحقق من الهوية، ويسجّل كل إجراء، ويصعّد عند الحاجة. والتحكم الكامل بيد فريق الامتثال عندكم.',
    'Verified financial inquiries': 'استفسارات مالية موثقة',
    'Every action logged': 'كل إجراء مسجّل',
    'Digital bank handles 50K daily inquiries':
      'بنك رقمي يتعامل مع ٥٠ ألف استفسار يومياً',
    'Account lookups, card replacements, and payment questions automated with 92% resolution rate.':
      'الاستعلام عن الحسابات، استبدال البطاقات، أسئلة الدفع — مؤتمتة بمعدل حل ٩٢٪.',
    'Credit union reduces wait times by 80%':
      'اتحاد ائتماني يقلل أوقات الانتظار بنسبة ٨٠٪',
    'Members get instant answers for balance inquiries, loan status, and transaction history—24/7.':
      'الأعضاء يلقون جواب فوري عن الرصيد وحالة القرض وسجل المعاملات — ٢٤/٧.',
    'Fintech scales support without headcount':
      'شركة تقنية مالية توسع الدعم بلا زيادة عدد الموظفين',
    'Handles authentication, payment disputes, and account access for 2M+ users with consistent quality.':
      'مصادقة، نزاعات دفع، وصول للحساب — لأكثر من ٢ مليون مستخدم، وبجودة ثابتة.',
    'Investment platform improves CSAT to 94%':
      'منصة استثمار تحسن معدل رضا العملاء إلى ٩٤٪',
    'Customers get immediate help with transfers, withdrawals, and portfolio questions—verified and secure.':
      'مساعدة فورية في التحويلات والسحوبات وأسئلة المحفظة — موثّقة وآمنة.',
    'Payment processor cuts fraud inquiries 65%':
      'معالج مدفوعات يقلل استفسارات الاحتيال بنسبة ٦٥٪',
    'Proactive fraud alerts, instant card blocks, and clear explanations reduce customer anxiety and calls.':
      'تنبيهات احتيال استباقية، حظر فوري للبطاقة، وشرح واضح — قلق أقل عند العميل، ومكالمات أقل عندك.',
    'Why financial institutions choose Agent 5':
      'ليش المؤسسات المالية تختار النظام',
    "Built specifically for regulated industries where accuracy and compliance aren't optional.":
      'مبني خصيصاً لقطاعات منظّمة، الدقة والامتثال فيها ليسا خياراً.',
    'What Matters in Finance': 'وش يهم في القطاع المالي',
    'Data Security': 'أمن البيانات',
    'PII Handling': 'التعامل مع بيانات الهوية',
    'Response Accuracy': 'دقة الاستجابة',
    'Fraud Prevention': 'منع الاحتيال',
    'Audit Trail': 'سجل التدقيق',
    'Handoff to Human': 'التحويل لموظف بشري',
    'Cost per Interaction': 'التكلفة لكل تفاعل',
    'SOC 2, encryption at rest & transit':
      'حاصل على شهادة SOC 2، مع تشفير البيانات أثناء التخزين والنقل',
    'Varies by vendor': 'يختلف حسب المزود',
    'GDPR, SOC 2, audit logs':
      'متوافق مع GDPR، حاصل على شهادة SOC 2، سجلات التدقيق',
    'Basic compliance': 'امتثال أساسي',
    'Automatic redaction': 'تنقيح تلقائي',
    'Manual processes': 'عمليات يدوية',
    '95%+ verified responses': 'استجابات موثقة بعتبات ثقة',
    '60-70% accuracy': '٦٠-٧٠٪ دقة',
    'Real-time verification': 'تحقق لحظي',
    'Limited checks': 'عمليات فحص محدودة',
    'Complete conversation logs': 'سجلات محادثة كاملة',
    'Partial logging': 'تسجيل جزئي',
    'Seamless with context': 'سلس، والسياق كامل',
    'Customer restarts': 'العميل يعيد شرح مشكلته',
    '$0.75-$0.90 per resolution': '٢-٣ ⃁ لكل حل',
    '$5-15 per ticket': '١٩-٥٦ ⃁ لكل تذكرة',
    'Questions we hear from compliance teams': 'أسئلة نسمعها من فرق الامتثال',
    'Direct answers to the concerns that matter most in financial services.':
      'إجابات مباشرة عن أكثر ما يقلق فرق الامتثال في الخدمات المالية.',
    'How do you handle PII and sensitive financial data?':
      'كيف تتعاملون مع بيانات الهوية والبيانات المالية الحساسة؟',
    'All data is encrypted at rest (AES-256) and in transit (TLS 1.3). PII is automatically detected and can be redacted or masked. We maintain complete audit logs. Your data stays in your chosen region (US or EU). We never use customer data to train our models.':
      'جميع البيانات مشفّرة أثناء التخزين (AES-256) وأثناء النقل (TLS 1.3). ويُكشف عن بيانات الهوية تلقائياً، مع إمكانية تنقيحها أو حجبها. نحتفظ بسجلات تدقيق كاملة، وتبقى بياناتكم في المنطقة اللي تختارونها (الولايات المتحدة أو الاتحاد الأوروبي). ولا نستخدم بيانات العملاء لتدريب نماذجنا إطلاقاً.',
    'What compliance certifications do you have?':
      'وش شهادات الامتثال اللي تحملونها؟',
    'SOC 2 Type II, GDPR compliant, working toward ISO 27001. We maintain detailed documentation for your auditors and can provide DPA agreements. EU data residency available (Frankfurt servers).':
      'حاصلون على شهادتي SOC 2 Type II وISO 27001، ومتوافقون مع GDPR. نحتفظ بوثائق مفصّلة لمدققيكم، ونوفّر اتفاقيات معالجة البيانات (DPA). وخيار الاحتفاظ بالبيانات داخل الاتحاد الأوروبي متاح (خوادم فرانكفورت).',
    'Will the AI give financial advice or make unauthorized transactions?':
      'هل يقدّم الـ AI نصائح مالية أو ينفّذ معاملات غير مصرّح بها؟',
    'No. Agent 5 is configured with strict guardrails. It cannot provide investment advice, approve transactions, or make decisions requiring human judgment. It handles information requests, account inquiries, and support issues—then escalates appropriately.':
      'لا. النظام مقيّد بحواجز حماية صارمة: لا يقدّم مشورة استثمارية، ولا يعتمد معاملات، ولا يتخذ قراراً يتطلب حكماً بشرياً. يتولّى طلبات المعلومات واستفسارات الحساب ومشكلات الدعم، ثم يصعّد ما عدا ذلك للجهة المناسبة.',
    'How do you prevent fraud and account takeovers?':
      'كيف تمنعون الاحتيال والاستيلاء على الحسابات؟',
    'Agent 5 verifies customer identity before sharing sensitive information, integrates with your existing authentication systems, and flags suspicious patterns. When in doubt, it escalates to a human agent with full context.':
      'يتحقق النظام من هوية العميل قبل مشاركة أي معلومة حساسة، ويتكامل مع أنظمة المصادقة القائمة عندكم، ويرصد الأنماط المشبوهة. وعند أي شك، يصعّد لموظف بشري بسياق كامل.',
    'Can we review and approve responses before they go out?':
      'هل نقدر نراجع الردود ونعتمدها قبل إرسالها؟',
    'Yes. You can configure Agent 5 to operate in supervised mode where responses require human approval, or set confidence thresholds for automatic vs. reviewed responses. Full customization based on your risk tolerance.':
      'نعم. تقدرون تشغّلون النظام في وضع مراقَب تتطلب فيه الردود موافقة بشرية، أو تحددون حدود ثقة تفصل بين الردود التلقائية والردود الخاضعة للمراجعة. تخصيص كامل بحسب قدرتكم على تحمّل المخاطر.',
    'What happens if the AI makes a mistake?': 'وماذا يحدث إذا أخطأ الـ AI؟',
    'Every interaction is logged and reviewable. Mistakes are flagged in our QA system, and we provide correction tools. You have full visibility into what happened and can implement immediate corrections. We also offer error insurance for enterprise customers.':
      'كل تفاعل مسجّل وقابل للمراجعة. تُرصد الأخطاء في نظام ضمان الجودة عندنا، ونوفّر أدوات لتصحيحها. عندكم رؤية كاملة لما حدث، وقدرة على التصحيح الفوري. ونقدّم كذلك تأميناً ضد الأخطاء لعملاء المؤسسات.',
    'How long does implementation take?': 'كم يستغرق التنفيذ؟',
    'Most financial institutions are live within 2 weeks. That includes compliance review, knowledge base setup, team training, and phased rollout. We work with your timeline and security requirements.':
      'تنطلق أغلب المؤسسات المالية خلال أسبوعين، وتشمل هذه المدة مراجعة الامتثال، وإعداد قاعدة المعرفة، وتدريب الفريق، والنشر التدريجي. ونعمل وفق جدولكم الزمني ومتطلبات الأمان عندكم.',
    'Do you support multiple languages and regions?':
      'هل تدعمون لغات ومناطق متعددة؟',
    'Yes. Agent 5 handles 100+ languages with the same accuracy and compliance standards. Regional data residency options available for EU, US, and other jurisdictions. Localized compliance rules per region.':
      'نعم. يتعامل النظام مع أكثر من ١٠٠ لغة بنفس معايير الدقة والامتثال. وتتوفّر خيارات للاحتفاظ بالبيانات في مناطق محددة تشمل الاتحاد الأوروبي والولايات المتحدة وغيرها، مع قواعد امتثال محلية لكل منطقة.',
    'for healthcare organizations': 'لمؤسسات الرعاية الصحية',
    "Care that doesn't clock out": 'رعاية ما تنتهي بنهاية الدوام',
    'Give your patients 24/7 answers about appointments, insurance, and prescriptions—securely. Agent 5 handles the admin work so your team can focus on care.':
      'موعد يتغيّر بعد منتصف الليل، سؤال عن تغطية تأمين، وصفة تحتاج تجديداً. النظام يجيب مرضاك ٢٤/٧ وبأمان، ويرفع عن فريقك العبء الإداري عشان يتفرّغ للرعاية.',
    'See how it works for healthcare': 'شوف كيف يعمل للرعاية الصحية',
    'Support patients better, protect their privacy':
      'ادعم مرضاك أحسن، واحفظ خصوصيتهم',
    'Handle the support issues that matter most in healthcare—securely and compliantly.':
      'عالج أهم مشاكل الدعم في الرعاية الصحية — بأمان وامتثال.',
    'Appointment scheduling and changes': 'جدولة المواعيد وتغييرها',
    'Patients book appointments, request reschedules, and get reminders—instantly, any time. Integrates with your scheduling system. No more phone tag.':
      'المريض يحجز، يعدّل، ويستلم تذكيره — فوراً وبأي وقت. النظام يتكامل مع نظام الجدولة عندك. لا مزيد من ملاحقة المكالمات.',
    'Insurance eligibility and coverage questions':
      'استفسارات أهلية التأمين والتغطية',
    "Is this procedure covered? What's my copay? Which providers accept my insurance? Agent 5 verifies coverage in real-time so patients know before they book.":
      'هل هذا الإجراء مغطّى؟ كم نصيبي من التكلفة؟ من يقبل تأميني؟ النظام يتحقق من التغطية لحظياً، والمريض يعرف قبل ما يحجز.',
    'Prescription refills and medication questions':
      'إعادة صرف الوصفات الطبية وأسئلة الأدوية',
    'Patients request refills, check prescription status, and ask about side effects or dosage. Agent 5 processes requests, tracks status, and escalates medical questions appropriately.':
      'طلب تجديد وصفة، سؤال عن حالتها، استفسار عن الجرعة أو أثر جانبي. النظام يعالج الطلب، يتابع حالته، ويصعّد كل سؤال طبي لمن يخصّه.',
    'Billing inquiries and payment questions':
      'استفسارات الفواتير وأسئلة الدفع',
    'What does my insurance cover? Why was I charged this? When is payment due? Agent 5 explains bills clearly, processes payments, and sets up payment plans—reducing billing confusion.':
      'وش يغطيه تأميني؟ ليش هذا المبلغ عليّ؟ متى آخر موعد للسداد؟ النظام يشرح الفاتورة بنداً بنداً، ويعالج الدفع، ويرتّب خطة تقسيط — فواتير أوضح، ومكالمات أقل.',
    'Test results and follow-up care': 'نتائج الفحوصات ورعاية المتابعة',
    'Are my results ready? What happens next? Agent 5 notifies patients when results are available, explains next steps, and schedules follow-ups—keeping care moving forward.':
      'هل صدرت نتائجي؟ ما الخطوة التالية؟ النظام ينبّه المريض فور جهوز النتيجة، ويشرح ما بعدها، ويحجز المتابعة — الرعاية لا تتوقف عند الانتظار.',
    'Provider directory and referrals': 'دليل مقدمي الخدمة والإحالات',
    'Help patients find specialists, check provider availability, and understand referral requirements. Agent 5 guides them to the right care, faster.':
      'ساعد مرضاك يلقون الأخصائي، يشوفون مواعيده، ويفهمون متطلبات الإحالة. النظام يوصّلهم للرعاية الصح أسرع.',
    'Privacy and security by design': 'خصوصية وأمان من التصميم',
    "All patient data encrypted. Automatic PHI detection. Complete audit trails. We're building toward HIPAA compliance—your security requirements guide our roadmap.":
      'كل بيانات المرضى مشفّرة. اكتشاف تلقائي للمعلومات الصحية المحمية (PHI). سجلات تدقيق كاملة. نعمل على التوافق مع HIPAA، ومتطلبات الأمان لديكم هي ما يوجّه خارطة طريقنا.',
    'Patient Support': 'دعم المرضى',
    "When care can't wait": 'لمّا ما تحتمل الرعاية الانتظار',
    'Regional hospital reduces call volume 70%':
      'مستشفى إقليمي يقلل حجم المكالمات بنسبة ٧٠٪',
    'Appointment scheduling, insurance verification, and billing questions automated while maintaining personal touch.':
      'جدولة المواعيد، التحقق من التأمين، أسئلة الفواتير — مؤتمتة، واللمسة الإنسانية باقية.',
    'Telehealth platform scales to 500K patients':
      'منصة صحة عن بعد تتوسع لتشمل ٥٠٠ ألف مريض',
    'Prescription refills, appointment reminders, and follow-up scheduling handled instantly across time zones.':
      'تجديد الوصفات، تذكيرات المواعيد، وجدولة المتابعة — فوراً وعبر كل المناطق الزمنية.',
    'Medical group improves patient satisfaction to 91%':
      'مجموعة طبية تحسن معدل رضا المرضى إلى ٩١٪',
    'After-hours support, test result notifications, and care coordination—patients get help when they need it.':
      'دعم بعد الدوام، إشعارات نتائج الفحوصات، تنسيق الرعاية — المريض يلقى المساعدة وقت ما يحتاجها.',
    'Insurance provider handles 40K inquiries daily':
      'مزود تأمين يتعامل مع ٤٠ ألف استفسار يومياً',
    'Eligibility checks, claims status, and coverage questions answered instantly with 94% accuracy.':
      'التحقق من الأهلية، حالة المطالبة، أسئلة التغطية — جواب فوري بدقة ٩٤٪.',
    'Why healthcare providers choose Agent 5':
      'ليش مقدّمو الرعاية الصحية يختارون النظام',
    "Purpose-built for healthcare's unique combination of urgency, privacy, and complexity.":
      'مبني خصيصاً لقطاع يجتمع فيه الاستعجال والخصوصية والتعقيد في وقت واحد.',
    'What Matters in Healthcare': 'وش يهم في قطاع الرعاية الصحية',
    'Patient Privacy': 'خصوصية المرضى',
    'Appointment Scheduling': 'جدولة المواعيد',
    'Insurance Verification': 'التحقق من التأمين',
    'After-Hours Support': 'دعم بعد الدوام',
    'Prescription Refills': 'إعادة صرف الوصفات',
    'Language Support': 'دعم اللغات',
    'Response Time': 'وقت الاستجابة',
    'Encrypted, PII redaction': 'مشفّرة، مع تنقيح بيانات الهوية',
    'Basic encryption': 'تشفير أساسي',
    'Instant booking & changes': 'حجز وتغيير فوري',
    'Phone-only, long waits': 'بس عبر الهاتف، انتظار طويل',
    'Real-time eligibility checks': 'تحقق لحظي من الأهلية',
    'Manual lookups': 'بحث يدوي',
    '24/7 availability': 'متاح ٢٤/٧',
    'Voicemail or emergencies only': 'بس بريد صوتي أو حالات طوارئ',
    'Automated requests & tracking': 'طلب وتتبّع مؤتمت',
    'Phone tag with pharmacy': 'ملاحقة مكالمات مع الصيدلية',
    '100+ languages instantly': 'أكثر من ١٠٠ لغة فوراً',
    'Limited translator access': 'وصول محدود للمترجمين',
    'Under 10 seconds': 'أقل من ١٠ ثوانٍ',
    '15-30 minute holds': 'انتظار ١٥-٣٠ دقيقة',
    '$8-20 per call': '٨-٢٠ دولاراً لكل مكالمة',
    'Questions from healthcare compliance teams':
      'أسئلة من فرق امتثال الرعاية الصحية',
    'Honest answers about where we are with healthcare compliance.':
      'إجابات صادقة عن موقعنا الحالي من امتثال الرعاية الصحية.',
    'Are you HIPAA compliant?': 'هل أنتم متوافقون مع HIPAA؟',
    "We're building toward HIPAA compliance. Our infrastructure includes encryption at rest and in transit, automatic PHI detection, complete audit logs, and BAA-ready contracts. We work with healthcare organizations to meet their specific security requirements. Full HIPAA certification is on our roadmap for 2025.":
      'نعمل على تحقيق التوافق مع HIPAA. تشمل بنيتنا التحتية التشفير أثناء التخزين والنقل، والاكتشاف التلقائي للمعلومات الصحية المحمية (PHI)، وسجلات تدقيق كاملة، وعقوداً جاهزة لـ BAA. ونعمل مع مؤسسات الرعاية الصحية على تلبية متطلبات الأمان الخاصة بكل منها. وشهادة HIPAA الكاملة مدرجة على خارطة طريقنا لعام ٢٠٢٥.',
    'How do you handle PHI (Protected Health Information)?':
      'كيف تتعاملون مع المعلومات الصحية المحمية (PHI)؟',
    'All PHI is encrypted (AES-256 at rest, TLS 1.3 in transit). Agent 5 automatically detects and can redact or mask sensitive health information. Complete audit trails track who accessed what and when. Your data is isolated and never used to train our models.':
      'جميع المعلومات الصحية المحمية مشفّرة (AES-256 أثناء التخزين، وTLS 1.3 أثناء النقل). ويكشف النظام المعلومات الصحية الحساسة تلقائياً، مع إمكانية تنقيحها أو حجبها. وتوثّق سجلات التدقيق الكاملة مين وصل إلى وش ومتى. بياناتكم معزولة، ولا تُستخدم لتدريب نماذجنا إطلاقاً.',
    'Will the AI give medical advice or diagnoses?':
      'هل يقدّم الـ AI نصائح طبية أو تشخيصات؟',
    'No. Agent 5 handles administrative tasks—scheduling, insurance, billing, refills. It does not diagnose, recommend treatments, or provide medical advice. Medical questions are immediately escalated to your clinical staff with full context.':
      'لا. يتولّى النظام المهام الإدارية: الجدولة، والتأمين، والفواتير، وتجديد الوصفات. لا يشخّص، ولا يوصي بعلاج، ولا يقدّم نصيحة طبية. ويصعّد الأسئلة الطبية فوراً لطاقمكم السريري بسياق كامل.',
    'Can you integrate with our EHR/PMS system?':
      'هل تتكاملون مع نظام EHR/PMS عندنا؟',
    'Yes. We integrate with major systems including Epic, Cerner, Athenahealth, and others through secure APIs. Agent 5 can read appointment slots, verify insurance, and update records based on your permissions and workflows.':
      'نعم. نتكامل مع الأنظمة الكبرى: Epic وCerner وAthenahealth وغيرها، عبر واجهات آمنة. ويقدر النظام يقرأ المواعيد المتاحة، ويتحقق من التأمين، ويحدّث السجلات وفق الصلاحيات وسير العمل اللي تحدّدونه.',
    'What about emergency situations?': 'وماذا عن حالات الطوارئ؟',
    'Agent 5 is configured to recognize urgent keywords (chest pain, difficulty breathing, etc.) and immediately provides emergency contact information while alerting your on-call team. It never delays urgent care.':
      'النظام مضبوط على التعرّف الفوري على الكلمات العاجلة (ألم في الصدر، صعوبة في التنفس، وغيرها)، فيقدّم معلومات الاتصال بالطوارئ مباشرة، وينبّه فريقكم المناوب. ولا يؤخّر الرعاية العاجلة بأي حال.',
    'How long does setup take for a healthcare organization?':
      'كم يستغرق الإعداد لمؤسسة رعاية صحية؟',
    'Most healthcare providers are live within 3-4 weeks. This includes security review, EHR integration, knowledge base setup, clinical team training, and phased rollout. We work with your IT and compliance requirements.':
      'تنطلق أغلب مؤسسات الرعاية الصحية خلال ٣-٤ أسابيع، وتشمل هذه المدة المراجعة الأمنية، والتكامل مع نظام EHR، وإعداد قاعدة المعرفة، وتدريب الفريق السريري، والنشر التدريجي. ونعمل وفق متطلبات تقنية المعلومات والامتثال عندكم.',
    'Can patients opt out of AI support?':
      'هل يقدر المريض يستغني عن الدعم بالـ AI؟',
    'Yes, always. Patients can request a human agent at any time. The handoff is seamless—your team gets full conversation context. We believe AI should help, not force itself on patients who prefer human interaction.':
      'نعم، في أي وقت. يقدر المريض يطلب موظف بشري متى شاء، والتحويل سلس: يستلم فريقكم سياق المحادثة كاملاً. نرى أن الـ AI وُجد عشان يساعد، لا عشان يُفرض على من يفضّل التعامل مع إنسان.',
    'What languages do you support for diverse patient populations?':
      'وش اللغات اللي تدعمونها لمجموعات المرضى المتنوعة؟',
    'Agent 5 supports 100+ languages with automatic detection. Automatic language detection means patients can communicate in their preferred language without requesting a translator or waiting.':
      'يدعم النظام أكثر من ١٠٠ لغة مع كشف تلقائي للغة. والكشف التلقائي يعني أن المريض يتواصل بلغته المفضّلة بلا طلب مترجم ولا انتظار.',
    'for mobility platforms': 'لمنصات التنقل',
    'Your riders and drivers need help now—not in 15 minutes. Agent 5 handles trip issues, refunds, and account questions instantly while you scale. Built for platforms that move millions of people daily.':
      'الراكب واقف على الرصيف، والسواق واقف بسيارته — ولا واحد فيهم يقدر ينتظر ١٥ دقيقة. النظام يحل مشاكل الرحلات والاستردادات وأسئلة الحساب فوراً. مبني لمنصات تنقّل ملايين كل يوم.',
    'See how it works for mobility': 'شوف كيف يعمل للتنقل',
    'Support riders and drivers at scale':
      'ادعم الركاب والسواقين مهما كبر العدد',
    'Handle the support issues that matter when people are on the move.':
      'عالج المشاكل اللي تصير والناس على الطريق.',
    'Trip issues and ride disputes': 'مشاكل الرحلات والنزاعات',
    "Wrong pickup location? Unexpected charges? Driver didn't show? Agent 5 handles complaints, processes refunds, and resolves disputes in real-time—while riders are still in the app.":
      'نقطة استلام غلط؟ رسوم زايدة؟ السواق ما وصل؟ النظام يستلم الشكوى، يعالج الاسترداد، ويقفل النزاع لحظياً — والراكب ما طلع من التطبيق أصلاً.',
    'Driver support and earnings questions': 'دعم السواقين وأسئلة الأرباح',
    'Drivers ask about earnings, missing trips, account access, and app issues. Agent 5 answers instantly so they can get back to driving—not waiting on hold.':
      'وين رحلة أمس؟ ليش الأرباح ناقصة؟ الحساب مقفل؟ النظام يجيب فوراً، والسائق يعود للطريق بدل الانتظار.',
    'Refunds and cancellations': 'استردادات وإلغاءات',
    'Cancelled ride? overcharged? Agent 5 reviews the trip, applies your refund policies automatically, and processes returns instantly. No manual review for straightforward cases.':
      'رحلة ملغاة؟ مبلغ زائد؟ النظام يراجع الرحلة، يطبّق سياسة الاسترداد عندك، ويرجّع المبلغ فوراً. الحالات الواضحة لا تحتاج مراجعة يدوية.',
    'Account access and payment methods': 'الوصول للحساب وطرق الدفع',
    "Can't log in? Need to update your card? Agent 5 resets passwords, updates payment info, and fixes account issues—without making users wait.":
      'ما يدخل على حسابه؟ بطاقته منتهية؟ النظام يعيد ضبط كلمة المرور، يحدّث بيانات الدفع، ويفتح الحساب — بدون طابور انتظار.',
    'Lost items and safety reports': 'مفقودات وتقارير سلامة',
    'Left phone in the car? Safety concern during a ride? Agent 5 logs lost items, connects riders with drivers, and escalates safety issues to your team immediately.':
      'هاتف نُسي في المقعد الخلفي؟ موقف جعله يشعر بعدم الأمان؟ النظام يسجّل المفقودات، ويصل الراكب بالسائق، ويصعّد أي بلاغ سلامة لفريقك فوراً.',
    'Rental extensions and damage claims': 'تمديد الإيجار ومطالبات الأضرار',
    'Car rental customers extend reservations, report damage, and ask about insurance coverage. Agent 5 handles the common stuff so your team focuses on complex claims.':
      'تمديد يومين على الحجز، خدش جديد على الصادم، سؤال عن التغطية التأمينية. النظام يخلّص الشائع، وفريقك يتفرّغ للمطالبات المعقدة.',
    'Scale during peak demand': 'التوسع أثناء ذروة الطلب',
    'Rush hour, holidays, bad weather—support volume spikes 10x. Agent 5 handles the surge without slowing down. Your riders and drivers get help when they need it most.':
      'ساعة الذروة، آخر العيد، أول مطر — الطلب على الدعم يرتفع ١٠ أضعاف. النظام يستوعب الموجة بدون ما يبطّئ ثانية واحدة. والمساعدة توصل بأصعب لحظة.',
    'During peak hours': 'أثناء ساعات الذروة',
    'Ride-sharing platform handles 200K daily tickets':
      'منصة مشاركة ركوب تتعامل مع ٢٠٠ ألف تذكرة يومياً',
    'Trip disputes, driver earnings, and refund requests automated with 89% resolution rate during peak hours.':
      'نزاعات الرحلات، أرباح السواقين، طلبات الاسترداد — مؤتمتة بمعدل حل ٨٩٪ في ساعة الذروة.',
    'Car rental company reduces wait times 85%':
      'شركة تأجير سيارات تقلل أوقات الانتظار بنسبة ٨٥٪',
    'Reservation changes, damage claims, and insurance questions handled instantly across 50 countries.':
      'تغييرات الحجز، مطالبات الأضرار، أسئلة التأمين — فوراً وفي ٥٠ دولة.',
    'Scooter sharing startup scales to 2M users':
      'شركة ناشئة لمشاركة السكوتر تتوسع لتشمل ٢ مليون مستخدم',
    'Account unlocks, payment issues, and location help—automated from day one without hiring support staff.':
      'فتح الحسابات، مشاكل الدفع، المساعدة في تحديد الموقع — مؤتمتة من أول يوم، وبدون توظيف طاقم دعم.',
    'Delivery platform improves driver satisfaction 40%':
      'منصة توصيل تحسن رضا السواقين بنسبة ٤٠٪',
    'Instant answers for earnings, routes, and app issues keep drivers on the road instead of on hold.':
      'إجابات فورية عن الأرباح والمسارات ومشاكل التطبيق تُبقي السائق على الطريق، لا في الانتظار.',
    'Why mobility platforms choose Agent 5': 'ليش منصات التنقل تختار النظام',
    'Built for businesses where speed matters and support volume is unpredictable.':
      'مبني لشركات تعيش على السرعة، وحجم الدعم فيها ما يتوقعه أحد.',
    'What Matters in Mobility': 'وش يهم في قطاع التنقل',
    'Driver Support': 'دعم السواقين',
    'Trip Issues': 'مشاكل الرحلات',
    'Refund Processing': 'معالجة الاستردادات',
    'Peak Hour Scaling': 'التوسع في ساعات الذروة',
    'Lost Item Requests': 'طلبات المفقودات',
    'Cost per Ticket': 'التكلفة لكل تذكرة',
    'Instant help 24/7': 'مساعدة فورية ٢٤/٧',
    'Limited hours': 'ساعات محدودة',
    'Real-time resolution': 'حل لحظي',
    'Email-only, slow': 'بس إيميل، وبطيء',
    'Automated with rules': 'مؤتمت وفق قواعدك',
    'Manual review required': 'تتطلب مراجعة يدوية',
    'Unlimited capacity': 'سعة غير محدودة',
    'Long queues': 'طوابير انتظار طويلة',
    '100+ languages': 'أكثر من ١٠٠ لغة',
    'English + a few others': 'الإنجليزية وكم لغة ثانية',
    'Automated logging & tracking': 'تسجيل وتتبع مؤتمت',
    'Phone calls, spreadsheets': 'مكالمات وجداول بيانات',
    '$6-12 per ticket': '٢٣-٤٥ ⃁ لكل تذكرة',
    'Questions from mobility platform operators':
      'أسئلة من مشغّلي منصات التنقل',
    'Straight answers about handling support at scale.':
      'أجوبة صريحة عن الدعم لمّا يوصل للملايين.',
    'Can Agent 5 handle both rider and driver support?':
      'النظام يقدر يتعامل مع دعم الركاب والسواقين؟',
    'Yes. We configure separate agents or one agent with different knowledge bases for riders vs drivers. Each gets contextual support tailored to their needs—riders ask about trips, drivers ask about earnings.':
      'نعم. نضبط نظامين منفصلين أو نظام واحد بقاعدتين معرفيتين — واحدة للراكب وواحدة للسواق. كل واحد يحصل على الدعم اللي يخصه: الراكب يسأل عن رحلته، والسواق عن أرباحه.',
    'How do you handle safety-critical situations?':
      'كيف تتعاملون مع حالات السلامة الحرجة؟',
    'Safety reports (accidents, harassment, dangerous driving) are immediately escalated to your safety team with full context. Agent 5 never delays or handles safety issues alone—it connects users to humans and logs everything for investigation.':
      'بلاغات السلامة (حادث، تحرش، قيادة خطرة) تتصعّد فوراً لفريق السلامة عندك بسياق كامل. النظام لا يتعامل معها بمفرده ولا يتأخر فيها ثانية — يصل المستخدم بموظف بشري، ويسجّل كل شيء للتحقيق.',
    'Can it process refunds automatically?': 'يقدر يعالج الاستردادات تلقائياً؟',
    'Yes. You set the rules (trip cancelled within 5 minutes, overcharge above $10, etc.) and Agent 5 applies them consistently. Complex disputes go to your team. Simple cases get resolved immediately.':
      'نعم. أنت تحدّد القاعدة — إلغاء خلال ٥ دقائق، فرق فوق $١٠، وهكذا — والنظام يطبّقها بنفس الطريقة كل مرة. البسيط ينحل فوراً، والنزاعات المعقدة تروح لفريقك.',
    'What about peak hours when support volume explodes?':
      'وش عن ساعات الذروة لمّا ينفجر حجم الدعم؟',
    'Agent 5 scales instantly. Whether you get 100 tickets or 10,000 in an hour, response time stays under 10 seconds. No queue, no hiring surge staff, no degraded experience during rush hour or bad weather.':
      'النظام يتوسّع فوراً. ١٠٠ تذكرة بالساعة أو ١٠ آلاف — وقت الرد يبقى أقل من ١٠ ثوانٍ. بدون طوابير، بدون توظيف طارئ، وبدون تجربة تتراجع وقت الذروة أو الطقس السيّئ.',
    'How does it handle lost item requests?': 'كيف يتعامل مع طلبات المفقودات؟',
    'Agent 5 logs the item, connects the rider with the driver or vehicle owner, tracks the return process, and follows up. No more lost items falling through the cracks or living in spreadsheets.':
      'النظام يسجّل المفقود، يوصّل الراكب بالسواق أو مالك المركبة، ويتابع الإرجاع خطوة بخطوة. ما فيه شنطة تضيع بين الإيميلات، ولا جدول بيانات منسي.',
    'Can it help with app troubleshooting and technical issues?':
      'هل يقدر يساعد في حل مشاكل التطبيق والأمور الفنية؟',
    "Yes. Common issues (GPS not working, payment declined, can't book a ride) are diagnosed and resolved with step-by-step guidance. Unusual technical problems get escalated to your support engineers with diagnostic details.":
      'نعم. المشاكل الشائعة — تحديد المواقع لا يعمل، الدفع مرفوض، الرحلة لا تُحجز — تُشخّص وتنحل بتوجيه خطوة بخطوة. والمشاكل الفنية غير المعتادة تتصعّد لمهندسي الدعم عندك مع تفاصيل التشخيص.',
    'How quickly can we implement this?': 'خلال كم نقدر ننفّذه؟',
    'Most mobility platforms are live within 2-3 weeks. That includes API integration with your platform, knowledge base setup, refund rule configuration, and team training. We can move faster if needed.':
      'أغلب منصات التنقل تبدأ التشغيل خلال ٢-٣ أسابيع: تكامل API مع منصتك، وإعداد قاعدة المعرفة، وضبط قواعد الاسترداد، وتدريب الفريق. وإذا كنت مستعجلاً، نقدر نكون أسرع.',
    'What languages do you support for international markets?':
      'وش اللغات اللي تدعمونها للأسواق الدولية؟',
    'Agent 5 supports 100+ languages with automatic detection. Whether your platform operates in one city or 100 countries, riders and drivers get support in their language instantly.':
      'النظام يدعم أكثر من ١٠٠ لغة، ويتعرّف على اللغة تلقائياً. مدينة واحدة أو ١٠٠ دولة — الراكب والسواق يحصلون الدعم بلغتهم فوراً.',
    'for SaaS & tech platforms': 'لمنصات التقنية والبرمجيات السحابية',
    'Your product is complex. Your users need help understanding features, fixing issues, and getting set up. Agent 5 handles onboarding, troubleshooting, and technical questions—so your team can focus on building product instead of answering the same questions.':
      'منتجك معقّد. والمستخدم الجديد واقف عند شاشة الإعداد ما يعرف من وين يبدأ. النظام يتولّى التأهيل وحل المشاكل والأسئلة الفنية، وفريقك يبني المنتج بدل ما يعيد نفس الجواب كل يوم.',
    'See how it works for SaaS': 'شوف كيف يعمل للبرمجيات السحابية',
    'Support users through complexity': 'خلّ التعقيد ما يوقف مستخدمك',
    'Help customers succeed with your product—from onboarding to power user.':
      'ساعد عميلك على النجاح بمنتجك — من أول تسجيل دخول حتى يصبح محترفاً فيه.',
    'Onboard new users faster': 'تأهيل أسرع للمستخدمين الجدد',
    'New users ask: How do I set this up? Where do I start? What does this feature do? Agent 5 guides them through initial setup, explains key features, and gets them to their first success quickly.':
      'من وين أبدأ؟ كيف أربط حسابي؟ وش تعمل هذه الميزة؟ النظام يرشد المستخدم في الإعداد، ويشرح الأساسيات، ويوصله لأول نتيجة حقيقية بسرعة.',
    'Feature explanations and how-to questions':
      'شروحات الميزات وأسئلة "كيفية الاستخدام"',
    "Users ask how features work, what options mean, and how to achieve specific outcomes. Agent 5 provides contextual help based on what they're trying to accomplish—not just pointing to docs.":
      'المستخدم ما يريد يعرف وش تعمل الميزة، بل كيف توصله لهدفه. النظام يجيب حسب ما يحاول إنجازه، وما يرمي له رابطاً في الوثائق.',
    'Technical troubleshooting and bug reports':
      'استكشاف الأخطاء الفنية وتقارير الأعطال',
    'Something not working? Error messages? Agent 5 diagnoses common issues, provides fixes, and automatically logs bugs with reproduction steps for your engineering team.':
      'شيء لا يعمل؟ رسالة خطأ بلا معنى؟ النظام يشخّص المشاكل الشائعة، ويعطي الحل، ويرفع تقرير العطل تلقائياً بخطوات إعادة إنتاجه لفريقك الهندسي.',
    'Integration and API support': 'دعم التكامل وواجهة برمجة التطبيقات (API)',
    'Developers ask about API endpoints, authentication, webhooks, and integration steps. Agent 5 provides code examples, troubleshoots connection issues, and explains technical concepts clearly.':
      'أسئلة المطورين ما تنتهي: نقاط النهاية، المصادقة، الـ webhooks، خطوات التكامل. النظام يعطي مثال كود جاهز، يفكّ مشاكل الاتصال، ويشرح المفهوم الفني بلغة مفهومة.',
    'Account and billing management': 'إدارة الحساب والفواتير',
    'Upgrade plan? Update payment method? Need an invoice? Agent 5 handles account changes, billing questions, and subscription management—reducing churn from billing friction.':
      'ترقية خطة؟ تحديث بطاقة؟ فاتورة للمحاسبة؟ النظام يتولّى تغييرات الحساب وأسئلة الفواتير وإدارة الاشتراك — عشان ما تخسر عميلاً بسبب مشكلة فوترة.',
    'Proactive help at friction points': 'مساعدة استباقية عند نقاط الاحتكاك',
    'Agent 5 detects when users struggle (failed attempts, repeated actions, stuck workflows) and offers help before they ask. Catches users before they churn out of frustration.':
      'محاولات تفشل وتتكرر، نفس الخطوة مرة ورا مرة، سير عمل واقف بالنص — النظام يشوف التعثّر ويعرض المساعدة قبل ما يطلبها المستخدم. يلحق عليه قبل ما ينسحب من الإحباط.',
    'Scale support without hiring': 'توسيع الدعم بلا توظيف',
    'Your user base doubles. Your product gets more complex. Agent 5 scales with you—handling the volume increase and learning new features as you ship them.':
      'مستخدموك يتضاعفون. ومنتجك يزداد تعقيداً. النظام ينمو معك: يستوعب الحجم الجديد، ويتعلّم الميزة فور إطلاقها.',
    'For technical inquiries': 'للاستفسارات الفنية',
    'Marketplace reduces onboarding time 60%': 'سوق يقلّل وقت التأهيل ٦٠٪',
    'New sellers get setup help instantly—listings live faster, fewer abandoned signups, higher activation rate.':
      'البائع الجديد يلقى مساعدة الإعداد فوراً — قوائم تنشر أسرع، تسجيلات متروكة أقل، وتفعيل أعلى.',
    'Ticketing platform handles 100K technical questions monthly':
      'منصة تذاكر تتعامل مع ١٠٠ ألف سؤال فني شهرياً',
    'Buyers and sellers get instant help with ticket transfers, payment issues, and verification—without overwhelming support team.':
      'تحويل تذكرة، دفع مرفوض، توثيق حساب — جواب فوري للمشتري والبائع، وفريق الدعم ما ينهار.',
    'API-first SaaS automates developer support':
      'برمجيات سحابية تعتمد على API تؤتمت دعم المطورين',
    'Integration questions, authentication help, and webhook debugging—developers get unblocked in minutes, not days.':
      'أسئلة التكامل، المصادقة، تصحيح الـ webhook — المطوّر يعود لكتابة الكود بعد دقائق، لا بعد أيام.',
    'B2B platform cuts churn 35% with proactive help':
      'منصة B2B تقلل فقدان العملاء بنسبة ٣٥٪ بالمساعدة الاستباقية',
    'Identifies struggling users and offers assistance before they cancel—turning confusion into success.':
      'تلقط المستخدم المتعثّر وتعرض عليه المساعدة قبل ما يلغي — والارتباك يتحوّل نجاح.',
    'Why tech companies choose Agent 5': 'ليش شركات التقنية تختار النظام',
    'Built for products where customer success requires deep product knowledge.':
      'مبني لمنتجات ما يكفي فيها جواب عام — نجاح العميل يحتاج معرفة عميقة بالمنتج نفسه.',
    'What Matters for SaaS': 'وش يهم لقطاع البرمجيات السحابية',
    'Onboarding Time': 'وقت التأهيل',
    'Technical Troubleshooting': 'استكشاف الأخطاء الفنية',
    'Feature Questions': 'أسئلة الميزات',
    'API Support': 'دعم API',
    'Bug Reports': 'تقارير الأعطال',
    'Account Management': 'إدارة الحساب',
    'Churn Prevention': 'منع فقدان العملاء',
    'Instant guided setup': 'إعداد موجّه فوري',
    'Wait for support call': 'انتظار مكالمة الدعم',
    'Step-by-step diagnostics': 'تشخيص خطوة بخطوة',
    'Generic help articles': 'مقالات مساعدة عامة',
    'Contextual answers': 'إجابات سياقية',
    'Search documentation': 'دوّر بنفسك في الوثائق',
    'Code examples & debugging': 'أمثلة كود وتصحيح أخطاء',
    'Developer docs only': 'بس وثائق المطورين',
    'Auto-logged with details': 'تسجيل تلقائي مع التفاصيل',
    'Manual form submission': 'تعبئة نموذج يدوي',
    'Instant updates & changes': 'تحديثات وتغييرات فورية',
    'Email back-and-forth': 'إيميلات رايحة جاية',
    'Proactive help at friction': 'مساعدة استباقية عند الاحتكاك',
    'Users give up': 'المستخدم يستسلم',
    '$10-25 per ticket': '٣٨-٩٤ ⃁ لكل تذكرة',
    'Questions from SaaS product teams':
      'أسئلة من فرق منتجات البرمجيات السحابية',
    'How Agent 5 helps complex products scale support.':
      'كيف يوسّع النظام الدعم لمنتج معقّد.',
    "Can Agent 5 learn our product's complexity?":
      'هل النظام يقدر يتعلّم تعقيد منتجنا؟',
    "Yes. We train Agent 5 on your documentation, feature specs, and common workflows. As you ship new features, we update the knowledge base. The AI understands context—when a user asks about integrations, it knows which plan they're on and what's available to them.":
      'نعم. ندرّب النظام على وثائقك ومواصفات الميزات وسير العمل الشائع، وفور إطلاق ميزة جديدة نحدّث قاعدة المعرفة. والنظام يفهم السياق: لمّا يسأل المستخدم عن التكاملات، يعرف على أي خطة هو ووش المتاح له فيها.',
    'How does it handle technical troubleshooting?':
      'كيف يتعامل مع حل المشاكل الفنية؟',
    "Agent 5 walks users through diagnostic steps, checks common causes, and suggests fixes based on the specific error or behavior. If it can't resolve the issue, it logs details (browser, plan, steps to reproduce) and escalates to your team with everything needed to fix it.":
      'النظام يمشّي المستخدم خطوة خطوة في التشخيص، يفحص الأسباب الشائعة، ويقترح الحل حسب الخطأ نفسه. ولو ما قدر يحلها، يسجّل التفاصيل — المتصفح، الخطة، خطوات إعادة الإنتاج — ويصعّدها لفريقك مع كل ما يلزم لإصلاحها.',
    'What about API and integration questions from developers?':
      'وش عن أسئلة API والتكامل من المطورين؟',
    'Agent 5 provides code examples, explains authentication flows, troubleshoots API errors, and helps developers integrate with your platform. It understands technical concepts and can debug common integration issues on the spot.':
      'النظام يعطي أمثلة كود، ويشرح تدفقات المصادقة، ويحل أخطاء API، ويرشد المطوّر في التكامل مع منصتك. يفهم المفاهيم الفنية، ويصحّح مشاكل التكامل الشائعة فوراً.',
    'Can it detect when users are about to churn?':
      'يقدر يكتشف المستخدمين اللي على وشك المغادرة؟',
    'Yes. Agent 5 identifies friction patterns (repeated failed attempts, downgrade requests, cancellation page visits) and proactively offers help. Often a simple explanation or quick fix prevents cancellation—catching users before they give up.':
      'نعم. النظام يقرأ أنماط الاحتكاك — محاولات فاشلة مكررة، طلب تخفيض الخطة، زيارة صفحة الإلغاء — ويعرض المساعدة قبل ما تُطلب. وغالباً يكفي شرح بسيط أو حل سريع لمنع الإلغاء.',
    'How does it stay updated when we ship new features?':
      'كيف يبقى محدّثاً عند إطلاق ميزات جديدة؟',
    'You update the knowledge base (API, documentation feed, or manual updates) and Agent 5 learns the new features immediately. No retraining delay. We also provide tools to test responses before they go live to users.':
      'تحدّث قاعدة المعرفة — عبر API، أو موجز الوثائق، أو يدوياً — والنظام يتعلّم الميزة فوراً. لا يوجد تأخير إعادة تدريب. وتقدر تختبر الردود قبل ما توصل للمستخدمين.',
    'What happens with really complex or unique questions?':
      'وش يحدث عند وصول سؤال معقّد أو غير مألوف؟',
    'Agent 5 escalates to your team with full conversation context. Your team gets the question, what\'s been tried, and relevant account details. No "can you explain your issue again"—they pick up exactly where the AI left off.':
      'النظام يصعّد لفريقك بسياق المحادثة كامل: السؤال، وما جُرِّب قبلها، وتفاصيل الحساب ذات الصلة. لا مزيد من "ممكن تشرح مشكلتك مرة ثانية" — يكملون من نفس النقطة اللي وقف عندها.',
    'How long does it take to implement for a SaaS product?':
      'كم ياخذ التنفيذ لمنتج برمجيات سحابية؟',
    'Most SaaS companies are live within 2-3 weeks. That includes knowledge base setup, integration with your product (if needed), training on your workflows, and team handoff processes. Complex products might take 4 weeks.':
      'أغلب شركات البرمجيات السحابية تبدأ التشغيل خلال ٢-٣ أسابيع: إعداد قاعدة المعرفة، والتكامل مع منتجك (عند الحاجة)، والتدريب على سير عملك، وضبط عمليات التحويل للفريق. والمنتجات المعقدة قد تستغرق ٤ أسابيع.',
    'Can we review and improve AI responses over time?':
      'نقدر نراجع ونحسّن ردود AI مع الوقت؟',
    'Yes. You see every conversation, flag incorrect responses, and provide corrections. Agent 5 learns from your feedback and gets better at handling your specific product nuances. Full transparency and control.':
      'نعم. ترى كل محادثة، وتحدد الرد الخاطئ، وتكتب التصحيح. النظام يتعلّم من ملاحظاتك ويصبح أدق في تفاصيل منتجك. شفافية كاملة، وتحكم كامل.',
    'for travel & hospitality': 'للسفر والضيافة',
    "Your guests book tours at midnight. RV renters need help on the road. Questions don't wait for business hours. Agent 5 handles bookings, modifications, and customer questions instantly—so your team focuses on creating amazing experiences.":
      'ضيفك يحجز جولة في منتصف الليل. ومستأجر الكرفان واقف على طريق بلا شبكة يريد أن يعرف كيف يوصّل الماء. الأسئلة لا تنتظر الدوام. النظام يرد على الحجوزات والتعديلات وأسئلة العملاء فوراً، وفريقك يتفرّغ للتجربة نفسها.',
    'See how it works for travel': 'شوف كيف يعمل للسفر',
    'Support customers from booking to checkout':
      'ادعم العملاء من الحجز حتى المغادرة',
    'Handle every stage of the customer journey—automatically and accurately.':
      'من أول استفسار لآخر تقييم — كل مرحلة مغطّاة، تلقائياً وبدقة.',
    'Booking confirmations and modifications': 'تأكيدات الحجز وتعديلاتها',
    'Customers change dates, add participants, or request specific time slots. Agent 5 checks availability, processes changes, and sends updated confirmations—instantly, any time.':
      'تأجيل يومين، شخصين زيادة، طلب موعد الصباح بدل العصر. النظام يتحقق من التوفّر، ينفّذ التغيير، ويرسل التأكيد المحدّث — فوراً وبأي ساعة.',
    'Tour details and special requests': 'تفاصيل الجولة والطلبات الخاصة',
    'What should I bring? Is the tour wheelchair accessible? Can we accommodate dietary restrictions? Agent 5 answers tour specifics, logs special requests, and ensures nothing falls through the cracks.':
      'وش ألبس؟ هل الجولة مهيّأة للكرسي المتحرك؟ فيه خيار يناسب حساسية غذائية؟ النظام يجيب على تفاصيل الجولة، ويسجّل الطلبات الخاصة، وما يدع طلباً يضيع.',
    'Weather cancellations and rebooking': 'إلغاءات الطقس وإعادة الحجز',
    'Storm cancelled the tour? Heavy rain makes RV travel unsafe? Agent 5 notifies customers proactively, offers alternative dates, and processes cancellations or rebookings based on your policies.':
      'العاصفة ألغت جولة الصباح؟ المطر جعل الطريق غير آمن للكرفان؟ النظام يبلّغ العملاء قبل ما يسألون، ويعرض تواريخ بديلة، ويعالج الإلغاء أو إعادة الحجز حسب سياستك.',
    'Equipment guides and RV questions':
      'أدلة المعدات وأسئلة المركبات الترفيهية',
    "How do I connect the water? Where's the fuse box? What does this light mean? For RV and camper rentals, Agent 5 provides walkthroughs, troubleshooting guides, and answers equipment questions on the road.":
      'كيف أوصّل الماء؟ وين صندوق المصاهر؟ وش يعني هذا الضوء الأحمر؟ للكرفانات والمركبات الترفيهية، النظام يرشد العميل خطوة بخطوة ويجيب على أسئلة المعدات وهو على الطريق.',
    'Directions and check-in instructions': 'الاتجاهات وتعليمات تسجيل الوصول',
    "Where do we meet? What's the parking situation? When should we arrive? Agent 5 sends location details, parking info, and check-in instructions automatically as the date approaches.":
      'وين نلتقي بالضبط؟ فيه مواقف؟ متى يجب أن نصل؟ النظام يرسل الموقع والمواقف وتعليمات تسجيل الوصول تلقائياً كلما اقترب الموعد.',
    'Group coordination and multi-booking':
      'تنسيق المجموعات والحجوزات المتعددة',
    'Large groups need multiple vehicles or tour slots. Agent 5 coordinates bookings, manages group inquiries, and ensures everyone has the same information—no back-and-forth chaos.':
      'مجموعة كبيرة تحتاج أكثر من مركبة أو أكثر من موعد. النظام ينسّق الحجوزات، يرد على استفسارات المجموعة، ويخلّي الكل عنده نفس المعلومة — بدون سلسلة إيميلات ما تنتهي.',
    'Cancellations and refund processing': 'عمليات الإلغاء ومعالجة الاسترداد',
    "Customer can't make it? Policy allows cancellation within 48 hours? Agent 5 applies your cancellation rules automatically, processes refunds, and offers rebooking options.":
      'العميل ما يقدر يجي؟ سياستك تسمح بالإلغاء خلال ٤٨ ساعة؟ النظام يطبّق القاعدة تلقائياً، يرجّع المبلغ، ويعرض بدائل لإعادة الحجز.',
    'When travel plans change': 'لمّا تتغيّر خطط السفر',
    'Tour operator automates 85% of bookings':
      'مشغل جولات يؤتمت ٨٥٪ من الحجوزات',
    'FareHarbor partners handle confirmations, modifications, and customer questions without expanding support teams.':
      'شركاء FareHarbor يخلّصون التأكيدات والتعديلات وأسئلة العملاء بدون ما يزيدون موظف واحد.',
    'RV rental company supports 24/7 on-road help':
      'شركة تأجير مركبات ترفيهية تدعم المساعدة على الطريق ٢٤/٧',
    'Customers get equipment troubleshooting, location guidance, and booking changes while traveling—no waiting.':
      'مشاكل المعدات، إرشاد الطريق، تعديل الحجز — كله وهم على الطريق، وبدون انتظار.',
    'Adventure booking platform scales to 50 countries':
      'منصة حجز مغامرات تتوسع لتشمل ٥٠ دولة',
    'Multi-language support for bookings, cancellations, and special requests across time zones—no language barriers.':
      'حجوزات وإلغاءات وطلبات خاصة بعدة لغات وعبر كل المناطق الزمنية — ما فيه حاجز لغة.',
    'Hotel group improves guest satisfaction to 92%':
      'مجموعة فنادق تحسن رضا الضيوف إلى ٩٢٪',
    'Pre-arrival questions, room changes, and concierge requests handled before guests even check in.':
      'أسئلة ما قبل الوصول، تغيير الغرف، طلبات الكونسيرج — مُنجزة قبل ما يصل الضيف للاستقبال.',
    'Why travel companies choose Agent 5': 'ليش شركات السفر تختار النظام',
    'Purpose-built for businesses where customer experience is everything.':
      'مبني لشركات التجربة فيها هي المنتج.',
    'What Matters in Travel': 'وش يهم في قطاع السفر',
    'Booking Modifications': 'تعديلات الحجز',
    'Weather Cancellations': 'إلغاءات الطقس',
    'Group Bookings': 'حجوزات المجموعات',
    'Equipment Questions': 'أسئلة المعدات',
    'Refund Requests': 'طلبات الاسترداد',
    'Peak Season Support': 'الدعم في مواسم الذروة',
    'Instant changes 24/7': 'تغييرات فورية ٢٤/٧',
    'Email only, 24hr response': 'بس إيميل، ورد بعد ٢٤ ساعة',
    'Auto-rebooking options': 'خيارات إعادة حجز تلقائية',
    'Manual coordination': 'تنسيق يدوي',
    'Multi-party coordination': 'تنسيق بين أطراف متعددة',
    'Phone tag chaos': 'فوضى مكالمات ما تنتهي',
    'Instant specs & guides': 'مواصفات وأدلة فورية',
    'Wait for specialist': 'انتظار أخصائي',
    'Policy-based automation': 'أتمتة قائمة على السياسات',
    'Manual approval delays': 'تأخيرات الموافقة اليدوية',
    'Scales instantly': 'يتوسع فوراً',
    'Overwhelmed team': 'فريق منهك',
    'English + 2-3 others': 'الإنجليزية + ٢-٣ لغات أخرى',
    '$7-15 per ticket': '٧-١٥ دولاراً لكل تذكرة',
    'Questions from travel operators': 'أسئلة من مشغّلي السفر',
    'Real answers for tour operators, rental companies, and hospitality businesses.':
      'أجوبة صريحة لمشغّلي الجولات وشركات التأجير والضيافة.',
    'Can it handle last-minute booking changes?':
      'يقدر يتعامل مع تغييرات الحجز في آخر لحظة؟',
    'Yes. Agent 5 checks availability in your booking system, processes changes based on your policies (same-day fees, availability, etc.), and sends updated confirmations. Works 24/7, even when your team is offline.':
      'نعم. النظام يفحص التوفّر في نظام الحجز عندك، وينفّذ التغيير حسب سياستك (رسوم نفس اليوم، التوفّر، وغيرها)، ويرسل التأكيد المحدّث. يعمل ٢٤/٧، حتى وفريقك خارج الدوام.',
    'How does it handle weather cancellations for outdoor activities?':
      'كيف يتعامل مع إلغاءات الطقس للأنشطة الخارجية؟',
    'Agent 5 can monitor weather data and proactively notify customers of cancellations, offer rebooking options for alternative dates, or process refunds according to your policies. Reduces no-shows and customer frustration.':
      'النظام يقدر يراقب بيانات الطقس، فيبلّغ العملاء بالإلغاء قبل ما يسألون، ويعرض تواريخ بديلة، أو يعالج المبالغ المستردة حسب سياستك. حالات عدم الحضور تنزل، وإحباط العميل معها.',
    'What about equipment questions for RV or camper rentals?':
      'وش عن أسئلة المعدات لاستئجار المركبات الترفيهية أو الكرفانات؟',
    'Agent 5 provides troubleshooting guides, equipment manuals, and step-by-step instructions for common issues (connecting hookups, operating appliances, etc.). When customers are on the road, they get help immediately instead of searching manuals.':
      'النظام يوفّر أدلة حل المشاكل وكتيبات المعدات وتعليمات خطوة بخطوة للحالات الشائعة (توصيل الوصلات، تشغيل الأجهزة، وغيرها). وهم على الطريق يحصلون الجواب فوراً، بدل ما يفتّشون في كتيّب.',
    'Can it coordinate group bookings?': 'يقدر ينسّق حجوزات المجموعات؟',
    'Yes. Agent 5 handles inquiries from multiple people booking together, coordinates timing, manages capacity across multiple slots, and keeps everyone informed. No more 20-person email threads.':
      'نعم. النظام يرد على كل واحد في المجموعة، ينسّق التوقيت، يوزّع السعة على أكثر من فترة، ويخلّي الكل على اطلاع. خلاص من سلاسل بريد فيها ٢٠ شخص.',
    'How does refund processing work?': 'كيف تتم معالجة الاسترداد؟',
    'You set the rules (cancel 48hrs before = full refund, within 24hrs = 50%, etc.) and Agent 5 applies them automatically. Clear cases get processed instantly. Edge cases escalate to your team with full context.':
      'أنت تحدّد القاعدة — إلغاء قبل ٤٨ ساعة = استرداد كامل، خلال ٢٤ ساعة = ٥٠٪، وهكذا — والنظام يطبّقها تلقائياً. الحالات الواضحة تنعالج فوراً، والاستثنائية تتصعّد لفريقك بسياق كامل.',
    'What happens during peak season when volume spikes?':
      'وش يحدث خلال موسم الذروة عند ارتفاع حجم الطلب؟',
    'Agent 5 scales instantly. Summer rush? Holiday bookings? Bad weather affecting hundreds of reservations? Response time stays under 10 seconds regardless of volume. No hiring seasonal staff, no degraded service during your busiest weeks.':
      'النظام يتوسّع فوراً. زحام الصيف؟ حجوزات العطلات؟ طقس سيّئ يضرب مئات الحجوزات في يوم واحد؟ وقت الاستجابة يبقى أقل من ١٠ ثوانٍ مهما كان الحجم. بدون توظيف موسمي، وبدون خدمة تتراجع في أزحم أسابيعك.',
    'Does it work with FareHarbor and other booking platforms?':
      'هل يعمل مع FareHarbor ومنصات الحجز الأخرى؟',
    'Yes. Agent 5 integrates with FareHarbor, Checkfront, Bokun, and other tour/activity booking systems through APIs. It reads availability, processes changes, and updates bookings automatically.':
      'نعم. النظام يتكامل مع FareHarbor وCheckfront وBokun وأنظمة حجز الجولات/الأنشطة الأخرى عبر واجهات برمجة التطبيقات. يقرأ التوفّر، ينفّذ التغييرات، ويحدّث الحجوزات تلقائياً.',
    'What about international customers and language barriers?':
      'وش عن العملاء الدوليين وحواجز اللغة؟',
    'Agent 5 supports 100+ languages with automatic detection. Tourists from anywhere get help in their native language—no translation delays, no misunderstandings about important details.':
      'النظام يدعم أكثر من ١٠٠ لغة، ويتعرّف على اللغة تلقائياً. السايح من أي مكان يحصل المساعدة بلغته الأم — بدون تأخير ترجمة، وبدون سوء فهم في التفاصيل المهمة.',
    'Automation Rate': 'معدل الأتمتة',
    '5-15 minutes': '٥-١٥ دقيقة',
    Compliance: 'الامتثال',
  },
  helpdesks: {
    'Choose your helpdesk': 'اختر نظام الدعم',
    'Agent 5 works with your existing helpdesk or as a standalone platform. Pick where you want to add AI.':
      'نشتغل فوق الأداة اللي عندك، أو نكون المنصة كلها. اختر من وين تريد إضافة AI.',
    'Learn more →': 'اعرف أكثر ←',
    Open: 'Open',
    Zendesk: 'Zendesk',
    Intercom: 'Intercom',
    Salesforce: 'Salesforce',
    Freshdesk: 'Freshdesk',
    HubSpot: 'HubSpot',
    'Twilio Flex': 'Twilio Flex',
    'The complete AI communication platform': 'منصة تواصل متكاملة بالـ AI',
    'AI agent for Zendesk': 'وكيل ذكي داخل Zendesk',
    'Better & cheaper than Fin': 'أفضل وأرخص من Fin',
    'No consultants required': 'بدون مستشارين',
    'Beyond Freddy AI': 'أكثر من Freddy AI',
    'Enterprise AI, any tier': 'AI للمؤسسات، بأي باقة',
    "The AI Twilio doesn't have": 'الـ AI اللي ما تلقاه في Twilio',
  },
  industries: {
    'AI customer support': 'دعم عملاء بالـ AI',
    'for your industry': 'لقطاعك',
    'Every industry has unique support needs. Agent 5 adapts to yours—handling the specific questions, compliance requirements, and workflows that matter most.':
      'لكل قطاع احتياجات دعم تخصّه وحده. النظام يتأقلم مع قطاعك — يتعامل مع أسئلته المحددة، ومتطلبات الامتثال فيه، وسير العمل اللي يهمك.',
    'Learn more →': 'اعرف أكثر ←',
    'Financial Services': 'الخدمات المالية',
    Healthcare: 'الرعاية الصحية',
    'Mobility & Transportation': 'التنقل والمواصلات',
    'Technology & SaaS': 'التقنية والبرمجيات السحابية',
    'Travel & Hospitality': 'السفر والضيافة',
    'Banks, fintech, and credit unions. Handle account inquiries, fraud reports, and payment questions with compliant AI that customers trust.':
      'بنوك وتقنية مالية واتحادات ائتمانية. استفسارات الحسابات، بلاغات الاحتيال، أسئلة الدفع — بـ AI ملتزم بالأنظمة، ويثق فيه عميلك.',
    'Hospitals, clinics, and telehealth. Automate appointment scheduling, insurance verification, and prescription refills while protecting patient privacy.':
      'مستشفيات وعيادات ومنصات صحة عن بعد. أتمتة جدولة المواعيد والتحقق من التأمين وتجديد الوصفات، وخصوصية المريض محفوظة.',
    'Ride-sharing, car rentals, and gig economy. Support riders and drivers at scale with instant trip dispute resolution and refund automation.':
      'مشاركة الركوب وتأجير السيارات واقتصاد العمل الحر. ادعم الركاب والسواقين مهما كبر العدد: نزاعات الرحلات تنحل فوراً، والاستردادات مؤتمتة.',
    'Software platforms, marketplaces, and B2B SaaS. Help users succeed with onboarding, troubleshooting, and API support for complex products.':
      'منصات برمجيات وأسواق إلكترونية وSaaS للأعمال. ساعد مستخدمك ينجح — تأهيل، وحل مشاكل، ودعم API لمنتج معقّد.',
    'Tour operators, RV rentals, and activity bookings. Handle reservations, weather cancellations, and equipment questions across 100+ languages.':
      'مشغّلو الجولات وتأجير المركبات الترفيهية وحجوزات الأنشطة. تعامل مع الحجوزات، والإلغاء بسبب الطقس، وأسئلة المعدات — بأكثر من ١٠٠ لغة.',
    'Tours & Activity Operators': 'مشغّلو الجولات والأنشطة',
    'Cruises, dives, adventures, and experiences. Answer bookings, reschedules, and weather cancellations 24/7 in 100+ languages—so your crew stays in the field.':
      'رحلات بحرية وغطس ومغامرات وتجارب. جاوب على الحجوزات وإعادة الجدولة والإلغاء بسبب الطقس، على مدار الساعة وبأكثر من ١٠٠ لغة — وفريقك يظل بالميدان.',
    "Don't see your industry?": 'ما لقيت قطاعك؟',
    'Agent 5 works across industries. If you have customers who need support, we can help.':
      'النظام يعمل في كل القطاعات. عندك عملاء يحتاجون دعماً؟ نحن معك.',
    'Talk to us about your industry': 'كلّمنا عن قطاعك',
    '6 factors analyzed': 'تحليل ٦ عوامل',
  },
  tools_pages: {
    'AI Readiness Assessment': 'تقييم الجاهزية للـ AI',
    'Automation rate': 'معدل الأتمتة',
    Location: 'الموقع',
    'E-commerce & Retail': 'التجارة الإلكترونية والتجزئة',
    'SaaS & Technology': 'البرمجيات والتكنولوجيا',
    'Fintech & Banking': 'التكنولوجيا المالية والبنوك',
    'Travel & Hospitality': 'السفر والضيافة',
    'Telecom & Utilities': 'الاتصالات والمرافق',
    Insurance: 'التأمين',
    'Under $5': 'أقل من ٥ دولار',
    '$5 - $10': '٥ - ١٠ دولار',
    '$10 - $15': '١٠ - ١٥ دولار',
    '$15 - $25': '١٥ - ٢٥ دولار',
    '$25 - $40': '٢٥ - ٤٠ دولار',
    'Over $40': 'أكثر من ٤٠ دولار',
    "I don't know": 'ما أعرف',
    'Under 1 hour': 'أقل من ساعة',
    '1 - 4 hours': '١ - ٤ ساعات',
    '4 - 8 hours': '٤ - ٨ ساعات',
    '8 - 24 hours': '٨ - ٢٤ ساعة',
    'Over 24 hours': 'أكثر من ٢٤ ساعة',
    '90%+': '+٩٠٪',
    '80% - 90%': '٨٠٪ - ٩٠٪',
    '70% - 80%': '٧٠٪ - ٨٠٪',
    '60% - 70%': '٦٠٪ - ٧٠٪',
    'Under 60%': 'أقل من ٦٠٪',
    "I don't track this": 'ما أتابع هذا',
    'What industry are you in?': 'في أي مجال تعمل؟',
    "We'll compare your metrics against companies in your space.":
      'راح نقارن مقاييسك مع الشركات في مجالك.',
    "What's your average cost per ticket?": 'كم متوسط تكلفة التذكرة عندك؟',
    'Include labor, tools, and overhead costs.':
      'اشمل تكاليف العمالة والأدوات والتكاليف العامة.',
    "What's your average first response time?": 'كم متوسط وقت الرد الأول عندك؟',
    'How long until a customer gets their first reply?':
      'كم ينتظر العميل حتى يصله أول رد؟',
    "What's your current CSAT score?": 'كم درجة رضا العملاء الحالية عندك؟',
    'Customer satisfaction percentage from surveys.':
      'نسبة رضا العملاء من الاستبيانات.',
    Benchmark: 'المعيار',
    'Your Benchmark Results': 'نتائج مقارنتك المعيارية',
    'Percentile ranking vs. {industry} peers':
      'الترتيب المئوي مقارنة بشركات {industry}',
    'Metric Breakdown': 'تفصيل المقاييس',
    'Industry avg:': 'متوسط المجال:',
    'Not tracked': 'بدون متابعة',
    'Top {percentile}%': 'أفضل {percentile}٪',
    'Cost per ticket': 'تكلفة التذكرة',
    'CSAT Score': 'درجة رضا العملاء',
    'Track this metric to understand your true support costs.':
      'تابع هذا المقياس عشان تفهم تكاليف الدعم الحقيقية عندك.',
    "Excellent cost efficiency! You're outperforming most competitors.":
      'كفاءة تكلفة ممتازة. متقدّم على معظم المنافسين.',
    "Good cost control. There's still room for optimization.":
      'تحكّم جيد بالتكلفة. بس فيه مجال للتحسين.',
    'Your costs are above average. AI automation could help reduce this significantly.':
      'تكاليفك أعلى من المتوسط. الأتمتة بالـ AI ممكن تنزّلها كثير.',
    'High support costs detected. This is a prime opportunity for AI automation.':
      'تكاليف دعم عالية. هذه فرصة ممتازة للأتمتة بالـ AI.',
    'Response time directly impacts customer satisfaction.':
      'وقت الاستجابة يؤثر مباشرة على رضا العملاء.',
    'Lightning fast! Your customers appreciate quick responses.':
      'سرعة ممتازة. عملاؤك يقدّرون الرد السريع.',
    "Good response times. You're meeting customer expectations.":
      'أوقات استجابة جيدة. تلبّي توقعات العملاء.',
    'Slower than average. Each hour of delay increases churn risk by 5%.':
      'أبطأ من المتوسط. كل ساعة تأخير تزيد خطر فقدان العملاء بنسبة ٥٪.',
    'Critical: Slow responses are likely costing you customers. AI can respond instantly, 24/7.':
      'وضع حرج: الردود البطيئة غالباً تكلّفك عملاء. الـ AI يرد فوراً، ٢٤/٧.',
    'Start tracking CSAT to measure customer happiness.':
      'ابدأ تتبع درجة رضا العملاء لقياس سعادتهم.',
    'Outstanding! Your customers love your support experience.':
      'رائع. عملاؤك يحبون تجربة الدعم عندك.',
    "Solid CSAT. You're meeting industry standards.":
      'درجة رضا قوية. تلبّي معايير المجال.',
    'Room for improvement. Faster responses and consistent quality can boost this.':
      'فيه مجال للتحسين. ردود أسرع وجودة ثابتة ترفعها.',
    'Below average CSAT. Consistency and speed are key drivers—AI can help with both.':
      'درجة رضا أقل من المتوسط. الاتساق والسرعة هما المحرّكان الأساسيان - والـ AI يساعد بالاثنين.',
    'Incomplete Data': 'بيانات ناقصة',
    Step: 'الخطوة',
    'of 4': 'من ٤',
    'Above Average': 'أعلى من المتوسط',
    Average: 'متوسط',
    'Below Average': 'أقل من المتوسط',
    'Needs Improvement': 'يحتاج تحسين',
    'Industry Leader': 'رائد في المجال',
    'Room for Improvement Detected': 'عندك مجال للتحسين',
    'Companies using AI support automation see an average 40% reduction in cost per ticket, 90% faster response times, and 15-point CSAT improvement.':
      'الشركات اللي تستخدم أتمتة الدعم بالـ AI تخفّض تكلفة التذكرة ٤٠٪ بالمتوسط، وترد أسرع بنسبة ٩٠٪، وترفع رضا العملاء ١٥ نقطة.',
    'Calculate your potential savings': 'احسب التوفير المحتمل عندك',
    "You're a Top Performer!": 'أنت من الأفضل',
    'Great job! Your support metrics are above average. AI can help you maintain this edge while scaling without adding headcount.':
      'عمل ممتاز. مقاييس الدعم عندك أعلى من المتوسط. الـ AI يساعدك على الحفاظ على هذا التميز مع التوسع بدون زيادة عدد الموظفين.',
    'See how to stay ahead': 'شوف كيف تظل متقدم',
    Back: 'رجوع',
    'One last step': 'خطوة أخيرة',
    'Enter your email to unlock your personalized results.':
      'أدخل إيميلك لفتح نتائجك المخصصة.',
    'View my results': 'اعرض نتائجي',
    'Your email may be used by Open to contact you about our product. You can unsubscribe anytime.':
      'قد يستخدم Open إيميلك للتواصل معك بخصوص منتجنا. تقدر تلغي الاشتراك في أي وقت.',
    'Support Budget Planner': 'مخطط ميزانية الدعم',
    'How many tickets do you handle monthly?': 'كم تذكرة تتعامل معها شهرياً؟',
    'This is the foundation for calculating your budget.':
      'هذا الأساس اللي نحسب عليه ميزانيتك.',
    'tickets per month': 'تذكرة شهرياً',
    'Yearly tickets': 'التذاكر السنوية',
    'United States': 'الولايات المتحدة',
    'United Kingdom': 'المملكة المتحدة',
    'Western Europe': 'أوروبا الغربية',
    'Eastern Europe': 'أوروبا الشرقية',
    'GCC / Middle East': 'دول الخليج / الشرق الأوسط',
    'Latin America': 'أمريكا اللاتينية',
    'Asia (India, Philippines)': 'آسيا (الهند، الفلبين)',
    'Where is your support team located?': 'وين فريق الدعم عندك؟',
    "What's your company size?": 'كم حجم شركتك؟',
    'Salary data:': 'بيانات الرواتب:',
    'Avg salary: {range}/year': 'متوسط الراتب: {range}/سنة',
    'US agents average $34,547/year ($26K-$46K range). European salaries range €18K-€42K.':
      'موظفو الدعم في أمريكا بمتوسط ٣٤ ٥٤٧ دولار/سنة (٢٦-٤٦ ألف). والرواتب الأوروبية بين ١٨-٤٢ ألف يورو.',
    'Startup (1-50 employees)': 'شركة ناشئة (١-٥٠ موظف)',
    'SMB (51-200 employees)': 'شركات صغيرة ومتوسطة (٥١-٢٠٠ موظف)',
    'Mid-Market (201-1000)': 'السوق المتوسط (٢٠١-١٠٠٠)',
    'Enterprise (1000+)': 'مؤسسة (١٠٠٠+)',
    'Lean operations, minimal overhead': 'عمليات رشيقة، تكاليف عامة قليلة',
    'Growing infrastructure needs': 'احتياجات بنية تحتية متنامية',
    'Established processes, more tools': 'عمليات راسخة، أدوات أكثر',
    'Full infrastructure, compliance needs':
      'بنية تحتية كاملة، احتياجات امتثال',
    'Larger companies have higher overhead costs.':
      'الشركات الأكبر عندها تكاليف عامة أعلى.',
    Telecommunications: 'الاتصالات',
    'Support costs vary significantly by industry complexity.':
      'تكاليف الدعم تختلف كثير حسب تعقيد المجال.',
    'Healthcare averages $50-60/ticket due to complexity, while e-commerce averages $2.70-$12.':
      'الرعاية الصحية بمتوسط ٥٠-٦٠ دولار/تذكرة بسبب التعقيد، بينما التجارة الإلكترونية بمتوسط ٢,٧٠-١٢ دولار.',
    'Your Support Budget Estimate': 'تقدير ميزانية الدعم حقك',
    'Recommended Annual Budget': 'الميزانية السنوية الموصى بها',
    'per year': 'في السنة',
    'Budget Breakdown': 'تفصيل الميزانية',
    'Labor (65%)': 'العمالة (٦٥٪)',
    'Salaries, benefits, contractors': 'الرواتب، المزايا، المتعاقدون',
    'Tools & Software (15%)': 'الأدوات والبرمجيات (١٥٪)',
    'Helpdesk, CRM, analytics': 'نظام الدعم، إدارة العملاء، التحليلات',
    'Training (8%)': 'التدريب (٨٪)',
    'Onboarding, ongoing education': 'التأهيل، التعليم المستمر',
    'Overhead (12%)': 'التكاليف العامة (١٢٪)',
    'Management, facilities, misc': 'الإدارة، المرافق، نثريات',
    '+ Benefits (30%) + Overhead ({percentage}%)':
      '+ المزايا (٣٠٪) + التكاليف العامة ({percentage}٪)',
    'How We Calculated This': 'كيف حسبنا هذا',
    'Method 1: Cost per Ticket': 'الطريقة ١: التكلفة لكل تذكرة',
    'Industry cost/ticket ({label})': 'تكلفة المجال/تذكرة ({label})',
    'Estimated by cost/ticket': 'مقدَّر حسب التكلفة/تذكرة',
    'Method 2: Headcount Based': 'الطريقة ٢: بناءً على عدد الموظفين',
    'Base agents needed': 'الموظفون الأساسيون المطلوبون',
    'Avg salary ({label})': 'متوسط الراتب ({label})',
    '{agents} agents estimated': '{agents} موظف تقديرياً',
    'Recommended (average of both methods)': 'موصى به (متوسط الطريقتين)',
    'Budget insight:': 'نظرة على الميزانية:',
    'Labor costs are the biggest factor in support budgets.':
      'تكاليف العمالة هي العامل الأكبر في ميزانيات الدعم.',
    'Support operations typically account for ~0.7% of total company revenue in B2B SaaS.':
      'عمليات الدعم عادةً تمثل ~٠,٧٪ من إجمالي إيرادات الشركة في برمجيات B2B.',
    'Industry insight:': 'نظرة على المجال:',
    'Cost benchmarks:': 'معايير التكلفة:',
    'Self-service resolutions cost $0.50-$2.37, while assisted support averages $13.50 per contact.':
      'حلول الخدمة الذاتية تكلف ٠,٥٠-٢,٣٧ دولار، بينما الدعم بمساعدة موظف بمتوسط ١٣,٥٠ دولار لكل تواصل.',
    'Research Sources': 'مصادر البحث',
    Source: 'المصدر',
    'With AI Automation (70% automated)': 'مع الأتمتة بالـ AI (٧٠٪ مؤتمت)',
    'Reduce your budget while handling the same volume:':
      'قلّل ميزانيتك وأنت تتعامل مع نفس الحجم:',
    'Save {amount} ({percentage}%)': 'وفر {amount} ({percentage}٪)',
    'See how AI can reduce your budget': 'شوف كيف يخفّض الـ AI ميزانيتك',
    'Calculate exact team size needed': 'احسب حجم الفريق المطلوب بالضبط',
    'Calculate my budget': 'احسب ميزانيتي',
    'Mixed Channels': 'قنوات متعددة',
    'Business hours (8h/day)': 'ساعات العمل (٨ س/يوم)',
    'Extended hours (12h/day)': 'ساعات ممتدة (١٢ س/يوم)',
    'Full week (8h × 7 days)': 'الأسبوع الكامل (٨ س × ٧ أيام)',
    '24/5 coverage': 'تغطية ٢٤/٥',
    '24/7 coverage': 'تغطية ٢٤/٧',
    '< 15 minutes': '< ١٥ دقيقة',
    '1 hour': '١ ساعة',
    '4 hours': '٤ ساعات',
    '8 hours': '٨ ساعات',
    '24 hours': '٢٤ ساعة',
    'Free Guide • 28 min read': 'دليل مجاني • ٢٨ دقيقة قراءة',
    'A Practical Guide to AI in Customer Support':
      'دليل عملي للذكاء الاصطناعي في دعم العملاء',
    "What works, what doesn't, and how to think about adopting AI for your support team.":
      'وش ينجح، ووش ما ينجح، وكيف تفكر في تبنّي الذكاء الاصطناعي لفريق الدعم عندك.',
    "A practical guide based on what we've learned helping teams implement AI support—covering the approach, timeline, and common pitfalls.":
      'دليل عملي بناءً على ما تعلمناه من مساعدة الفرق في تطبيق دعم الذكاء الاصطناعي - يغطي الطريقة والجدول الزمني والعقبات الشائعة.',
    '6 Chapters Inside:': '٦ فصول بالداخل:',
    'Get the Full Guide': 'احصل على الدليل الكامل',
    'Instant access to all 6 chapters': 'وصول فوري لكل الفصول الستة',
    'Enter your work email': 'أدخل إيميلك للعمل',
    'Read the Guide': 'اقرأ الدليل',
    'No spam, ever. Unsubscribe anytime.':
      'لا رسائل مزعجة أبداً. تقدر تلغي الاشتراك في أي وقت.',
    'Sources cited': 'مصادر مذكورة',
    'Latest data': 'أحدث البيانات',
    'Avg ROI': 'متوسط عائد الاستثمار',
    'Next Chapter': 'الفصل التالي',
    'Guide Complete': 'اكتمل الدليل',
    Previous: 'السابق',
    'Chapter 1': 'الفصل الأول',
    'The Current State of Things': 'وين وصلنا الآن',
    "AI in customer support has reached a turning point. Here's what that means for your team.":
      'الذكاء الاصطناعي في دعم العملاء وصل لنقطة تحول. وهذا ما يعنيه لفريقك.',
    'AI in customer support has gotten genuinely good. The technology has matured to the point where it can handle a meaningful portion of support requests—not just simple FAQs, but nuanced questions that require understanding context and taking actions.':
      'الذكاء الاصطناعي في دعم العملاء أصبح جيداً فعلاً. نضجت التقنية للحد اللي تقدر فيه تتعامل مع جزء كبير من طلبات الدعم - مو بس الأسئلة الشائعة البسيطة، بل الأسئلة الدقيقة اللي تتطلب فهم السياق واتخاذ إجراءات.',
    "Roughly 80% of companies have deployed some form of AI support, and 89% plan to by 2026. The market is projected to reach $74 billion by 2032. These aren't speculative numbers—this is happening now.":
      'تقريباً ٨٠٪ من الشركات نشرت شكل من أشكال دعم الذكاء الاصطناعي، و٨٩٪ تخطط لذلك بحلول عام ٢٠٢٦. ويُتوقع أن يصل حجم السوق إلى ٧٤ مليار دولار بحلول عام ٢٠٣٢. هذه مو أرقام تخمينية - هذا يصير الآن.',
    'What good looks like': 'وش يعني تطبيق ناجح',
    'The companies getting meaningful results from AI support share some common traits. They have decent documentation. They start with a focused scope. They keep humans involved for complex issues. And they think of AI as a tool to help their team, not replace it.':
      'الشركات اللي تحقق نتائج ملموسة من دعم الذكاء الاصطناعي تشترك في عدة صفات. عندها توثيق جيد. وتبدأ بنطاق محدد. وتُبقي البشر مشاركين في القضايا المعقدة. وتنظر للذكاء الاصطناعي كأداة تساعد فريقها، لا تستبدله.',
    'When it works well, the benefits are significant: faster response times, happier customers, and support teams that can focus on genuinely interesting problems instead of answering the same questions repeatedly.':
      'لمّا يشتغل الذكاء الاصطناعي جيداً، تكون الفوائد كبيرة: أوقات استجابة أسرع، وعملاء أسعد، وفرق دعم تركّز على مشاكل مثيرة للاهتمام فعلاً بدل الرد على نفس الأسئلة مراراً.',
    'The approach matters': 'الطريقة تفرق',
    "The technology works. But about 67% of implementations don't deliver the expected ROI in the first year. The difference between success and disappointment usually isn't the AI itself—it's how it's implemented.":
      'التقنية تشتغل. بس حوالي ٦٧٪ من التطبيقات ما تحقق عائد الاستثمار المتوقع في السنة الأولى. والفرق بين النجاح وخيبة الأمل عادة مو في الذكاء الاصطناعي نفسه - بل في طريقة تطبيقه.',
    "That's what this guide covers: the approach that works, the timeline to expect, and the mistakes to avoid.":
      'وهذا ما يغطيه الدليل: الطريقة اللي تنجح، الجدول الزمني المتوقع، والأخطاء اللي يجب أن تتجنبها.',
    "This guide will help you understand what's involved, plan an approach that fits your situation, and set realistic expectations for the journey.":
      'هذا الدليل يساعدك على فهم ما هو المطلوب، والتخطيط لطريقة تناسب وضعك، ووضع توقعات واقعية للرحلة.',
    'Chapter 2': 'الفصل الثاني',
    'Where to Start': 'من وين تبدأ',
    "In an ideal world, you'd build your support system from scratch with AI at the core. But that's rarely realistic.":
      'في عالم مثالي، تبني نظام الدعم عندك من الصفر والذكاء الاصطناعي في قلبه. بس هذا نادراً ما يكون واقعياً.',
    "Here's the situation most companies are in: you probably have an existing helpdesk—Zendesk, Intercom, Freshdesk, or something similar. Your team knows how to use it. Your workflows are built around it. You have years of customer data and conversation history there.":
      'هذا وضع معظم الشركات: غالباً عندك نظام دعم حالي - Zendesk أو Intercom أو Freshdesk أو شيء مشابه. فريقك يعرف كيف يستخدمه. وسير عملك مبني حوله. وعندك سنوات من بيانات العملاء وسجل المحادثات هناك.',
    'An AI-native solution would theoretically be better. When AI is at the center of the system rather than bolted on, it can do more. It understands context better. It can take actions more naturally. The experience is smoother for everyone.':
      'الحل المبني على الذكاء الاصطناعي من الأساس أفضل نظرياً. فلمّا يكون الذكاء الاصطناعي في قلب النظام لا مضافاً عليه، يقدر يعمل المزيد. يفهم السياق أفضل. ويتصرف بطريقة أقرب إلى الطبيعي. وتصبح التجربة أسلس للجميع.',
    'But switching to a completely new system is a massive undertaking. Most companies that try to do it all at once struggle. The migration takes longer than expected. Things break. The team is frustrated. Customers notice the disruption.':
      'بس الانتقال لنظام جديد كامل مهمة ضخمة. ومعظم الشركات اللي تحاول تنفيذها دفعة واحدة تتعثّر. النقل يستغرق وقتاً أطول من المتوقع. وأشياء تتعطل. والفريق يُحبط. والعملاء يلاحظون الاضطراب.',
    'A more realistic path': 'مسار أكثر واقعية',
    'What actually works for most companies is to start alongside your existing system. Find an AI tool that can work with your current helpdesk—connecting through APIs to handle conversations while keeping everything in one place.':
      'ما ينجح فعلاً مع معظم الشركات هو إنك تبدأ إلى جانب نظامك الحالي. ابحث عن أداة ذكاء اصطناعي تعمل مع نظام الدعم الحالي عندك - تتصل عبر واجهات API وتتعامل مع المحادثات ويبقى كل شيء في مكان واحد.',
    "This isn't the perfect end state. But it lets you learn what AI can do for your specific situation without betting everything on a big migration. You can see what works and what doesn't. Your team can adapt gradually.":
      'هذه مو الحالة النهائية المثالية. بس تتيح لك أن تتعلم وش يقدر الذكاء الاصطناعي يعمله لحالتك بدون ما تراهن بكل شيء على نقلة كبيرة. تقدر تشوف وش ينجح ووش ما ينجح. وفريقك يتأقلم بالتدريج.',
    "Then, once you understand what you actually need—not what you thought you'd need—you can make a more informed decision about whether to go deeper. Maybe you eventually move to a fully AI-native system. Maybe the hybrid approach turns out to be enough. Either way, you'll know based on real experience rather than speculation.":
      'بعد ذلك، لمّا تفهم وش تحتاجه فعلاً - مو اللي كنت تظن أنك ستحتاجه - تقدر تاخذ قرار أكثر دراسة بشأن المضي قدماً. قد تنتقل في النهاية لنظام كامل مبني على الذكاء الاصطناعي. وقد يتبيّن أن الطريقة الهجينة كافية. في الحالتين، ستعرف بناءً على تجربة حقيقية لا على تكهنات.',
    'What to look for': 'وش تدوّر عليه',
    "If you're evaluating AI tools, look for ones that offer this kind of gradual path. Can it work alongside your existing system? Can you start with just a portion of your tickets and expand from there? Is there a path to deeper integration if you want it later?":
      'إذا كنت تقيّم أدوات ذكاء اصطناعي، ابحث عن اللي تمنحك مساراً تدريجياً مثل هذا. هل تشتغل إلى جانب نظامك الحالي؟ تقدر تبدأ بجزء بسيط من التذاكر ثم توسّع؟ فيه مسار لتكامل أعمق إذا أردته لاحقاً؟',
    "Be skeptical of vendors who insist you need to replace everything immediately. That approach might make sense eventually, but it's usually not the right first step.":
      'كن حذراً من الموردين اللي يصرّون على أن تستبدل كل شيء فوراً. قد تكون هذه الطريقة منطقية في النهاية، بس عادة مو الخطوة الأولى الصحيحة.',
    "The goal isn't to find the theoretically perfect solution—it's to find a realistic path forward that you can actually execute without breaking things.":
      'الهدف مو إيجاد الحل المثالي نظرياً - بل إيجاد مسار واقعي تقدر تنفّذه فعلاً بدون ما تعطّل الأمور.',
    'Chapter 3': 'الفصل الثالث',
    'How to Actually Do This': 'كيف تسوّيها فعلياً',
    'Your timeline depends on one thing: how ready you are.':
      'جدولك الزمني يعتمد على شيء واحد: مستوى جاهزيتك.',
    "Here's something that might surprise you: if your company is AI-ready, you can genuinely go live in days or weeks. Not a watered-down version—actually handling real customer conversations and resolving tickets.":
      'شيء قد يفاجئك: إذا كانت شركتك جاهزة للذكاء الاصطناعي، تقدر فعلاً تبدأ خلال أيام أو أسابيع. ومو نسخة مخففة - بل تتعامل فعلاً مع محادثات العملاء الحقيقية وتحل التذاكر.',
    'The question isn\'t "how long does AI implementation take?" It\'s "how ready is your company?"':
      'السؤال مو "كم يستغرق تطبيق الذكاء الاصطناعي؟" بل "وش مستوى جاهزية شركتك؟"',
    'What AI-ready means': 'وش تعني الجاهزية للذكاء الاصطناعي',
    'Companies that can move fast typically have a few things in place:':
      'الشركات اللي تقدر تتحرك بسرعة عادة عندها عدة أمور جاهزة:',
    'A mainstream support stack.': 'نظام دعم أساسي ومعروف.',
    "Zendesk, Intercom, Freshdesk, HubSpot—the standard platforms. Modern AI tools integrate with these out of the box. If you're on something custom or unusual, that adds time.":
      'Zendesk وIntercom وFreshdesk وHubSpot - المنصات القياسية. أدوات الذكاء الاصطناعي الحديثة تتكامل معها جاهزة. إذا كنت على شيء مخصص أو غير معتاد، هذا ياخذ وقت زيادة.',
    'Decent documentation.': 'توثيق جيد.',
    "You don't need perfect docs, but you need something. Help articles, FAQs, product guides. AI learns from this. If your knowledge base is empty or badly outdated, that needs to be fixed first.":
      'ما تحتاج توثيقاً مثالياً، بس تحتاج شي. مقالات مساعدة، وأسئلة شائعة، وأدلة منتجات. الذكاء الاصطناعي يتعلم من هذا. وإذا كانت قاعدة معرفتك فارغة أو قديمة جداً، فلا بد من إصلاحها أولاً.',
    'Clear actions.': 'إجراءات واضحة.',
    'What should the AI actually be able to do? Answer questions? Reset passwords? Check order status? Process refunds? The clearer you are on this, the faster you can move.':
      'وش المفترض يعمله الذكاء الاصطناعي فعلاً؟ الرد على الأسئلة؟ إعادة تعيين كلمات المرور؟ التحقق من حالة الطلب؟ معالجة المستردات؟ كلما كانت الصورة أوضح عندك، تحركت أسرع.',
    "If you're ready": 'إذا أنت جاهز',
    "If you have these basics in place, implementation can be fast. Connect your helpdesk, point AI at your docs, define what it should handle, and you're live. You can start with a portion of traffic to build confidence, then expand.":
      'إذا كانت هذه الأساسيات متوفرة عندك، يصبح التطبيق سريعاً. اربط نظام الدعم، ووجّه الذكاء الاصطناعي لوثائقك، وحدد ما يتعامل معه، وتكون جاهزاً. وتقدر تبدأ بجزء من حركة المحادثات لبناء الثقة، ثم التوسع.',
    'If you need prep work': 'إذا تحتاج تحضير',
    "If your docs are sparse or outdated, spend time on that first. AI is only as good as what it knows. This isn't a blocker—it's just work that needs to happen. Some companies do this in a week, some take a month. Depends on your starting point.":
      'إذا كانت وثائقك قليلة أو قديمة، فخصص لها وقتاً أولاً. فالذكاء الاصطناعي جيد بقدر ما يعرف. وهذا مو عائق - بل عمل لا بد من إنجازه. بعض الشركات تنجزه في أسبوع، وبعضها يستغرق شهراً. يعتمد على نقطة البداية.',
    "After you're live": 'بعد البدء الفعلي',
    "Going live isn't the end—it's the beginning. You'll learn what works and what needs adjustment. Customer questions evolve. Your product changes. Good implementations include ongoing attention: reviewing what the AI handles, updating knowledge, expanding scope.":
      'الإطلاق الفعلي مو النهاية - بل هو البداية. ستتعلم وش ينجح ووش يحتاج تعديلاً. أسئلة العملاء تتطور. ومنتجك يتغير. والتطبيقات الجيدة تتضمن اهتماماً مستمراً: تراجع ما يتعامل معه الذكاء الاصطناعي، وتحدّث المعرفة، وتوسّع النطاق.',
    "The timeline isn't fixed. Ready companies go live in weeks. Others need prep time. Either way, the goal is getting to value—not following an arbitrary schedule.":
      'الجدول الزمني مو ثابت. الشركات الجاهزة تبدأ خلال أسابيع. وغيرها يحتاج وقت تحضير. في الحالتين، الهدف الوصول إلى القيمة - لا اتباع جدول عشوائي.',
    'Chapter 4': 'الفصل الرابع',
    'What Goes Wrong': 'وش يحدث من أخطاء',
    "Learning from the 67% of implementations that don't work out.":
      'دروس من الـ٦٧٪ من التطبيقات اللي ما نجحت.',
    "When AI projects fail, it's rarely because the AI technology itself was bad. Usually it's the implementation—the decisions around how to roll it out and what to expect.":
      'لمّا تفشل مشاريع الذكاء الاصطناعي، نادراً ما يكون السبب أن التقنية نفسها سيئة. عادة السبب هو التطبيق - القرارات حول كيفية طرحه وما تتوقعه منه.',
    'Launching before being ready': 'الإطلاق قبل ما تجهز',
    "The most common issue: launching AI without the foundations in place. No documentation for the AI to learn from. No clear definition of what it should handle. No plan for what happens when it can't answer something.":
      'المشكلة الأكثر شيوعاً: إطلاق الذكاء الاصطناعي بدون أساسات جاهزة. لا يوجد توثيق يتعلم منه. ولا تعريف واضح لما يتعامل معه. ولا خطة لحين عجزه عن الإجابة.',
    "Speed isn't the problem—lack of readiness is. Companies that are ready can go live quickly and see great results. Companies that skip the basics struggle regardless of timeline.":
      'السرعة مو المشكلة - نقص الجاهزية هو المشكلة. الشركات الجاهزة تقدر تبدأ بسرعة وتشوف نتائج رائعة. أما الشركات اللي تتجاهل الأساسيات فتتعثّر بغض النظر عن الجدول الزمني.',
    'Bad documentation': 'توثيق سيئ',
    "AI learns from your knowledge base. If your documentation is outdated, incomplete, or poorly organized, the AI will give bad answers. It's not smart enough to know that the information it learned is wrong.":
      'الذكاء الاصطناعي يتعلم من قاعدة معرفتك. وإذا كان توثيقك قديماً أو ناقصاً أو سيئ التنظيم، فسيعطي إجابات سيئة. وهو مو ذكي بما يكفي عشان يعرف أن المعلومات اللي تعلمها خاطئة.',
    'This is fixable, but you have to actually do the work. Most companies underestimate how much effort it takes to get documentation AI-ready.':
      'هذا قابل للإصلاح، بس لا بد من إنجاز العمل فعلاً. ومعظم الشركات تستهين بالجهد اللي يتطلبه تجهيز التوثيق للذكاء الاصطناعي.',
    'Ignoring the team': 'تجاهل الفريق',
    "Support agents often see AI as a threat to their jobs. If you don't involve them in the process, they'll be skeptical at best and actively hostile at worst. They'll find reasons why the AI doesn't work, because they're looking for them.":
      'غالباً ما يرى موظفو الدعم الذكاء الاصطناعي تهديداً لوظائفهم. وإذا ما أشركتهم في العملية، سيكونون متشككين في أفضل الأحوال ومعادين في أسوئها. وسيجدون أسباباً تثبت أن الذكاء الاصطناعي ما يشتغل، لأنهم يبحثون عنها.',
    'The good implementations treat AI as something that helps agents do their jobs better, not something that replaces them.':
      'التطبيقات الجيدة تتعامل مع الذكاء الاصطناعي كأداة تساعد الموظفين على أداء عملهم بشكل أفضل، لا كبديل عنهم.',
    'Automating too much': 'الأتمتة المفرطة',
    "There's a temptation to automate everything. But some situations—frustrated customers, complex problems, sensitive issues—actually need a human. Companies that try to handle these with AI usually make things worse.":
      'فيه إغراء بأتمتة كل شيء. بس بعض المواقف - العملاء المحبطون، والمشاكل المعقدة، والقضايا الحساسة - تحتاج فعلاً إنسان. والشركات اللي تحاول التعامل معها بالذكاء الاصطناعي عادة تزيد الأمور سوءاً.',
    'Set it and forget it': 'الإعداد ثم النسيان',
    'AI isn\'t a one-time project. It needs ongoing attention. Customer questions change. Products change. New edge cases come up. Companies that treat AI as "done" after the initial rollout are often surprised when it stops working well six months later.':
      'الذكاء الاصطناعي مو مشروع لمرة وحدة. بل يحتاج اهتماماً مستمراً. أسئلة العملاء تتغير. والمنتجات تتغير. وتظهر حالات استثنائية جديدة. والشركات اللي تتعامل معه كأنه "انتهى" بعد أول طرح غالباً تُفاجأ لمّا يتوقف عن العمل بكفاءة بعد ستة أشهر.',
    "Most of these mistakes come from treating AI implementation like buying software. It's not. It's more like hiring a new team member who needs training and oversight.":
      'معظم هذه الأخطاء تأتي من التعامل مع تطبيق الذكاء الاصطناعي كأنه شراء برنامج. وهو مو كذلك. بل أقرب إلى تعيين عضو فريق جديد يحتاج تدريباً وإشرافاً.',
    'Chapter 5': 'الفصل الخامس',
    'What to Expect': 'وش تتوقع',
    'Honest expectations about timeline and results.':
      'توقعات صادقة عن الجدول الزمني والنتائج.',
    "You'll see various ROI claims in the AI industry—350%, 400%, sometimes higher. These numbers are real, but they're also cherry-picked from the best cases. Not everyone gets these results.":
      'سترى ادعاءات كثيرة عن عائد الاستثمار في مجال الذكاء الاصطناعي - ٣٥٠٪، ٤٠٠٪، وأحياناً أعلى. هذه الأرقام حقيقية، بس منتقاة بعناية من أفضل الحالات. ومو كل واحد يوصلها.',
    'What you can realistically expect depends a lot on your specific situation: how good your documentation is, how complex your product is, what kinds of questions customers ask, how well you execute the implementation.':
      'اللي تتوقعه واقعياً يعتمد كثيراً على وضعك: مستوى توثيقك، وتعقيد منتجك، ونوع الأسئلة اللي يسألها العملاء، وجودة تنفيذك.',
    'The first few months': 'الأشهر الأولى',
    "Early on, you're mostly learning. The AI will handle some simple stuff—password resets, basic questions, order status. Your team will spend time monitoring what works and fixing what doesn't. You might see some efficiency gains, but this period is more about building a foundation.":
      'في البداية، ستكون في مرحلة تعلّم غالباً. الذكاء الاصطناعي يتعامل مع أشياء بسيطة - إعادة تعيين كلمات المرور، والأسئلة الأساسية، وحالة الطلب. وفريقك يقضي وقتاً في مراقبة وش ينجح وإصلاح وش ما ينجح. قد تشوف بعض مكاسب الكفاءة، بس هذه الفترة أكثرها بناء أساس.',
    'Getting to useful': 'لمّا يصير مفيداً فعلاً',
    'Around 3-6 months in, if things are going well, the AI starts becoming genuinely useful. It handles a meaningful chunk of tickets on its own. Your team has more time for complex problems. Response times improve. Customer satisfaction often goes up because people get faster answers.':
      'بعد ٣-٦ أشهر تقريباً، إذا سارت الأمور جيداً، يبدأ الذكاء الاصطناعي في أن يصبح مفيداً فعلاً. يتعامل مع جزء كبير من التذاكر بمفرده. ويصبح عند فريقك وقت أكثر للمشاكل المعقدة. وتتحسن أوقات الاستجابة. وغالباً يرتفع رضا العملاء لأن الناس يحصلون على رد أسرع.',
    'The longer term': 'على المدى الطويل',
    "Companies that do this well often end up automating 50-70% of routine inquiries. The economics can be compelling—it costs much less for AI to answer a simple question than for a person to. But the bigger benefit is often qualitative: your support team can focus on work that's actually interesting, customers get help faster, and you can offer support that would have been too expensive otherwise (like 24/7 coverage).":
      'الشركات اللي تنفّذ هذا جيداً غالباً تنتهي بأتمتة ٥٠-٧٠٪ من الاستفسارات الروتينية. والجدوى الاقتصادية قد تكون مقنعة - تكلفة رد الذكاء الاصطناعي على سؤال بسيط أقل بكثير من رد شخص. بس الفائدة الأكبر غالباً نوعية: فريق الدعم يركّز على عمل مثير للاهتمام فعلاً، والعملاء يحصلون على مساعدة أسرع، وتقدر تقدّم دعم كان سيكون مكلفاً جداً لولا ذلك (مثل التغطية ٢٤/٧).',
    'Results vary depending on your situation. Some companies see dramatic improvements. Others find it helpful but not transformative. The best approach is to start small, see what you learn, and make decisions based on actual results rather than projections.':
      'النتائج تختلف حسب وضعك. بعض الشركات ترى تحسينات جذرية. وغيرها تجدها مفيدة بس مو تحويلية. وأفضل طريقة أن تبدأ صغيراً، وتشوف وش تتعلمه، وتتخذ قراراتك بناءً على النتائج الفعلية لا التوقعات.',
    'Chapter 6': 'الفصل السادس',
    'Where to Go From Here': 'وش الخطوة الجاية',
    'Some practical next steps, depending on where you are.':
      'خطوات عملية تالية، حسب موقعك الحالي.',
    "If you're still deciding": 'إذا ما قررت بعد',
    'Start by understanding your current situation better. What are the most common questions your support team answers? How good is your documentation? How much time does your team spend on repetitive vs. complex issues?':
      'ابدأ بفهم وضعك الحالي بشكل أفضل. وش أكثر الأسئلة اللي يجيب عليها فريق الدعم؟ وش مستوى توثيقك؟ كم من الوقت يقضي فريقك في المشاكل المتكررة مقابل المعقدة؟',
    "We have a readiness assessment that can help you think through this, and a calculator to help estimate what the impact might look like. These aren't meant to convince you—they're meant to help you think through whether this makes sense for your specific situation.":
      'عندنا تقييم جاهزية يساعدك على التفكير في هذا الموضوع، وحاسبة تساعدك على تقدير شكل التأثير المتوقع. وهذه الأدوات مو لإقناعك - بل لمساعدتك على تقييم ما إذا كان هذا منطقياً لحالتك.',
    'If you want to learn more': 'إذا أردت أن تعرف أكثر',
    "Talk to companies that have done this. Ask them what worked and what didn't. Case studies from vendors only show the successes, so try to find people who will share the full picture.":
      'تحدّث مع شركات نفّذت هذا. اسألهم وش نجح ووش ما نجح. دراسات الحالة من الموردين تُظهر بس النجاحات، فحاول أن تجد أشخاصاً يشاركونك الصورة كاملة.',
    "If you want to talk to us, we're happy to answer questions even if you're not sure Open is right for you. We'd rather help you make the right decision than push you into something that doesn't fit.":
      'إذا أردت التحدث معنا، يسعدنا الإجابة على أسئلتك حتى لو ما كنت متأكداً أن Open مناسب لك. نفضّل أن نساعدك على اتخاذ القرار الصحيح بدل ما ندفعك لشي ما يناسبك.',
    "If you're ready to try": 'إذا أنت جاهز تجرّب',
    'Look for a solution that lets you start small. Can you run it alongside your existing system? Can you start with just one channel or one type of question? Is there a way to test without making a big commitment?':
      'ابحث عن حل يتيح لك البدء صغيراً. تقدر تشغّله إلى جانب نظامك الحالي؟ تقدر تبدأ بقناة واحدة بس أو نوع واحد من الأسئلة؟ فيه طريقة للتجربة بدون التزام كبير؟',
    'We built Open with this in mind—it works alongside Zendesk, Intercom, and other helpdesks, and you can start with a small pilot before expanding. But there are other options too. The right choice depends on your specific situation.':
      'بنينا Open وهذا في بالنا - يشتغل إلى جانب Zendesk وIntercom وأنظمة الدعم الأخرى، وتقدر تبدأ بتجربة صغيرة قبل التوسع. بس فيه خيارات أخرى أيضاً. والخيار الصحيح يعتمد على وضعك.',
    "If you want to explore whether Open might be a good fit, you're welcome to schedule a conversation. We'll try to be helpful regardless of whether you end up using our product.":
      'إذا أردت استكشاف ما إذا كان Open يناسبك، يسعدنا أن تحجز مكالمة. سنحاول أن نكون مفيدين بغض النظر عمّا إذا انتهى بك الأمر إلى استخدام منتجنا أم لا.',
    'Thanks for reading. We hope this was useful.':
      'شكراً لك على القراءة. نتمنى إنه كان مفيد.',
    'What ticketing system do you use?': 'وش نظام التذاكر اللي تستخدمه؟',
    'Select your current helpdesk or ticketing platform.':
      'اختر نظام الدعم أو منصة التذاكر الحالية عندك.',
    'What channels do you want to automate?': 'وش القنوات اللي تبي تأتمتها؟',
    'Select all that apply.': 'اختر كل ما ينطبق.',
    'What type of interactions?': 'وش نوع التفاعلات؟',
    'Are these customer-initiated or company-initiated?':
      'هل هذه التفاعلات تبدأ من العميل أم من الشركة؟',
    'How many interactions per month?': 'كم عدد التفاعلات شهرياً؟',
    'Total tickets, conversations, or calls across all channels.':
      'إجمالي التذاكر أو المحادثات أو المكالمات عبر كل القنوات.',
    'Tell us about your support team': 'أخبرنا عن فريق الدعم عندك',
    'This helps us calculate your potential savings.':
      'هذا يساعدنا على حساب التوفير المحتمل عندك.',
    'Number of support employees': 'عدد موظفي الدعم',
    employees: 'موظف',
    'Annual cost per employee': 'التكلفة السنوية لكل موظف',
    'Support team size': 'حجم فريق الدعم',
    'Remaining staff needed': 'الموظفون المتبقّون المطلوبون',
    'You could save': 'تقدر توفّر',
    'Your personalized savings': 'توفيرك المخصص',
    'Your results': 'نتائجك',
    'You are already doing great!': 'شغلك ممتاز أصلاً',
    'Open might not be a fit for you right now.':
      'قد لا يكون Open مناسباً لك الآن.',
    'Your current setup is already cost-efficient! We recommend sticking with what works. Come back when you scale and need to handle more volume.':
      'إعدادك الحالي فعّال من ناحية التكلفة. ننصحك بالاستمرار على اللي ينجح. وارجع لنا لمّا تتوسع وتحتاج للتعامل مع حجم أكبر.',
    'Annual cost': 'التكلفة السنوية',
    'Tickets automated/year': 'التذاكر المؤتمتة سنوياً',
    'Save even more with Open Helpdesk': 'وفّر أكثر مع Open Helpdesk',
    'pay per resolution, not per agent': 'ادفع مقابل كل حل، لا مقابل كل موظف',
    'See the exact math behind this calculation':
      'شوف الحسبة بالضبط وراء هذا التقدير',
    'Calculation Breakdown': 'تفاصيل الحساب',
    'Step 1: Your Inputs': 'الخطوة ١: مدخلاتك',
    'Step 2: Automation Rate Calculation': 'الخطوة ٢: حساب معدل الأتمتة',
    'Step 3: Your Current Monthly Cost': 'الخطوة ٣: تكلفتك الشهرية الحالية',
    'Step 4: Cost with Open': 'الخطوة ٤: التكلفة مع Open',
    'Step 5: Your Savings': 'الخطوة ٥: توفيرك',
    'Get started now': 'ابدأ الآن',
    'Start over': 'ابدأ من جديد',
    Continue: 'تابع',
    'See my savings': 'شوف توفيري',
    'of 5': 'من ٥',
    'interactions per month': 'تفاعل شهرياً',
    Today: 'اليوم',
    'With Open': 'مع Open',
    'Per resolution': 'لكل حل',
    'Automated tickets': 'التذاكر المؤتمتة',
    'Human-handled tickets': 'التذاكر اللي يعالجها البشر',
    'Total with Open': 'الإجمالي مع Open',
    'Monthly savings': 'التوفير الشهري',
    'Annual savings': 'التوفير السنوي',
    'In-App Chat': 'دردشة داخل التطبيق',
    'A mix of inbound and outbound': 'مزيج من التفاعلات الواردة والصادرة',
    'Customers reaching out to you': 'عملاء يتواصلون معك',
    'You reaching out to customers': 'أنت تتواصل مع العملاء',
    'North America': 'أمريكا الشمالية',
    'Automation rates based on 2024 industry data. Priced at $0.90 per resolution — the top of the published $0.75-$0.90 range, so the saving shown is the conservative one. Calculation assumes proportional staff reduction with automation.':
      'معدلات الأتمتة بناءً على بيانات المجال لعام ٢٠٢٤. الحساب على ٣ ⃁ للحل الواحد، وهو أعلى المدى المنشور (٢-٣ ⃁)، فالتوفير المعروض هو الأقل تقديراً. ويفترض تقليل عدد الموظفين بالتناسب مع الأتمتة.',
    'Include all support requests across all channels.':
      'اشمل كل طلبات الدعم عبر كل القنوات.',
    'Benchmark:': 'المعيار:',
    'Agents typically handle 20-40 tickets/day for mixed channels, up to 80/day for email-only.':
      'الموظفون عادة يتعاملون مع ٢٠-٤٠ تذكرة يومياً للقنوات المختلطة، وحتى ٨٠ للإيميل بس.',
    "What's your primary support channel?": 'وش قناة الدعم الأساسية عندك؟',
    'Different channels have different productivity rates.':
      'القنوات المختلفة عندها معدلات إنتاجية مختلفة.',
    'Industry & operating hours': 'المجال وساعات العمل',
    'Handle time varies by industry complexity.':
      'وقت المعالجة يختلف حسب تعقيد المجال.',
    'Your Industry': 'مجالك',
    'Operating Hours': 'ساعات العمل',
    'AHT Benchmarks:': 'معايير وقت المعالجة:',
    'E-commerce 4-6 min, Healthcare 6-8 min, Telecom 8-10 min.':
      'التجارة الإلكترونية ٤-٦ دقائق، الصحة ٦-٨ دقائق، الاتصالات ٨-١٠ دقائق.',
    "What's your target response time?": 'وش وقت الرد المستهدف عندك؟',
    'Faster SLAs require more agents to maintain coverage.':
      'كل ما كان الـ SLA أسرع، احتجت موظفين أكثر للحفاظ على التغطية.',
    'Utilization:': 'الاستخدام:',
    'Optimal agent utilization is 70-85%. Above 90% leads to burnout.':
      'الاستخدام الأمثل للموظفين ٧٠-٨٥٪. فوق الـ٩٠٪ يؤدي للإرهاق.',
    'You need approximately': 'تحتاج تقريباً',
    'support agents': 'موظف دعم',
    'Including 18% buffer for PTO, sick days, and training':
      'يشمل ١٨٪ احتياطي للإجازات والمرض والتدريب',
    'With AI Automation': 'مع الأتمتة بالـ AI',
    'With 70% of tickets automated by AI, you would only need:':
      'مع أتمتة ٧٠٪ من التذاكر بالـ AI، ما تحتاج سوى:',
    'Save {count} headcount': 'توفير {count} من الموظفين',
    'Daily tickets (÷ 22 working days)': 'التذاكر اليومية (÷ ٢٢ يوم عمل)',
    'Tickets/agent/day ({label})': 'تذكرة/موظف/يوم ({label})',
    'Utilization rate (optimal)': 'معدل الاستخدام (الأمثل)',
    'AHT adjustment ({label})': 'تعديل وقت المعالجة ({label})',
    'Coverage adjustment ({label})': 'تعديل التغطية ({label})',
    'SLA adjustment ({label})': 'تعديل الـ SLA ({label})',
    'Buffer for PTO/sick/training': 'احتياطي إجازات/مرض/تدريب',
    'Final team size': 'حجم الفريق النهائي',
    'Calculate cost savings with AI': 'احسب التوفير مع الـ AI',
    'Get a personalized demo': 'احصل على عرض توضيحي مخصص',
    'Calculate team size': 'احسب حجم الفريق',
    'Research:': 'الأبحاث:',
    'Phone agents handle 40-60 calls/day, chat agents 50-80/day, email agents 40-80/day.':
      'موظفو الهاتف يتعاملون مع ٤٠-٦٠ مكالمة يومياً، موظفو الدردشة ٥٠-٨٠، وموظفو الإيميل ٤٠-٨٠.',
    'How many support tickets do you handle monthly?':
      'كم تذكرة دعم تتعامل معها شهرياً؟',
    'This helps us understand the scale of your support operations.':
      'هذا يساعدنا على فهم حجم عمليات الدعم عندك.',
    'Under 1,000': 'أقل من ١ ٠٠٠',
    '1,000 - 5,000': '١ ٠٠٠ - ٥ ٠٠٠',
    '5,000 - 20,000': '٥ ٠٠٠ - ٢٠ ٠٠٠',
    '20,000 - 50,000': '٢٠ ٠٠٠ - ٥٠ ٠٠٠',
    'Over 50,000': 'أكثر من ٥٠ ٠٠٠',
    'How mature is your knowledge base?': 'ما مدى نضج قاعدة المعرفة عندك؟',
    'AI learns from your documentation to provide accurate answers.':
      'الـ AI يتعلم من توثيقك عشان يعطي إجابات دقيقة.',
    'No documentation': 'لا يوجد توثيق',
    'We rely on tribal knowledge': 'نعتمد على المعرفة الشفهية المتوارثة',
    'Basic FAQs': 'أسئلة شائعة أساسية',
    'Simple FAQ page or help articles':
      'صفحة أسئلة شائعة بسيطة أو مقالات مساعدة',
    'Moderate documentation': 'توثيق متوسط',
    'Help center with categorized articles': 'مركز مساعدة مع مقالات مصنفة',
    'Comprehensive knowledge base': 'قاعدة معرفة شاملة',
    'Well-organized docs covering most topics':
      'وثائق منظمة جيداً تغطي معظم المواضيع',
    'Extensive & up-to-date': 'شاملة ومحدثة باستمرار',
    'Regularly updated with internal + external docs':
      'محدّثة بانتظام بوثائق داخلية وخارجية',
    'What systems do you currently use?': 'وش الأنظمة اللي تستخدمها حالياً؟',
    'Select all that apply. More integrations = more AI capabilities.':
      'اختر كل ما ينطبق. المزيد من التكاملات يعني قدرات AI أكبر.',
    'Helpdesk/Ticketing': 'نظام الدعم / التذاكر',
    'CRM System': 'نظام CRM',
    'E-commerce Platform': 'منصة تجارة إلكترونية',
    'Payment Processor': 'معالج مدفوعات',
    'Analytics Tools': 'أدوات تحليلية',
    'Communication Tools': 'أدوات تواصل',
    'Which support channels do you offer?': 'وش قنوات الدعم اللي تقدمها؟',
    'Select all channels where customers can reach you.':
      'اختر كل القنوات اللي يقدر العملاء يوصلونك عبرها.',
    'How large is your support team?': 'كم حجم فريق الدعم عندك؟',
    'This helps us understand your operational scale.':
      'هذا يساعدنا على فهم حجم عملياتك.',
    '1-2 people': 'شخص أو شخصان',
    'Small team wearing many hats': 'فريق صغير يتولى كل شيء',
    '3-10 people': '٣-١٠ أشخاص',
    'Dedicated support team': 'فريق دعم متخصص',
    '11-50 people': '١١-٥٠ شخصاً',
    'Structured support department': 'قسم دعم مهيكل',
    '50+ people': 'أكثر من ٥٠ شخصاً',
    'Large support organization': 'منظمة دعم كبيرة',
    "What's your current automation level?": 'وش مستوى الأتمتة الحالي عندك؟',
    'This helps us identify your automation opportunity.':
      'هذا يساعدنا على تحديد فرص الأتمتة عندك.',
    'No automation': 'لا توجد أتمتة',
    'Everything is handled manually': 'كل شيء يدوي',
    'Basic automation': 'أتمتة أساسية',
    'Auto-replies, canned responses': 'ردود تلقائية، ردود جاهزة',
    'Some automation': 'أتمتة جزئية',
    'Chatbots for simple queries': 'روبوتات دردشة للاستفسارات البسيطة',
    'Advanced automation': 'أتمتة متقدمة',
    'AI-powered but limited capabilities': 'مدعوم بالـ AI بس بقدرات محدودة',
    'Your AI Readiness Score': 'درجة جاهزيتك للـ AI',
    'Assessment Complete': 'اكتمل التقييم',
    'AI Ready': 'جاهز للـ AI',
    Excellent: 'ممتاز',
    Good: 'جيد',
    Moderate: 'متوسط',
    'Needs Preparation': 'يحتاج تحضير',
    "You're highly ready for AI support!": 'أنت جاهز لدعم الـ AI',
    'Your infrastructure, documentation, and scale make you an ideal candidate. You could see ROI within weeks.':
      'بنيتك التحتية وتوثيقك وحجم عملياتك تجعلك مرشحاً مثالياً. وقد ترى عائد الاستثمار خلال أسابيع.',
    "You're well-positioned for AI support.": 'أنت في وضع زين لدعم AI.',
    "With a few improvements, you'll maximize your automation potential. Let's discuss your roadmap.":
      'مع بعض التحسينات، ستعظّم إمكانات الأتمتة عندك. دعنا نناقش خارطة طريقك.',
    'You have a solid foundation.': 'عندك أساس متين.',
    'Some areas need attention before going live, but AI can still drive significant value.':
      'فيه جوانب تحتاج اهتماماً قبل الإطلاق، بس الـ AI لا يزال يقدم قيمة كبيرة.',
    "Let's build your foundation together.": 'خل نبني أساسك مع بعض.',
    "We'll help you prepare your documentation and systems for AI success.":
      'بنساعدك تجهّز توثيقك وأنظمتك لنجاح AI.',
    'Detailed Breakdown': 'تفصيل دقيق',
    'Ticket Volume': 'حجم التذاكر',
    'Knowledge Base': 'قاعدة المعرفة',
    Integrations: 'التكاملات',
    'Channel Coverage': 'تغطية القنوات',
    'Team Scale': 'حجم الفريق',
    'Automation Opportunity': 'فرص الأتمتة',
    'Great volume for AI ROI. You will see significant savings.':
      'حجم تذاكر رائع لعائد استثمار AI. بتشوف توفير ملحوظ.',
    'AI can still help, but ROI builds as you scale.':
      'لا يزال الـ AI قادراً على المساعدة، بس عائد الاستثمار يزيد مع توسعك.',
    'Good foundation for AI training.': 'أساس جيد لتدريب AI.',
    'Consider building documentation—AI learns from your content.':
      'فكّر في بناء التوثيق - الـ AI يتعلم من محتواك.',
    'Well-connected stack. AI can take real actions.':
      'بيئة تقنية متصلة زين. الـ AI يقدر ياخذ إجراءات فعلية.',
    'More integrations = more AI capabilities.':
      'مزيد من التكاملات = قدرات AI أكثر.',
    'Multi-channel presence. AI can unify your support.':
      'تواجد عبر قنوات متعددة. الـ AI يقدر يوحّد دعمك.',
    'Consider expanding channels—AI handles them all.':
      'فكر في توسيع القنوات - الـ AI يتعامل معها جميعاً.',
    'Team can focus on complex issues while AI handles routine.':
      'الفريق يقدر يركّز على القضايا المعقدة بينما الـ AI يتعامل مع الروتيني.',
    'AI can be your force multiplier.': 'الـ AI يضاعف قوة فريقك.',
    'High opportunity! Lots of room to automate.':
      'فرصة كبيرة. فيه مجال واسع للأتمتة.',
    'You have some automation. AI can take it further.':
      'عندك بعض الأتمتة. والـ AI يقدر ياخذها لأبعد.',
    "Ready to see what's possible?": 'جاهز تشوف وش ممكن يحدث؟',
    'Based on your assessment, we estimate you could automate':
      'بناءً على تقييمك، نقدّر إنك تقدر تأتمت',
    "of your support tickets with Open. Let's run the numbers together.":
      'من تذاكر الدعم عندك مع Open. دعنا نحسب الأرقام معاً.',
    'Calculate your ROI': 'احسب عائد استثمارك',
    'See my results': 'شوف نتائجي',
    'of 6': 'من ٦',
  },
  legal: {
    // Legal & Compliance directory (/legal)
    'Legal & Compliance': 'الشؤون القانونية والامتثال',
    'Everything about how we handle your data, privacy, and security. Transparent policies you can trust.':
      'كل ما يخص طريقة تعاملنا مع بياناتك وخصوصيتها وأمنها. سياسات شفافة يمكنك الوثوق بها.',
    'How Open meets EU data protection requirements with enterprise-grade safeguards.':
      'كيف تلبّي Open متطلبات حماية البيانات في الاتحاد الأوروبي عبر ضمانات بمستوى المؤسسات.',
    Subprocessors: 'المعالجون الفرعيون',
    'Standard Terms': 'الشروط القياسية',
    'The Cloud Service Standard Terms that apply to every Open agreement, with version history.':
      'الشروط القياسية لخدمة Open السحابية التي تنطبق على كل اتفاقية، مع سجل الإصدارات. (متوفرة بالإنجليزية)',
    'SLA Standard Terms': 'الشروط القياسية لاتفاقية مستوى الخدمة',
    'Uptime, service credits and remedies that apply to every Open agreement, with version history.':
      'نسبة التشغيل وأرصدة الخدمة وسبل المعالجة المطبقة على كل اتفاقية مع Open، مع سجل الإصدارات. (متوفرة بالإنجليزية)',
    'DPA Standard Terms': 'الشروط القياسية لاتفاقية معالجة البيانات',
    'The Data Processing Agreement Standard Terms that apply to every Open DPA, with version history.':
      'الشروط القياسية لاتفاقية معالجة البيانات التي تنطبق على كل اتفاقية معالجة بيانات مع Open، مع سجل الإصدارات. (متوفرة بالإنجليزية)',
    'DPA Annexes': 'ملاحق اتفاقية معالجة البيانات',
    'Processing details and technical and organizational security measures for every Open DPA.':
      'تفاصيل المعالجة والتدابير الأمنية التقنية والتنظيمية لكل اتفاقية معالجة بيانات مع Open. (متوفرة بالإنجليزية)',
    'Price List': 'قائمة الأسعار',
    'Every Open product and how it is charged, with upcoming changes.':
      'جميع منتجات Open وطريقة احتساب كل منها، مع التغييرات القادمة. (متوفرة بالإنجليزية)',
    'Incentive Campaign Terms': 'شروط الحملات الترويجية',
    'The rules for Open promotional campaigns, credits, and referral offers.':
      'قواعد حملات Open الترويجية والأرصدة وعروض الإحالة.',
    'The third-party services we use to deliver Open, and how they handle your data.':
      'خدمات الأطراف الخارجية التي نستخدمها لتقديم Open، وكيفية تعاملها مع بياناتك.',
    'How we collect, use, and protect your personal information.':
      'كيف نجمع بياناتك الشخصية ونستخدمها ونحميها.',
    'The terms and conditions for using the Open platform.':
      'الشروط والأحكام الخاصة باستخدام منصة Open.',
    'Cookie Policy': 'سياسة ملفات تعريف الارتباط',
    'The cookies and trackers we use, what they do, and how to control them.':
      'ملفات تعريف الارتباط وأدوات التتبّع التي نستخدمها، وما تفعله، وكيف تتحكم بها.',
    'GDPR Compliance': 'الامتثال للائحة العامة لحماية البيانات (GDPR)',
    'Open is built for European data protection standards. Your data stays in Europe, encrypted and secure.':
      'Open مبنية وفق معايير حماية البيانات الأوروبية. بياناتك تبقى في أوروبا، مشفّرة وآمنة.',
    'Where Your Data Lives': 'أين تُحفظ بياناتك',
    'Infrastructure - Frankfurt': 'البنية التحتية - فرانكفورت',
    'Our primary cloud infrastructure and data storage is hosted in Frankfurt, Germany. All customer data, conversations, and analytics remain within EU borders.':
      'تتم استضافة بنيتنا التحتية السحابية الأساسية وتخزين البيانات في فرانكفورت، ألمانيا. تظل جميع بيانات العملاء والمحادثات والتحليلات داخل حدود الاتحاد الأوروبي.',
    'AI Models - Sweden': 'نماذج الذكاء الاصطناعي - السويد',
    'Our AI language models are deployed and run from Sweden, ensuring that all AI processing happens within the European Union with full GDPR compliance.':
      'تُنشر نماذجنا اللغوية للذكاء الاصطناعي وتُشغَّل من السويد، بما يضمن إجراء جميع عمليات معالجة الذكاء الاصطناعي داخل الاتحاد الأوروبي بامتثال كامل لـ GDPR.',
    'Data Security': 'أمن البيانات',
    'Encryption in Transit': 'التشفير أثناء النقل',
    'All data transmitted to and from Open is encrypted using TLS 1.3. Every API call, webhook, and user interaction is secured end-to-end.':
      'جميع البيانات المنقولة إلى Open ومنها مشفّرة باستخدام TLS 1.3. وكل استدعاء API أو webhook أو تفاعل من المستخدم مؤمَّن من طرف إلى طرف.',
    'Encryption at Rest': 'التشفير في حالة السكون',
    'Sensitive data including customer information, conversation logs, and authentication credentials are encrypted at rest using AES-256 encryption.':
      'تُشفَّر البيانات الحساسة، بما فيها معلومات العملاء وسجلات المحادثات وبيانات الاعتماد، باستخدام تشفير AES-256 في حالة السكون.',
    'Your GDPR Rights': 'حقوقك بموجب GDPR',
    'Right to access': 'الحق في الوصول',
    'Request a copy of your personal data we hold':
      'طلب نسخة من بياناتك الشخصية التي نحتفظ بها',
    'Right to rectification': 'الحق في التصحيح',
    'Correct inaccurate or incomplete data':
      'تصحيح البيانات غير الدقيقة أو غير الكاملة',
    'Right to erasure': 'الحق في المحو (الحق في النسيان)',
    'Request deletion of your personal data': 'طلب حذف بياناتك الشخصية',
    'Right to data portability': 'الحق في نقل البيانات',
    'Export your data in a machine-readable format':
      'تصدير بياناتك بتنسيق قابل للقراءة آلياً',
    'Right to restrict processing': 'الحق في تقييد المعالجة',
    'Limit how we use your personal data':
      'الحد من كيفية استخدامنا لبياناتك الشخصية',
    'Right to object': 'الحق في الاعتراض',
    'Object to processing of your personal data':
      'الاعتراض على معالجة بياناتك الشخصية',
    'Rights related to automated decision-making':
      'الحقوق المتعلقة باتخاذ القرار الآلي',
    'Not be subject to decisions based solely on automated processing':
      'عدم الخضوع لقرارات مبنية حصراً على المعالجة الآلية',
    'Security & Trust Center': 'مركز الأمن والثقة',
    'For detailed information about our security practices, certifications, and compliance documentation, visit our Trust Center.':
      'لمعلومات مفصّلة عن ممارساتنا الأمنية وشهاداتنا ووثائق الامتثال، زُر مركز الثقة لدينا.',
    'Visit Trust Center': 'زيارة مركز الثقة',
    'Questions about GDPR?': 'أسئلة حول GDPR؟',
    'If you have any questions about how we handle your data or want to exercise your GDPR rights, contact us at':
      'إذا كانت لديك أي أسئلة حول طريقة تعاملنا مع بياناتك أو أردت ممارسة حقوقك بموجب GDPR، فتواصل معنا على',
    'Privacy Policy': 'سياسة الخصوصية',
    'Terms of Service': 'شروط الخدمة',
    'Last updated:': 'آخر تحديث:',
    '1. Information We Collect': '١. المعلومات التي نجمعها',
    'We may collect personal details like your name, email address, phone number, and payment information to process transactions, provide customer support, and offer personalized experiences.':
      'قد نجمع معلومات شخصية مثل اسمك وإيميلك ورقم هاتفك ومعلومات الدفع من أجل معالجة المعاملات وتقديم دعم العملاء وتوفير تجارب مخصصة.',
    'We automatically gather data on how you interact with our services, including your IP address, device type, operating system, browser type, and site navigation.':
      'نجمع تلقائياً بيانات عن طريقة تفاعلك مع خدماتنا، منها عنوان IP ونوع الجهاز ونظام التشغيل ونوع المتصفح وتنقّلك في الموقع.',
    'We use cookies and similar technologies to enhance your experience, remember preferences, and analyze site traffic. You can manage cookie settings through your browser.':
      'نستخدم ملفات تعريف الارتباط (cookies) وتقنيات مشابهة لتحسين تجربتك وتذكّر تفضيلاتك وتحليل حركة الزيارات على الموقع. ويمكنك التحكم في إعدادات ملفات تعريف الارتباط عبر متصفحك.',
    '2. How We Use Your Information': '٢. كيف نستخدم معلوماتك',
    'Data enables us to complete transactions, authenticate users, and deliver our services as expected.':
      'تُمكّننا البيانات من إتمام المعاملات، والتحقق من هوية المستخدمين، وتقديم خدماتنا على النحو المتوقع.',
    'We may use your contact information to inform you about account updates, service changes, and promotional offers. You can opt out of marketing messages at any time.':
      'قد نستخدم معلومات التواصل الخاصة بك لإبلاغك بتحديثات الحساب وتغييرات الخدمة والعروض الترويجية. ويمكنك إلغاء اشتراكك في الرسائل التسويقية في أي وقت.',
    'Information on user behaviour and preferences helps us improve functionality, troubleshoot issues, and personalize content.':
      'تساعدنا المعلومات المتعلقة بسلوك المستخدم وتفضيلاته على تحسين الوظائف، واستكشاف الأخطاء وإصلاحها، وتخصيص المحتوى.',
    'We may process data to comply with legal obligations, enforce agreements, or prevent fraud.':
      'قد نعالج البيانات للامتثال للالتزامات القانونية أو إنفاذ الاتفاقيات أو منع الاحتيال.',
    '3. Sharing Your Information': '٣. مشاركة معلوماتك',
    'Third-party vendors assist us with payment processing, hosting, analytics, and customer support. They only have access to information necessary for their tasks and are contractually obligated to keep it confidential.':
      'يساعدنا مزوّدو خدمات خارجيون في معالجة المدفوعات والاستضافة والتحليلات ودعم العملاء. ولا يمكنهم الوصول إلا إلى المعلومات الضرورية لأداء مهامهم، وهم ملزمون تعاقدياً بالحفاظ على سرّيتها.',
    'With your consent, we may share data with trusted partners for co-marketing efforts or joint promotions.':
      'بموافقتك، قد نشارك البيانات مع شركاء موثوقين لجهود التسويق المشترك أو العروض الترويجية المشتركة.',
    'We may share information if required by law, legal proceedings, or to protect the rights and safety of OpenChat, Inc and users.':
      'قد نشارك المعلومات إذا كان ذلك مطلوباً بموجب القانون أو الإجراءات القانونية، أو لحماية حقوق وسلامة شركة OpenChat, Inc والمستخدمين.',
    '4. Your Data Rights': '٤. حقوقك في بياناتك',
    'You can review and correct your personal data by logging into your account or contacting us directly.':
      'يمكنك مراجعة بياناتك الشخصية وتصحيحها عن طريق تسجيل الدخول إلى حسابك أو التواصل معنا مباشرة.',
    'In certain circumstances, you may request data deletion, subject to applicable legal retention requirements.':
      'في ظروف معينة، يمكنك طلب حذف البيانات، مع مراعاة متطلبات الاحتفاظ القانونية المعمول بها.',
    'You may request a copy of your data in a commonly used format for transfer to another service.':
      'يمكنك طلب نسخة من بياناتك بتنسيق شائع الاستخدام لنقلها إلى خدمة أخرى.',
    'You may object to or restrict certain data processing activities where we rely on legitimate interests.':
      'يمكنك الاعتراض على أنشطة معالجة بيانات معينة أو تقييدها في الحالات التي نعتمد فيها على المصالح المشروعة.',
    'To opt out, click "unsubscribe" in promotional emails or update your account preferences.':
      'لإلغاء الاشتراك، اضغط على "إلغاء الاشتراك" في رسائل الإيميل الترويجية أو حدّث تفضيلات حسابك.',
    '5. Your Data Security': '٥. أمن بياناتك',
    'We employ appropriate security measures to protect your data from unauthorized access, alteration, or disclosure. However, no security system is fully impenetrable, so we recommend being cautious when sharing information online.':
      'نستخدم تدابير أمنية مناسبة لحماية بياناتك من الوصول غير المصرح به أو التعديل أو الإفصاح. ومع ذلك، لا يوجد نظام أمني منيع تماماً، لذا نوصي بالحذر عند مشاركة المعلومات عبر الإنترنت.',
    '6. Data Retention': '٦. الاحتفاظ بالبيانات',
    'We retain your data only for as long as necessary to fulfill the purposes outlined in this policy, comply with legal requirements, or resolve disputes.':
      'نحتفظ ببياناتك للمدة اللازمة فقط لتحقيق الأغراض الموضحة في هذه السياسة أو الامتثال للمتطلبات القانونية أو حل النزاعات.',
    "7. Children's Privacy": '٧. خصوصية الأطفال',
    'Our services are intended for users over the age of 13. We do not knowingly collect personal data from children. If you believe a child has provided us with information, please contact us to remove it.':
      'خدماتنا مخصصة للمستخدمين الذين تزيد أعمارهم عن ١٣ سنة. ولا نجمع عن قصد بيانات شخصية من الأطفال. وإذا كنت تعتقد أن طفلاً قد زوّدنا بمعلومات، فتواصل معنا لحذفها.',
    '8. International Data Transfers': '٨. نقل البيانات دولياً',
    "If your data is transferred outside of your home country, we take appropriate safeguards, such as standard contractual clauses, to ensure it's protected in line with local regulations.":
      'إذا نُقلت بياناتك خارج بلدك، فإننا نتخذ الضمانات المناسبة، مثل البنود التعاقدية القياسية، لضمان حمايتها بما يتماشى مع اللوائح المحلية.',
    '9. Policy Changes': '٩. تغييرات السياسة',
    'We may update this Privacy Policy to reflect changes in our practices or legal obligations. Revisions will be posted with an updated effective date.':
      'قد نحدّث سياسة الخصوصية هذه لتعكس التغييرات في ممارساتنا أو التزاماتنا القانونية. وستُنشر المراجعات مع تاريخ سريان محدَّث.',
    '10. Contact Us': '١٠. اتصل بنا',
    'If you have questions, concerns, or requests related to this Privacy Policy, please reach out to us:':
      'إذا كانت لديك أسئلة أو مخاوف أو طلبات تتعلق بسياسة الخصوصية هذه، فتواصل معنا:',
    'Email:': 'الإيميل:',
    '1. Acceptance of Terms': '١. قبول الشروط',
    'By accessing our website and using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. If you do not agree to any part of these terms, you must not use our services.':
      'بدخولك إلى موقعنا واستخدام خدماتنا، فإنك تقر بأنك قرأت هذه الشروط والأحكام وفهمتها وتوافق على الالتزام بها. وإذا لم توافق على أي جزء منها، فلا تستخدم خدماتنا.',
    '2. Definitions': '٢. التعريفات',
    'Service:': 'الخدمة:',
    'refers to all services provided by Open, including the website, software, features, tools, and applications.':
      'تشير إلى كل الخدمات التي تقدمها "أوبن"، بما فيها الموقع الإلكتروني والبرمجيات والميزات والأدوات والتطبيقات.',
    'User:': 'المستخدم:',
    'refers to any individual or entity that accesses or uses our services.':
      'يشير إلى أي فرد أو كيان يدخل إلى خدماتنا أو يستخدمها.',
    'Account:': 'الحساب:',
    "refers to the user's personal account created to access our services.":
      'يشير إلى الحساب الشخصي الذي ينشئه المستخدم للوصول إلى خدماتنا.',
    '3. Eligibility': '٣. الأهلية',
    'To use Open, you must be at least 18 years old or have parental consent if you are a minor. By using our service, you represent and warrant that you meet these eligibility requirements.':
      'لاستخدام Open، يجب أن يكون عمرك ١٨ سنة على الأقل، أو أن تحصل على موافقة الوالدين إذا كنت قاصراً. وباستخدامك لخدمتنا، فإنك تقر وتضمن أنك تستوفي متطلبات الأهلية هذه.',
    '4. User Accounts': '٤. حسابات المستخدمين',
    '4.1 Account Creation': '٤.١ إنشاء الحساب',
    'To access certain features of our services, you must create an account. When creating an account, you agree to provide accurate, current, and complete information and to update your information to keep it accurate, current, and complete.':
      'للوصول إلى بعض ميزات خدماتنا، يجب أن تنشئ حساباً. وعند إنشاء الحساب، فإنك توافق على تقديم معلومات دقيقة وحديثة وكاملة، وعلى تحديثها لتبقى دقيقة وحديثة وكاملة.',
    '4.2 Account Security': '٤.٢ أمن الحساب',
    'You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account or any other breach of security.':
      'أنت مسؤول عن الحفاظ على سرية بيانات اعتماد حسابك وعن كل الأنشطة التي تجري من خلال حسابك. وتوافق على إخطارنا فوراً بأي استخدام غير مصرح به لحسابك أو أي خرق أمني آخر.',
    '4.3 Account Termination': '٤.٣ إنهاء الحساب',
    'We reserve the right to suspend or terminate your account at our sole discretion, without notice, for conduct that we believe violates these Terms or is harmful to other users or our business interests.':
      'نحتفظ بالحق في تعليق حسابك أو إنهائه وفقاً لتقديرنا الخاص، دون إشعار، بسبب سلوك نعتقد أنه ينتهك هذه الشروط أو يضر بالمستخدمين الآخرين أو بمصالحنا التجارية.',
    '5. User Conduct': '٥. سلوك المستخدم',
    'You agree not to use the service for any unlawful purpose or to solicit others to perform or participate in any unlawful acts. You agree to abide by all applicable laws and regulations and to comply with the following restrictions:':
      'توافق على عدم استخدام الخدمة لأي غرض غير قانوني، أو حثّ الآخرين على القيام بأي أعمال غير قانونية أو المشاركة فيها. وتوافق على الالتزام بجميع القوانين واللوائح المعمول بها والامتثال للقيود التالية:',
    'Do not use the service in any manner that could damage, disable, overburden, or impair the service.':
      'عدم استخدام الخدمة بأي طريقة قد تؤدي إلى إتلافها أو تعطيلها أو تحميلها فوق طاقتها أو إضعافها.',
    'Do not engage in any form of data mining, robots, or similar data gathering or extraction methods.':
      'عدم الانخراط في أي شكل من أشكال التنقيب عن البيانات أو استخدام الروبوتات أو الأساليب المماثلة لجمع البيانات أو استخراجها.',
    'Do not interfere with or circumvent any security features of the service.':
      'عدم التدخل في أي ميزات أمنية للخدمة أو الالتفاف عليها.',
    '6. Intellectual Property Rights': '٦. حقوق الملكية الفكرية',
    '6.1 Ownership': '٦.١ الملكية',
    'All content, features, and functionality on the Open platform, including but not limited to text, graphics, logos, software, and code, are the exclusive property of Open and are protected by intellectual property laws.':
      'كل المحتويات والميزات والوظائف الموجودة على منصة "أوبن"، بما في ذلك على سبيل المثال لا الحصر النصوص والرسومات والشعارات والبرمجيات والكود، هي ملكية حصرية لشركة "أوبن" ومحمية بقوانين الملكية الفكرية.',
    '6.2 License to Use': '٦.٢ ترخيص الاستخدام',
    'OpenChat, Inc grants you a limited, non-exclusive, non-transferable license to access and use the service for personal or business purposes. You may not reproduce, distribute, modify, or create derivative works based on the service without our express written consent.':
      'تمنحك شركة OpenChat, Inc ترخيصاً محدوداً وغير حصري وغير قابل للنقل للوصول إلى الخدمة واستخدامها للأغراض الشخصية أو التجارية. لا يجوز لك إعادة إنتاج الخدمة أو توزيعها أو تعديلها أو إنشاء أعمال مشتقة بناءً عليها دون موافقة خطية صريحة منا.',
    '7. Payment Terms': '٧. شروط الدفع',
    '7.1 Pricing': '٧.١ التسعير',
    'Access to certain features of Open may require payment. The pricing for our plans is outlined on our Pricing page. We reserve the right to change our pricing at any time, with notice to users.':
      'قد يتطلب الوصول إلى ميزات معينة في "أوبن" دفع رسوم. وأسعار خططنا موضّحة في صفحة الأسعار. ونحتفظ بالحق في تغيير أسعارنا في أي وقت، مع إخطار المستخدمين.',
    '7.2 Payment Methods': '٧.٢ طرق الدفع',
    'Payments can be made using the payment methods specified on our website. By providing your payment information, you represent and warrant that you are authorized to use that payment method.':
      'يمكن إجراء المدفوعات باستخدام طرق الدفع المحددة في موقعنا. وبتقديمك معلومات الدفع الخاصة بك، فإنك تقر وتضمن أنك مخوَّل باستخدام طريقة الدفع تلك.',
    '7.3 Refund Policy': '٧.٣ سياسة الاسترداد',
    'All fees paid are non-refundable unless otherwise stated. Please refer to our Refund Policy for more details.':
      'جميع الرسوم المدفوعة غير قابلة للاسترداد ما لم يُنص على خلاف ذلك. ويرجى الرجوع إلى سياسة الاسترداد الخاصة بنا لمزيد من التفاصيل.',
    '8. Third-Party Links and Services': '٨. روابط وخدمات الأطراف الثالثة',
    'Our service may contain links to third-party websites or services that are not owned or controlled by Open. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services. You acknowledge and agree that Open shall not be liable for any damages or losses caused or alleged to be caused by the use of any such content, goods, or services available on or through any such websites or services.':
      'قد تحتوي خدمتنا على روابط لمواقع أو خدمات تابعة لأطراف ثالثة لا تملكها "أوبن" ولا تسيطر عليها. ولا سيطرة لنا على المحتوى أو سياسات الخصوصية أو الممارسات الخاصة بأي مواقع أو خدمات تابعة لأطراف ثالثة، ولا نتحمل أي مسؤولية عنها. وأنت تقر وتوافق على أن "أوبن" لن تكون مسؤولة عن أي أضرار أو خسائر ناجمة أو يُزعم أنها ناجمة عن استخدام أي من هذا المحتوى أو السلع أو الخدمات المتاحة في أي من هذه المواقع أو الخدمات أو من خلالها.',
    '9. Disclaimers': '٩. إخلاء المسؤولية',
    'The service is provided on an "as is" and "as available" basis. Open makes no representations or warranties of any kind, express or implied, regarding the operation of the service or the information, content, materials, or products included on the service. You agree that your use of the service is at your own risk.':
      'تُقدَّم الخدمة على أساس "كما هي" و"كما تتوفر". ولا تقدم "أوبن" أي إقرارات أو ضمانات من أي نوع، صريحة أو ضمنية، فيما يتعلق بتشغيل الخدمة أو بالمعلومات أو المحتوى أو المواد أو المنتجات المدرجة فيها. وتوافق على أن استخدامك للخدمة يكون على مسؤوليتك الخاصة.',
    '10. Limitation of Liability': '١٠. تحديد المسؤولية',
    'In no event shall Open, its directors, employees, partners, agents, suppliers, or affiliates be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of (or inability to access or use) the service; (ii) any conduct or content of any third party on the service; (iii) any content obtained from the service; and (iv) unauthorized access, use, or alteration of your transmissions or content.':
      'لا تتحمل "أوبن" أو مديروها أو موظفوها أو شركاؤها أو وكلاؤها أو موردوها أو الشركات التابعة لها، في أي حال من الأحوال، المسؤولية عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو تأديبية، بما في ذلك على سبيل المثال لا الحصر فقدان الأرباح أو البيانات أو الاستخدام أو السمعة الطيبة أو غيرها من الخسائر غير الملموسة، الناتجة عن (١) وصولك إلى الخدمة أو استخدامها (أو عدم قدرتك على الوصول إليها أو استخدامها)؛ (٢) أي سلوك أو محتوى لأي طرف ثالث في الخدمة؛ (٣) أي محتوى تم الحصول عليه من الخدمة؛ و(٤) الوصول غير المصرح به إلى عمليات الإرسال أو المحتوى الخاص بك أو استخدامها أو تغييرها.',
    '11. Indemnification': '١١. التعويض',
    "You agree to indemnify, defend, and hold harmless Open, its affiliates, officers, directors, employees, agents, and licensors from and against any claims, liabilities, damages, losses, costs, or expenses (including reasonable attorney's fees) arising out of or in any way connected with your use of the service, your violation of these Terms, or your infringement of any intellectual property or other rights of any person or entity.":
      'توافق على تعويض "أوبن" والشركات التابعة لها ومسؤوليها ومديريها وموظفيها ووكلائها ومرخِّصيها والدفاع عنهم وحمايتهم من أي مطالبات أو التزامات أو أضرار أو خسائر أو تكاليف أو مصاريف (بما في ذلك أتعاب المحاماة المعقولة) تنشأ عن استخدامك للخدمة أو ترتبط به بأي شكل من الأشكال، أو عن انتهاكك لهذه الشروط، أو انتهاكك لأي حقوق ملكية فكرية أو حقوق أخرى لأي شخص أو كيان.',
    '12. Changes to These Terms': '١٢. التغييرات في هذه الشروط',
    'We may revise these Terms from time to time at our sole discretion. We will notify you of any changes by posting the new Terms on this page with a new effective date. Your continued use of the service after any changes to the Terms constitutes acceptance of those changes.':
      'قد نراجع هذه الشروط من وقت لآخر وفقاً لتقديرنا الخاص. وسنخطرك بأي تغييرات عبر نشر الشروط الجديدة في هذه الصفحة مع تاريخ سريان جديد. ويُعدّ استمرارك في استخدام الخدمة بعد أي تغييرات في الشروط قبولاً لهذه التغييرات.',
    '13. Governing Law': '١٣. القانون الحاكم',
    'These Terms shall be governed by and construed in accordance with the laws of Delaware, without regard to its conflict of law principles. Any legal action or proceeding arising under these Terms shall be brought exclusively in the courts located in Delaware, and you consent to the jurisdiction of such courts.':
      'تخضع هذه الشروط لقوانين ولاية ديلاوير وتُفسَّر وفقاً لها، بصرف النظر عن مبادئ تنازع القوانين. وتُرفع أي دعوى أو إجراء قانوني ينشأ بموجب هذه الشروط أمام المحاكم الواقعة في ولاية ديلاوير حصراً، وأنت توافق على الاختصاص القضائي لهذه المحاكم.',
    '14. DPA & List of Subprocessors':
      '١٤. اتفاقية معالجة البيانات وقائمة المعالجين الفرعيين',
    'Please email': 'يرجى مراسلتنا عبر الإيميل',
    '15. Contact Us': '١٥. اتصل بنا',
    '16. SMS Messaging Program': '١٦. برنامج الرسائل النصية القصيرة',
    'Open operates text messaging programs for users who expressly subscribe to them. You subscribe by sending the keyword START to the number published for the program, or by providing your mobile number to us and agreeing to receive text messages about the request you have opened. We send only the messages described when you subscribed. We do not send promotional or marketing text messages under these programs.':
      'تُشغّل Open برامج رسائل نصية للمستخدمين الذين يشتركون فيها صراحةً. ويتم الاشتراك بإرسال كلمة START إلى الرقم المنشور للبرنامج، أو بتزويدنا برقم هاتفك الجوال والموافقة على استقبال رسائل نصية بخصوص الطلب الذي فتحته. ولا نرسل سوى الرسائل الموضّحة عند اشتراكك، ولا نرسل رسائل ترويجية أو تسويقية ضمن هذه البرامج.',
    'Message frequency varies and depends on your activity, typically fewer than five messages per request. Message and data rates may apply. Carriers are not liable for delayed or undelivered messages.':
      'يختلف عدد الرسائل بحسب نشاطك، وعادةً يكون أقل من خمس رسائل لكل طلب. وقد تُطبَّق رسوم الرسائل والبيانات. ولا تتحمّل شركات الاتصالات مسؤولية تأخّر الرسائل أو عدم تسليمها.',
    'You can cancel at any time by replying STOP to any message, after which we send one confirmation and no further messages. Reply HELP to any message for assistance, or contact us at the address below.':
      'يمكنك الإلغاء في أي وقت بالردّ بكلمة STOP على أي رسالة، وعندها نرسل رسالة تأكيد واحدة ولا نرسل أي رسائل بعدها. وللمساعدة، ردّ بكلمة HELP على أي رسالة أو تواصل معنا على العنوان أدناه.',
    'We do not share, sell, or provide your mobile phone number or messaging consent data to third parties or affiliates for marketing or promotional purposes. Consent to receive text messages is collected for each program directly and is never a condition of purchase.':
      'لا نشارك رقم هاتفك الجوال أو بيانات موافقتك على الرسائل ولا نبيعها ولا نتيحها لأي طرف ثالث أو شركة تابعة لأغراض التسويق أو الترويج. وتُجمع الموافقة على استقبال الرسائل النصية لكل برنامج على حدة، ولا تكون أبداً شرطاً للشراء.',
    'If you have any questions about these Terms and Conditions, please contact us at:':
      'إذا كانت لديك أي أسئلة حول هذه الشروط والأحكام، فتواصل معنا على:',
    'Effective Date:': 'تاريخ السريان:',
  },
  giftCardModal: {
    'Get a $50 Gift Card': 'هديتك ٥٠ دولار',
    'Schedule a personalized demo with our team and receive a $50 gift card as a thank you.':
      'احجز عرضاً توضيحياً مخصصاً لك مع فريقنا، واحصل على ٥٠ دولار هدية منّا.',
    'Work email': 'إيميل العمل',
    'you@company.com': 'you@company.com',
    'Scheduling...': 'جارٍ الحجز...',
    'Schedule Demo & Claim Gift Card': 'احجز العرض واستلم هديتك',
    'By submitting, you agree to our': 'بالإرسال، توافق على',
    'Incentive Campaign Terms': 'شروط العرض',
    "You're all set!": 'كل شيء جاهز',
    'Redirecting you to schedule your demo...':
      'نحوّلك الآن لحجز العرض التوضيحي...',
  },
  incentiveTerms: {
    'Incentive Campaign Terms': 'شروط حملة الحوافز',
    'These terms ("Terms") apply to the Open marketing incentive campaign described below (the "Offer"). By participating in the Offer, you agree to be bound by these Terms and Open\'s':
      'تنطبق هذه الشروط ("الشروط") على حملة Open التسويقية التحفيزية الموضحة أدناه ("العرض"). وبمشاركتك في العرض، فإنك توافق على الالتزام بهذه الشروط و',
    'This Offer is administered by Open ("Open," "we," or "us").':
      'يُدار هذا العرض من قِبَل Open ("Open" أو "نحن").',
    '1. Offer eligibility': '١. أهلية العرض',
    'To be eligible to receive the incentive described in these Terms (the "Reward"), you must meet all of the following conditions:':
      'لتكون مؤهلاً للحصول على الحافز الموضح في هذه الشروط ("المكافأة")، يجب أن تستوفي جميع الشروط التالية:',
    'New to Open:': 'جديد على Open:',
    "You must not be a current or former Open customer, have previously submitted your email to Open, or have previously engaged with Open's sales team.":
      'يجب ألا تكون عميلاً حالياً أو سابقاً لدى Open، وألا تكون قد أرسلت إيميلك إلى Open من قبل، وألا تكون قد تواصلت مع فريق مبيعات Open سابقاً.',
    'Session-based activity:': 'نشاط الجلسة:',
    'You must visit at least eight (8) unique pages on the Open website (https://www.open.cx) in a single browsing session.':
      'يجب أن تزور ثماني (٨) صفحات مختلفة على الأقل في موقع Open (https://www.open.cx) خلال جلسة تصفح واحدة.',
    'Session-defined eligibility:': 'أهلية الجلسة:',
    'Eligibility is triggered when you reach the eighth unique page during that session. If your session ends before reaching the eighth page, you will not qualify. Eligibility ends when your session ends (e.g., browser tab closed, session times out).':
      'تُفعَّل الأهلية عند وصولك إلى الصفحة الثامنة المختلفة خلال تلك الجلسة. وإذا انتهت جلستك قبل الوصول إلى الصفحة الثامنة، فلن تكون مؤهلاً. وتنتهي الأهلية بانتهاء الجلسة (مثل إغلاق تبويب المتصفح أو انتهاء مهلة الجلسة).',
    'Geography and role:': 'الموقع الجغرافي والدور:',
    'You must (i) be located in a jurisdiction where Open offers its services and (ii) be in a customer support, operations, or leadership role where you have influence over purchasing decisions for your organization.':
      'يجب أن (١) تكون في منطقة تقدم فيها Open خدماتها، و(٢) أن تشغل دوراً في دعم العملاء أو العمليات أو القيادة يكون لك فيه تأثير على قرارات الشراء في مؤسستك.',
    'Sales meeting:': 'اجتماع المبيعات:',
    'After reaching eligibility, you must complete a meeting with an Open sales representative to receive the Reward.':
      'بعد بلوغ الأهلية، يجب أن تُكمل اجتماعاً مع أحد ممثلي مبيعات Open للحصول على المكافأة.',
    'Identification:': 'تحديد الهوية:',
    'You must not browse anonymously (i.e., "non-revealed" users are not eligible).':
      'يجب ألا تتصفح بشكل مجهول (أي أن المستخدمين غير المعرَّفين غير مؤهلين).',
    'Open reserves the right to determine whether you meet the eligibility criteria and may disqualify individuals at its sole discretion.':
      'تحتفظ Open بالحق في تحديد ما إذا كنت تستوفي معايير الأهلية، وقد تستبعد أي مشارك حسب تقديرها.',
    '2. Reward fulfillment': '٢. تسليم المكافأة',
    'Eligible participants who complete all requirements will receive a $50 digital gift card issued by Open. This card may be used at major retailers including Amazon, Visa, and other participating merchants.':
      'سيحصل المشاركون المؤهلون الذين يستوفون جميع المتطلبات على بطاقة هدايا رقمية بقيمة ٥٠ دولار صادرة عن Open. ويمكن استخدام هذه البطاقة لدى كبار التجار، ومنهم Amazon وVisa وغيرهم من التجار المشاركين.',
    'Delivery:': 'التسليم:',
    "Rewards will be delivered by email to eligible participants through Open's gift card fulfillment system.":
      'تُسلَّم المكافآت إلى المشاركين المؤهلين عبر الإيميل من خلال نظام بطاقات الهدايا لدى Open.',
    'Timing:': 'التوقيت:',
    'Rewards for completed meetings will be issued within 5-7 business days of completing your demo.':
      'تُصدَر مكافآت الاجتماعات المكتملة خلال ٥-٧ أيام عمل من إتمام العرض التوضيحي.',
    'Redemption window:': 'فترة الاسترداد:',
    'You must claim your Reward within 30 days of receiving the email. Unclaimed cards will expire.':
      'يجب أن تطالب بمكافأتك خلال ٣٠ يوماً من استلام الإيميل. وتنتهي صلاحية البطاقات غير المطالَب بها.',
    'Card expiration:': 'انتهاء صلاحية البطاقة:',
    'Once issued, the gift card must be used within one (1) year.':
      'بمجرد إصدار بطاقة الهدايا، يجب استخدامها خلال سنة (١) واحدة.',
    'Tracking:': 'التتبع:',
    "Eligible leads are tracked using internal systems, including CRM tagging and campaign enrollment. Reward eligibility and fulfillment are coordinated by Open's Growth team.":
      'يُتتبَّع العملاء المحتملون المؤهلون عبر الأنظمة الداخلية، بما في ذلك وسم CRM والتسجيل في الحملة. ويتولّى فريق النمو في Open تنسيق أهلية المكافأة وتسليمها.',
    'Open is not responsible for late, lost, misdirected, or undelivered emails or for Rewards not received due to user error (including incorrect or inaccessible email addresses or failure to complete required actions).':
      'لا تتحمل Open المسؤولية عن رسائل الإيميل المتأخرة أو المفقودة أو الموجَّهة خطأً أو غير المُسلَّمة، ولا عن المكافآت غير المستلَمة بسبب خطأ المستخدم (بما في ذلك عناوين الإيميل غير الصحيحة أو التي يتعذر الوصول إليها، أو عدم إكمال الإجراءات المطلوبة).',
    '3. Restrictions': '٣. القيود',
    'Non-transferable:': 'غير قابلة للتحويل:',
    'Rewards are personal to the recipient and may not be sold, transferred, or assigned.':
      'المكافآت شخصية للمستلم ولا يجوز بيعها أو تحويلها أو التنازل عنها.',
    'No combination:': 'عدم الجمع:',
    'This Offer cannot be combined with any other Open offers, referral rewards, promotional campaigns, or discounts.':
      'لا يمكن الجمع بين هذا العرض وأي عروض أخرى من Open أو مكافآت الإحالة أو الحملات الترويجية أو الخصومات.',
    'One per participant:': 'واحدة لكل مشارك:',
    'Limit one Reward per eligible participant.':
      'الحد الأقصى مكافأة واحدة لكل مشارك مؤهل.',
    'Tax responsibility:': 'المسؤولية الضريبية:',
    'Rewards may be taxable. Participants are solely responsible for any applicable taxes and should consult their tax advisor.':
      'قد تكون المكافآت خاضعة للضريبة. والمشاركون وحدهم مسؤولون عن أي ضرائب واجبة التطبيق، ويجب عليهم استشارة مستشارهم الضريبي.',
    '4. Modifications and termination': '٤. التعديلات والإنهاء',
    'Open reserves the right to modify, suspend, or terminate this Offer at any time without notice and for any reason. Open also reserves the right to withhold or cancel the Reward in the event of actual or suspected fraud, misuse, or violation of these Terms or any applicable law.':
      'تحتفظ Open بالحق في تعديل هذا العرض أو تعليقه أو إنهائه في أي وقت دون إشعار ولأي سبب. كما تحتفظ Open بالحق في حجب المكافأة أو إلغائها في حالة الاحتيال الفعلي أو المشتبه به أو سوء الاستخدام أو انتهاك هذه الشروط أو أي قانون معمول به.',
    "This Offer is currently scheduled to run beginning December 30, 2025, and may end at any time at Open's discretion.":
      'من المقرر حالياً أن يبدأ هذا العرض في ٣٠ ديسمبر ٢٠٢٥، وقد ينتهي في أي وقت وفقاً لتقدير Open.',
    '5. Limitation of Liability': '٥. تحديد المسؤولية',
    "Open is not responsible for any errors, delays, or failures in the processing or administration of this offer. All rewards are subject to Open's review and may be withheld or forfeited if eligibility criteria are not met.":
      'لا تتحمل Open المسؤولية عن أي أخطاء أو تأخيرات أو إخفاقات في معالجة هذا العرض أو إدارته. وتخضع جميع المكافآت لمراجعة Open، وقد تُحجب أو تُصادَر إذا لم تُستوفَ معايير الأهلية.',
    '6. Contact Information': '٦. معلومات الاتصال',
    'For questions about this Offer or these Terms, please contact us at:':
      'لأي أسئلة بشأن هذا العرض أو هذه الشروط، يرجى التواصل معنا على:',
  },
  features_pages: {
    'Support Cost Benchmarking': 'معايير تكلفة الدعم',
    'Agentic Workflows': 'سير العمل الذكي',
    'Automate the unautomatable': 'أتمت ما لا يتأتمت',
    "Map and automate complex communication flows that traditional automation can't handle. Multi-party coordination, conditional logic, human-like behavior—executed at scale.":
      'ارسم وأتمت تدفقات التواصل المعقدة اللي ما تقدر الأتمتة التقليدية تتعامل معها. تنسيق بين أطراف متعددة، منطق شرطي، وسلوك يشبه البشر - كله ينفّذ على نطاق واسع.',
    'Workflow Capabilities': 'قدرات سير العمل',
    'Automate complex multi-party communication':
      'أتمت التواصل المعقد بين أطراف متعددة',
    'Automate Manual Communication': 'أتمت التواصل اليدوي',
    'Map and automate complex communication flows between parties without APIs. Just manual communication at scale.':
      'ارسم وأتمت تدفقات التواصل المعقدة بين الأطراف بدون APIs. مجرد تواصل يدوي على نطاق واسع.',
    'Phone → Email → Follow-up Chains': 'هاتف ← إيميل ← سلاسل متابعة',
    'Call multiple parties. When one responds positively, automatically send emails, schedule follow-ups, and coordinate next steps.':
      'اتصل بأطراف متعددة. وأول ما يرد واحد منهم بإيجابية، ترسل الإيميلات تلقائياً، وتجدول المتابعات، وتنسّق الخطوات التالية.',
    'Human Behavior at Scale': 'سلوك بشري على نطاق واسع',
    'One-to-one mapping of human communication patterns. Agentic workflows mimic how humans would handle complex scenarios.':
      'مطابقة واحد لواحد لأنماط التواصل البشري. سير العمل الذكي يحاكي كيف يتعامل البشر مع السيناريوهات المعقدة.',
    '15 Triggers, 25 Actions': '١٥ محفزاً، ٢٥ إجراءً',
    'Comprehensive trigger and action library. AI phone calling, outbound sequences, emails, WhatsApp, form submissions, CRM integration.':
      'مكتبة شاملة للمحفزات والإجراءات. مكالمات هاتفية بالـ AI، تسلسلات صادرة، إيميلات، WhatsApp، تعبئة نماذج، وتكامل مع CRM.',
    "Automate what can't be automated": 'أتمت ما لا يتأتمت',
    "Complex multi-party flows that traditional automation can't handle. Agentic workflows map human behavior patterns and execute them at scale.":
      'تدفقات معقدة بين أطراف متعددة، ما تقدر الأتمتة التقليدية تتعامل معها. سير العمل الذكي يرسم أنماط السلوك البشري وتنفّذها على نطاق واسع.',
    'Drag-and-Drop Builder': 'منشئ بالسحب والإفلات',
    'Visual workflow builder. No code required. Map complex multi-party communication flows with a simple interface.':
      'منشئ بصري لسير العمل. بدون كود. ارسم تدفقات تواصل معقدة بين أطراف متعددة بواجهة بسيطة.',
    '15 Triggers Available': '١٥ محفزاً متاحاً',
    'Form submissions, webhooks, CRM updates, time-based triggers, and more. Start workflows from any event.':
      'تعبئة نماذج، Webhooks، تحديثات CRM، محفزات قائمة على الوقت، وأكثر. ابدأ سير العمل من أي حدث.',
    '25 Actions to Execute': '٢٥ إجراءً للتنفيذ',
    'AI phone calls, outbound emails, WhatsApp messages, CRM updates, conditional logic, delays, and more.':
      'مكالمات هاتفية بالـ AI، إيميلات صادرة، رسائل WhatsApp، تحديثات CRM، منطق شرطي، تأخيرات، وأكثر.',
    'Multi-Party Orchestration': 'تنسيق بين أطراف متعددة',
    'Coordinate communication between multiple parties. Make calls, wait for responses, follow up automatically—mimicking human behavior at scale.':
      'نسّق التواصل بين أطراف متعددة. سوّ مكالمات، انتظر الردود، وتابع تلقائياً - محاكاةً للسلوك البشري على نطاق واسع.',
    'Conditional Logic & Branching': 'منطق شرطي وتفرع',
    'If/then logic based on responses. Branch workflows depending on what people say or do. Handle every scenario.':
      'منطق (إذا/ثم) بناءً على الردود. فرّع سير العمل حسب ما يقوله الناس أو يفعلونه. تعامل مع كل سيناريو.',
    'Comprehensive library of triggers and actions to build any workflow you can imagine.':
      'مكتبة شاملة من المحفزات والإجراءات لبناء أي سير عمل تتخيله.',
    'Available Triggers (15)': 'المحفزات المتاحة (١٥)',
    'Form Submissions': 'تعبئة النماذج',
    'WhatsApp Webhooks': 'Webhooks WhatsApp',
    'CRM Updates': 'تحديثات CRM',
    'Time-based Triggers': 'محفزات قائمة على الوقت',
    'Email Received': 'إيميل وارد',
    '+10 more triggers': '١٠ محفزات إضافية',
    'Available Actions (25)': 'الإجراءات المتاحة (٢٥)',
    'AI Phone Calling': 'مكالمات هاتفية بالـ AI',
    'Outbound Email Sequences': 'تسلسلات الإيميل الصادر',
    'WhatsApp Messages': 'رسائل WhatsApp',
    'CRM Integration': 'تكامل CRM',
    'Conditional Logic': 'منطق شرطي',
    'Wait for Response': 'انتظار الرد',
    'AI Decision Making': 'اتخاذ القرار بالـ AI',
    'Data Transformation': 'تحويل البيانات',
    '+17 more actions': '١٧ إجراءً إضافياً',
    'View All Triggers & Actions': 'عرض كل المحفزات والإجراءات',
    'Find answers to common questions about Agentic Workflows.':
      'إجابات للأسئلة الشائعة حول سير العمل الذكي.',
    'What makes Agentic Workflows different?': 'وش يميّز سير العمل الذكي؟',
    'Traditional automation requires APIs and structured data. Agentic workflows handle manual communication between parties—they understand responses, wait for replies, and adapt like humans do.':
      'الأتمتة التقليدية تحتاج APIs وبيانات منظمة. سير العمل الذكي يتعامل مع التواصل اليدوي بين الأطراف - تفهم الردود، تنتظر الجواب، وتتكيف كما يفعل البشر.',
    'Do I need to code to build workflows?': 'هل أحتاج لبرمجة لبناء سير العمل؟',
    'No. Drag-and-drop visual builder. Connect triggers to actions, set conditions, and map your flow visually.':
      'لا. منشئ بصري بالسحب والإفلات. اربط المحفزات بالإجراءات، واضبط الشروط، وارسم تدفقك بصرياً.',
    'Can workflows make phone calls?': 'هل يقدر سير العمل يجري مكالمات هاتفية؟',
    'Yes. AI phone calling is one of 25 available actions. Make calls, wait for responses, and follow up based on what was said.':
      'نعم. المكالمات الهاتفية بالـ AI واحدة من ٢٥ إجراء متاح. أجرِ مكالمات، انتظر الردود، وتابع حسب ما قيل.',
    'How do workflows handle multiple parties?':
      'كيف يتعامل سير العمل مع أطراف متعددة؟',
    'Workflows can coordinate communication between unlimited parties. Call person A, email person B, wait for C to respond, then trigger next steps based on all inputs.':
      'سير العمل يقدر ينسّق التواصل بين أطراف غير محدودة. اتصل بالشخص (أ)، راسل الشخص (ب)، انتظر رد الشخص (ج)، وبعدها فعّل الخطوات التالية بناءً على كل المدخلات.',
    'What triggers are available?': 'وش المحفزات المتاحة؟',
    'Form submissions, WhatsApp webhooks, CRM updates, time-based triggers, email received, chat messages, and 9 more trigger types.':
      'تعبئة النماذج، Webhooks WhatsApp، تحديثات CRM، محفزات قائمة على الوقت، إيميل وارد، رسائل دردشة، و٩ أنواع ثانية من المحفزات.',
    'Can workflows integrate with my CRM?':
      'هل يقدر سير العمل يتكامل مع CRM حقك؟',
    'Yes. Third-party CRM integration is supported as both a trigger and an action. Sync data, update records, and coordinate with your existing systems.':
      'نعم. التكامل مع أنظمة CRM الخارجية مدعوم كمحفز وكإجراء. زامن البيانات، حدّث السجلات، ونسّق مع أنظمتك الحالية.',
    'Every customer touch,': 'كل تواصل مع العميل،',
    'one unified voice': 'بصوت واحد',
    'Customer Insights analyzes every interaction across all channels and turns raw conversations into actionable insights. What your customers actually want, delivered to the right teams, automatically.':
      'رؤى العملاء تحلل كل تفاعل عبر كل القنوات وتحوّل المحادثات الخام لرؤى قابلة للتنفيذ. ما يريده عملاؤك فعلاً، يصل للفرق المناسبة، تلقائياً.',
    'Customer Insights Features': 'ميزات رؤى العملاء',
    'AI that understands what drives your support volume':
      'AI يفهم ما يحرّك حجم الدعم عندك',
    'Understands What Drives Support': 'يفهم ما يحرّك الدعم',
    "The AI agent analyzes every conversation to identify what's actually driving support requests, feature requests, and bug reports. Not just counting—understanding root causes.":
      'الوكيل الذكي يحلل كل محادثة عشان يحدد وش يحرّك فعلاً طلبات الدعم، وطلبات الميزات، وتقارير الأعطال. مو مجرد عدّ - بل فهم للأسباب الجذرية.',
    'Smart Clustering': 'تجميع ذكي',
    'AI clusters similar issues together. 50 conversations about the same bug become one actionable cluster. See patterns, not individual tickets.':
      'الـ AI يجمّع المشكلات المتشابهة معاً. ٥٠ محادثة عن نفس العطل تصير مجموعة وحدة قابلة للتنفيذ. شوف الأنماط، مو مجرد تذاكر فردية.',
    'Auto-Generated Jira Tickets': 'توليد تذاكر جيرا تلقائياً',
    'Deep research agent generates complete Jira tickets for your team. Full context, customer impact analysis, affected user count, and priority level—all automated.':
      'وكيل البحث العميق يولّد تذاكر جيرا كاملة لفريقك. سياق كامل، تحليل تأثير العملاء، عدد المستخدمين المتأثرين، ومستوى الأولوية - كله مؤتمت.',
    'Team Competition & Gamification': 'منافسة الفرق والتحفيز',
    "Teams compete to resolve insights. Leaderboards track who's solving the most impactful customer problems. Turn insights into team motivation.":
      'الفرق تتنافس على حل الرؤى. لوحات الصدارة تتبع من يحل أكثر مشاكل العملاء تأثيراً. حوّل الرؤى لدافع للفريق.',
    'From conversations to Jira tickets': 'من المحادثات إلى تذاكر جيرا',
    'AI agent understands root causes, clusters similar issues, and generates complete Jira tickets with customer impact analysis.':
      'الوكيل الذكي يفهم الأسباب الجذرية، يجمّع المشكلات المتشابهة، ويولّد تذاكر جيرا كاملة مع تحليل تأثير العملاء.',
    'Identifies Root Causes': 'تحديد الأسباب الجذرية',
    "AI agent understands what's actually driving your support volume. Not just symptoms—root causes. Is it a bug? Missing feature? Confusing UX? Poor documentation?":
      'الوكيل الذكي يفهم وش يحرّك فعلاً حجم الدعم عندك. مو بس الأعراض - بل الأسباب الجذرية. عطل؟ ميزة ناقصة؟ تجربة مستخدم مربكة؟ توثيق ضعيف؟',
    'Clusters Similar Issues': 'يجمّع المشكلات المتشابهة',
    'Groups similar support requests, feature asks, and bug reports together. 100 conversations about the same issue become one cluster with full context and customer count.':
      'يجمّع طلبات الدعم المتشابهة، وطلبات الميزات، وتقارير الأعطال مع بعض. ١٠٠ محادثة عن نفس المشكلة تصير مجموعة وحدة بسياق كامل وعدد العملاء.',
    'Generates Jira Tickets': 'توليد تذاكر جيرا',
    'Deep research agent creates complete Jira tickets automatically. Title, description, user impact analysis, affected customer count, reproduction steps, and priority—all generated from clustered conversations.':
      'وكيل البحث العميق ينشئ تذاكر جيرا كاملة تلقائياً. العنوان، الوصف، تحليل تأثير المستخدم، عدد العملاء المتأثرين، خطوات تكرار المشكلة، والأولوية - كلها مولّدة من المحادثات المجمّعة.',
    'Cross-Channel Analysis': 'تحليل عبر القنوات',
    'Analyzes support requests from Voice, Chat, Email, WhatsApp, Social, and Slack. See the same issue reported across different channels, clustered together.':
      'يحلل طلبات الدعم من الصوت، والدردشة، والإيميل، وWhatsApp، والسوشيال ميديا، وSlack. شوف نفس المشكلة مبلّغ عنها عبر قنوات مختلفة، مجمّعة مع بعض.',
    'Team Gamification': 'تحفيز الفريق',
    "Teams compete on leaderboards to resolve the most impactful insights. Track who's fixing the issues that affect the most customers. Turn problem-solving into motivation.":
      'الفرق تتنافس في لوحات الصدارة على حل الرؤى الأكثر تأثيراً. تابع مين يصلّح المشكلات اللي تؤثر على أكبر عدد من العملاء. حوّل حل المشكلات لدافع.',
    'API-First Customer Insights': 'رؤى العملاء — API أولاً',
    'Access insights programmatically. Build custom dashboards, integrate with your tools, automate actions.':
      'اوصل للرؤى برمجياً. ابنِ لوحات تحكم مخصصة، وتكامل مع أدواتك، وأتمت الإجراءات.',
    'Get Customer Insights': 'الحصول على رؤى العملاء',
    'Retrieve all customer insights with optional filtering':
      'استرجاع جميع رؤى العملاء مع تصفية اختيارية',
    'Get Specific Insight': 'الحصول على رؤية محددة',
    'Get detailed information about a specific insight':
      'الحصول على معلومات مفصلة حول رؤية محددة',
    'Mark as Resolved': 'تعليم كمحلولة',
    'Mark an insight as resolved when action is taken':
      'علّم الرؤية كمحلولة بعد ما تاخذ إجراء',
    'Assign to Team': 'تعيين لفريق',
    'Assign insight to a team member or group':
      'تعيين الرؤية لعضو فريق أو مجموعة',
    'View Insights API Docs': 'عرض وثائق API للرؤى',
    'Find answers to common questions about Customer Insights.':
      'إجابات للأسئلة الشائعة حول رؤى العملاء.',
    'What channels are analyzed for insights?': 'وش القنوات اللي نحللها للرؤى؟',
    'All of them. Voice, Chat, Email, WhatsApp, Social (Instagram & Messenger), and Slack. Every customer interaction across every channel.':
      'كلها. الصوت، والدردشة، والإيميل، وWhatsApp، والسوشيال ميديا (Instagram وMessenger)، وSlack. كل تفاعل للعملاء عبر كل قناة.',
    'How are insights presented?': 'كيف تُعرض الرؤى؟',
    'Plain language summaries that anyone can understand. No data science degree required. Just clear, actionable insights about customer needs.':
      'ملخصات بلغة بسيطة يفهمها أي شخص. ما تحتاج شهادة في علم البيانات. بس رؤى واضحة وقابلة للتنفيذ حول احتياجات العملاء.',
    'What is the deep research agent?': 'ما هو وكيل البحث العميق؟',
    'One-click deep dive into any insight. See all conversations that contributed to it, understand the context, and analyze customer pain points in detail.':
      'تعمّق بنقرة وحدة في أي رؤية. شوف كل المحادثات اللي ساهمت فيها، افهم السياق، وحلل نقاط ألم العملاء بالتفصيل.',
    'How does auto-assignment work?': 'كيف يعمل التعيين التلقائي؟',
    'Insights are automatically assigned to relevant teams based on topic. Engineering gets technical issues, product gets feature requests, support gets service problems.':
      'الرؤى تتعيّن تلقائياً للفرق ذات الصلة حسب الموضوع. الهندسة تاخذ المشاكل الفنية، والمنتج طلبات الميزات، والدعم مشاكل الخدمة.',
    'What are weekly impact reminders?': 'ما هي تذكيرات التأثير الأسبوعية؟',
    'Teams receive weekly emails about their assigned insights and their impact on customers. Keeps insights top-of-the-mind and teams accountable.':
      'الفرق تستلم إيميلات أسبوعية عن الرؤى المعيّنة لهم وتأثيرها على العملاء. تُبقي الرؤى حاضرة في الأذهان والفرق مسؤولة.',
    'How does gamification work?': 'كيف يعمل التحفيز؟',
    'Teams earn points for resolving insights. Leaderboards show top performers. Recognition for solving customer problems. Competition drives faster resolution.':
      'الفرق تكسب نقاطاً لمّا تحل الرؤى. ولوحات الصدارة تبيّن الأفضل. تقدير لحل مشاكل العملاء. والمنافسة تدفع للحل الأسرع.',
    'Can I access insights via API?': 'هل أقدر أوصل للرؤى عبر API؟',
    'Yes. Full API access to get insights, mark as resolved, and assign to teams. Build custom dashboards or integrate with your existing tools.':
      'نعم. وصول كامل لـ API لجلب الرؤى، وتعليمها كمحلولة، وتعيينها للفرق. ابنِ لوحات تحكم مخصصة أو تكامل مع أدواتك الحالية.',
    'Garbage in, garbage out.': 'مدخلات خربانة، مخرجات خربانة.',
    'Fix the garbage.': 'صلّح الخربان.',
    'Your AI is only as good as your knowledge base. Knowledge Gap Detection finds bad documentation by tracking what causes Agent 5 to escalate to humans. Fix the gaps that matter most.':
      'ذكاؤك الاصطناعي لا يتجاوز جودة قاعدة معرفتك. كشف فجوات المعرفة يجد التوثيق السيئ عبر تتبع وش يخلي الوكيل يصعّد للبشر. صلّح الفجوات الأهم.',
    'Knowledge Gap Detection': 'كشف فجوات المعرفة',
    'Maintain your knowledge base automatically': 'صُن قاعدة معرفتك تلقائياً',
    'Identify Bad Documentation': 'تحديد التوثيق السيئ',
    'Agent 5 tracks which knowledge sources cause handoffs to humans. Bad docs reveal themselves through escalation patterns.':
      'الوكيل يتتبع أي مصادر معرفة تسبب التحويل للبشر. التوثيق السيئ يكشف نفسه عبر أنماط التصعيد.',
    'Multi-Channel Gap Detection': 'كشف الفجوات عبر القنوات المتعددة',
    "Detect gaps across Voice, Chat, Email, WhatsApp, Social, and Slack. Know what's missing everywhere.":
      'اكتشف الفجوات عبر الصوت، والدردشة، والإيميل، وWhatsApp، والسوشيال ميديا، وSlack. اعرف ما ينقصك في كل مكان.',
    'AI-Suggested Content': 'محتوى مقترح بالـ AI',
    'Agent 5 suggests what to add to your knowledge base. Drafts documentation based on successful human agent responses.':
      'الوكيل يقترح ما تضيفه لقاعدة معرفتك. يصيغ التوثيق بناءً على ردود الموظفين الناجحة.',
    'Your knowledge base, maintained automatically':
      'قاعدة معرفتك تصون نفسها تلقائياً',
    'Stop guessing what documentation to write. Agent 5 shows you exactly where your knowledge gaps are.':
      'ما فيه داعي تخمّن وش توثّق. الوكيل يريك بالضبط وين فجوات معرفتك.',
    'Handoff Pattern Analysis': 'تحليل أنماط التحويل',
    'Track which knowledge sources cause the most AI-to-human handoffs. Bad knowledge reveals itself through escalations.':
      'تتبع أي مصادر معرفة تسبب أكثر تحويلات من الـ AI للبشر. المعرفة الضعيفة تكشف نفسها عبر التصعيد.',
    'Cross-Channel Gap Clustering': 'تجميع الفجوات عبر القنوات',
    "See knowledge gaps across Voice, Chat, Email, WhatsApp, Social, and Slack. Identify what's missing everywhere.":
      'شوف فجوات المعرفة عبر الصوت، والدردشة، والإيميل، وWhatsApp، والسوشيال ميديا، وSlack. حدد ما ينقصك في كل مكان.',
    'Automatic Prioritization': 'الأولوية التلقائية',
    'Gaps ranked by impact. Fix the documentation that causes the most handoffs first.':
      'الفجوات مرتّبة حسب التأثير. صلّح أولاً التوثيق اللي يسبب أكثر التحويلات.',
    'Suggested Improvements': 'التحسينات المقترحة',
    'AI suggests what to add to your knowledge base. Not just identifying gaps—showing you how to fill them.':
      'الـ AI يقترح وش تضيفه لقاعدة معرفتك. مو بس يحدد الفجوات - بل يريك كيف تسدها.',
    'Knowledge Base Autopilot': 'قاعدة المعرفة على الطيار الآلي',
    'Your knowledge base maintains itself. Agent 5 identifies gaps, suggests fixes, and helps you keep documentation current.':
      'قاعدة معرفتك تصون نفسها. الوكيل يحدد الفجوات، يقترح الحلول، ويساعدك على إبقاء التوثيق محدّثاً.',
    'Find answers to common questions about Knowledge Gap Detection.':
      'إجابات للأسئلة الشائعة حول كشف فجوات المعرفة.',
    'How does it detect knowledge gaps?': 'كيف يكتشف فجوات المعرفة؟',
    'By tracking which knowledge sources cause Agent 5 to escalate to humans. High escalation rate = bad documentation.':
      'عن طريق تتبع أي مصادر معرفة تخلي الوكيل يصعّد للبشر. معدل تصعيد عالي = توثيق سيئ.',
    'What channels are analyzed?': 'وش القنوات اللي نحللها؟',
    'All of them. Voice, Chat, Email, WhatsApp, Social, and Slack. Gaps are detected across every customer touchpoint.':
      'كلها. الصوت، والدردشة، والإيميل، وWhatsApp، والسوشيال ميديا، وSlack. نكتشف الفجوات في كل نقطة تواصل مع العملاء.',
    'How are gaps prioritized?': 'كيف نرتّب أولويات الفجوات؟',
    'By impact. Gaps that cause the most handoffs appear first. Fix what matters most to customers.':
      'حسب التأثير. الفجوات اللي تسبب أكثر التحويلات تظهر أولاً. صلّح اللي يهم العملاء أكثر.',
    'Does it suggest how to fix gaps?': 'هل يقترح كيفية إصلاح الفجوات؟',
    'Yes. Agent 5 analyzes successful human responses and suggests documentation to add. Drafts content based on what actually worked.':
      'نعم. الوكيل يحلل الردود البشرية الناجحة ويقترح توثيقاً تضيفه. يصيغ المحتوى بناءً على ما نجح فعلاً.',
    'How often are gaps detected?': 'كم مرة نكتشف الفجوات؟',
    'Continuously. Every interaction is analyzed in real-time. Gaps are identified as they emerge.':
      'باستمرار. كل تفاعل نحلله لحظياً. والفجوات تُحدَّد فور ظهورها.',
    'Can this really maintain my knowledge base on autopilot?':
      'هل فعلاً يصون قاعدة معرفتي تلقائياً؟',
    'Not fully automated—you still approve changes. But it tells you exactly what to fix, why it matters, and suggests the content. Knowledge maintenance becomes easy.':
      'مو مؤتمت بالكامل - ما زلت توافق على التغييرات. بس يخبرك بالضبط وش تصلحه، وليش يهم، ويقترح المحتوى. صيانة المعرفة تصير سهلة.',
    'Outbound Sequencing': 'التسلسلات الصادرة',
    'with AI at scale': 'بالـ AI على نطاق واسع',
    'Reach customers before they contact you — delivery delays, renewals, failed payments, appointment reminders. Voice, WhatsApp, SMS and email in one sequence, and every reply lands with the same agent that handles your support inbox.':
      'تواصل مع عملائك قبل ما يتواصلون معك — تأخير شحنة، تجديد اشتراك، دفعة فاشلة، تذكير بموعد. الصوت وWhatsApp ورسائل نصية وإيميل في تسلسل واحد، وكل رد يوصل لنفس الوكيل الذي يدير صندوق الدعم عندك.',
    'Outbound Sequencing Capabilities': 'قدرات التسلسلات الصادرة',
    'Personalized outreach at scale': 'تواصل مخصص على نطاق واسع',
    'AI WhatsApp Sequences': 'تسلسلات WhatsApp بالـ AI',
    'Send personalized WhatsApp messages to your contact list. Agent 5 crafts each message based on customer data.':
      'أرسل رسائل WhatsApp مخصصة لقائمة جهات اتصالك. الوكيل يصيغ كل رسالة بناءً على بيانات العميل.',
    'AI Phone Call Campaigns': 'حملات المكالمات الهاتفية بالـ AI',
    'Agent 5 calls your contact list. Natural conversations, qualification, appointment setting—all automated.':
      'الوكيل يتصل بقائمة جهات اتصالك. محادثات طبيعية، تأهيل، تحديد مواعيد - كله مؤتمت.',
    'SMS with AI Responses': 'رسائل نصية مع ردود AI',
    'Send SMS campaigns with AI that responds to replies. Two-way conversations, not just broadcasts.':
      'أرسل حملات رسائل نصية مع AI يرد على الردود. محادثات ثنائية الاتجاه، لا مجرد بث رسائل.',
    'AI Email Sequences': 'تسلسلات الإيميل بالـ AI',
    'Multi-step email campaigns with AI personalization. Follow-ups, drip campaigns, and targeted outreach.':
      'حملات إيميل متعددة الخطوات مع تخصيص بالـ AI. متابعات، وحملات تدريجية، وتواصل مستهدف.',
    'Reach thousands with AI personalization': 'تواصل مع الآلاف بتخصيص AI',
    'Not mass messaging. Personalized outreach at scale. Each contact gets AI-crafted communication tailored to them.':
      'مو رسائل جماعية عامة. تواصل مخصص على نطاق واسع. كل جهة اتصال تتلقى تواصلاً مصاغاً بالـ AI ومفصّلاً لها.',
    'Bulk Contact Import': 'استيراد جهات الاتصال بالجملة',
    'Upload hundreds of thousands of contacts at once. CSV import, API integration, or sync from your CRM.':
      'حمّل مئات الآلاف من جهات الاتصال دفعة واحدة. استيراد CSV، تكامل API، أو مزامنة من CRM الخاص بك.',
    'Multi-Channel Sequences': 'تسلسلات عبر قنوات متعددة',
    'Mix WhatsApp, AI phone calls, SMS, and email in one sequence. Start with a call, follow up via email, remind via WhatsApp.':
      'امزج WhatsApp، ومكالمات هاتفية بالـ AI، ورسائل نصية، وإيميل في تسلسل واحد. ابدأ بمكالمة، تابع عبر الإيميل، وذكّر عبر WhatsApp.',
    'AI-Powered Personalization': 'تخصيص مدعوم بالـ AI',
    'Agent 5 personalizes every message based on customer data. Not templates—actual personalized communication.':
      'الوكيل يخصص كل رسالة بناءً على بيانات العميل. مو قوالب - بل تواصل مخصص فعلي.',
    'Response-Based Branching': 'تفرع بناءً على الاستجابة',
    'Sequences adapt based on responses. Positive reply? Move to sales. Negative? Remove from sequence. AI understands intent.':
      'التسلسلات تتكيف بناءً على الردود. رد إيجابي؟ ينقله لتسلسل المبيعات. سلبي؟ يُزيله من التسلسل. الـ AI يفهم النية.',
    'API & UI Access': 'الوصول عبر API وواجهة المستخدم',
    'Build sequences programmatically via API or use the visual editor. Full programmatic control or no-code interface—your choice.':
      'ابنِ التسلسلات برمجياً عبر API أو استخدم المحرر البصري. تحكم برمجي كامل أو واجهة بدون كود - الخيار لك.',
    'Build sequences programmatically via API or use the visual editor. Complete control however you prefer.':
      'ابنِ التسلسلات برمجياً عبر API أو استخدم المحرر البصري. تحكم كامل بالطريقة اللي تفضّلها.',
    'Create Sequence': 'إنشاء تسلسل',
    'Create multi-step sequences with delays and filters':
      'إنشاء تسلسلات متعددة الخطوات مع تأخيرات وفلاتر',
    'Start Sequence': 'بدء التسلسل',
    'Activate sequence to begin reaching contacts':
      'تنشيط التسلسل لبدء التواصل مع جهات الاتصال',
    'Get Sequence': 'الحصول على التسلسل',
    'Retrieve sequence details and performance':
      'استرجاع تفاصيل التسلسل والأداء',
    'Update Sequence': 'تحديث التسلسل',
    'Modify steps, delays, and targeting':
      'تعديل الخطوات والتأخيرات والاستهداف',
    'Cancel Sequence': 'إلغاء التسلسل',
    'Stop a running sequence immediately': 'إيقاف تسلسل قيد التشغيل فوراً',
    'Add Contacts': 'إضافة جهات اتصال',
    'Add contacts to continuous sequences': 'إضافة جهات اتصال لتسلسلات مستمرة',
    'View Sequencing API Docs': 'عرض وثائق API للتسلسلات',
    'Find answers to common questions about Outbound Sequencing.':
      'إجابات للأسئلة الشائعة حول التسلسلات الصادرة.',
    'How many contacts can I add to a sequence?':
      'كم جهة اتصال أقدر أضيف للتسلسل؟',
    'Hundreds of thousands. Upload contacts in bulk via CSV, API, or sync from your CRM.':
      'مئات الآلاف. حمّل جهات الاتصال بالجملة عبر CSV، أو API، أو مزامنة من CRM الخاص بك.',
    'What channels can I use in sequences?':
      'وش القنوات اللي أقدر أستخدمها في التسلسلات؟',
    'WhatsApp, AI phone calls, SMS, and email. Mix and match channels in one sequence.':
      'WhatsApp، مكالمات هاتفية بالـ AI، رسائل نصية، وإيميل. امزج وطابق القنوات في تسلسل واحد.',
    'Is each message personalized?': 'هل كل رسالة مخصصة؟',
    'Yes. Agent 5 personalizes every message based on customer data, conversation history, and context. Not templates—actual personalized communication.':
      'نعم. الوكيل يخصص كل رسالة بناءً على بيانات العميل، وتاريخ المحادثة، والسياق. مو قوالب - بل تواصل مخصص فعلي.',
    'Can sequences adapt based on responses?':
      'هل التسلسلات تتكيف بناءً على الردود؟',
    'Yes. Sequences branch based on what customers say. Positive reply? Move to sales sequence. Negative? Remove from list. AI understands intent.':
      'نعم. التسلسلات تتفرّع حسب ما يقوله العملاء. رد إيجابي؟ ينقله لتسلسل المبيعات. سلبي؟ يُزيله من القائمة. الـ AI يفهم النية.',
    'Can I build sequences via API?': 'هل أقدر أبني تسلسلات عبر API؟',
    'Yes. Full API access to create, start, update, and cancel sequences programmatically. Or use the visual editor.':
      'نعم. وصول كامل لـ API لإنشاء التسلسلات وبدئها وتحديثها وإلغائها برمجياً. أو استخدم المحرر البصري.',
    'What use cases work best?': 'وش حالات الاستخدام اللي تنجح أكثر؟',
    'Proactive support — delivery and delay notices, appointment reminders, failed payments, renewals, and win-back. Marketing campaigns and lead nurturing run on the same sequences.':
      'الدعم الاستباقي — إشعارات التوصيل والتأخير، تذكير المواعيد، الدفعات الفاشلة، التجديدات، واستعادة العملاء. وحملات التسويق وتنمية العملاء المحتملين تشتغل على نفس التسلسلات.',
    'Open Subprocessors': 'المعالجون الفرعيون لـ Open',
    'Know exactly where your data is and how it is being used. This page lists all third-party service providers (subprocessors) that Open uses to deliver our services.':
      'اعرف بالضبط أين توجد بياناتك وكيف تُستخدم. تعرض هذه الصفحة جميع مزوّدي الخدمات من أطراف خارجية (المعالِجين الفرعيين) الذين تستخدمهم Open لتقديم خدماتها.',
    'Current as of November 2, 2024': 'محدث اعتباراً من ١٣ سبتمبر ٢٠٢٦',
    Name: 'الاسم',
    Purpose: 'الغرض',
    Location: 'الموقع',
    Website: 'الموقع الإلكتروني',
    'Data Protection': 'حماية البيانات',
    'All subprocessors listed above are carefully selected and required to maintain appropriate security measures to protect your data. We regularly review our subprocessors to ensure they meet our security and privacy standards.':
      'جميع المعالجين الفرعيين المذكورين أعلاه مختارون بعناية ومطالَبون بالحفاظ على تدابير أمنية مناسبة لحماية بياناتك. نراجع معالجينا الفرعيين بانتظام للتأكد من التزامهم بمعايير الأمان والخصوصية لدينا.',
    'This list is updated as we add or remove subprocessors. We will notify customers of any material changes in accordance with our Data Processing Agreement.':
      'تُحدَّث هذه القائمة عند إضافة معالِجين فرعيين جدد أو إزالة معالِجين حاليين. وسنخطر العملاء بأي تغييرات جوهرية وفقاً لاتفاقية معالجة البيانات الخاصة بنا.',
    'Cloud infrastructure and hosting services':
      'البنية التحتية السحابية وخدمات الاستضافة',
    'AI language model services (Claude)':
      'خدمات نماذج لغة الذكاء الاصطناعي (Claude)',
    'AI language model services (GPT)':
      'خدمات نماذج لغة الذكاء الاصطناعي (GPT)',
    'Speech-to-text and audio processing': 'تحويل الكلام إلى نص ومعالجة الصوت',
    'Speech recognition and audio intelligence':
      'التعرف على الكلام وذكاء الصوت',
    'Payment processing and billing': 'معالجة المدفوعات والفوترة',
    'Frontend hosting and deployment': 'استضافة ونشر الواجهة الأمامية',
    'CDN and security services': 'شبكة توزيع المحتوى وخدمات الأمان',
    'Serverless PostgreSQL database': 'قاعدة بيانات PostgreSQL بدون خوادم',
    'Vector database and semantic search': 'قاعدة بيانات متجهية وبحث دلالي',
    'Product analytics and event tracking': 'تحليلات المنتج وتتبع الأحداث',
    'Website analytics': 'تحليلات الموقع',
    'Transactional email delivery': 'توصيل رسائل الإيميل للمعاملات',
    'Enterprise authentication and SSO':
      'مصادقة المؤسسات وتسجيل الدخول الموحد (SSO)',
    'United States': 'الولايات المتحدة',
    'Germany (Frankfurt)': 'ألمانيا (فرانكفورت)',
    'Ireland (Dublin)': 'أيرلندا (دبلن)',
    'Netherlands (Amsterdam)': 'هولندا (أمستردام)',
    'Sweden (Stockholm)': 'السويد (ستوكهولم)',
    'Belgium (St. Ghislain)': 'بلجيكا (سانت غيسلان)',
    Finland: 'فنلندا',
    'UAE (Dubai)': 'الإمارات (دبي)',
    'UAE (Abu Dhabi)': 'الإمارات (أبوظبي)',
    'Saudi Arabia (Riyadh)': 'السعودية (الرياض)',
    'Saudi Arabia (Jeddah)': 'السعودية (جدة)',
    'Saudi Arabia (Dammam)': 'السعودية (الدمام)',
    'Bahrain (Manama)': 'البحرين (المنامة)',
    'AI and cloud services': 'خدمات الذكاء الاصطناعي والسحابة',
    'Cloud infrastructure and database services':
      'البنية التحتية السحابية وخدمات قواعد البيانات',
    'Payment gateway services': 'خدمات بوابة الدفع',
    'Database services': 'خدمات قواعد البيانات',

    /* App Builder */
    "World's first self-building platform": 'أول منصة في العالم تبني نفسها',
    "Build me a mini app for the driver's live location and ETA.":
      'ابنِ لي تطبيقاً مصغّراً لموقع السائق المباشر ووقت الوصول.',
    'App Builder · building': 'بنّاء التطبيقات · قيد البناء',
    'Reading your data and connected tools': 'يقرأ بياناتك وأدواتك المربوطة',
    'Generating logic and interface': 'يولّد المنطق والواجهة',
    'Pinned in the delivery channel': 'مثبّت في قناة التوصيل',
    vs: 'مقابل',
    'waiting for the roadmap': 'انتظار خارطة الطريق',
    'What changes when the feature you are missing is a sentence away instead of a quarter away.':
      'وش يتغيّر لمّا تكون الميزة الناقصة على بُعد جملة، مو على بُعد ربع سنة.',
    Capability: 'القدرة',
    'A traditional CX platform': 'منصة CX تقليدية',
    'A new feature from one sentence': 'ميزة جديدة من جملة وحدة',
    'Ships without an engineer': 'تطلق بلا مهندس',
    'Waits on a vendor roadmap': 'تنتظر خارطة طريق المزوّد',
    'Runs on your live customer context': 'تشتغل على سياق عملائك اللحظي',
    'Renders beside the conversation': 'تظهر جنب المحادثة',
    'Audit trail and one-click rollback': 'سجل تدقيق وتراجع بضغطة وحدة',
    'Start from a template, then build past it':
      'ابدأ من قالب، وبعدها ابنِ أبعد منه',
    'Open ships playbooks for the work every support team shares. The app builder is for everything after that — the parts nobody could have specced in advance.':
      'Open يجي بقوالب جاهزة للشغل المشترك بين كل فرق الدعم. وبنّاء التطبيقات لكل اللي بعدها — الأجزاء اللي ما كان أحد يقدر يحدّدها مسبقاً.',
    'Captions available in English.': 'الترجمة متوفرة بالإنجليزية.',
    'See the original post': 'شوف المنشور الأصلي',
    "Open is the first CX platform you can extend by prompting. Ask Companion for a feature that doesn't exist yet, and it builds it into the platform — live, in the channel your team already works in.":
      'Open أول منصة CX تقدر توسّعها بالكلام. اطلب من Companion ميزة ما هي موجودة أصلاً، ويبنيها لك داخل المنصة — مباشرة، في نفس القناة اللي يشتغل فيها فريقك.',
    'App Builder': 'بنّاء التطبيقات',
    'Describe the feature. Open builds it.': 'وصف الميزة. و Open يبنيها.',
    'Driver Location In The Channel': 'موقع السائق داخل القناة',
    'An agent mid-conversation needs the driver position and ETA, which normally means switching tabs while the customer waits. One prompt builds a live location app into the channel.':
      'وكيل في وسط محادثة يحتاج موقع السائق ووقت الوصول، واللي يعني عادةً إنه يتنقل بين التبويبات والعميل ينتظر. طلب واحد يبني تطبيق موقع مباشر داخل القناة.',
    'QA On Your Own Scorecard': 'الجودة على معيارك أنت',
    "Every team scores quality differently. Instead of bending to someone else's QA module, describe your scorecard and Companion builds the app around it.":
      'كل فريق يقيس الجودة بطريقته. بدل ما تتأقلم مع وحدة جودة صمّمها غيرك، وصف معيارك ويبني Companion التطبيق حوله.',
    'Whatever You Need Next': 'وش ما تحتاج بعدها',
    'Nothing about the method changes with the ask. A returns triage board, a fraud review queue, a carrier SLA tracker. Describe it and it gets built, whether or not it has ever existed.':
      'الطريقة ما تتغيّر باختلاف الطلب. لوحة فرز مرتجعات، أو طابور مراجعة احتيال، أو متابعة اتفاقيات مستوى الخدمة مع شركات الشحن. وصفه وينبني، سواء كان موجود قبل أو ما كان.',
    'Your platform, extended by prompting': 'منصتك، تتوسّع بالكلام',
    'Stop waiting on a roadmap. Describe the feature you need and Companion builds it into Open.':
      'بس انتظار خرائط الطريق. وصف الميزة اللي تحتاجها ويبنيها Companion داخل Open.',
    'Plain Language Input': 'مدخل بلغة عادية',
    'Describe the feature in a sentence. No spec, no config screens, no ticket to raise.':
      'وصف الميزة في جملة. بلا مواصفات، ولا شاشات إعداد، ولا تذكرة ترفعها.',
    'Built On Your Context': 'مبني على سياقك',
    'It reads your customer data, your connected tools and the conversation it is sitting in. The app knows who it is for.':
      'يقرأ بيانات عملائك، وأدواتك المربوطة، والمحادثة اللي هو فيها. التطبيق يعرف لمين هو.',
    'Lives In The Channel': 'يعيش داخل القناة',
    'Apps render next to the conversation they serve. A driver tracker sits in the delivery channel, a QA app where quality is reviewed.':
      'التطبيقات تظهر جنب المحادثة اللي تخدمها. تتبّع السائق في قناة التوصيل، وتطبيق الجودة وين تُراجَع الجودة.',
    'Plan, Approve, Roll Back': 'خطة، وموافقة، وتراجع',
    'Multi-step work is shown as a plan before it runs. Every build leaves an audit trail, and anything built can be rolled back.':
      'أي شغل متعدد الخطوات يظهر كخطة قبل ما ينفّذ. وكل بناء يترك سجل تدقيق، وكل اللي ينبني قابل للتراجع.',
    'Proven At Scale': 'مثبت بأي حجم',
    'Customers built 1,000+ features and 2,000+ apps in the first two months, including workforce management that replaced $100K+ contracts.':
      'العملاء بنوا أكثر من ١ ٠٠٠ ميزة و٢ ٠٠٠ تطبيق في أول شهرين، منها إدارة قوى عاملة عوّضت عقوداً بأكثر من ١٠٠ ألف دولار.',
    'Find answers to common questions about the App Builder.':
      'إجابات على أكثر الأسئلة تكراراً عن بنّاء التطبيقات.',
    'What is the Open app builder?': 'وش هو بنّاء التطبيقات في Open؟',
    'It lets you extend Open with features that were never in the product. You describe what you need to Companion in one prompt, and it builds a working app into the platform.':
      'يخليك توسّع Open بميزات ما كانت في المنتج أصلاً. تصف اللي تحتاجه لـ Companion في طلب واحد، ويبني تطبيقاً شغّالاً داخل المنصة.',
    'Do I need a developer?': 'أحتاج مطوّر؟',
    'No. The input is a sentence, not a spec. Most of these are built by support leads and ops managers describing the thing they keep switching tabs for.':
      'لا. المدخل جملة، مو مواصفات. ومعظم اللي يبنون هذي الأشياء قادة دعم ومدراء عمليات يوصفون الشي اللي يخليهم يتنقلون بين التبويبات.',
    'What can actually be built?': 'وش اللي ينبني فعلاً؟',
    'Workforce management, QA and real-time monitoring across channels, upselling dashboards, live order and driver tracking, and several thousand smaller things. If it reads your data, your connected tools, or the conversation in front of you, it is buildable.':
      'إدارة قوى عاملة، ومراقبة جودة لحظية عبر القنوات، ولوحات بيع إضافي، وتتبّع طلبات وسائقين مباشر، وآلاف الأشياء الأصغر. لو كان يقرأ بياناتك أو أدواتك المربوطة أو المحادثة اللي قدامك، فهو قابل للبناء.',
    'Where do the apps live?': 'وين تعيش هذي التطبيقات؟',
    'Inside Open, next to the conversation they serve. A driver-tracking app sits in the delivery channel, a QA app sits where quality is reviewed. Nothing gets its own tab.':
      'داخل Open، جنب المحادثة اللي تخدمها. تطبيق تتبّع السائق يعيش في قناة التوصيل، وتطبيق الجودة يعيش وين تُراجَع الجودة. ما في شي ياخذ تبويباً خاصاً به.',
    'Can it change things without us approving?':
      'يقدر يغيّر أشياء بدون موافقتنا؟',
    'No. Multi-step work is shown as a plan first, so you approve, edit or stop it before anything runs. Every build leaves an audit trail and anything built can be rolled back.':
      'لا. أي شغل متعدد الخطوات يظهر كخطة أولاً — توافق أو تعدّل أو توقف قبل ما ينفّذ شي. وكل بناء يترك سجل تدقيق، وكل اللي ينبني قابل للتراجع.',
    'How is this different from a workflow or an integration?':
      'وش الفرق بينه وبين سير العمل أو التكامل؟',
    'A workflow automates a process Open already models, and an integration connects a tool that already exists. The app builder adds functionality that did not exist anywhere: new interfaces, new views, new features in the product itself.':
      'سير العمل يؤتمت عملية Open يعرفها أصلاً، والتكامل يربط أداة موجودة أصلاً. أما بنّاء التطبيقات فيضيف وظائف ما كانت موجودة في أي مكان — واجهات جديدة، وشاشات جديدة، وميزات جديدة في المنتج نفسه.',
  },
  tools: {
    'Free Tools': 'أدوات مجانية',
    'Support Operations Tools': 'أدوات عمليات الدعم',
    'Free calculators and assessments to help you optimize your customer support. All tools are backed by industry research and provide actionable insights.':
      'حاسبات وتقييمات مجانية تساعدك على تحسين دعم العملاء عندك. جميعها مبنية على أبحاث القطاع، وتمنحك رؤى قابلة للتنفيذ.',
    Popular: 'شائع',
    'Learn more →': 'اعرف أكثر ←',
    'AI Adoption Guide': 'دليل تبني AI',
    'ROI Calculator': 'حاسبة العائد على الاستثمار',
    'Team Size Calculator': 'حاسبة حجم الفريق',
    'Support Budget Planner': 'مخطط ميزانية الدعم',
    'Support Benchmarking': 'معايير الدعم المرجعية',
    'AI Readiness Assessment': 'تقييم الجاهزية للـ AI',
    'A comprehensive, research-backed guide to implementing AI in customer support. 6 chapters of actionable insights.':
      'دليل شامل مبني على الأبحاث يشرح لك كيف تطبّق الـ AI في دعم العملاء. ٦ فصول عملية جاهزة للتنفيذ.',
    'Calculate how much you could save by automating customer support with AI. See your potential yearly savings.':
      'احسب حجم التوفير الممكن عند أتمتة دعم العملاء بالـ AI، واطّلع على توفيرك السنوي المتوقع.',
    'Figure out exactly how many support agents you need based on ticket volume, channels, and SLA requirements.':
      'اعرف بالضبط عدد موظفي الدعم اللي تحتاجهم حسب عدد التذاكر والقنوات ومتطلبات اتفاقية مستوى الخدمة (SLA).',
    'Plan your annual support budget based on industry benchmarks, team location, and company size.':
      'خطّط ميزانية دعمك السنوية حسب معايير القطاع وموقع الفريق وحجم الشركة.',
    'Compare your cost per ticket, response time, and CSAT against industry peers. See where you rank.':
      'قارن تكلفة التذكرة ووقت الرد ورضا العملاء عندك مع نظرائك في القطاع، وتعرّف على موقعك بالضبط.',
    'Get a personalized score on how ready your support team is for AI automation. Includes actionable recommendations.':
      'قيّم جاهزية فريق الدعم عندك للأتمتة بدرجة مخصصة، مع توصيات عملية قابلة للتنفيذ.',
    '28 min read • 15+ sources': '٢٨ دقيقة قراءة • أكثر من ١٥ مصدر',
    '77% avg automation rate': '٧٧٪ متوسط معدل الأتمتة',
    'Research-backed formulas': 'معادلات مدعومة بالأبحاث',
    'salary & cost data': 'بيانات الرواتب والتكاليف',
    '8 industries covered': '٨ قطاعات مشمولة',
    '6 factors analyzed': 'تحليل ٦ عوامل',
  },
  academy: {
    'Master AI for Customer Support': 'إتقان الذكاء الاصطناعي في دعم العملاء',
    'The best place on earth to learn AI for customer support.':
      'أحلى مكان على وجه الأرض تتعلم فيه الذكاء الاصطناعي لدعم العملاء.',
    'Learn something new today!': 'تعلّم شيئاً جديداً اليوم',
    Search: 'بحث',
    Beginner: 'مبتدئ',
    Intermediate: 'متوسط',
    Advanced: 'متقدم',
    'Original Series': 'سلسلة حصرية',
    New: 'جديد',
    Masterclass: 'ماستر كلاس',
    'AI Customer Support': 'دعم العملاء بالذكاء الاصطناعي',
    'The Fundamentals': 'الأساسيات',
    Conversational: 'المحادثات',
    Design: 'التصميم',
    Knowledge: 'المعرفة',
    Architecture: 'الهندسة',
    Building: 'بناء',
    'Agentic Workflows': 'سير العمل الذكي',
    Sentiment: 'المشاعر',
    Empathy: 'التعاطف',
    'Quality Assurance': 'ضمان الجودة',
    Voice: 'الصوت',
    Implementation: 'التطبيق',
    Multilingual: 'متعدد اللغات',
    Strategy: 'الاستراتيجية',
    Ethics: 'الأخلاقيات',
    'Compliance in CS': 'الامتثال في خدمة العملاء',
    'AI Customer Support Fundamentals': 'أساسيات دعم العملاء بالذكاء الاصطناعي',
    'Start here. Understand the basics of AI, how LLMs work, and how to identify automation opportunities in your support stack.':
      'ابدأ من هنا. افهم أساسيات الذكاء الاصطناعي، كيف تعمل نماذج اللغة الكبيرة، وكيف تحدد فرص الأتمتة في نظام الدعم عندك.',
    'This comprehensive course is designed to take you from zero to hero in the world of AI customer support. You will learn the foundational concepts of Large Language Models (LLMs), how they differ from traditional chatbots, and how to strategically implement them to reduce ticket volume and improve customer satisfaction.':
      'هذه الدورة الشاملة مصممة عشان تاخذك من الصفر إلى الاحتراف في عالم دعم العملاء بالذكاء الاصطناعي. ستتعلم المفاهيم الأساسية لنماذج اللغة الكبيرة (LLMs)، وكيف تختلف عن روبوتات الدردشة العادية، وكيف تستخدمها بشكل صحيح لتقليل عدد التذاكر ورفع رضا العملاء.',
    '1. Introduction to AI in Support': '١. مقدمة للذكاء الاصطناعي في الدعم',
    'The Evolution of Customer Service': 'تطور خدمة العملاء',
    'Understanding LLMs vs. Chatbots':
      'فهم نماذج اللغة الكبيرة مقابل روبوتات الدردشة',
    'Identifying Automation Opportunities': 'تحديد فرص الأتمتة',
    '2. Setting the Strategy': '٢. وضع الاستراتيجية',
    'Defining Success Metrics': 'تحديد مقاييس النجاح',
    'Building a Knowledge Base Strategy': 'بناء استراتيجية قاعدة المعرفة',
    'Designing Conversational Flows': 'تصميم مسارات المحادثة',
    'Learn to map out customer journeys and design natural, human-like conversation paths that solve problems without frustration.':
      'تعلّم كيف ترسم رحلة العميل، وتصمم مسارات محادثة طبيعية تحل المشكلة بدون ما تتعب العميل.',
    'Great AI agents need great design. In this course, you will learn the art of conversation design specifically for customer support. We cover how to map user journeys, handle edge cases, and write scripts that feel human, helpful, and concise.':
      'الوكيل الذكي الممتاز ما يجي من فراغ — يجي من تصميم محادثة صح. في هالدورة بتتعلم فن تصميم المحادثات لدعم العملاء بالتحديد: ترسم رحلة المستخدم، تتعامل مع الحالات الاستثنائية، وتكتب سكربتات تحس إنها بشرية ومفيدة ومختصرة.',
    '1. Principles of Conversation Design': '١. مبادئ تصميم المحادثة',
    'The Gricean Maxims in Support': 'مبادئ جرايس في الدعم',
    'Mapping the Happy Path': 'رسم المسار المثالي',
    '2. Handling Complexity': '٢. التعامل مع التعقيد',
    'Designing for Error Recovery': 'التصميم للتعافي من الأخطاء',
    'Managing Context and Memory': 'إدارة السياق والذاكرة',
    'Knowledge Architecture': 'هندسة المعرفة',
    'Your AI is only as good as its data. Master the art of structuring your help center and documentation for optimal AI ingestion.':
      'ذكاؤك الاصطناعي بقدر بياناته. أتقن فن ترتيب مركز المساعدة والتوثيق عندك، عشان يستوعبه صح.',
    'A well-structured knowledge base is the foundation of effective AI support. This course teaches you how to organize, structure, and optimize your documentation for AI consumption, ensuring accurate and helpful responses every time.':
      'قاعدة المعرفة المرتبة جيداً هي أساس الدعم الفعّال بالذكاء الاصطناعي. وهذه الدورة تعلمك كيف ترتب وتهيكل وتحسّن توثيقك عشان يفهمه الذكاء الاصطناعي، وتضمن ردود دقيقة ومفيدة كل مرة.',
    '1. Documentation Best Practices': '١. أفضل ممارسات التوثيق',
    'Structuring Your Knowledge Base': 'هيكلة قاعدة المعرفة',
    'Writing for AI Comprehension': 'الكتابة لفهم الذكاء الاصطناعي',
    'Metadata and Tagging Strategies': 'استراتيجيات البيانات الوصفية والوسوم',
    '2. Optimization Techniques': '٢. تقنيات التحسين',
    'Semantic Search Optimization': 'تحسين البحث الدلالي',
    'Version Control for Docs': 'إدارة إصدارات الوثائق',
    'Building Agentic Workflows': 'بناء سير العمل الذكي',
    'Go beyond Q&A. Teach your AI to perform actions—process refunds, update subscriptions, and schedule calls autonomously.':
      'تجاوز الأسئلة والأجوبة. علّم ذكاءك الاصطناعي ينفّذ إجراءات — يعالج طلبات الاسترداد، يحدّث الاشتراكات، ويجدول المكالمات بروحه.',
    'Master the art of designing complex AI workflows that handle multi-step tasks autonomously. Learn how to build AI agents that can take real actions in your systems, from processing refunds to updating customer accounts.':
      'أتقن تصميم سير عمل ذكي يتعامل مع خطوات متعددة بروحه. بتتعلم كيف تبني وكلاء ياخذون إجراءات حقيقية داخل أنظمتك، من معالجة طلبات الاسترداد لتحديث حسابات العملاء.',
    '1. Introduction to Agentic AI': '١. مقدمة للذكاء الاصطناعي الوكيل',
    'Understanding Agent Capabilities': 'فهم قدرات الوكيل',
    'Planning Multi-Step Workflows': 'تخطيط سير عمل متعدد الخطوات',
    'Security Considerations': 'اعتبارات الأمان',
    '2. Implementation': '٢. التطبيق',
    'Building Your First Agent': 'بناء أول وكيل لك',
    'API Integration Patterns': 'أنماط تكامل الواجهات البرمجية',
    'Error Handling and Recovery': 'معالجة الأخطاء والتعافي منها',
    'Sentiment Analysis & Empathy': 'تحليل المشاعر والتعاطف',
    'Fine-tune your AI to detect customer frustration and respond with appropriate empathy, tone, and escalation paths.':
      'اضبط ذكاءك الاصطناعي عشان يستشعر ضيق العميل، ويرد بالنبرة والتعاطف ومسار التصعيد المناسب.',
    'Learn how to build AI systems that understand and respond to customer emotions. This course covers sentiment analysis, empathy modeling, and creating escalation paths for frustrated customers.':
      'تعلّم كيف تبني ذكاء اصطناعي يقرأ مشاعر العميل ويرد عليها صح. نغطي تحليل المشاعر، ونمذجة التعاطف، وبناء مسارات تصعيد للعميل المتضايق.',
    '1. Understanding Sentiment': '١. فهم المشاعر',
    'Emotion Detection Fundamentals': 'أساسيات كشف المشاعر',
    'Building Sentiment Models': 'بناء نماذج المشاعر',
    'Tone Analysis': 'تحليل النبرة',
    '2. Empathetic Responses': '٢. الردود التعاطفية',
    'Crafting Empathetic Messages': 'صياغة رسائل تعاطفية',
    'Escalation Triggers': 'محفزات التصعيد',
    'Quality Assurance for AI Agents': 'ضمان الجودة للوكلاء الأذكياء',
    'How to monitor, evaluate, and continuously improve your AI agents performance using automated testing and human-in-the-loop review.':
      'كيف تراقب وتقيّم وتحسّن أداء الوكلاء الأذكياء باستمرار عن طريق الاختبار الآلي ومراجعة بشرية داخل الحلقة.',
    'Ensure your AI agents maintain high quality standards through systematic testing and evaluation. Learn automated testing strategies, human review processes, and continuous improvement methodologies.':
      'حافظ على جودة عالية لوكلائك الأذكياء عبر اختبار وتقييم منهجي. ستتعلم استراتيجيات الاختبار الآلي، وعمليات المراجعة البشرية، وطرق التحسين المستمر.',
    '1. Testing Strategies': '١. استراتيجيات الاختبار',
    'Automated Testing for AI': 'الاختبار الآلي للذكاء الاصطناعي',
    'Creating Test Suites': 'إنشاء مجموعات الاختبار',
    'Performance Metrics': 'مقاييس الأداء',
    '2. Continuous Improvement': '٢. التحسين المستمر',
    'Human-in-the-Loop Review': 'مراجعة بشرية داخل الحلقة',
    'Feedback Loops': 'حلقات التغذية الراجعة',
    'Voice AI Implementation': 'تطبيق الذكاء الاصطناعي الصوتي',
    'The frontier of support. Learn to configure, script, and deploy voice agents that handle phone calls with human-like latency and understanding.':
      'حدود الدعم الجديدة. تعلّم كيف تضبط وتبرمج وتنشر وكلاء صوتيين يتعاملون مع المكالمات الهاتفية بسرعة استجابة وفهم يشبه البشر.',
    'Dive into the cutting edge of AI support with voice technology. Learn how to build and deploy voice AI agents that can handle phone calls with natural conversation flow and minimal latency.':
      'ادخل أحدث ما وصل له الدعم بالذكاء الاصطناعي: الصوت. بتتعلم كيف تبني وتنشر وكلاء صوتيين يتعاملون مع المكالمات بمحادثة طبيعية وزمن استجابة قصير.',
    '1. Voice AI Fundamentals': '١. أساسيات الذكاء الاصطناعي الصوتي',
    'Speech Recognition Basics': 'أساسيات التعرف على الكلام',
    'Text-to-Speech Systems': 'أنظمة تحويل النص إلى كلام',
    'Latency Optimization': 'تحسين زمن الاستجابة',
    '2. Building Voice Agents': '٢. بناء الوكلاء الصوتيين',
    'Conversation Design for Voice': 'تصميم المحادثة للصوت',
    'Interruption Handling': 'التعامل مع المقاطعات',
    'Deployment Strategies': 'استراتيجيات النشر',
    'Multilingual Support Strategy': 'استراتيجية الدعم متعدد اللغات',
    'Scale your support globally without hiring local teams. Master real-time translation pipelines and cultural nuance in AI responses.':
      'وسّع دعمك عالمياً بدون ما توظّف فرق محلية. أتقن مسارات الترجمة الفورية والفروق الثقافية الدقيقة في ردود الذكاء الاصطناعي.',
    'Expand your support globally with AI-powered multilingual capabilities. Learn how to implement real-time translation, handle cultural nuances, and maintain quality across languages.':
      'وسّع دعمك عالمياً بذكاء اصطناعي يتكلم لغات عملائك كلها. بتتعلم كيف تطبّق الترجمة الفورية، وتتعامل مع الفروق الثقافية، وتحافظ على الجودة بكل لغة.',
    '1. Multilingual Fundamentals': '١. أساسيات تعدد اللغات',
    'Translation Technologies': 'تقنيات الترجمة',
    'Language Detection': 'كشف اللغة',
    'Cultural Considerations': 'الاعتبارات الثقافية',
    'Building Translation Pipelines': 'بناء مسارات الترجمة',
    'Quality Assurance Across Languages': 'ضمان الجودة عبر اللغات',
    'AI Ethics & Compliance in CS':
      'أخلاقيات وامتثال الذكاء الاصطناعي في خدمة العملاء',
    'Navigate the legal and ethical landscape. GDPR, data privacy, bias mitigation, and ensuring your AI agents remain compliant.':
      'تنقّل في المشهد القانوني والأخلاقي: GDPR، وخصوصية البيانات، وتقليل التحيز، وكيف تُبقي وكلاءك ملتزمين.',
    'Ensure your AI systems are ethical, compliant, and trustworthy. This course covers legal requirements, privacy considerations, bias mitigation, and ethical AI development practices.':
      'خلّي أنظمتك الذكية أخلاقية وملتزمة وموثوقة. هالدورة تغطي المتطلبات القانونية، واعتبارات الخصوصية، وتقليل التحيز، وممارسات تطوير الذكاء الاصطناعي الأخلاقية.',
    '1. Legal & Regulatory Framework': '١. الإطار القانوني والتنظيمي',
    'GDPR and Data Privacy': 'GDPR وخصوصية البيانات',
    'Compliance Requirements': 'متطلبات الامتثال',
    'Data Retention Policies': 'سياسات الاحتفاظ بالبيانات',
    '2. Ethical AI Development': '٢. تطوير الذكاء الاصطناعي الأخلاقي',
    'Bias Detection and Mitigation': 'كشف التحيز وتقليله',
    'Transparency and Explainability': 'الشفافية والقابلية للتفسير',
    'Accountability Frameworks': 'أطر المساءلة',
    'No results found': 'ما لقينا نتائج',
    'Try a different search term or browse all courses below.':
      'جرّب كلمة بحث ثانية، أو تصفّح كل الدورات تحت.',
    students: 'طالب',
    Enroll: 'سجّل',
    'Start Here': 'ابدأ من هنا',
    'Essential foundations for AI-powered customer support':
      'الأساس اللي تبني عليه كل شيء في الدعم بالذكاء الاصطناعي',
    'Level Up': 'ارفع مستواك',
    'Advanced techniques and specialized skills':
      'تقنيات متقدمة ومهارات متخصصة',
    'Expert Track': 'مسار الخبراء',
    'Master the cutting edge of AI support':
      'أتقن أحدث ما وصل له الدعم بالذكاء الاصطناعي',
    'Open Academy': 'أكاديمية Open',
    'for AI': 'للذكاء الاصطناعي',
    '& Empathy': 'والتعاطف',
    Agentic: 'سير العمل',
    Workflows: 'الذكي',
    '& Compliance': 'والامتثال',
    'AI Ethics': 'أخلاقيات الذكاء الاصطناعي',
    lessons: 'درس',
    With: 'مع',
    Home: 'الرئيسية',
    Courses: 'الدورات',
    'Course details': 'تفاصيل الدورة',
    'Start Course': 'ابدأ الدورة',
    'Join Waitlist': 'انضم لقائمة الانتظار',
    weeks: 'أسابيع',
    week: 'أسبوع',
    'Join our Slack community of AI customer support builders!':
      'انضم لمجتمعنا على Slack، حيث يجتمع من يبنون دعم العملاء بالذكاء الاصطناعي.',
    'Connect with over 5,000 support leaders, share your workflows, ask questions, and get direct access to instructors.':
      'تواصل مع قادة الدعم، شارك سير عملك، اسأل ما تريد، وتحدّث مع المدربين مباشرة.',
    '(Invite Only)': '(بالدعوة بس)',
    'Join the Community': 'انضم للمجتمع',
    'Latest Lessons': 'أحدث الدروس',
    'Bite-sized knowledge to level up your skills quickly.':
      'دروس قصيرة ترفع مستواك بسرعة.',
    'Setting up your first AI Agent': 'إعداد أول وكيل ذكي لك',
    'Getting Started': 'البداية',
    'Understanding Intent Classification': 'فهم تصنيف النوايا',
    'AI Concepts': 'مفاهيم الذكاء الاصطناعي',
    'Connecting to Zendesk API': 'الربط بواجهة Zendesk البرمجية',
    Integrations: 'التكاملات',
    'Optimizing Token Usage': 'تحسين استهلاك التوكنز',
    Performance: 'الأداء',
    'Designing Conversation Flows': 'تصميم مسارات المحادثة',
    'Watch Now': 'شوفه الآن',
    'Frequently Asked Questions': 'الأسئلة الشائعة',
    'No fluff. Just straight answers.': 'بدون لف ودوران. إجابات مباشرة.',
    'Why is AI taking over customer support?':
      'ليش الذكاء الاصطناعي يسيطر على دعم العملاء؟',
    "It's not about taking over, it's about handling scale. AI can instantly resolve 50-80% of routine questions (refunds, status checks, FAQs) without making customers wait. This frees up humans to handle the complex, emotional, or high-stakes issues that actually require a human touch.":
      'الموضوع مو سيطرة، بل حجم. الذكاء الاصطناعي يحل ٥٠-٨٠٪ من الأسئلة الروتينية (الاسترداد، وحالة الطلب، والأسئلة الشائعة) فوراً وبدون انتظار. وهذا يفرّغ البشر للمواضيع المعقدة والعاطفية والحساسة، اللي تحتاج فعلاً لمسة بشرية.',
    'Why should I learn this now?': 'ليش أتعلم هذا الآن؟',
    "Because the industry is shifting. Support roles are moving from 'answering tickets' to 'managing AI agents' and 'designing conversation flows'. Learning these skills now positions you as an expert in the new era of support, rather than someone who just answers phones.":
      'لأن المجال يتغيّر. أدوار الدعم تتحول من "الرد على التذاكر" إلى "إدارة الوكلاء الأذكياء" و"تصميم مسارات المحادثة". وإذا تعلمت هذه المهارات الآن، تكون خبيراً في عصر الدعم الجديد، مو مجرد شخص يرد على الهاتف.',
    'Will this take my job?': 'راح ياخذ وظيفتي؟',
    "It will change your job. Low-level data entry and copy-pasting answers will disappear. But the demand for people who understand customer problems and can train AI to solve them is skyrocketing. You'll spend less time on repetitive tasks and more time on strategy, quality assurance, and complex problem-solving.":
      'سيغيّر وظيفتك. إدخال البيانات ونسخ الردود ولصقها سيختفي. بس الطلب على اللي يفهم مشكلة العميل ويعرف كيف يدرّب الذكاء الاصطناعي عليها يزداد بسرعة. وقت أقل على المهام المتكررة، ووقت أكثر على الاستراتيجية والجودة وحل المشاكل المعقدة.',
    'Are these courses free?': 'الدورات مجانية؟',
    'Yes. We believe the future of support should be accessible to everyone. The core curriculum at Open Academy is completely free. We want to empower the next generation of support leaders.':
      'نعم. نرى أن مستقبل الدعم يجب أن يكون متاحاً للجميع. المنهج الأساسي في أكاديمية Open مجاني تماماً، لأننا نريد تمكين الجيل القادم من قادة الدعم.',
    'Do I get a certificate upon completion?': 'فيه شهادة بعد ما أخلّص؟',
    "While we don't issue formal certificates yet, our team is happy to endorse your new skills on LinkedIn or provide a reference via email upon successful completion of the advanced tracks.":
      'ما نصدر شهادات رسمية حتى الآن، بس فريقنا مستعد للتوصية بمهاراتك الجديدة على LinkedIn أو منحك توصية بالإيميل بعد إكمالك المسارات المتقدمة.',
    'Do I need technical skills to start?': 'أحتاج مهارات تقنية للبدء؟',
    'No coding experience is required. Our courses are designed for support professionals, not software engineers. We focus on the practical application of AI tools, strategy, and workflow design using no-code interfaces.':
      'لا تحتاج خبرة برمجة. دوراتنا مصممة لمحترفي الدعم، لا لمهندسي البرمجيات. نركز على التطبيق العملي لأدوات الذكاء الاصطناعي، والاستراتيجية، وتصميم سير العمل باستخدام واجهات بدون كود.',
    'How often is the content updated?': 'كل كم تحدّثون المحتوى؟',
    'AI moves fast, and so do we. We update our lessons monthly to include the latest developments in LLMs, new tooling features, and emerging best practices in the industry.':
      'الذكاء الاصطناعي يتطور بسرعة، وإحنا كذلك. نحدّث دروسنا كل شهر: آخر التطورات في نماذج اللغة الكبيرة، ومزايا الأدوات الجديدة، وأحدث الممارسات في المجال.',
    'Is there a community I can join?': 'فيه مجتمع أقدر أنضم له؟',
    "Yes! When you enroll, you get access to our private Slack community of over 5,000 support leaders and AI enthusiasts. It's the perfect place to ask questions, share wins, and network.":
      'إي. أول ما تسجل، تدخل مجتمعنا الخاص على Slack مع قادة الدعم والمهتمين بالذكاء الاصطناعي. أفضل مكان تسأل فيه، تشارك نجاحاتك، وتبني علاقات.',
  },
  integrations: {
    Integrations: 'التكاملات',
    'Open connects with your existing tools. Integrate ticketing systems, knowledge bases, CRMs, and more to power your AI agent.':
      'Open يعمل مع أدواتك الحالية. اربط أنظمة التذاكر وقواعد المعرفة وأنظمة CRM وغيرها، ويتغذى منها الوكيل الذكي.',
    'Ticketing Systems': 'أنظمة التذاكر',
    'The AI agent solves tickets end-to-end alongside your team. Native integration means it works inside your existing system—no migration needed.':
      'الوكيل الذكي يحل التذاكر من أولها لآخرها، إلى جانب فريقك. والتكامل الأصلي يعني أنه يعمل داخل نظامك الحالي — بلا نقل بيانات.',
    'Training Sources': 'مصادر التدريب',
    'Train the AI by connecting it to your knowledge bases and data sources. We support anything Airbyte connects to, plus web crawling.':
      'درّب الوكيل الذكي بربطه بقواعد معرفتك ومصادر بياناتك. ندعم كل ما يتصل به Airbyte، وزحف الويب كذلك.',
    'CRM Systems': 'أنظمة CRM',
    'Bi-directional sync and updates with your existing CRM. Keep customer data in sync automatically.':
      'مزامنة وتحديثات ثنائية الاتجاه مع نظام CRM عندك. بيانات العملاء تبقى متطابقة على الجهتين، تلقائياً.',
    'E-commerce': 'التجارة الإلكترونية',
    'Allow the AI agent to fetch, read, and update orders for customers in real-time.':
      'خلّ الوكيل الذكي يجيب طلبات العميل ويقرأها ويحدّثها في نفس اللحظة.',
    'IT & DevOps': 'تقنية المعلومات والتطوير',
    'Connect your development and IT tools for seamless issue tracking and escalation.':
      'اربط أدوات التطوير وتقنية المعلومات عندك، عشان يسير تتبّع المشاكل وتصعيدها بسلاسة.',
    'Automation & Other': 'الأتمتة وغيرها',
    'Connect to thousands of apps through automation platforms or build custom integrations.':
      'اوصل لآلاف التطبيقات عبر منصات الأتمتة، أو ابنِ تكاملاتك المخصصة بنفسك.',
    'Learn more': 'اعرف أكثر',
    'Coming soon': 'قريباً',
    Beta: 'تجريبي',
    'Limited access': 'وصول محدود',
    "Don't see your integration?": 'ما تلقى التكامل اللي تريده؟',
    "We're constantly adding new integrations. Let us know what you need, or build your own with our API.":
      'نضيف تكاملات جديدة باستمرار. أخبرنا بما تحتاج — أو ابنِه بنفسك على API عندنا.',
    'Request Integration': 'اطلب تكامل',
    'View API Docs': 'شوف وثائق API',
    'Full ticket management, macros, and agent handoff':
      'إدارة تذاكر كاملة وماكرو وتحويل للموظف',
    'Inbox integration with conversation routing':
      'تكامل صندوق الوارد مع توجيه المحادثات',
    'Ticket automation and SLA management':
      'أتمتة التذاكر وإدارة اتفاقيات مستوى الخدمة',
    'Unified customer service with CRM context':
      'خدمة عملاء موحدة بسياق من نظام CRM',
    'Enterprise-grade case management': 'إدارة حالات على مستوى المؤسسات',
    'Programmable contact center integration': 'تكامل مركز اتصال قابل للبرمجة',
    'Our native AI-first helpdesk solution':
      'نظام الدعم عندنا — الـ AI في صلبه',
    'Automatically crawl and index your website': 'زحف وفهرسة موقعك تلقائياً',
    'Sync pages, databases, and workspaces':
      'مزامنة الصفحات وقواعد البيانات ومساحات العمل',
    'Import spaces and documentation': 'استيراد المساحات والتوثيق',
    'Connect documents and shared drives': 'ربط المستندات والأقراص المشتركة',
    'Import structured data from spreadsheets':
      'استيراد بيانات منظمة من جداول البيانات',
    'Sync articles and knowledge base': 'مزامنة المقالات وقاعدة المعرفة',
    'Import help center articles': 'استيراد مقالات مركز المساعدة',
    'Import help center articles from Intercom':
      'استيراد مقالات مركز المساعدة من Intercom',
    'Sync all published help center articles with full content.':
      'نزامن كل مقالة منشورة في مركز المساعدة، بمحتواها الكامل.',
    'Sync solution articles': 'مزامنة مقالات الحلول',
    'Import documentation and guides': 'استيراد التوثيق والأدلة',
    'Sync README files and wikis': 'مزامنة ملفات README والويكي',
    'Learn from channel history and threads':
      'التعلم من تاريخ القنوات والمواضيع',
    'Learn from channel history, threads, and conversations':
      'التعلم من تاريخ القنوات والمواضيع والمحادثات',
    'Connect bases and tables': 'ربط القواعد والجداول',
    'Sync docs and structured content': 'مزامنة المستندات والمحتوى المنظم',
    'Import documents and files': 'استيراد المستندات والملفات',
    'Connect Microsoft documents': 'ربط مستندات Microsoft',
    'Sync enterprise document libraries': 'مزامنة مكتبات مستندات المؤسسة',
    'Sync enterprise document libraries from SharePoint':
      'مزامنة مكتبات مستندات المؤسسة من SharePoint',
    'Import project documentation': 'استيراد توثيق المشاريع',
    'Sync board data and docs': 'مزامنة بيانات ووثائق اللوحات',
    'Import knowledge base articles': 'استيراد مقالات قاعدة المعرفة',
    'Import knowledge base articles from HubSpot':
      'استيراد مقالات قاعدة المعرفة من HubSpot',
    'Import document collections': 'استيراد مجموعات المستندات',
    'Import document collections from MongoDB':
      'استيراد مجموعات المستندات من MongoDB',
    'Connect data warehouse': 'ربط مستودع البيانات',
    'Sync Google data warehouse': 'مزامنة مستودع بيانات Google',
    'Import spreadsheet data': 'استيراد بيانات جداول البيانات',
    'Custom API integration': 'تكامل API مخصص',
    'Full contact sync, deals, and activity logging':
      'مزامنة كاملة لجهات الاتصال والصفقات وتسجيل النشاطات',
    'Enterprise CRM with case and account sync':
      'نظام CRM للمؤسسات مع مزامنة الحالات والحسابات',
    'Sales pipeline integration and contact sync':
      'تكامل مسار المبيعات ومزامنة جهات الاتصال',
    'Contact and deal synchronization': 'مزامنة جهات الاتصال والصفقات',
    'Complete CRM sync and automation': 'مزامنة وأتمتة كاملة لإدارة العملاء',
    'Pipe contact data and interactions': 'نقل بيانات جهات الاتصال والتفاعلات',
    'Customer lifecycle management': 'إدارة دورة حياة العميل',
    'Full order management: view, update, cancel, and refund orders':
      'إدارة كاملة للطلبات: عرض وتحديث وإلغاء واسترجاع',
    'Create and track issues from support conversations':
      'إنشاء وتتبع المشاكل من محادثات الدعم',
    'Managed integration with 5,000+ apps': 'تكامل مُدار مع +٥٠٠٠ تطبيق',
    'Train your AI on': 'درّب وكيلك الذكي على',
    'Auth:': 'المصادقة:',
    'Incremental sync': 'مزامنة تزايدية',
    'Full refresh': 'تحديث كامل',
    "Connect once, and Open automatically keeps your AI agent's knowledge up to date. When you update content in {name}, the changes sync automatically—no manual retraining required.":
      'اربط مرة وحدة، وOpen يتولى الباقي. حدّث المحتوى في {name} وقت ما تريد، والتغيير يصل الوكيل الذكي من نفسه — بلا إعادة تدريب يدوية.',
    'syncs to': 'يتزامن مع',
    'AI Agent': 'الوكيل الذكي',
    'What can be synced': 'وش يتزامن',
    Features: 'المميزات',
    Requirements: 'المتطلبات',
    'How to connect': 'كيف تربطه',
    'Good to know': 'ما تحتاج معرفته',
    'Common questions': 'أسئلة شائعة',
    'Security:': 'الأمان:',
    'Open only requires read access to your {name}. We never write, modify, or delete your content. All data is encrypted in transit and at rest. SOC 2 Type II and GDPR compliant.':
      'Open يطلب صلاحية قراءة فقط على {name}. لا نكتب ولا نعدّل ولا نحذف أي شيء من محتواك. جميع البيانات مشفّرة أثناء النقل وفي التخزين. متوافق مع SOC 2 Type II وGDPR.',
    'Ready to connect {name}?': 'جاهز تربط {name}؟',
    'AI Training → Sources → {name}':
      'تدريب الذكاء الاصطناعي ← المصادر ← {name}',
    'Get a demo': 'اعرف أكثر',
    'Log in →': 'تسجيل الدخول ←',
    'Other training sources': 'مصادر تدريب أخرى',
    'View all →': 'عرض الكل ←',
    'Custom event-driven integrations': 'تكاملات مخصصة مدفوعة بالأحداث',
    'Build custom integrations with our API':
      'ابنِ تكاملات مخصصة عبر API عندنا',
    'Connect your Notion workspace to train your AI agent on your company knowledge. Open syncs your pages, databases, and all content blocks to give your AI agent deep understanding of your documentation, processes, and internal knowledge.':
      'اربط مساحة عمل Notion ودرّب الوكيل الذكي على معرفة شركتك. Open يسحب الصفحات وقواعد البيانات وكل كتلة محتوى فيها، فيصير عند الوكيل فهم عميق لتوثيقك وعملياتك ومعرفتك الداخلية.',
    'Full Page Sync': 'مزامنة كاملة للصفحات',
    'Automatically sync all pages from your Notion workspace, including nested subpages and their full content hierarchy.':
      'نزامن كل صفحة في مساحة عمل Notion تلقائياً — الصفحات الفرعية المتداخلة وهيكل المحتوى كامل.',
    'Database Integration': 'تكامل قاعدة البيانات',
    'Import structured data from Notion databases, including all properties, relations, and rollups for comprehensive knowledge.':
      'نستورد البيانات المنظمة من قواعد بيانات Notion: كل الخصائص والعلاقات والتجميعات.',
    'Real-time Updates': 'تحديثات فورية',
    "Changes in Notion are automatically reflected in your AI agent's knowledge base with configurable sync intervals.":
      'أي تغيير في Notion ينعكس على قاعدة معرفة الوكيل الذكي، بفترات مزامنة تضبطها بنفسك.',
    'Rich Content Support': 'دعم المحتوى الغني',
    'Handles all Notion block types including text, images, code blocks, tables, callouts, and embedded content.':
      'نتعامل مع كل أنواع كتل Notion: النصوص والصور وكتل الكود والجداول والتنبيهات والمحتوى المضمن.',
    Pages: 'الصفحات',
    'All pages and subpages with full content, including title, content blocks, and metadata.':
      'كل الصفحات والصفحات الفرعية بمحتواها الكامل: العنوان وكتل المحتوى والبيانات الوصفية.',
    Databases: 'قواعد البيانات',
    'Database entries with all properties (text, numbers, dates, selects, multi-selects, relations, formulas).':
      'مدخلات قاعدة البيانات بكل الخصائص (نصوص، أرقام، تواريخ، اختيارات، اختيارات متعددة، علاقات، معادلات).',
    Blocks: 'الكتل',
    'Individual content blocks including paragraphs, headings, lists, toggles, callouts, code, and more.':
      'كتل المحتوى الفردية: الفقرات والعناوين والقوائم وعناصر الطي والتنبيهات والكود وغيرها.',
    Users: 'المستخدمين',
    'Workspace user information for context on content ownership and permissions.':
      'معلومات مستخدمي مساحة العمل: من يملك المحتوى ومن له صلاحية عليه.',
    Comments: 'التعليقات',
    'Page and block comments for additional context and discussions.':
      'تعليقات الصفحات والكتل، وفيها سياق إضافي ونقاشات.',
    'Train AI on internal documentation and SOPs':
      'درّب الوكيل على التوثيق الداخلي وإجراءات التشغيل القياسية',
    'Sync product knowledge bases for customer support':
      'مزامنة قواعد معرفة المنتجات لدعم العملاء',
    'Import HR policies and employee handbooks':
      'استيراد سياسات الموارد البشرية وكتيبات الموظفين',
    'Connect engineering wikis and technical docs':
      'ربط ويكي الهندسة والمستندات التقنية',
    'Sync sales playbooks and objection handling guides':
      'مزامنة كتيبات المبيعات وأدلة التعامل مع الاعتراضات',
    'Import customer success runbooks': 'استيراد كتيبات نجاح العملاء',
    'Log in to your Notion workspace and go to My Integrations page':
      'سجل دخول لمساحة عمل Notion وروح لصفحة My Integrations',
    'Click "New integration" and select your workspace':
      'اضغط على "تكامل جديد" واختر مساحة عملك',
    'Enable "Read content" capability (required), plus "Read comments" and "Read user information" if needed':
      'فعّل قدرة "قراءة المحتوى" (مطلوبة)، ومعها "قراءة التعليقات" و"قراءة معلومات المستخدم" إذا احتجتها',
    'Navigate to pages you want to sync and click ••• menu → Add connections → select your integration':
      'انتقل للصفحات اللي تريد مزامنتها واضغط على قائمة ••• ← إضافة اتصالات ← اختر تكاملك',
    'Copy the Access Token from the Secrets tab of your integration':
      'انسخ رمز الوصول من تبويب الأسرار في تكاملك',
    'In Open, go to AI Training → Sources → Connect Notion and paste your token':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط Notion والصق رمزك',
    'Access to a Notion workspace': 'صلاحية وصول لمساحة عمل Notion',
    'Owner permissions to create integrations':
      'صلاحيات المالك لإنشاء التكاملات',
    'Pages must be explicitly shared with the integration':
      'لازم الصفحات تكون مشاركة صراحة مع التكامل',
    'OAuth 2.0 simplifies setup and is recommended for most users':
      'OAuth 2.0 يبسط الإعداد وموصى به لمعظم المستخدمين',
    'With Access Token auth, you must manually share each page you want to sync':
      'مع مصادقة رمز الوصول، لازم تشارك يدوياً كل صفحة تريد مزامنتها',
    'Incremental sync only replicates data generated after your configured start date':
      'المزامنة التزايدية ما تنسخ إلا البيانات اللي أُنشئت بعد تاريخ البداية اللي ضبطته',
    'Default start date is 2 years ago if not specified':
      'إذا ما حددت تاريخ بداية، الافتراضي قبل سنتين',
    'Do I need to share every page individually?':
      'هل لازم أشارك كل صفحة بشكل فردي؟',
    'If using Access Token auth, yes - you must share each page with your integration. With OAuth 2.0, you can select pages during the authorization flow.':
      'إذا تستخدم مصادقة رمز الوصول، نعم — لازم تشارك كل صفحة مع تكاملك. مع OAuth 2.0، تقدر تختار الصفحات أثناء عملية التفويض.',
    'How often does the content sync?': 'كم مرة يتزامن المحتوى؟',
    'You can configure sync frequency in Open. Incremental sync only fetches changes since the last sync, making updates efficient.':
      'تقدر تضبط تكرار المزامنة في Open. والمزامنة التزايدية ما تجلب إلا التغييرات من آخر مزامنة، فالتحديثات تطلع سريعة وخفيفة.',
    'Are comments and discussions included?': 'هل التعليقات والنقاشات مشمولة؟',
    'Yes, if you enable the "Read comments" capability in your Notion integration settings.':
      'نعم، إذا فعّلت قدرة "قراءة التعليقات" في إعدادات تكامل Notion.',
    'Connect Microsoft OneDrive documents': 'ربط مستندات Microsoft OneDrive',
    'Connect your Microsoft OneDrive to train your AI agent on your documents. Open syncs files from your personal or business OneDrive, extracting content from Office documents and PDFs.':
      'اربط Microsoft OneDrive ودرّب الوكيل الذكي على مستنداتك. Open يزامن ملفاتك من OneDrive الشخصي أو للأعمال، ويستخرج محتوى مستندات Office وملفات PDF.',
    'Sync files from specific OneDrive folders recursively.':
      'نزامن الملفات من المجلدات اللي تحددها في OneDrive، ومجلداتها الفرعية.',
    'Office Integration': 'تكامل Office',
    'Native support for Word, Excel, and PowerPoint content extraction.':
      'دعم أصلي لاستخراج محتوى Word وExcel وPowerPoint.',
    'Business & Personal': 'للأعمال والشخصي',
    'Works with OneDrive for Business and personal accounts.':
      'يعمل مع OneDrive للأعمال والحسابات الشخصية.',
    'Shared Content': 'المحتوى المشترك',
    'Access shared files and folders.': 'نوصل للملفات والمجلدات المشتركة.',
    Files: 'الملفات',
    'Document files with content extraction for Office and PDF formats.':
      'ملفات المستندات مع استخراج المحتوى لصيغ Office وPDF.',
    Folders: 'المجلدات',
    'Folder structure and organization.': 'هيكل وتنظيم المجلدات.',
    Metadata: 'البيانات الوصفية',
    'File properties, dates, and sharing information.':
      'خصائص الملفات وتواريخها ومعلومات مشاركتها.',
    'Corporate documents and templates': 'مستندات ونماذج الشركة',
    'Team shared folders': 'مجلدات الفريق المشتركة',
    'Project deliverables': 'مخرجات المشاريع',
    'HR and policy documents': 'مستندات الموارد البشرية والسياسات',
    'Training materials': 'مواد التدريب',
    'Client files': 'ملفات العملاء',
    'In Open, go to AI Training → Sources → Connect OneDrive':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط OneDrive',
    'Click "Authenticate with Microsoft" and sign in':
      'اضغط "المصادقة مع Microsoft" وسجل دخول',
    'Authorize access to your OneDrive files': 'فوّض الوصول لملفات OneDrive',
    'Select folders to sync': 'اختر المجلدات للمزامنة',
    'Configure file type filters if needed':
      'اضبط تصفية أنواع الملفات إذا احتجت',
    'Microsoft account (personal or work)': 'حساب Microsoft (شخصي أو عمل)',
    'Access to OneDrive folders you want to sync':
      'صلاحية وصول لمجلدات OneDrive اللي تريد مزامنتها',
    'OneDrive for Business may require admin consent for OAuth':
      'OneDrive للأعمال قد يحتاج موافقة المسؤول لـ OAuth',
    'Office documents are extracted as text with formatting':
      'نستخرج مستندات Office كنص مع تنسيقها',
    'SharePoint document libraries need SharePoint connector':
      'مكتبات مستندات SharePoint تحتاج موصل SharePoint',
    'Large syncs may hit Microsoft Graph API rate limits':
      'المزامنات الكبيرة قد تصطدم بحدود المعدل في Microsoft Graph API',
    'Import documents and files from Dropbox':
      'استيراد المستندات والملفات من Dropbox',
    'Connect your Dropbox to train your AI agent on your documents. Open syncs files from selected folders, extracting content from documents, PDFs, and other text-based files.':
      'اربط Dropbox ودرّب الوكيل الذكي على مستنداتك. Open يزامن الملفات من المجلدات اللي تختارها، ويستخرج المحتوى من المستندات وملفات PDF وبقية الملفات النصية.',
    'Folder Sync': 'مزامنة المجلدات',
    'Sync files from selected folders including subfolders.':
      'نزامن الملفات من المجلدات اللي تختارها، والمجلدات الفرعية معها.',
    'Document Extraction': 'استخراج المستندات',
    'Extract text content from PDFs, Office docs, and text files.':
      'نستخرج المحتوى النصي من PDF ومستندات Office والملفات النصية.',
    'Shared Folders': 'المجلدات المشتركة',
    'Access shared folders and team content.':
      'نوصل للمجلدات المشتركة ومحتوى الفريق.',
    'File Filtering': 'تصفية الملفات',
    'Filter by file types using glob patterns.':
      'نصفّي حسب نوع الملف بأنماط glob.',
    'Text Documents': 'المستندات النصية',
    'PDF, DOCX, TXT and other text-based files. Binary files (images, videos, executables) are excluded.':
      'PDF، DOCX، TXT وملفات نصية أخرى. الملفات الثنائية (صور، فيديوهات، ملفات تنفيذية) مستبعدة.',
    'File names, paths, sizes, and modification dates.':
      'أسماء الملفات ومساراتها وأحجامها وتواريخ تعديلها.',
    'Folder structure for organization context.':
      'هيكل المجلدات، ومنه يجي السياق التنظيمي.',
    'Shared team documentation': 'توثيق الفريق المشترك',
    'Client files and deliverables': 'ملفات ومخرجات العملاء',
    'Company policies and procedures': 'سياسات وإجراءات الشركة',
    'Archived content and records': 'المحتوى والسجلات المؤرشفة',
    'In Open, go to AI Training → Sources → Connect Dropbox':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط Dropbox',
    'Click "Authenticate with Dropbox" and authorize access':
      'اضغط "المصادقة مع Dropbox" وفوض الوصول',
    'Select the folder path to sync from': 'اختر مسار المجلد للمزامنة منه',
    'Start syncing your Dropbox content': 'ابدأ مزامنة محتوى Dropbox',
    'Dropbox account with access to folders you want to sync':
      'حساب Dropbox مع وصول للمجلدات اللي تريد مزامنتها',
    'OAuth authorization': 'تفويض OAuth',
    'Document text extraction works for common formats (PDF, DOCX, TXT)':
      'استخراج نص المستندات يعمل مع الصيغ الشائعة (PDF، DOCX، TXT)',
    'Binary files (images, videos, executables) are not synced':
      'الملفات الثنائية (صور، فيديوهات، ملفات تنفيذية) ما تتزامن',
    'Only text-based documents are processed for AI training':
      'ما نعالج إلا المستندات النصية لتدريب الوكيل الذكي',
    'Large folders may take time for initial sync':
      'المجلدات الكبيرة قد تستغرق وقتاً في المزامنة الأولى',
    'Respects Dropbox sharing permissions': 'نحترم صلاحيات المشاركة في Dropbox',
    'Sync docs and structured content from Coda':
      'مزامنة المستندات والمحتوى المنظم من Coda',
    'Connect your Coda workspace to train your AI agent on your docs. Open syncs pages, tables, and formulas from your Coda docs, capturing both narrative content and structured data.':
      'اربط مساحة عمل Coda ودرّب الوكيل الذكي على مستنداتك. Open يزامن الصفحات والجداول والمعادلات من مستندات Coda، ويمسك المحتوى السردي والبيانات المنظمة مع بعض.',
    'Doc Sync': 'مزامنة المستندات',
    'Sync entire Coda docs with all pages and subpages.':
      'نزامن مستندات Coda كاملة، بصفحاتها وصفحاتها الفرعية.',
    'Table Data': 'بيانات الجدول',
    'Extract structured data from Coda tables with all column types.':
      'نستخرج البيانات المنظمة من جداول Coda، بكل أنواع الأعمدة.',
    'Formula Values': 'قيم المعادلات',
    'Sync computed formula values for derived content.':
      'نزامن قيم المعادلات المحسوبة للمحتوى المشتق.',
    'Page Content': 'محتوى الصفحة',
    'Full page content including text, embeds, and layouts.':
      'محتوى الصفحة كامل: النص والمضمنات والتخطيطات.',
    Docs: 'المستندات',
    'Document metadata and structure.': 'البيانات الوصفية وهيكل المستند.',
    'All pages with content, including nested pages.':
      'كل الصفحات بمحتواها، والصفحات المتداخلة كذلك.',
    Tables: 'الجداول',
    'Table data with rows and all column values.':
      'بيانات الجدول مع الصفوف وكل قيم الأعمدة.',
    'Team wikis and documentation': 'ويكي الفريق والتوثيق',
    'Project tracking docs': 'مستندات تتبع المشاريع',
    'Process playbooks': 'كتيبات العمليات',
    'Meeting notes and decisions': 'ملاحظات وقرارات الاجتماعات',
    'Product specs and PRDs': 'مواصفات المنتج ومستندات متطلباته',
    'Team databases and directories': 'قواعد بيانات ودلائل الفريق',
    'Go to Coda Account Settings → API Settings':
      'روح لإعدادات حساب Coda ← إعدادات الواجهة البرمجية',
    'Generate a new API Token': 'ولّد رمز واجهة برمجية جديد',
    'In Open, go to AI Training → Sources → Connect Coda':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط Coda',
    'Enter your API Token': 'أدخل رمز الواجهة البرمجية',
    'Select docs to sync': 'اختر المستندات للمزامنة',
    'Coda API Token': 'رمز واجهة Coda البرمجية',
    'Access to the docs you want to sync':
      'صلاحية وصول للمستندات اللي تريد مزامنتها',
    'API token determines which docs are accessible':
      'رمز الواجهة البرمجية هو اللي يحدد المستندات المتاحة',
    'Table formulas sync as their computed values':
      'معادلات الجدول تتزامن كقيمها المحسوبة',
    'Embedded content may not fully transfer':
      'المحتوى المضمن قد لا ينتقل كاملاً',
    'Large docs with many tables may take time to sync':
      'المستندات الكبيرة اللي تحتوي جداول كثيرة قد تستغرق وقتاً في المزامنة',
    'Connect your HubSpot Knowledge Base to train your AI agent on your support articles. Open syncs all published articles with their content, categories, and metadata for comprehensive AI training.':
      'اربط قاعدة معرفة HubSpot ودرّب الوكيل الذكي على مقالات الدعم عندك. Open يزامن كل مقالة منشورة بمحتواها وفئاتها وبياناتها الوصفية، عشان يكون التدريب شاملاً.',
    'Sync all published knowledge base articles with full content.':
      'نزامن كل مقالة منشورة في قاعدة المعرفة، بمحتواها الكامل.',
    'Category Organization': 'تنظيم الفئات',
    'Maintain article categories and subcategories.':
      'نحافظ على فئات المقالات وفئاتها الفرعية كما هي.',
    'Rich Content': 'محتوى غني',
    'Preserve formatting, images, and embedded content references.':
      'نحفظ التنسيق والصور ومراجع المحتوى المضمن.',
    'Automatic Updates': 'تحديثات تلقائية',
    'Changes in HubSpot sync automatically to your AI.':
      'أي تغيير في HubSpot يوصل الوكيل الذكي تلقائياً.',
    'Full article content including title, body, and metadata.':
      'محتوى المقالة كامل: العنوان والنص والبيانات الوصفية.',
    Categories: 'الفئات',
    'Knowledge base categories and organization.':
      'فئات قاعدة المعرفة وطريقة تنظيمها.',
    Tags: 'الوسوم',
    'Article tags for topic classification.': 'وسوم المقالات لتصنيف المواضيع.',
    'Train AI on existing help content':
      'درّب الوكيل على محتوى المساعدة الحالي',
    'Import onboarding guides': 'استيراد أدلة الإعداد',
    'Keep AI updated with new articles': 'خلّ الوكيل محدّث مع كل مقالة جديدة',
    'Consistent support across channels': 'دعم متسق عبر القنوات',
    'Go to HubSpot Settings → Integrations → Private Apps':
      'روح لإعدادات HubSpot ← التكاملات ← التطبيقات الخاصة',
    'Create a new Private App with CMS read scope':
      'أنشئ تطبيق خاص جديد مع صلاحية قراءة CMS',
    'Copy the Access Token': 'انسخ رمز الوصول',
    'Enter your Access Token': 'أدخل رمز الوصول',
    'In Open, go to AI Training → Sources → Connect HubSpot KB':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط HubSpot KB',
    'Select which knowledge bases to sync':
      'اختر قواعد المعرفة اللي تريد مزامنتها',
    'HubSpot account with Knowledge Base feature':
      'حساب HubSpot بميزة قاعدة المعرفة',
    'Private App with CMS read permissions': 'تطبيق خاص بصلاحيات قراءة CMS',
    'Published knowledge base articles': 'مقالات قاعدة المعرفة المنشورة',
    'Requires HubSpot Service Hub Professional or Enterprise':
      'يتطلب HubSpot Service Hub Professional أو Enterprise',
    'Only published articles are synced': 'ما يتزامن إلا المقالات المنشورة',
    'Only published articles are synced by default':
      'افتراضياً، ما يتزامن إلا المقالات المنشورة',
    'Article analytics not included in sync':
      'تحليلات المقالات غير مشمولة في المزامنة',
    'Multi-language articles sync as separate entries':
      'المقالات متعددة اللغات تتزامن كمدخلات منفصلة',
    'Sync solution articles from Freshdesk':
      'مزامنة مقالات الحلول من Freshdesk',
    'Connect your Freshdesk Knowledge Base to train your AI agent on your support articles. Open syncs all solution articles, categories, and folders to give your AI agent comprehensive knowledge of your help content.':
      'اربط قاعدة معرفة Freshdesk ودرّب الوكيل الذكي على مقالات الدعم عندك. Open يزامن مقالات الحلول والفئات والمجلدات كلها، فيصير عند الوكيل معرفة شاملة بمحتوى المساعدة.',
    'Solution Article Sync': 'مزامنة مقالات الحلول',
    'Sync all solution articles with full content and formatting.':
      'نزامن كل مقالات الحلول بمحتواها وتنسيقها كامل.',
    'Maintain folder and category organization for context.':
      'نحافظ على تنظيم المجلدات والفئات، فيوصل السياق معه.',
    'Optionally include draft articles for comprehensive coverage.':
      'وإذا أردت تغطية أشمل، ضم مقالات المسودة معها.',
    Multilingual: 'متعدد اللغات',
    'Sync articles across multiple language portals.':
      'نزامن المقالات عبر بوابات اللغات كلها.',
    'Solution Articles': 'مقالات الحلول',
    'Full article content including title, description, and body.':
      'محتوى المقالة كامل: العنوان والوصف والنص.',
    'Solution categories for organizational context.':
      'فئات الحلول، ومنها يجي السياق التنظيمي.',
    'Folder structure within categories.': 'هيكل المجلدات ضمن الفئات.',
    'Train AI on existing knowledge base':
      'درّب الوكيل على قاعدة المعرفة الحالية',
    'Import troubleshooting guides': 'استيراد أدلة حل المشاكل',
    'Ensure consistent support answers': 'ضمان أجوبة دعم متسقة',
    'Go to Freshdesk Admin → Profile Settings → API Key':
      'روح لمسؤول Freshdesk ← إعدادات الملف الشخصي ← مفتاح الواجهة البرمجية',
    'Copy your API Key': 'انسخ مفتاح الواجهة البرمجية',
    'In Open, go to AI Training → Sources → Connect Freshdesk KB':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط Freshdesk KB',
    'Enter your Freshdesk domain and API Key':
      'أدخل نطاق Freshdesk ومفتاح الواجهة البرمجية',
    'Select categories to sync': 'اختر الفئات للمزامنة',
    'Articles will sync automatically': 'المقالات تتزامن تلقائياً',
    'Freshdesk API Key': 'مفتاح واجهة Freshdesk البرمجية',
    'Freshdesk domain (yourcompany.freshdesk.com)':
      'نطاق Freshdesk (yourcompany.freshdesk.com)',
    'Published solution articles': 'مقالات الحلول المنشورة',
    'API Key found in Profile Settings, not Admin settings':
      'مفتاح الواجهة البرمجية موجود في إعدادات الملف الشخصي، لا في إعدادات المسؤول',
    'Only published articles sync by default':
      'افتراضياً، ما يتزامن إلا المقالات المنشورة',
    'Article attachments are referenced but not downloaded':
      'نشير لمرفقات المقالات، بس ما ننزّلها',
    'Folder permissions respected during sync':
      'نحترم صلاحيات المجلدات أثناء المزامنة',
    'Connect your Intercom Help Center to train your AI agent on your support articles. Open syncs all published articles with their content, categories, and metadata.':
      'اربط مركز مساعدة Intercom ودرّب الوكيل الذكي على مقالات الدعم عندك. Open يزامن كل مقالة منشورة بمحتواها وفئاتها وبياناتها الوصفية.',
    'Collection Structure': 'هيكل المجموعة',
    'Maintain article organization through collections and sections.':
      'نحافظ على تنظيم المقالات في مجموعاتها وأقسامها.',
    'Multilingual Support': 'دعم متعدد اللغات',
    'Sync articles across all configured languages.':
      'نزامن المقالات بكل اللغات المضبوطة.',
    'Author Tracking': 'تتبع المؤلف',
    'Include article authors and last update timestamps.':
      'نضم مؤلف كل مقالة وطابع آخر تحديث لها.',
    Articles: 'المقالات',
    'Help center collections and their organization structure.':
      'مجموعات مركز المساعدة وهيكل تنظيمها.',
    Sections: 'الأقسام',
    'Sections within collections for content hierarchy.':
      'أقسام داخل المجموعات، تبني هرمية المحتوى.',
    'Go to Intercom Settings → Integrations → Developer Hub':
      'روح لإعدادات Intercom ← التكاملات ← مركز المطورين',
    'Create a new app or use an existing one':
      'أنشئ تطبيق جديد أو استخدم واحد موجود',
    'Generate an Access Token with read permissions':
      'ولّد رمز وصول بصلاحيات قراءة',
    'In Open, go to AI Training → Sources → Connect Intercom':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط Intercom',
    'Intercom Access Token with Articles read permission':
      'رمز وصول Intercom بصلاحية قراءة المقالات',
    'Published articles in your Help Center':
      'مقالات منشورة في مركز المساعدة عندك',
    'Draft articles can be optionally included':
      'وتقدر تضم مقالات المسودة إذا أردت',
    'Article body is synced as HTML - formatting preserved':
      'محتوى المقالة يتزامن كـ HTML — والتنسيق يبقى على حاله',
    'Incremental sync picks up new and updated articles':
      'المزامنة التزايدية تلتقط المقالات الجديدة والمحدثة',
    'Sync your Google BigQuery data warehouse':
      'مزامنة مستودع بيانات Google BigQuery عندك',
    'Connect your Google BigQuery data warehouse to train your AI agent on analytics data. Open syncs tables and views, bringing your structured business intelligence data to your AI agent.':
      'اربط مستودع بيانات Google BigQuery ودرّب الوكيل الذكي على بيانات التحليلات. Open يزامن الجداول والعروض، ويوصّل بيانات ذكاء الأعمال المنظمة للوكيل جاهزة.',
    'Dataset Sync': 'مزامنة مجموعة البيانات',
    'Sync tables from selected BigQuery datasets.':
      'نزامن الجداول من مجموعات بيانات BigQuery اللي تختارها.',
    'Partitioned Tables': 'جداول مقسمة',
    'Support for partitioned tables with efficient incremental sync.':
      'دعم للجداول المقسمة مع مزامنة تزايدية فعالة.',
    'View Support': 'دعم العروض',
    'Sync both tables and materialized views.':
      'نزامن الجداول والعروض المادية سوا.',
    'GCP Integration': 'تكامل GCP',
    'Native Google Cloud authentication with service accounts.':
      'مصادقة Google Cloud الأصلية مع حسابات الخدمة.',
    'Full table data including all columns and nested/repeated fields.':
      'بيانات الجدول كاملة: كل الأعمدة، والحقول المتداخلة والمكررة.',
    Views: 'العروض',
    'Materialized views with their computed data.':
      'عروض مادية ببياناتها المحسوبة.',
    'Nested Data': 'بيانات متداخلة',
    'Support for STRUCT and ARRAY column types.':
      'دعم لأنواع أعمدة STRUCT وARRAY.',
    'Analytics dashboards data': 'بيانات لوحات التحليلات',
    'Customer segmentation data': 'بيانات تقسيم العملاء',
    'Product metrics and usage stats': 'مقاييس المنتج وإحصائيات الاستخدام',
    'Marketing attribution data': 'بيانات إسناد التسويق',
    'Financial aggregations': 'تجميعات مالية',
    'Data science model outputs': 'مخرجات نماذج علم البيانات',
    'Create a GCP service account with BigQuery Data Viewer role':
      'أنشئ حساب خدمة GCP بدور BigQuery Data Viewer',
    'Generate and download a JSON key for the service account':
      'ولّد مفتاح JSON لحساب الخدمة وحمّله',
    'In Open, go to AI Training → Sources → Connect BigQuery':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط BigQuery',
    'Upload your service account JSON key': 'ارفع مفتاح JSON لحساب الخدمة',
    'Enter your GCP project ID and dataset names':
      'أدخل معرف مشروع GCP وأسماء مجموعات البيانات',
    'Select tables to sync': 'اختر الجداول للمزامنة',
    'GCP service account with BigQuery Data Viewer role':
      'حساب خدمة GCP بدور BigQuery Data Viewer',
    'Service account JSON key file': 'ملف مفتاح JSON لحساب الخدمة',
    'Project ID and dataset names': 'معرف المشروع وأسماء مجموعات البيانات',
    'Costs may apply for BigQuery data scanned during sync':
      'البيانات الممسوحة في BigQuery أثناء المزامنة قد يترتب عليها تكلفة',
    'Large tables benefit from partitioning for incremental sync':
      'الجداول الكبيرة تستفيد من التقسيم للمزامنة التزايدية',
    'Nested and repeated fields are flattened in the output':
      'نسطّح الحقول المتداخلة والمكررة في الناتج',
    'Consider using views to pre-aggregate data':
      'فكّر تجمّع البيانات مسبقاً داخل عرض',
    'Are there costs for syncing data?': 'هل فيه تكاليف لمزامنة البيانات؟',
    'Yes, BigQuery charges for data scanned during queries. Consider using views or partitioned tables to reduce costs.':
      'نعم، BigQuery يحاسب على البيانات الممسوحة أثناء الاستعلامات. استخدم عروضاً أو جداول مقسمة، وتنزل الفاتورة.',
    'Connect your Snowflake data warehouse': 'ربط مستودع بيانات Snowflake عندك',
    'Connect your Snowflake data warehouse to train your AI agent on structured business data. Open syncs tables and views, making your data warehouse knowledge accessible to your AI agent.':
      'اربط مستودع بيانات Snowflake ودرّب الوكيل الذكي على بيانات أعمالك المنظمة. Open يزامن الجداول والعروض، فتصير معرفة المستودع كلها في متناول الوكيل.',
    'Table Sync': 'مزامنة الجداول',
    'Sync tables and views from your Snowflake database.':
      'نزامن الجداول والعروض من قاعدة بيانات Snowflake.',
    'Schema Discovery': 'اكتشاف المخطط',
    'Automatic schema detection for all data types.':
      'نكتشف المخطط تلقائياً لكل أنواع البيانات.',
    'Query Filtering': 'تصفية الاستعلامات',
    'Optionally filter data using SQL WHERE clauses.':
      'وتقدر تصفّي البيانات بجمل SQL WHERE إذا احتجت.',
    'Role-based Access': 'وصول قائم على الأدوار',
    'Respect Snowflake roles and access controls.':
      'نحترم أدوار Snowflake وضوابط الوصول فيه.',
    'Full table data with all columns and rows.':
      'بيانات الجدول الكاملة بكل الأعمدة والصفوف.',
    'Materialized and regular views with their computed data.':
      'عروض مادية وعادية ببياناتها المحسوبة.',
    Schemas: 'المخططات',
    'Schema metadata for structure understanding.':
      'بيانات المخطط الوصفية لفهم هيكله.',
    'Business intelligence data': 'بيانات ذكاء الأعمال',
    'Aggregated metrics and KPIs': 'مقاييس ومؤشرات أداء مجمعة',
    'Customer analytics data': 'بيانات تحليلات العملاء',
    'Product usage statistics': 'إحصائيات استخدام المنتج',
    'Financial reporting data': 'بيانات التقارير المالية',
    'Marketing campaign data': 'بيانات الحملات التسويقية',
    'Create a Snowflake user with read access to required schemas':
      'أنشئ مستخدم Snowflake بوصول قراءة للمخططات المطلوبة',
    'Note your account identifier, warehouse, database, and schema':
      'دوّن معرف الحساب والمستودع وقاعدة البيانات والمخطط',
    'In Open, go to AI Training → Sources → Connect Snowflake':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط Snowflake',
    'Enter your Snowflake credentials and connection details':
      'أدخل بيانات اعتماد Snowflake وتفاصيل الاتصال',
    'Select tables and views to sync': 'اختر الجداول والعروض للمزامنة',
    'Snowflake account identifier': 'معرف حساب Snowflake',
    'User credentials with SELECT permissions':
      'بيانات اعتماد مستخدم بصلاحيات SELECT',
    'Warehouse, database, and schema names':
      'أسماء المستودع وقاعدة البيانات والمخطط',
    'Network access (may need to whitelist IPs)':
      'وصول الشبكة (قد تحتاج تضيف عناوين IP للقائمة المسموح لها)',
    'Large tables may take significant time for initial sync':
      'الجداول الكبيرة قد تطوّل في المزامنة الأولى',
    'Consider using views to filter/aggregate data before syncing':
      'فكّر تصفّي البيانات أو تجمّعها في عرض قبل المزامنة',
    'Warehouse must be running for sync to work':
      'لازم يكون المستودع نشطاً حتى تعمل المزامنة',
    'Incremental sync uses standard CDC patterns':
      'المزامنة التزايدية تستخدم أنماط CDC القياسية',
    'What permissions does the user need?':
      'وش الصلاحيات اللي يحتاجها المستخدم؟',
    'SELECT permission on the tables/views you want to sync, and USAGE on the warehouse, database, and schema.':
      'صلاحية SELECT على الجداول والعروض اللي تريد مزامنتها، وUSAGE على المستودع وقاعدة البيانات والمخطط.',
    'Sync board data and documentation from Monday.com':
      'مزامنة بيانات اللوحة والتوثيق من Monday.com',
    'Connect your Monday.com workspace to train your AI agent on board data. Open syncs boards, items, and their values to capture project information, processes, and structured content.':
      'اربط مساحة عمل Monday.com ودرّب الوكيل الذكي على بيانات لوحاتك. Open يزامن اللوحات والعناصر وقيمها، فيمسك معلومات المشاريع والعمليات والمحتوى المنظم.',
    'Board Sync': 'مزامنة اللوحة',
    'Sync all boards with groups, items, and column configurations.':
      'نزامن كل اللوحات بمجموعاتها وعناصرها وتكوينات أعمدتها.',
    'Column Values': 'قيم الأعمدة',
    'Extract all column types including text, numbers, dates, and dropdowns.':
      'نستخرج كل أنواع الأعمدة: النصوص والأرقام والتواريخ والقوائم المنسدلة.',
    'Updates & Comments': 'التحديثات والتعليقات',
    'Include item updates and comments for discussion context.':
      'نجيب تحديثات العناصر وتعليقاتها، فيوصلك سياق النقاش كامل.',
    'Workspace Filtering': 'تصفية مساحة العمل',
    'Select specific workspaces or boards to sync.':
      'اختر مساحات عمل أو لوحات محددة للمزامنة.',
    Boards: 'اللوحات',
    'Board metadata with groups, columns, and configuration.':
      'بيانات اللوحة الوصفية: المجموعات والأعمدة والتكوين.',
    Items: 'العناصر',
    'All items with their column values across different column types.':
      'كل العناصر بقيم أعمدتها، على اختلاف أنواعها.',
    Updates: 'التحديثات',
    'Item updates and replies for communication history.':
      'تحديثات العناصر وردودها، ومنها يتكوّن تاريخ التواصل.',
    Teams: 'الفرق',
    'Team and user information from the workspace.':
      'معلومات الفريق والمستخدمين من مساحة العمل.',
    'Project tracking boards': 'لوحات تتبع المشاريع',
    'Process documentation in item descriptions':
      'توثيق العمليات في أوصاف العناصر',
    'CRM-style contact boards': 'لوحات جهات اتصال بنمط CRM',
    'Sprint and development tracking': 'تتبع السبرنت والتطوير',
    'Client management boards': 'لوحات إدارة العملاء',
    'Go to your Monday.com profile → Admin → API':
      'روح لملفك الشخصي في Monday.com ← المسؤول ← الواجهة البرمجية',
    'Paste your API Token': 'الصق رمز الواجهة البرمجية',
    'In Open, go to AI Training → Sources → Connect Monday.com':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط Monday.com',
    'Select boards to sync': 'اختر اللوحات للمزامنة',
    'Monday.com API Token with read access':
      'رمز واجهة Monday.com البرمجية بوصول قراءة',
    'Access to the boards you want to sync':
      'صلاحية وصول للوحات اللي تريد مزامنتها',
    'API token scopes determine which boards are accessible':
      'نطاقات رمز الواجهة البرمجية هي اللي تحدد اللوحات المتاحة',
    'Complex column types like formulas sync as their display values':
      'أنواع الأعمدة المعقدة مثل المعادلات تتزامن كقيم عرضها',
    'Subitems are synced as separate entries':
      'العناصر الفرعية تتزامن كمدخلات منفصلة',
    'Rate limits may apply for large workspaces':
      'مساحات العمل الكبيرة قد تصطدم بحدود المعدل',
    'Import project documentation and tasks from Asana':
      'استيراد توثيق المشاريع والمهام من Asana',
    'Connect your Asana workspace to train your AI agent on project documentation. Open syncs tasks, projects, and their descriptions to capture institutional knowledge about processes and workflows.':
      'اربط مساحة عمل Asana ودرّب الوكيل الذكي على توثيق مشاريعك. Open يزامن المهام والمشاريع وأوصافها، فيمسك المعرفة المؤسسية عن عملياتك وسير عملك.',
    'Project Sync': 'مزامنة المشاريع',
    'Sync all projects with their descriptions, sections, and organizational structure.':
      'نزامن كل المشاريع بأوصافها وأقسامها وهيكلها التنظيمي.',
    'Task Content': 'محتوى المهمة',
    'Extract task names, descriptions, comments, and attachments.':
      'نستخرج أسماء المهام وأوصافها وتعليقاتها ومرفقاتها.',
    'Custom Fields': 'حقول مخصصة',
    'Include custom field values for rich metadata on tasks.':
      'نضم قيم الحقول المخصصة، فتصير البيانات الوصفية للمهام أغنى.',
    'Workspace Support': 'دعم مساحة العمل',
    'Sync from specific workspaces or across your entire organization.':
      'نزامن من مساحات عمل محددة، أو من المنظمة كلها.',
    Projects: 'المشاريع',
    'All projects with names, descriptions, and section structure.':
      'كل المشاريع بأسمائها وأوصافها وهيكل أقسامها.',
    Tasks: 'المهام',
    'Tasks with names, descriptions, assignees, due dates, and custom fields.':
      'المهام بأسمائها وأوصافها والمعينين لها وتواريخ استحقاقها وحقولها المخصصة.',
    Stories: 'القصص',
    'Task comments and activity history for context.':
      'تعليقات المهام وتاريخ نشاطها، ومنها يجي السياق.',
    'Workspace members with names and email addresses.':
      'أعضاء مساحة العمل بالأسماء وعناوين الإيميل.',
    'Process documentation in project descriptions':
      'توثيق العمليات في أوصاف المشاريع',
    'Recurring task templates and checklists':
      'قوالب المهام المتكررة وقوائم التحقق',
    'Team workflows and procedures': 'سير عمل الفريق والإجراءات',
    'Meeting notes and action items': 'ملاحظات الاجتماعات وبنود التنفيذ',
    'Project status updates and decisions': 'تحديثات حالة المشروع والقرارات',
    'Onboarding task lists': 'قوائم مهام الإعداد',
    'Go to Asana Developer Console and create a Personal Access Token':
      'روح لوحة تحكم مطوري Asana وأنشئ رمز وصول شخصي',
    'Or set up OAuth for automatic token management':
      'أو اضبط OAuth، ويتولى إدارة الرمز عنك',
    'In Open, go to AI Training → Sources → Connect Asana':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط Asana',
    'Authenticate with your access token or OAuth':
      'صادق برمز الوصول أو عبر OAuth',
    'Select workspaces and projects to sync':
      'اختر مساحات العمل والمشاريع للمزامنة',
    'Configure which data types to include':
      'حدد أنواع البيانات اللي تريد ضمها',
    'Asana account with access to workspaces you want to sync':
      'حساب Asana بوصول لمساحات العمل اللي تريد مزامنتها',
    'Personal Access Token or OAuth app credentials':
      'رمز وصول شخصي أو بيانات اعتماد تطبيق OAuth',
    'Task attachments sync as URLs - file content needs separate extraction':
      'مرفقات المهام تتزامن كروابط URL — ومحتوى الملف يحتاج استخراج منفصل',
    'Completed tasks are included by default':
      'المهام المكتملة مشمولة افتراضياً',
    'Subtasks are synced as separate task entries':
      'المهام الفرعية تتزامن كمدخلات مهام منفصلة',
    'Rate limits apply - large workspaces may take time to sync':
      'هناك حدود معدل — ومساحات العمل الكبيرة قد تستغرق وقتاً في المزامنة',
    'Connect your Microsoft SharePoint to train your AI agent on enterprise documents. Open syncs files from document libraries, extracting content from Office documents, PDFs, and other supported formats.':
      'اربط Microsoft SharePoint ودرّب الوكيل الذكي على مستندات مؤسستك. Open يزامن الملفات من مكتبات المستندات، ويستخرج المحتوى من مستندات Office وPDF وبقية الصيغ المدعومة.',
    'Document Libraries': 'مكتبات المستندات',
    'Sync entire document libraries with folder structure preservation.':
      'نزامن مكتبات المستندات كاملة، وهيكل المجلدات يبقى على حاله.',
    'Office Document Support': 'دعم مستندات Office',
    'Extract text content from Word, Excel, PowerPoint, and PDF files.':
      'نستخرج المحتوى النصي من ملفات Word وExcel وPowerPoint وPDF.',
    'Site Selection': 'اختيار الموقع',
    'Choose specific SharePoint sites and libraries to sync.':
      'اختر مواقع SharePoint ومكتبات محددة للمزامنة.',
    'Metadata Sync': 'مزامنة البيانات الوصفية',
    'Include document metadata like author, modified date, and custom columns.':
      'نضم البيانات الوصفية للمستند: المؤلف، تاريخ التعديل، والأعمدة المخصصة.',
    'Document files with content extraction for supported formats (Office docs, PDFs).':
      'ملفات المستندات مع استخراج المحتوى للصيغ المدعومة (مستندات Office وملفات PDF).',
    'Folder structure and organization from document libraries.':
      'هيكل وتنظيم المجلدات من مكتبات المستندات.',
    'Document properties, custom columns, and SharePoint metadata.':
      'خصائص المستند، الأعمدة المخصصة، والبيانات الوصفية لـ SharePoint.',
    'Corporate policy documents': 'مستندات سياسة الشركة',
    'HR handbooks and procedures': 'كتيبات وإجراءات الموارد البشرية',
    'Sales collateral and presentations': 'مواد المبيعات والعروض التقديمية',
    'Technical documentation': 'التوثيق التقني',
    'Compliance and regulatory docs': 'مستندات الامتثال والتنظيم',
    'Register an app in Azure Active Directory with SharePoint permissions':
      'سجل تطبيق في Azure Active Directory بصلاحيات SharePoint',
    'Grant Sites.Read.All or more specific permissions':
      'امنح Sites.Read.All أو صلاحيات أكثر تحديداً',
    'Collect your Azure AD credentials (Client ID, Secret, Tenant ID)':
      'اجمع بيانات اعتماد Azure AD (معرف العميل، وسر العميل، ومعرف المستأجر)',
    'In Open, go to AI Training → Sources → Connect SharePoint':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط SharePoint',
    'Enter your Azure AD credentials and SharePoint site URL':
      'أدخل بيانات اعتماد Azure AD وURL موقع SharePoint',
    'Select document libraries to sync': 'اختر مكتبات المستندات للمزامنة',
    'Azure Active Directory app with SharePoint API permissions':
      'تطبيق Azure Active Directory بصلاحيات واجهة SharePoint البرمجية',
    'Client ID, Client Secret, and Tenant ID':
      'معرف العميل، سر العميل، ومعرف المستأجر',
    'SharePoint site URL': 'URL موقع SharePoint',
    'Appropriate permissions for the sites/libraries you want to sync':
      'صلاحيات مناسبة للمواقع والمكتبات اللي تريد مزامنتها',
    'Requires Azure AD app registration with appropriate permissions':
      'يتطلب تسجيل تطبيق Azure AD بصلاحيات مناسبة',
    'Large document libraries may take time for initial sync':
      'مكتبات المستندات الكبيرة قد تستغرق وقتاً في المزامنة الأولى',
    'Binary files are synced but need document extraction for text content':
      'الملفات الثنائية تتزامن، بس يلزمها استخراج مستندات لاستخراج المحتوى النصي',
    'Supports SharePoint Online (Microsoft 365) - on-premises may vary':
      'يدعم SharePoint Online (Microsoft 365) — أما النسخ داخل المؤسسة فقد تختلف',
    'Does it work with on-premises SharePoint?':
      'هل يعمل مع SharePoint داخل المؤسسة؟',
    'The connector is optimized for SharePoint Online (Microsoft 365). On-premises support may vary.':
      'الموصل محسّن لـ SharePoint Online (Microsoft 365)، والدعم للنسخ داخل المؤسسة قد يختلف.',
    'Connect your MongoDB database to train your AI agent on document collections. Open syncs collections using Change Data Capture (CDC) for real-time updates or full refresh for complete snapshots.':
      'اربط قاعدة بيانات MongoDB ودرّب الوكيل الذكي على مجموعات مستنداتك. Open يزامن المجموعات عبر Change Data Capture (CDC) للتحديثات الفورية، أو بتحديث كامل إذا أردت لقطة كاملة.',
    'CDC Replication': 'نسخ CDC',
    'Change Data Capture for real-time incremental sync of inserts, updates, and deletes.':
      'Change Data Capture لمزامنة تزايدية فورية للإدراجات والتحديثات والحذف.',
    'Schema-less Mode': 'وضع بدون مخطط',
    'Read documents without assuming a fixed schema - handles varying document structures.':
      'نقرأ المستندات بدون افتراض مخطط ثابت، فنتعامل مع أي هيكل يجي.',
    'Collection Sync': 'مزامنة المجموعة',
    'Sync entire collections or filter by specific criteria.':
      'نزامن المجموعات كاملة، أو نصفّيها بمعايير تحددها.',
    'Cluster Support': 'دعم العنقود',
    'Works with MongoDB Atlas and self-hosted replica set clusters.':
      'يعمل مع MongoDB Atlas ومجموعات النسخ المستضافة ذاتياً.',
    Collections: 'المجموعات',
    'Full collection data with all documents and their nested structures.':
      'بيانات المجموعة الكاملة بكل المستندات وهياكلها المتداخلة.',
    Documents: 'المستندات',
    'Individual documents with all fields, including nested objects and arrays.':
      'مستندات فردية بكل حقولها، والكائنات المتداخلة والمصفوفات معها.',
    'Change Streams': 'تدفقات التغيير',
    'Real-time capture of inserts, updates, and deletes via CDC (requires replica set).':
      'التقاط فوري للإدراجات والتحديثات والحذف عبر CDC (يتطلب مجموعة نسخ).',
    'Product catalogs stored in MongoDB': 'كتالوجات منتجات مخزنة في MongoDB',
    'User profiles and preferences': 'ملفات المستخدمين وتفضيلاتهم',
    'Content management system data': 'بيانات نظام إدارة المحتوى',
    'Application configuration data': 'بيانات تكوين التطبيق',
    'Logging and analytics data': 'بيانات السجلات والتحليلات',
    'IoT sensor data and metrics': 'بيانات ومقاييس مستشعرات إنترنت الأشياء',
    'Create a database user with read access (and oplog access for CDC)':
      'أنشئ مستخدم قاعدة بيانات بوصول قراءة (ووصول oplog لـ CDC)',
    'Get your MongoDB connection string from Atlas or your cluster':
      'احصل على سلسلة اتصال MongoDB من Atlas أو من العنقود عندك',
    'Ensure your cluster is a replica set (required for CDC)':
      'تأكد أن العنقود عندك مجموعة نسخ (مطلوب لـ CDC)',
    'In Open, go to AI Training → Sources → Connect MongoDB':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط MongoDB',
    'Enter your connection string and credentials':
      'أدخل سلسلة الاتصال وبيانات الاعتماد',
    'Select collections to sync and choose sync mode':
      'اختر المجموعات للمزامنة واختر وضع المزامنة',
    'MongoDB replica set cluster (Atlas or self-hosted)':
      'عنقود مجموعة نسخ MongoDB (Atlas أو مستضاف ذاتياً)',
    'Database user with read permissions': 'مستخدم قاعدة بيانات بصلاحيات قراءة',
    'For CDC: oplog access for the user': 'لـ CDC: وصول oplog للمستخدم',
    'Network access to MongoDB (whitelist IPs if needed)':
      'وصول الشبكة لـ MongoDB (أضف عناوين IP للقائمة المسموح لها إذا احتجت)',
    'CDC requires a replica set - standalone MongoDB instances only support full refresh':
      'CDC يتطلب مجموعة نسخ — ومثيلات MongoDB المنفردة ما تدعم إلا التحديث الكامل',
    'Schema-less mode handles documents with varying structures':
      'الوضع بدون مخطط يتعامل مع مستندات بهياكل متنوعة',
    'For large collections, initial sync may take significant time':
      'مع المجموعات الكبيرة، المزامنة الأولى قد تطوّل',
    'MongoDB 3.6+ required for Change Streams':
      'MongoDB 3.6+ مطلوب لـ Change Streams',
    'Atlas M10+ clusters recommended for production CDC':
      'عناقيد Atlas M10+ موصى بها لـ CDC الإنتاجي',
    'Do I need a replica set?': 'هل أحتاج مجموعة نسخ؟',
    'For CDC (incremental) sync, yes. Standalone MongoDB instances only support full refresh sync.':
      'لمزامنة CDC (التزايدية)، نعم. مثيلات MongoDB المنفردة ما تدعم إلا مزامنة التحديث الكامل.',
    'What MongoDB versions are supported?': 'وش إصدارات MongoDB المدعومة؟',
    'MongoDB 3.6 or higher is required for Change Streams support.':
      'MongoDB 3.6 أو أعلى مطلوب لدعم Change Streams.',
    'Connect your Airtable workspace to train your AI agent on structured data. Open syncs all tables from your bases, including all field types, attachments, and linked records for comprehensive knowledge.':
      'اربط مساحة عمل Airtable ودرّب الوكيل الذكي على بياناتك المنظمة. Open يزامن كل الجداول من قواعدك — كل أنواع الحقول والمرفقات والسجلات المرتبطة، بلا استثناء.',
    'Full Base Sync': 'مزامنة قاعدة كاملة',
    'Sync all tables from selected bases with complete field data and relationships.':
      'نزامن كل الجداول من القواعد اللي تختارها، ببيانات حقولها وعلاقاتها كاملة.',
    'Rich Field Support': 'دعم حقول غنية',
    'Handles all Airtable field types including attachments, lookups, rollups, and formulas.':
      'نتعامل مع كل أنواع حقول Airtable: المرفقات، البحث، التجميعات، والمعادلات.',
    'Linked Records': 'سجلات مرتبطة',
    'Preserves relationships between tables through linked record fields.':
      'نحفظ العلاقات بين الجداول عبر حقول السجلات المرتبطة.',
    'View Filtering': 'تصفية العرض',
    'Optionally sync only records visible in specific views.':
      'وتقدر تزامن بس السجلات المرئية في عروض محددة.',
    'All tables from selected bases with complete record data and metadata.':
      'كل الجداول من القواعد المحددة، بسجلاتها وبياناتها الوصفية كاملة.',
    Records: 'السجلات',
    'Individual records with all field values, including complex field types like attachments and lookups.':
      'سجلات فردية بكل قيم حقولها، حتى المعقدة منها مثل المرفقات والبحث.',
    Attachments: 'المرفقات',
    'File attachments with URLs and metadata (actual file content requires additional processing).':
      'مرفقات الملفات بروابطها وبياناتها الوصفية (محتوى الملف نفسه يحتاج معالجة إضافية).',
    'Product databases with rich metadata':
      'قواعد بيانات منتجات ببيانات وصفية غنية',
    'Content calendars and editorial data': 'تقويمات محتوى وبيانات تحريرية',
    'CRM-style contact databases': 'قواعد بيانات جهات اتصال بنمط CRM',
    'Project tracking and documentation': 'تتبع وتوثيق المشاريع',
    'Inventory and catalog management': 'إدارة المخزون والكتالوج',
    'Team wikis in tabular format': 'ويكي الفريق بصيغة جدولية',
    'Go to airtable.com/create/tokens to create a Personal Access Token':
      'روح لـ airtable.com/create/tokens لإنشاء رمز وصول شخصي',
    'Add scope: schema.bases:read and data.records:read':
      'أضف نطاق: schema.bases:read وdata.records:read',
    'Select which bases to grant access to':
      'اختر القواعد اللي تريد منحها الوصول',
    'In Open, go to AI Training → Sources → Connect Airtable':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط Airtable',
    'Choose OAuth or paste your Personal Access Token':
      'اختر OAuth أو الصق رمز الوصول الشخصي',
    'Select bases and tables to sync': 'اختر القواعد والجداول للمزامنة',
    'Personal Access Token with schema.bases:read and data.records:read scopes':
      'رمز وصول شخصي بنطاقات schema.bases:read وdata.records:read',
    'Access to the bases you want to sync':
      'صلاحية وصول للقواعد اللي تريد مزامنتها',
    'OAuth is recommended for simpler setup': 'نوصي بـOAuth لإعداد أبسط',
    'If you rename a table in Airtable, reset the connection to continue syncing':
      'إذا غيرت اسم جدول في Airtable، أعد ضبط الاتصال لمواصلة المزامنة',
    'Deleted tables stop syncing automatically':
      'الجداول المحذوفة توقف المزامنة تلقائياً',
    'Formula fields sync their computed values':
      'حقول المعادلات تتزامن بقيمها المحسوبة',
    'Attachment URLs are synced but files need separate download':
      'روابط المرفقات تتزامن، بس الملفات نفسها تحتاج تنزيل منفصل',
    'What happens if I rename a table?': 'وش يحدث إذا غيرت اسم جدول؟',
    'You need to reset the connection schema and re-select the renamed table. Airtable cannot notify Open of table renames.':
      'تحتاج تعيد ضبط مخطط الاتصال وتختار الجدول المعاد تسميته. Airtable ما يقدر يخبر Open بإعادة تسمية الجداول.',
    'Are attachments synced?': 'هل المرفقات تتزامن؟',
    'Attachment URLs and metadata are synced. The actual file content requires additional processing.':
      'روابط المرفقات وبياناتها الوصفية تتزامن. أما محتوى الملف نفسه فيحتاج معالجة إضافية.',
    'Connect your Google Sheets to train your AI agent on structured data. Open syncs all sheets within a spreadsheet, extracting rows as knowledge. Perfect for FAQs, product information, pricing tables, and any structured content.':
      'اربط Google Sheets ودرّب الوكيل الذكي على بياناتك المنظمة. Open يزامن كل ورقة في جدول البيانات، ويحوّل الصفوف لمعرفة. مثالي للأسئلة الشائعة ومعلومات المنتجات وجداول الأسعار وأي محتوى منظم.',
    'Sheet Sync': 'مزامنة الورقة',
    'Sync all sheets within a spreadsheet, with each sheet becoming a separate data stream.':
      'نزامن كل ورقة في جدول البيانات، وكل ورقة تصير تدفق بيانات مستقل.',
    'Header Detection': 'اكتشاف الرأس',
    'Automatically detects column headers and uses them as field names for structured extraction.':
      'نكتشف رؤوس الأعمدة تلقائياً ونستخدمها كأسماء حقول للاستخراج المنظم.',
    'Row-based Learning': 'تعلم قائم على الصفوف',
    'Each row becomes a knowledge entry, perfect for FAQ lists and product catalogs.':
      'كل صف يصبح مدخل معرفة، مثالي لقوائم الأسئلة الشائعة وكتالوجات المنتجات.',
    'Named Ranges': 'نطاقات مسماة',
    'Optionally sync specific named ranges instead of entire sheets.':
      'وتقدر تزامن نطاقات مسماة بدل الأوراق الكاملة.',
    Sheets: 'الأوراق',
    'Each sheet tab within the spreadsheet is synced as a separate stream with all rows and columns.':
      'كل تبويب ورقة داخل جدول البيانات يتزامن كتدفق منفصل بكل الصفوف والأعمدة.',
    'Cell Values': 'قيم الخلايا',
    'All cell values including text, numbers, dates, and formulas (evaluated results).':
      'كل قيم الخلايا: النصوص، الأرقام، التواريخ، والمعادلات (بنتائجها المحسوبة).',
    'FAQ sheets with questions and answers':
      'أوراق الأسئلة الشائعة بسؤالها وجوابها',
    'Product catalogs with specifications': 'كتالوجات منتجات بمواصفات',
    'Pricing tables and comparison charts': 'جداول أسعار ومخططات مقارنة',
    'Team directories and contact lists': 'دلائل فريق وقوائم جهات اتصال',
    'Process checklists and procedures': 'قوائم تحقق وإجراءات العمليات',
    'Training content in tabular format': 'محتوى تدريبي بصيغة جدولية',
    'In Open, go to AI Training → Sources → Connect Google Sheets':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط Google Sheets',
    'Click "Authenticate via Google (OAuth)" and authorize access':
      'اضغط "المصادقة عبر Google (OAuth)" وفوض الوصول',
    'Copy the spreadsheet link from your browser address bar':
      'انسخ رابط جدول البيانات من شريط عنوان المتصفح',
    'Paste the link and configure which sheets to sync':
      'الصق الرابط وحدد الأوراق اللي تريد مزامنتها',
    'Optionally rename sheets or specify named ranges':
      'وإذا أردت، غيّر أسماء الأوراق أو حدد نطاقات مسماة',
    'Start syncing your spreadsheet data': 'ابدأ مزامنة بيانات جدولك',
    'Google Sheets spreadsheet link': 'رابط جدول بيانات Google Sheets',
    'Read access to the spreadsheet': 'وصول قراءة لجدول البيانات',
    'For Service Account: JSON key and sheet shared with service account email':
      'لحساب الخدمة: مفتاح JSON، والورقة مشاركة مع بريد حساب الخدمة',
    'Syncs from a single spreadsheet - use multiple connections for multiple spreadsheets':
      'يزامن من جدول بيانات واحد — ولجداول متعددة استخدم اتصالات متعددة',
    'First row is typically used as column headers':
      'الصف الأول عادة يستخدم كرؤوس أعمدة',
    'Empty rows and columns are skipped': 'نتخطى الصفوف والأعمدة الفارغة',
    'Formulas are synced as their evaluated values, not the formula itself':
      'المعادلات تتزامن كقيمها المحسوبة، لا المعادلة نفسها',
    'For multiple spreadsheets, use Google Drive connector instead':
      'لجداول بيانات متعددة، استخدم موصل Google Drive بدله',
    'Can I sync multiple spreadsheets?': 'هل أقدر أزامن جداول بيانات متعددة؟',
    'Each connection syncs one spreadsheet. For multiple spreadsheets, create multiple connections or use Google Drive connector.':
      'كل اتصال يزامن جدول بيانات واحد. لجداول بيانات متعددة، أنشئ اتصالات متعددة أو استخدم موصل Google Drive.',
    'How are formulas handled?': 'كيف تتعامل مع المعادلات؟',
    'Formulas sync as their computed values, not the formula text itself.':
      'المعادلات تتزامن كقيمها المحسوبة، لا نص المعادلة نفسه.',
    "Connect your Slack workspace to train your AI agent on your team's conversations and knowledge sharing. Open syncs channel messages, threads, and shared files to capture institutional knowledge.":
      'اربط مساحة عمل Slack ودرّب الوكيل الذكي على محادثات فريقك وطريقتهم في تبادل المعرفة. Open يزامن رسائل القنوات والمواضيع والملفات المشتركة، ويمسك المعرفة المؤسسية قبل ما تضيع.',
    'Channel Sync': 'مزامنة القناة',
    'Sync messages from selected public and private channels.':
      'نزامن الرسائل من القنوات العامة والخاصة اللي تختارها.',
    'Thread Context': 'سياق الموضوع',
    'Capture full thread conversations for complete context.':
      'نجيب الموضوع من أوله لآخره، فيوصل السياق كله.',
    'File Extraction': 'استخراج الملفات',
    'Extract content from shared documents and files.':
      'نستخرج المحتوى من المستندات والملفات المشتركة.',
    'User Context': 'سياق المستخدم',
    'Understand who shared information for authority weighting.':
      'نعرف من شارك المعلومة، عشان نقدّر مصداقيتها.',
    Channels: 'القنوات',
    'Channel metadata including public and private channels the bot is a member of (via Conversations API).':
      'بيانات القناة الوصفية، للقنوات العامة والخاصة اللي البوت عضو فيها (عبر Conversations API).',
    'Channel Messages': 'رسائل القناة',
    'Messages from non-archived public and private channels. The Slack App must be added to channels to sync messages.':
      'رسائل من قنوات عامة وخاصة غير مؤرشفة. ولازم تضيف تطبيق Slack للقناة حتى تتزامن رسائلها.',
    Threads: 'المواضيع',
    'Full thread conversations and replies with configurable lookback window.':
      'محادثات المواضيع وردودها كاملة، بنافذة رجوع تضبطها بنفسك.',
    'Workspace user information including profiles and basic metadata.':
      'معلومات مستخدمي مساحة العمل: الملفات الشخصية والبيانات الوصفية الأساسية.',
    'Capture tribal knowledge from team discussions':
      'التقاط الخبرة المتوارثة في نقاشات الفريق',
    'Train AI on support channel Q&As':
      'درّب الوكيل على أسئلة وأجوبة قناة الدعم',
    'Learn from engineering discussions': 'التعلم من نقاشات الهندسة',
    'Import sales team win/loss insights':
      'استيراد دروس فريق المبيعات من الصفقات الرابحة والخاسرة',
    'Sync customer feedback discussions': 'مزامنة نقاشات ملاحظات العملاء',
    'Capture decision-making context': 'التقاط سياق اتخاذ القرار',
    'Create a Slack app at api.slack.com/apps and select your workspace':
      'أنشئ تطبيق Slack في api.slack.com/apps واختر مساحة عملك',
    'Go to OAuth & Permissions and add Bot Token Scopes: channels:history, channels:join, channels:read, users:read':
      'روح لـ OAuth & Permissions وأضف نطاقات رمز البوت: channels:history, channels:join, channels:read, users:read',
    'Install the app to your workspace and copy the Bot User OAuth Token':
      'ثبت التطبيق لمساحة عملك وانسخ رمز OAuth لمستخدم البوت',
    'Add the app to channels you want to sync (click channel → Integrations → Add apps)':
      'أضف التطبيق للقنوات اللي تريد مزامنتها (اضغط القناة ← التكاملات ← أضف تطبيقات)',
    'In Open, go to AI Training → Sources → Connect Slack':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط Slack',
    'Authenticate via OAuth or paste your Bot Token, then select channels':
      'صادق عبر OAuth أو الصق رمز البوت، ثم اختر القنوات',
    'Slack app with appropriate Bot Token Scopes':
      'تطبيق Slack بنطاقات رمز بوت مناسبة',
    'App must be added to channels to sync messages':
      'لازم تضيف التطبيق للقنوات حتى تتزامن الرسائل',
    'Required scopes: channels:history, channels:read, users:read':
      'نطاقات مطلوبة: channels:history, channels:read, users:read',
    'The app only syncs from channels it has been explicitly added to':
      'التطبيق ما يزامن إلا من القنوات اللي أضفته لها صراحة',
    'Enable "join_channels" to auto-join all public channels':
      'فعل "join_channels" للانضمام التلقائي لكل القنوات العامة',
    'For private channels, manually add the bot even with join_channels enabled':
      'للقنوات الخاصة، أضف البوت يدوياً حتى مع join_channels مفعل',
    'Configure "Threads Lookback window" for historical thread data':
      'اضبط "نافذة رجوع المواضيع" عشان تصلك المواضيع القديمة',
    'Monitor for rate limits when syncing large historical data sets':
      'راقب حدود المعدل عند مزامنة مجموعات بيانات تاريخية كبيرة',
    'Increase workers count for faster sync (may trigger rate limits)':
      'زد عدد الـ workers لمزامنة أسرع (قد يصطدم بحدود المعدل)',
    "Why aren't messages syncing from a channel?":
      'ليش الرسائل ما تتزامن من قناة؟',
    'The Slack app must be explicitly added to each channel. Go to the channel → Integrations → Add apps and select your app.':
      'لازم تطبيق Slack يضاف صراحة لكل قناة. روح للقناة ← التكاملات ← أضف تطبيقات واختر تطبيقك.',
    'Can I sync private channels?': 'هل أقدر أزامن قنوات خاصة؟',
    'Yes, but you must manually add the bot to private channels even if join_channels is enabled.':
      'نعم، بس لازم تضيف البوت يدوياً للقنوات الخاصة حتى لو join_channels مفعل.',
    'Sync README files, wikis, and documentation from repositories':
      'مزامنة ملفات README، الويكي، والتوثيق من المستودعات',
    'Connect your GitHub repositories to train your AI agent on your technical documentation. Open syncs README files, wikis, and markdown documentation to give your AI agent deep understanding of your codebase and processes.':
      'اربط مستودعات GitHub ودرّب الوكيل الذكي على توثيقك التقني. Open يزامن ملفات README والويكي وتوثيق markdown، فيصير عند الوكيل فهم عميق لقاعدة الكود وعملياتك.',
    'Repository Docs': 'مستندات المستودع',
    'Sync README files and documentation from selected repositories.':
      'نزامن ملفات README والتوثيق من المستودعات اللي تختارها.',
    'Wiki Integration': 'تكامل الويكي',
    'Import GitHub Wiki pages for comprehensive documentation coverage.':
      'نستورد صفحات GitHub Wiki، فتكتمل تغطية التوثيق.',
    'Markdown Support': 'دعم Markdown',
    'Full markdown parsing with code block and formatting preservation.':
      'نحلل markdown كامل، وكتل الكود والتنسيق تبقى على حالها.',
    'Branch Selection': 'اختيار الفرع',
    'Choose which branches to sync documentation from.':
      'اختر الفروع اللي تريد سحب التوثيق منها.',
    Repositories: 'المستودعات',
    'Repository metadata including descriptions, topics, and basic information.':
      'بيانات المستودع الوصفية: الأوصاف، المواضيع، والمعلومات الأساسية.',
    Commits: 'الـ Commits',
    'Commit history with messages, authors, and timestamps from specified branches.':
      'تاريخ الـ Commits برسائلها ومؤلفيها وطوابعها الزمنية، من الفروع المحددة.',
    Issues: 'المشاكل',
    'GitHub issues with titles, bodies, labels, assignees, and comments.':
      'مشاكل GitHub بعناوينها ومحتوياتها وتسمياتها والمعينين لها وتعليقاتها.',
    'Pull Requests': 'طلبات السحب',
    'Pull requests with descriptions, review status, commits, and review comments.':
      'طلبات السحب بأوصافها وحالة مراجعتها والـ Commits وتعليقات المراجعة.',
    'Issue comments and commit comments for discussion context.':
      'تعليقات المشاكل وتعليقات الـ Commits، عشان ينتقل سياق النقاش.',
    Branches: 'الفروع',
    'Branch information and protection rules from repositories.':
      'معلومات الفرع وقواعد الحماية من المستودعات.',
    'Train AI on API documentation': 'درّب الوكيل على توثيق الواجهة البرمجية',
    'Sync developer guides and tutorials': 'مزامنة أدلة ودروس المطورين',
    'Import contribution guidelines': 'استيراد إرشادات المساهمة',
    'Connect architecture decision records': 'ربط سجلات قرارات البنية',
    'Sync deployment and ops documentation': 'مزامنة توثيق النشر والتشغيل',
    'Import coding standards and best practices':
      'استيراد معايير البرمجة وأفضل الممارسات',
    'Go to GitHub Settings → Developer settings → Personal access tokens':
      'روح لإعدادات GitHub ← إعدادات المطور ← رموز الوصول الشخصية',
    'Generate a new token with repo scope (and org:read for organization repos)':
      'ولّد رمز جديد بنطاق repo (وorg:read لمستودعات المنظمة)',
    'Copy the token for use in Open': 'انسخ الرمز للاستخدام في Open',
    'In Open, go to AI Training → Sources → Connect GitHub':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط GitHub',
    'Enter your token and specify repositories (e.g., "org/repo" or "org/*" for all)':
      'أدخل رمزك وحدد المستودعات (مثلاً: "org/repo" أو "org/*" للكل)',
    'Optionally specify branches to sync (default branch is used if not specified)':
      'وحدد الفروع اللي تريد مزامنتها إذا احتجت (وإلا يُستخدم الفرع الافتراضي)',
    'Personal Access Token or OAuth credentials':
      'رمز وصول شخصي أو بيانات اعتماد OAuth',
    'List of repositories to sync (format: org/repo)':
      'قائمة المستودعات للمزامنة (صيغة: org/repo)',
    'Appropriate permissions for private repositories':
      'صلاحيات مناسبة للمستودعات الخاصة',
    'Use multiple tokens separated by "," to load balance API quota':
      'استخدم رموز متعددة مفصولة بـ "," توزّع الحمل على حصة الواجهة البرمجية',
    'Most streams support incremental sync (append + deduplication)':
      'معظم التدفقات تدعم مزامنة تزايدية (إضافة + إلغاء تكرار)',
    'Specify branches like "org/repo/branch1,branch2" to sync specific branches':
      'حدد فروع مثل "org/repo/branch1,branch2" لمزامنة فروع محددة',
    'Invalid or inaccessible repository names are skipped with a warning':
      'نتخطى أسماء المستودعات غير الصالحة أو غير المتاحة، ونعطيك تحذير',
    'Syncs commits, issues, PRs, reviews, comments, and more':
      'يزامن الـ Commits والمشاكل وطلبات السحب والمراجعات والتعليقات وغيرها',
    'Can I sync from multiple organizations?':
      'هل أقدر أزامن من منظمات متعددة؟',
    'Yes, list repositories from different orgs in the format "org1/repo1,org2/repo2" or use "org/*" for all repos in an org.':
      'نعم، أدرج المستودعات من منظمات مختلفة بالصيغة "org1/repo1,org2/repo2" أو استخدم "org/*" لكل المستودعات في منظمة.',
    'How do I avoid rate limits?': 'كيف أتجنب حدود المعدل؟',
    'Use multiple personal access tokens separated by commas to load balance API quota across tokens.':
      'استخدم رموز وصول شخصية متعددة مفصولة بفواصل، فيتوزّع استهلاك حصة الواجهة البرمجية على الرموز كلها.',
    'Sync articles and knowledge base content from Zendesk':
      'مزامنة المقالات ومحتوى قاعدة المعرفة من Zendesk',
    'Connect your Zendesk Help Center to train your AI agent on your existing knowledge base. Open syncs all articles, categories, and sections to ensure your AI agent has the same knowledge as your help center.':
      'اربط مركز مساعدة Zendesk ودرّب الوكيل الذكي على قاعدة معرفتك الحالية. Open يزامن المقالات والفئات والأقسام كلها، فيعرف الوكيل بالضبط ما يعرفه مركز المساعدة عندك.',
    'Article Sync': 'مزامنة المقالات',
    'Automatically sync all published articles with full content and formatting.':
      'نزامن كل مقالة منشورة تلقائياً، بمحتواها وتنسيقها كامل.',
    'Category Structure': 'هيكل الفئة',
    'Maintain the category and section hierarchy for organized knowledge.':
      'نحافظ على هرمية الفئات والأقسام، فتبقى المعرفة منظمة.',
    'Multi-language': 'متعدد اللغات',
    'Sync articles across all configured languages in your Help Center.':
      'نزامن المقالات بكل اللغات المضبوطة في مركز المساعدة عندك.',
    'Draft Support': 'دعم المسودة',
    'Optionally include draft articles to prepare AI for upcoming content.':
      'وضم مقالات المسودة إذا أردت تجهيز الوكيل للمحتوى القادم.',
    'Help Center articles with full content, titles, body, labels, and metadata via the Zendesk Help Center API.':
      'مقالات مركز المساعدة كاملة: العناوين والنصوص والتسميات والبيانات الوصفية، عبر واجهة Zendesk Help Center البرمجية.',
    'Article Comments': 'تعليقات المقالات',
    'Comments on articles including user feedback and discussions.':
      'التعليقات على المقالات، وفيها ملاحظات المستخدمين ونقاشاتهم.',
    'Help Center categories with names, descriptions, and hierarchical structure.':
      'فئات مركز المساعدة بأسمائها وأوصافها وهيكلها الهرمي.',
    'Sections within categories for organized content structure.':
      'أقسام ضمن الفئات لهيكل محتوى منظم.',
    Posts: 'المنشورات',
    'Community posts from your Zendesk community forums.':
      'منشورات المجتمع من منتديات مجتمع Zendesk عندك.',
    Topics: 'المواضيع',
    'Community topics and discussion threads.':
      'مواضيع المجتمع وسلاسل النقاش فيه.',
    'Ensure AI answers match your help center':
      'اضمن أن أجوبة الوكيل تطابق مركز المساعدة عندك',
    'Train AI on product documentation': 'درّب الوكيل على توثيق المنتج',
    'Sync troubleshooting guides': 'مزامنة أدلة حل المشاكل',
    'Import FAQ content': 'استيراد محتوى الأسئلة الشائعة',
    'Connect how-to articles': 'ربط مقالات كيفية الاستخدام',
    'Sync getting started guides': 'مزامنة أدلة البدء',
    'In Zendesk Admin Center, go to Apps and Integrations → APIs → Zendesk API':
      'في مركز مسؤول Zendesk، روح للتطبيقات والتكاملات ← الواجهات البرمجية ← واجهة Zendesk البرمجية',
    'Click "Add API token" under Settings and give it a description':
      'اضغط "أضف رمز واجهة برمجية" تحت الإعدادات واكتب له وصفاً',
    "Copy the token immediately (you won't see it again)":
      'انسخ الرمز فوراً (ما تشوفه مرة ثانية)',
    'Enter your subdomain (from https://YOUR_SUBDOMAIN.zendesk.com/)':
      'أدخل النطاق الفرعي (من https://YOUR_SUBDOMAIN.zendesk.com/)',
    'Choose OAuth 2.0 or API Token auth, then enter credentials':
      'اختر مصادقة OAuth 2.0 أو رمز واجهة برمجية، ثم أدخل بيانات الاعتماد',
    'Zendesk subdomain': 'نطاق Zendesk الفرعي',
    'API token or OAuth credentials': 'رمز واجهة برمجية أو بيانات اعتماد OAuth',
    'Email associated with Zendesk account (for API token)':
      'إيميل مرتبط بحساب Zendesk (لرمز الواجهة البرمجية)',
    'OAuth is recommended as it simplifies setup significantly':
      'OAuth موصى به لأنه يختصر عليك الإعداد',
    'Most streams support incremental sync for efficient updates':
      'معظم التدفقات تدعم المزامنة التزايدية، فتجي التحديثات أخف',
    'Some streams like Audit Logs require enterprise accounts':
      'بعض التدفقات مثل سجلات التدقيق تتطلب حسابات مؤسسات',
    'Two sync types: server-side incremental and client-side filtering':
      'نوعان من المزامنة: تزايدية من جانب الخادم، وتصفية من جانب العميل',
    'Syncs Help Center articles, categories, sections, and community content':
      'يزامن مقالات مركز المساعدة وفئاتها وأقسامها ومحتوى المجتمع',
    "What's the difference between OAuth and API Token?":
      'وش الفرق بين OAuth ورمز الواجهة البرمجية؟',
    "OAuth is simpler to set up and doesn't require managing tokens. API Token requires your Zendesk email and manually generated token.":
      'OAuth أسهل في الإعداد ولا يضطرك لإدارة رموز. أما رمز الواجهة البرمجية فيحتاج بريد Zendesk عندك ورمزاً تولّده بنفسك.',
    'Are community forums included?': 'هل منتديات المجتمع مشمولة؟',
    'Yes, Posts and Topics from your Zendesk community are synced alongside Help Center articles.':
      'نعم، المنشورات والمواضيع من مجتمع Zendesk عندك تتزامن جنباً لجنب مع مقالات مركز المساعدة.',
    'Connect documents and shared drives from Google Workspace':
      'ربط المستندات والأقراص المشتركة من Google Workspace',
    'Connect your Google Workspace to train your AI agent on your documents, spreadsheets, and presentations. Open syncs content from Google Drive, including shared drives, to build comprehensive knowledge.':
      'اربط Google Workspace ودرّب الوكيل الذكي على مستنداتك وجداول بياناتك وعروضك التقديمية. Open يزامن المحتوى من Google Drive، والأقراص المشتركة كذلك، ويبني منه معرفة شاملة.',
    'Drive Integration': 'تكامل Drive',
    'Sync documents from personal drives and shared team drives with folder selection.':
      'نزامن المستندات من أقراصك الشخصية وأقراص الفريق المشتركة، وأنت تختار المجلدات.',
    'Multi-format Support': 'دعم متعدد الصيغ',
    'Process Google Docs, Sheets, Slides, and uploaded files (PDF, Word, etc.).':
      'نعالج Google Docs وSheets وSlides والملفات المرفوعة (PDF، Word، وغيرها).',
    'Folder Filtering': 'تصفية المجلدات',
    'Select specific folders to sync, keeping your AI focused on relevant content.':
      'اختر مجلدات محددة للمزامنة، عشان يبقى الوكيل مركّزاً على المحتوى المهم.',
    'Sharing Permissions': 'صلاحيات المشاركة',
    'Respect existing sharing permissions to maintain content security.':
      'نحترم صلاحيات المشاركة القائمة، فيبقى المحتوى محمي.',
    'CSV Files': 'ملفات CSV',
    'Structured data from CSV files with configurable parsing options and schema inference.':
      'بيانات منظمة من ملفات CSV، بخيارات تحليل تضبطها واستنتاج تلقائي للمخطط.',
    'JSON/JSONL Files': 'ملفات JSON/JSONL',
    'JSON and JSON Lines files with full content extraction and nested structure support.':
      'ملفات JSON وJSON Lines، باستخراج كامل للمحتوى ودعم للهياكل المتداخلة.',
    'Parquet/Avro Files': 'ملفات Parquet/Avro',
    'Columnar data formats like Parquet and Avro for efficient structured data sync.':
      'صيغ بيانات عمودية مثل Parquet وAvro، لمزامنة فعّالة للبيانات المنظمة.',
    'Document Files': 'ملفات المستندات',
    'Google Docs and PDF documents with text extraction (experimental document file type format).':
      'مستندات Google Docs وPDF مع استخراج النص (صيغة ملف المستند تجريبية).',
    'Excel Files': 'ملفات Excel',
    'Microsoft Excel spreadsheets with sheet selection and data extraction.':
      'جداول بيانات Microsoft Excel — تختار الورقة، ونستخرج بياناتها.',
    'Train AI on policy documents and guidelines':
      'درّب الوكيل على مستندات السياسات والإرشادات',
    'Sync meeting notes and decision logs':
      'مزامنة ملاحظات الاجتماعات وسجلات القرارات',
    'Import training materials and guides': 'استيراد مواد وأدلة التدريب',
    'Connect project documentation': 'ربط توثيق المشاريع',
    'Sync customer communication templates': 'مزامنة قوالب تواصل العملاء',
    'Import sales collateral and presentations':
      'استيراد مواد المبيعات والعروض التقديمية',
    'In Open, go to AI Training → Sources → Connect Google Drive':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط Google Drive',
    'Click "Authenticate via Google (OAuth)" and complete the authorization':
      'اضغط "المصادقة عبر Google (OAuth)" وأكمل التفويض',
    'Copy the folder link from Google Drive (navigate to folder → copy URL)':
      'انسخ رابط المجلد من Google Drive (انتقل للمجلد ← انسخ URL)',
    'Paste the folder link - all files in this folder and subfolders will be synced':
      'الصق رابط المجلد — وكل الملفات فيه وفي مجلداته الفرعية تتزامن',
    'Use glob patterns to filter files (e.g., "**/*.csv" for only CSV files)':
      'استخدم أنماط glob لتصفية الملفات (مثلاً: "**/*.csv" لملفات CSV بس)',
    'Google Drive folder link': 'رابط مجلد Google Drive',
    'Google Workspace user with access to the folder':
      'مستخدم Google Workspace بوصول للمجلد',
    'For Service Account: JSON key file with proper permissions':
      'لحساب الخدمة: ملف مفتاح JSON بصلاحيات مناسبة',
    'Syncs from a single folder - subfolders are included recursively':
      'يزامن من مجلد واحد — ومجلداته الفرعية مشمولة معه',
    'Use glob patterns like "**/*.csv" to filter by file type':
      'استخدم أنماط glob مثل "**/*.csv" للتصفية حسب نوع الملف',
    'Document file type format is experimental for PDFs and Google Docs':
      'صيغة ملف المستند تجريبية لملفات PDF وGoogle Docs',
    'If folder is not public, grant Service Account access to it':
      'إذا ما كان المجلد عاماً، فامنح حساب الخدمة صلاحية الوصول إليه',
    'Supports CSV, JSON, JSONL, Parquet, Avro, Excel, and document formats':
      'يدعم CSV، JSON، JSONL، Parquet، Avro، Excel، وصيغ المستندات',
    'Can I sync multiple folders?': 'هل أقدر أزامن مجلدات متعددة؟',
    'The connector syncs from a single folder, but all subfolders are included recursively. For multiple unrelated folders, create separate connections.':
      'الموصل يزامن من مجلد واحد، بس كل مجلداته الفرعية مشمولة معه. وإذا كانت المجلدات متفرقة وغير مرتبطة، أنشئ لكل واحد اتصال منفصل.',
    'What file formats are supported?': 'وش صيغ الملفات المدعومة؟',
    'CSV, JSON, JSONL, Parquet, Avro, Excel, and experimental document format for PDFs and Google Docs text extraction.':
      'CSV، JSON، JSONL، Parquet، Avro، Excel، وصيغة مستند تجريبية لاستخراج النص من ملفات PDF وGoogle Docs.',
    'Import spaces, pages, and documentation from Confluence':
      'استيراد المساحات، الصفحات، والتوثيق من Confluence',
    "Connect your Atlassian Confluence to train your AI agent on your team's documentation. Open syncs spaces, pages, blog posts, and attachments to give your AI agent comprehensive knowledge of your internal documentation.":
      'اربط Atlassian Confluence ودرّب الوكيل الذكي على توثيق فريقك. Open يزامن المساحات والصفحات ومنشورات المدونة والمرفقات، فيصير عند الوكيل معرفة شاملة بتوثيقك الداخلي.',
    'Space Sync': 'مزامنة المساحة',
    'Sync entire Confluence spaces including all pages, blog posts, and nested content hierarchies.':
      'نزامن مساحات Confluence كاملة: الصفحات ومنشورات المدونة وهرميات المحتوى المتداخلة.',
    'Attachment Support': 'دعم المرفقات',
    'Extract and process content from PDF, Word, and other document attachments.':
      'نستخرج ونعالج المحتوى من مرفقات PDF وWord وغيرها من المستندات.',
    'Label Filtering': 'تصفية التسميات',
    'Filter content by labels to sync only relevant documentation for your AI agent.':
      'صفِّ المحتوى بالتسميات، وزامن بس التوثيق اللي يهم الوكيل الذكي.',
    'Version History': 'تاريخ الإصدارات',
    'Access page version history for understanding content evolution and updates.':
      'نوصل لتاريخ إصدارات الصفحة، فتتضح رحلة المحتوى وتحديثاته.',
    'All Confluence pages with full content, titles, and hierarchical structure via the Confluence REST API.':
      'كل صفحات Confluence بمحتواها وعناوينها وهيكلها الهرمي، عبر واجهة Confluence REST البرمجية.',
    Spaces: 'المساحات',
    'Space metadata and configuration. Note: The Space stream requires a Confluence Standard or Premium plan.':
      'البيانات الوصفية للمساحة وتكوينها. ملاحظة: تدفق المساحة يتطلب خطة Confluence Standard أو Premium.',
    'Train AI on technical documentation': 'درّب الوكيل على التوثيق التقني',
    'Sync product requirements and specs': 'مزامنة متطلبات ومواصفات المنتج',
    'Import runbooks and incident procedures':
      'استيراد كتيبات التشغيل وإجراءات الحوادث',
    'Connect team wikis and knowledge bases': 'ربط ويكي الفريق وقواعد المعرفة',
    'Sync onboarding documentation': 'مزامنة توثيق الإعداد',
    'Import compliance and policy documents':
      'استيراد مستندات الامتثال والسياسات',
    'Go to your Atlassian account settings and navigate to Security → API tokens':
      'روح لإعدادات حساب Atlassian ← الأمان ← رموز الواجهة البرمجية',
    'Click "Create API token" and give it a descriptive name':
      'اضغط "أنشئ رمز واجهة برمجية" واكتب له اسماً واضحاً',
    "Copy the generated API token (you won't see it again)":
      'انسخ رمز الواجهة البرمجية المتولد (ما تشوفه مرة ثانية)',
    'In Open, go to AI Training → Sources → Connect Confluence':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط Confluence',
    'Enter your Confluence domain name (e.g., your-company.atlassian.net)':
      'أدخل اسم نطاق Confluence (مثلاً: your-company.atlassian.net)',
    'Enter your Confluence login email and the API token':
      'أدخل بريد تسجيل دخول Confluence ورمز الواجهة البرمجية',
    'Configure sync frequency and start syncing':
      'اضبط تكرار المزامنة وابدأ المزامنة',
    'In Open, go to AI Training → Sources → Connect Zendesk':
      'في Open، روح لتدريب الذكاء الاصطناعي ← المصادر ← ربط Zendesk',
    'The Space stream requires a Confluence Standard or Premium plan':
      'تدفق المساحة يتطلب خطة Confluence Standard أو Premium',
    'Atlassian API Token': 'رمز واجهة Atlassian البرمجية',
    'Your Confluence domain name': 'اسم نطاق Confluence عندك',
    'Your Confluence login email': 'بريد تسجيل دخول Confluence عندك',
    'Standard or Premium plan for Space stream':
      'خطة Standard أو Premium لتدفق المساحة',
    'Only Full Refresh sync is supported (no incremental)':
      'ما ندعم إلا مزامنة التحديث الكامل (ما فيه تزايدية)',
    'The connector should not run into API limitations under normal usage':
      'في الاستخدام العادي، ما تتوقع تصطدم بقيود الواجهة البرمجية',
    'Uses Confluence REST API v2 for data extraction':
      'يستخدم واجهة Confluence REST البرمجية v2 لاستخراج البيانات',
    "Why can't I sync Spaces?": 'ليش ما أقدر أزامن المساحات؟',
    'The Space stream requires a Confluence Standard or Premium plan. Free and Basic plans only support page sync.':
      'تدفق المساحة يتطلب خطة Confluence Standard أو Premium. والخطط المجانية والأساسية ما تدعم إلا مزامنة الصفحات.',
    'Does it support incremental sync?': 'هل يدعم مزامنة تزايدية؟',
    'No, Confluence currently only supports Full Refresh sync, meaning all content is re-synced each time.':
      'لا، Confluence حالياً ما يدعم إلا مزامنة التحديث الكامل — يعني كل المحتوى يُسحب من جديد في كل مرة.',
  },
  templates: {
    'Automate everything': 'أتمتة كل شيء',
    'Open is the only AI customer communication engine that does it all, very well.':
      'Open هو المحرك الوحيد للتواصل مع العملاء بالـ AI اللي يعمل كل شيء — ويعمله صح.',
    'Search templates...': 'ابحث في القوالب...',
    'Filter available templates/automations by ticketing system':
      'صفّي القوالب والأتمتة المتاحة حسب نظام التذاكر',
    Templates: 'القوالب',
    Home: 'الرئيسية',
    'Support Excellence': 'التميز في الدعم',
    'Elevate your support quality and efficiency':
      'ارفع جودة وكفاءة الدعم عندك',
    'Revenue Automation': 'أتمتة الإيرادات',
    'Turn support into revenue opportunities': 'حوّل الدعم لفرص إيرادات',
    'Revenue Intelligence': 'ذكاء الإيرادات',
    'AI detects opportunities and triggers revenue actions':
      'الـ AI يكتشف الفرصة ويشغّل إجراء الإيرادات',
    'Platform Integration': 'تكامل المنصة',
    'System-specific automations for your helpdesk':
      'أتمتة مخصصة لنظام الدعم عندك',
    'AI Phone Calling': 'المكالمات الهاتفية بالـ AI',
    'Automate calls humans typically make':
      'أتمتة المكالمات اللي يقوم بها البشر عادة',
    'No templates found in this section.': 'ما لقينا قوالب في هذا القسم.',
    'No templates found. Try a different search or system filter.':
      'ما لقينا قوالب. جرّب بحث ثاني أو فلتر نظام مختلف.',
    'Supports these ticketing systems': 'يدعم أنظمة التذاكر التالية',
    'Key benefits': 'الفوائد الرئيسية',
    'Seeing is believing': 'الشوفة أصدق من الكلام',
    "Get a personalized demo with Mo and see this automation in action. We'll walk you through exactly how it works with your ticketing system, answer your questions, and show you the ROI within 15 minutes.":
      'احجز ديمو خاص مع مو، وشوف هذه الأتمتة وهي تعمل. نأخذك خطوة بخطوة على عملها مع نظام التذاكر عندك، ونجيب على أسئلتك، ونعرض لك العائد على الاستثمار في ١٥ دقيقة.',
    'Get a demo': 'اعرف أكثر',
    'Works with all major ticketing systems':
      'يعمل مع كل أنظمة التذاكر الرئيسية',
    'Related workflows': 'سير عمل مرتبط',
    Automate: 'أتمتة',
    on: 'على',
    'Frequently asked questions': 'أسئلة شائعة',
    'How quickly can Open work with my existing setup?':
      'بأي سرعة يندمج Open مع النظام اللي عندي؟',
    "Open works on top of your existing ticketing system—whether it's Zendesk, Salesforce, HubSpot, Intercom, Freshdesk, or Twilio Flex. Setup takes under one hour. There's no migration, no platform change, no disruption to your team. Simply connect via API and Open starts working within your current helpdesk immediately.":
      'Open يشتغل فوق نظام التذاكر اللي عندك — Zendesk أو Salesforce أو HubSpot أو Intercom أو Freshdesk أو Twilio Flex. الإعداد أقل من ساعة. لا نقل بيانات، ولا تغيير منصة، ولا تعطيل لفريقك. اربطه عبر الـ API ويبدأ العمل داخل نظام الدعم الحالي عندك فوراً.',
    'What does "automate your support" actually mean?':
      'وش يعني "أتمتة الدعم عندك" بالضبط؟',
    'Open automates 77% of customer support interactions on average. This means the AI handles the complete resolution of tickets—answering questions, processing requests, updating systems, and closing tickets—without human intervention. For the remaining 23%, it assists your agents or escalates to humans when needed. You choose what percentage to automate.':
      'Open يأتمت ٧٧٪ من تفاعلات دعم العملاء بالمتوسط. أي أن الـ AI يتكفّل بحل التذكرة كاملة: يجيب على الأسئلة، ويعالج الطلبات، ويحدّث الأنظمة، ويقفل التذكرة — بدون تدخل بشري. والـ٢٣٪ الباقية يساعد فيها موظفوك أو يرفعها لهم عند الحاجة. والنسبة اللي تريد أتمتتها تحددها أنت.',
    'How do these workflows and templates work?':
      'كيف تعمل هذه القوالب وسير العمل؟',
    'These templates mimic the exact operations your agents perform today—reading tickets, extracting information, making decisions, taking actions, and following up. For example, the "skill-based routing" template reads ticket content just like a human supervisor would, identifies the required expertise, and routes to the right agent. The "quality assurance" template reviews conversations exactly like a QA manager would, scoring quality and identifying coaching opportunities. They replicate human judgment at scale.':
      'هذه القوالب تحاكي بالضبط ما يقوم به موظفوك اليوم: قراءة التذكرة، واستخراج المعلومة، واتخاذ القرار، والتنفيذ، والمتابعة. فمثلاً قالب "التوجيه حسب المهارات" يقرأ محتوى التذكرة مثل أي مشرف بشري، ويحدد الخبرة المطلوبة، ويوجّهها للموظف المناسب. وقالب "ضمان الجودة" يراجع المحادثات كما يفعل مدير الجودة بالضبط، ويقيّم ويحدد فرص التدريب. نفس الحكم البشري، بس على نطاق ما يقدر عليه فريق.',
    'Does Open do automation AND workflow orchestration?':
      'هل ينفّذ Open أتمتة وتنسيق سير عمل؟',
    'Yes, Open does both. First, it automates direct customer interactions (answering questions, resolving tickets, making calls). Second, it orchestrates complex workflows that involve multiple systems and decision points (routing tickets, triggering alerts, filling fields, escalating issues). You can use pre-built templates for common scenarios or build custom workflows using our agentic workflow engine. Both run simultaneously within your existing systems.':
      'نعم، كلاهما. أولاً، يأتمت التفاعل المباشر مع العميل: يجيب، ويحل التذاكر، ويجري المكالمات. وثانياً، ينسّق سير عمل معقداً يمر على أنظمة ونقاط قرار متعددة: يوجّه التذاكر، ويشغّل التنبيهات، ويعبّئ الحقول، ويرفع المشاكل. وتقدر تستخدم قوالب جاهزة للسيناريوهات الشائعة، أو تبني سير عملك بمحرك سير العمل الذكي عندنا. وكلاهما يعمل في الوقت نفسه داخل أنظمتك الحالية.',
    'Do I need to change my existing tools or processes?':
      'هل لازم أغيّر أدواتي أو عملياتي؟',
    'No. Open integrates with your existing helpdesk, CRM, phone system, Slack, and other tools. Your agents continue using the same interfaces they know. Your workflows continue running. Open layers on top, working alongside your team without requiring process changes, retraining, or tool migration. It adapts to how you work today.':
      'لا. Open يتكامل مع نظام الدعم ونظام إدارة العملاء ونظام الهاتف وSlack وباقي أدواتك. وموظفوك يواصلون على نفس الواجهات اللي يعرفونها، ويبقى سير عملك كما هو. Open يضيف طبقة فوقه ويشتغل إلى جانب فريقك: بلا تغيير عمليات، ولا إعادة تدريب، ولا نقل أدوات. يتأقلم مع طريقة عملك اليوم.',
    'Can I customize these templates for my specific needs?':
      'أقدر أخصص القوالب على احتياجاتي؟',
    'Absolutely. Every template is built using our agentic workflow engine, which means you can customize the logic, add your own rules, integrate with your specific systems, and adjust the automation to match your exact processes. Templates are starting points—you have full control to modify them for your unique requirements.':
      'نعم. كل قالب مبني بمحرك سير العمل الذكي عندنا، أي تقدر تعدّل المنطق، وتضيف قواعدك، وتربطه بأنظمتك، وتضبط الأتمتة عشان تطابق عملياتك بالضبط. القوالب نقطة بداية، والتحكم كامل بيدك.',
    'How long does setup take?': 'كم ياخذ الإعداد؟',
    'Setup takes under 15 minutes. Simply connect your ticketing system, configure your quality criteria, and the AI starts reviewing conversations immediately.':
      'الإعداد أقل من ١٥ دقيقة: اربط نظام التذاكر، واضبط معايير الجودة، ويبدأ الـ AI مراجعة المحادثات فوراً.',
    'What are the requirements?': 'وش المتطلبات؟',
    'You need an active account with one of the supported ticketing systems. No technical setup or API knowledge required—the integration is handled automatically.':
      'تحتاج حساباً نشطاً في أحد أنظمة التذاكر المدعومة. لا أكثر. لا إعداد تقني ولا معرفة بالـ API — التكامل يتم تلقائياً.',
    'Can I customize the evaluation criteria?': 'هل أقدر أخصص معايير التقييم؟',
    'Yes. You can define custom quality criteria, compliance rules, and scoring weights through the agentic workflow builder. The AI adapts to your specific standards.':
      'إي. تحدد معايير جودة خاصة، وقواعد امتثال، وأوزان تقييم من منشئ سير العمل الذكي. والـ AI يتأقلم مع معاييرك.',
    'Is customer data secure?': 'هل بيانات العملاء آمنة؟',
    "Yes. All data is encrypted in transit and at rest. Conversations are processed securely and never stored beyond what's needed for analysis.":
      'نعم. كل البيانات مشفّرة أثناء النقل وفي التخزين. المحادثات تُعالَج بأمان، ولا نخزّن منها أكثر مما يحتاجه التحليل.',
    'Automate support tickets quality assurance with AI':
      'أتمتة ضمان جودة تذاكر الدعم بالذكاء الاصطناعي',
    'Automate skill-based routing with AI':
      'أتمتة التوجيه حسب المهارات بالذكاء الاصطناعي',
    'Automate escalating to the right team with AI':
      'أتمتة التصعيد للفريق الصح بالذكاء الاصطناعي',
    'Automate ticket prioritization based on its content with AI':
      'أتمتة تحديد أولوية التذكرة حسب محتواها بالذكاء الاصطناعي',
    'Automate ticket sentiment analysis with AI':
      'أتمتة تحليل مشاعر التذكرة بالذكاء الاصطناعي',
    'Automate Slack alerts based on the customer issue or report with AI':
      'أتمتة تنبيهات Slack حسب مشكلة العميل أو تقريره بالذكاء الاصطناعي',
    'Automate Slack alerts for customer issues with AI':
      'أتمتة تنبيهات Slack لمشاكل العملاء بالذكاء الاصطناعي',
    'Automate following up with a customer using voice calls with AI':
      'أتمتة متابعة العميل بالمكالمات الصوتية بالذكاء الاصطناعي',
    'Automate voice call follow-ups with AI':
      'أتمتة متابعات المكالمات الصوتية بالذكاء الاصطناعي',
    'Automate ticket prioritization with AI':
      'أتمتة تحديد أولوية التذاكر بالذكاء الاصطناعي',
    'Automate phone calling from email with AI':
      'أتمتة الاتصال الهاتفي من الإيميل بالذكاء الاصطناعي',
    'Automate up-sells from support tickets with AI':
      'أتمتة البيع الإضافي من تذاكر الدعم بالذكاء الاصطناعي',
    'Automate cart recovery with AI': 'أتمتة استرجاع السلة بالذكاء الاصطناعي',
    'Automate pre-sales qualification with AI':
      'أتمتة تأهيل ما قبل البيع بالذكاء الاصطناعي',
    'Automate replying to Trustpilot reviews with AI':
      'أتمتة الرد على مراجعات Trustpilot بالذكاء الاصطناعي',
    'Automate requesting review only when the customer is happy with AI':
      'أتمتة طلب المراجعة بس من العميل الراضي بالذكاء الاصطناعي',
    'Automate Zendesk custom fields fill up with AI':
      'أتمتة تعبئة حقول Zendesk المخصصة بالذكاء الاصطناعي',
    'Automate HubSpot custom fields fill up with AI':
      'أتمتة تعبئة حقول HubSpot المخصصة بالذكاء الاصطناعي',
    'Automate Salesforce custom fields fill up with AI':
      'أتمتة تعبئة حقول Salesforce المخصصة بالذكاء الاصطناعي',
    'Automate Intercom custom fields fill up with AI':
      'أتمتة تعبئة حقول Intercom المخصصة بالذكاء الاصطناعي',
    'Automate Freshdesk custom fields fill up with AI':
      'أتمتة تعبئة حقول Freshdesk المخصصة بالذكاء الاصطناعي',
    'Automate Twilio Flex custom fields fill up with AI':
      'أتمتة تعبئة حقول Twilio Flex المخصصة بالذكاء الاصطناعي',
    'Automate Open custom fields fill up with AI':
      'أتمتة تعبئة حقول Open المخصصة بالذكاء الاصطناعي',
    'AI phone calls for appointment reminders': 'مكالمات AI لتذكير المواعيد',
    'AI phone calls for payment collection': 'مكالمات AI لتحصيل الدفعات',
    'AI phone calls for delivery notifications': 'مكالمات AI لإشعارات التوصيل',
    'AI phone calls for customer surveys': 'مكالمات AI لاستبيانات العملاء',
    'AI phone calls for renewal reminders': 'مكالمات AI لتذكير التجديد',
    'AI phone calls for win-back campaigns':
      'مكالمات AI لحملات استرجاع العملاء',
    'AI phone calls for order confirmations': 'مكالمات AI لتأكيد الطلبات',
    'AI phone calls for proactive outreach campaigns':
      'مكالمات AI لحملات التواصل الاستباقي',
    'Detect churn risk + proactive retention call':
      'اكتشاف خطر فقدان العميل + مكالمة احتفاظ استباقية',
    'Identify high-value lead + priority sales routing':
      'تحديد عميل محتمل عالي القيمة + توجيه مبيعات بأولوية',
    'Detect expansion opportunity + account growth call':
      'اكتشاف فرصة توسع + مكالمة نمو الحساب',
    'Identify payment failure + recovery call':
      'تحديد فشل الدفع + مكالمة استرجاع',
    'Detect usage milestone + upgrade trigger':
      'اكتشاف معلم الاستخدام + تشغيل الترقية',
    'Identify referral opportunity + request referral':
      'تحديد فرصة إحالة + طلب إحالة',
    'Detect competitor evaluation + competitive win campaign':
      'اكتشاف تقييم منافس + حملة فوز تنافسي',
    'Identify free trial ending + conversion call':
      'تحديد انتهاء تجربة مجانية + مكالمة تحويل',
    'Detect bulk purchase intent + enterprise sales handoff':
      'اكتشاف نية شراء بالجملة + تسليم مبيعات المؤسسات',
    'Identify feature gap + product-led upsell':
      'تحديد ميزة ناقصة + بيع إضافي مدفوع بالمنتج',
    Ticket: 'تذكرة',
    'AI Review': 'مراجعة AI',
    Score: 'تقييم',
    Support: 'دعم',
    'AI Detects': 'الـ AI يكتشف',
    Upsell: 'بيع إضافي',
    Abandoned: 'متروك',
    'AI Follow-up': 'متابعة AI',
    Convert: 'تحويل',
    Customer: 'عميل',
    'AI Extracts': 'الـ AI يستخرج',
    'Fields Filled': 'الحقول معبّأة',
    'AI Triggers': 'الـ AI يشغّل',
    'Voice Call': 'مكالمة صوتية',
    Issue: 'مشكلة',
    'Slack Alert': 'تنبيه Slack',
    'AI Analyzes': 'الـ AI يحلّل',
    'Routes to Expert': 'يوجّه للخبير',
    'AI Evaluates': 'الـ AI يقيّم',
    'Priority Set': 'الأولوية محددة',
    Message: 'رسالة',
    'Sentiment Score': 'تقييم المشاعر',
    Review: 'مراجعة',
    'AI Crafts': 'الـ AI يصيغ',
    'Reply Sent': 'الرد مرسل',
    'Happy Customer': 'عميل راضي',
    'Request Review': 'طلب مراجعة',
    'Complex Issue': 'مشكلة معقدة',
    Escalates: 'يصعّد',
    'Email Thread': 'سلسلة إيميل',
    'Phone Call': 'مكالمة هاتفية',
    'Lead Inquiry': 'استفسار عميل محتمل',
    'AI Qualifies': 'الـ AI يؤهّل',
    'Route to Sales': 'توجيه للمبيعات',
    Appointment: 'موعد',
    'Upsell Offer': 'عرض بيع إضافي',
    'AI Schedules': 'الـ AI يجدول',
    'Reminder Call': 'مكالمة تذكير',
    Overdue: 'متأخر',
    'AI Calls': 'الـ AI يتصل',
    'Payment Resolved': 'الدفعة تسددت',
    'Order Ready': 'الطلب جاهز',
    'Delivery Confirmed': 'التوصيل مؤكد',
    'Survey Trigger': 'تشغيل الاستبيان',
    'Feedback Collected': 'الملاحظات مجموعة',
    'Renewal Due': 'التجديد مستحق',
    'Renewal Confirmed': 'التجديد مؤكد',
    'Churned Customer': 'عميل مفقود',
    'Customer Returns': 'العميل يرجع',
    'Order Placed': 'الطلب مقدّم',
    'Order Confirmed': 'الطلب مؤكد',
    'Campaign List': 'قائمة الحملة',
    'Outreach Complete': 'التواصل مكتمل',
    'Churn Signal': 'إشارة فقدان',
    'Retention Call': 'مكالمة احتفاظ',
    'AI Scores': 'الـ AI يقيّم',
    'Priority Route': 'توجيه بأولوية',
    'Usage Growth': 'نمو الاستخدام',
    'Expansion Call': 'مكالمة توسع',
    'Payment Fails': 'الدفع يفشل',
    'Recovery Call': 'مكالمة استرجاع',
    'Milestone Hit': 'الوصول لمعلم',
    'Upgrade Offer': 'عرض ترقية',
    'Referral Request': 'طلب إحالة',
    'Competitor Mention': 'ذكر منافس',
    'Competitive Pitch': 'عرض تنافسي',
    'Trial Ending': 'انتهاء التجربة',
    'Conversion Call': 'مكالمة تحويل',
    'Enterprise Signal': 'إشارة مؤسسية',
    'Enterprise Route': 'توجيه مؤسسي',
    'Feature Request': 'طلب ميزة',
    'AI Detects Gap': 'الـ AI يكتشف النقص',
    'Automatically review every support conversation for quality, compliance, and coaching opportunities. Works across all major ticketing systems.':
      'مراجعة تلقائية لكل محادثة دعم: الجودة، والامتثال، وفرص التدريب. وتشتغل مع كل أنظمة التذاكر الرئيسية.',
    'Identify upsell opportunities during support conversations and convert them into revenue. Seamlessly integrated with your ticketing system.':
      'تحديد فرص البيع الإضافي أثناء محادثات الدعم وتحويلها لإيرادات. متكامل بسلاسة مع نظام التذاكر عندك.',
    'Re-engage customers who abandoned their carts with personalized follow-ups via email, SMS, or voice.':
      'رجّع العملاء اللي تركوا سلاتهم بمتابعة شخصية عبر الإيميل أو SMS أو المكالمة.',
    'Automatically populate Zendesk custom fields during conversations, eliminating manual data entry for your support team.':
      'تعبئة تلقائية لحقول Zendesk المخصصة أثناء المحادثات، وتخلّص فريق الدعم من إدخال البيانات اليدوي.',
    'Automatically populate HubSpot custom fields during conversations, eliminating manual data entry for your support team.':
      'تعبئة تلقائية لحقول HubSpot المخصصة أثناء المحادثات، وتخلّص فريق الدعم من إدخال البيانات اليدوي.',
    'Automatically populate Salesforce custom fields during conversations, eliminating manual data entry for your support team.':
      'تعبئة تلقائية لحقول Salesforce المخصصة أثناء المحادثات، وتخلّص فريق الدعم من إدخال البيانات اليدوي.',
    'Automatically populate Intercom custom fields during conversations, eliminating manual data entry for your support team.':
      'تعبئة تلقائية لحقول Intercom المخصصة أثناء المحادثات، وتخلّص فريق الدعم من إدخال البيانات اليدوي.',
    'Automatically populate Freshdesk custom fields during conversations, eliminating manual data entry for your support team.':
      'تعبئة تلقائية لحقول Freshdesk المخصصة أثناء المحادثات، وتخلّص فريق الدعم من إدخال البيانات اليدوي.',
    'Automatically populate Twilio Flex custom fields during conversations, eliminating manual data entry for your support team.':
      'تعبئة تلقائية لحقول Twilio Flex المخصصة أثناء المحادثات، وتخلّص فريق الدعم من إدخال البيانات اليدوي.',
    'Automatically populate Open custom fields during conversations, eliminating manual data entry for your support team.':
      'تعبئة تلقائية لحقول Open المخصصة أثناء المحادثات، وتخلّص فريق الدعم من إدخال البيانات اليدوي.',
    'Trigger personalized voice call follow-ups based on ticket content or customer communication. AI handles the outreach automatically.':
      'مكالمات متابعة شخصية تنطلق حسب محتوى التذكرة أو تواصل العميل. والـ AI يتولى التواصل كامل.',
    'Send intelligent Slack notifications to the right team or channel when AI detects critical issues, high-value customers, or escalation triggers.':
      'إشعارات Slack ذكية تصل للفريق والقناة المناسبة لمّا يكتشف الـ AI مشكلة حرجة، أو عميلاً عالي القيمة، أو محفز تصعيد.',
    'Intelligently route tickets to the right team member based on ticket content, expertise required, and agent availability.':
      'توجيه ذكي للتذاكر لعضو الفريق الصح حسب محتوى التذكرة والخبرة المطلوبة وتوفّر الموظف.',
    'Automatically set ticket priority levels by analyzing urgency, customer value, and issue severity from the conversation.':
      'تحديد أولوية التذكرة تلقائياً بتحليل الاستعجال وقيمة العميل وخطورة المشكلة من نص المحادثة.',
    'Detect customer sentiment in real-time, flag frustrated customers, and route urgent cases for immediate human attention.':
      'اكتشف مشاعر العميل لحظياً، علّم العملاء المتضايقين، ووجّه الحالات العاجلة لاهتمام بشري فوري.',
    'Automatically respond to Trustpilot reviews with personalized, on-brand replies. AI crafts appropriate responses based on review sentiment and content.':
      'رد تلقائي على مراجعات Trustpilot بلغة شخصية وبنبرة علامتك. الـ AI يصيغ الرد حسب مشاعر المراجعة ومحتواها.',
    'Intelligently request reviews only after positive interactions. AI detects customer satisfaction and sends review requests at the perfect moment.':
      'اطلب المراجعة بس بعد التفاعل الإيجابي. الـ AI يستشعر رضا العميل ويرسل الطلب في اللحظة المناسبة.',
    'Smart escalation that routes complex issues to specialized teams based on ticket content, urgency, and required expertise.':
      'تصعيد ذكي يوجّه المشكلة المعقدة للفريق المتخصص حسب محتوى التذكرة والاستعجال والخبرة المطلوبة.',
    'When email conversations need urgent attention, AI automatically triggers a follow-up phone call to resolve issues faster.':
      'لمّا تحتاج سلسلة الإيميل تدخلاً عاجلاً، يشغّل الـ AI مكالمة متابعة تحل الموضوع أسرع.',
    'Qualify inbound leads automatically by gathering essential information, assessing fit, and routing hot prospects to your sales team.':
      'أهّل العملاء المحتملين تلقائياً: يجمع المعلومات الأساسية، يقيّم الملاءمة، ويوجّه الساخنين لفريق المبيعات عندك.',
    'Automated AI phone calls to remind customers about upcoming appointments, reducing no-shows and cancellations.':
      'مكالمات تلقائية بالـ AI تذكّر العملاء بمواعيدهم القادمة، وتقلل عدم الحضور والإلغاءات.',
    'Automated AI phone calls for overdue payment reminders and collection follow-ups with empathy and professionalism.':
      'مكالمات تلقائية بالـ AI للدفعات المتأخرة ومتابعات التحصيل، بتعاطف واحترافية.',
    'Automated AI phone calls to notify customers about delivery status, schedule delivery windows, and confirm receipt.':
      'مكالمات تلقائية بالـ AI تبلّغ العميل بحالة التوصيل، وتحدد وقت الوصول، وتأكد الاستلام.',
    'Automated AI phone calls to conduct customer satisfaction surveys, gather feedback, and collect NPS scores.':
      'مكالمات تلقائية بالـ AI تُجري استبيانات الرضا، وتجمع الملاحظات ودرجات NPS.',
    'Automated AI phone calls to remind customers about upcoming contract or subscription renewals, reducing churn.':
      'مكالمات تلقائية بالـ AI تذكّر العميل بتجديد عقده أو اشتراكه قبل ما يفوت، وتقلل الفقدان.',
    'Automated AI phone calls to re-engage churned customers with personalized offers and win them back.':
      'مكالمات تلقائية بالـ AI ترجع العملاء المفقودين بعروض شخصية تناسب كل واحد.',
    'Automated AI phone calls to confirm large or complex orders, verify details, and answer customer questions.':
      'مكالمات تلقائية بالـ AI تأكد الطلبات الكبيرة أو المعقدة، وتتحقق من التفاصيل، وتجاوب على أسئلة العميل.',
    'Bulk automated AI phone calls for announcements, promotions, or service updates at scale.':
      'مكالمات جماعية تلقائية بالـ AI للإعلانات والعروض وتحديثات الخدمة على نطاق واسع.',
    'AI detects customers at risk of churning and automatically triggers retention calls before they cancel.':
      'الـ AI يكتشف العملاء المعرضين للفقدان ويشغّل تلقائياً مكالمات احتفاظ قبل لا يلغون.',
    'AI identifies enterprise leads and routes them to senior sales reps instantly with full context.':
      'الـ AI يحدد عملاء المؤسسات ويوجههم لكبار ممثلي المبيعات فوراً، وبسياق كامل.',
    'AI detects when customers are ready to expand usage and triggers account growth calls with expansion offers.':
      'الـ AI يستشعر متى يكون العميل جاهزاً لتوسيع استخدامه، ويشغّل مكالمة نمو للحساب بعرض توسع.',
    'AI detects failed payments and triggers empathetic recovery calls to update payment methods and prevent churn.':
      'الـ AI يكتشف الدفعات الفاشلة ويشغل مكالمات استرجاع متعاطفة لتحديث طرق الدفع ومنع فقدان العملاء.',
    'AI detects when customers hit usage limits or milestones and triggers upgrade conversations at the perfect moment.':
      'الـ AI يكتشف لمّا يوصل العميل لحد الاستخدام أو لمعلم مهم، ويفتح محادثة ترقية في اللحظة المناسبة.',
    'AI detects happy customers and automatically requests referrals at the perfect moment with incentive offers.':
      'الـ AI يكتشف العميل الراضي، ويطلب منه إحالة في اللحظة الصح مع عرض تحفيزي.',
    'AI detects when prospects are comparing alternatives and triggers competitive sales materials and calls.':
      'الـ AI يكتشف لمّا يقارن العميل المحتمل البدائل، ويشغّل مواد ومكالمات مبيعات تنافسية.',
    'AI detects trial users approaching expiration and triggers conversion calls with onboarding help and offers.':
      'الـ AI يكتشف من قرّبت تجربته على الانتهاء، ويشغّل مكالمة تحويل مع مساعدة في الإعداد وعرض مناسب.',
    'AI detects enterprise buying signals and routes to enterprise sales team with custom pricing authority.':
      'الـ AI يكتشف إشارات شراء المؤسسات ويوجه لفريق مبيعات المؤسسات بصلاحية تسعير مخصصة.',
    'AI detects when customers ask for premium features and triggers product-led upsell offers at the moment of need.':
      'الـ AI يكتشف لمّا يطلب العميل ميزة مدفوعة، ويعرض الترقية في لحظة الحاجة نفسها.',
    'A/B test messaging and timing automatically':
      'اختبر الرسائل والتوقيت بـA/B تلقائياً',
    'Accurate priority assignment from day one': 'أولويات دقيقة من اليوم الأول',
    'Adapt questions based on responses': 'كيّف الأسئلة حسب ردود العميل',
    'Agent skill tracking and development': 'تتبّع مهارات موظفيك وتطويرها',
    'Agents call with full email context':
      'الموظفون يتصلون وعندهم سياق الإيميل كامل',
    'Agents get full context before calling':
      'موظفوك يعرفون القصة كاملة قبل ما يتصلون',
    'Answer order questions immediately': 'جاوب على أسئلة الطلب فوراً',
    'Arm sales with competitive intelligence':
      'سلّح المبيعات بمعلومات عن المنافس',
    'Ask only happy customers for referrals': 'اسأل بس الراضين عن الإحالات',
    'Automate entire review collection process':
      'اجمع المراجعات آلياً من أوله لآخره',
    'Automated incentive tracking': 'تتبّع تلقائي للحوافز',
    'Automatic call logging and summaries': 'تسجيل وملخص تلقائي لكل مكالمة',
    'Automatic call outcome logging': 'تسجيل نتيجة كل مكالمة تلقائياً',
    'Automatic retry logic and follow-ups': 'إعادة محاولة ومتابعة تلقائية',
    'Balance workload across team members': 'وازن عبء العمل بين أعضاء الفريق',
    'Capture expansion revenue automatically': 'التقط إيرادات التوسع تلقائياً',
    'Catch churn before it happens': 'اكتشف الفقدان قبل ما يصير',
    'Catch critical issues immediately': 'اكتشف المشاكل الحرجة فوراً',
    'Catch policy violations before they escalate':
      'التقط انتهاكات السياسة قبل ما تتصعّد',
    'Close deals faster with smart routing': 'اقفل الصفقات أسرع بتوجيه ذكي',
    'Conduct surveys at scale without staff':
      'شغّل استبيانات على نطاق واسع بدون موظفين',
    'Confirm addresses and access instructions': 'أكّد العنوان وتعليمات الوصول',
    'Confirm appointments 24/7 automatically': 'أكّد المواعيد ٢٤/٧ تلقائياً',
    'Confirm delivery details accurately': 'أكّد تفاصيل التوصيل بدقة',
    'Continuous learning and optimization': 'تعلّم وتحسين مستمر',
    'Continuous routing optimization': 'توجيه يتحسّن باستمرار',
    'Convert free users to paid at optimal timing':
      'حوّل المستخدم المجاني لمدفوع في التوقيت الأمثل',
    'Convert trials at optimal timing': 'حوّل التجارب في التوقيت الأمثل',
    'Coordinate delivery times automatically': 'نسّق أوقات التوصيل تلقائياً',
    'Customer Support': 'دعم العملاء',
    'Detect and escalate detractors immediately':
      'اكتشف المنتقدين وصعّدهم فوراً',
    'Detect and resolve order issues early':
      'اكتشف مشاكل الطلبات وحلّها مبكراً',
    'Detect frustrated customers immediately': 'اكتشف العملاء المتضايقين فوراً',
    'Detect frustration before it escalates': 'اكتشف الضيق قبل لا يتصعّد',
    'Detect upsell opportunities during renewal calls':
      'اكتشف فرص البيع الإضافي في مكالمات التجديد',
    'Eliminate manual data entry for agents':
      'خلّص موظفيك من إدخال البيانات يدوياً',
    'Empathetic outreach maintains relationships':
      'التواصل المتعاطف يحافظ على العلاقات',
    'Ensure compliance with industry regulations':
      'اضمن الامتثال لأنظمة القطاع',
    'Ensure consistent attribute population': 'اضمن تعبئة متسقة للسمات',
    'Ensure consistent field population': 'اضمن تعبئة متسقة للحقول',
    'Ensure VIP customers get immediate attention':
      'اضمن اهتمام فوري بعملاء VIP',
    'Filter out unqualified inquiries': 'صفّي الاستفسارات غير المؤهلة',
    'Full audit trail for compliance': 'مسار تدقيق كامل للامتثال',
    'Full context for enterprise conversations': 'سياق كامل لمحادثات المؤسسات',
    'Full context for sales reps instantly': 'سياق كامل لممثلي المبيعات فوراً',
    'Full context in every notification': 'سياق كامل في كل تنبيه',
    'Full compliance with collection regulations': 'امتثال كامل لأنظمة التحصيل',
    'Gather consistent qualification data': 'اجمع بيانات تأهيل متسقة',
    'Gather richer feedback than email surveys':
      'اجمع ملاحظات أغنى من استبيانات الإيميل',
    'Handle delivery delays proactively':
      'عالج تأخيرات التوصيل قبل لا تصير مشكلة',
    'Handle rescheduling requests instantly':
      'تعامل مع طلبات إعادة الجدولة فوراً',
    'Identify at-risk customers proactively':
      'حدّد العملاء المعرّضين للخطر مبكراً',
    'Identify coaching opportunities in real-time': 'حدّد فرص التدريب لحظياً',
    'Identify expansion opportunities automatically':
      'حدّد فرص التوسع تلقائياً',
    'Identify high-value feature requests': 'حدّد طلبات الميزات عالية القيمة',
    'Identify interested customers automatically':
      'حدّد العملاء المهتمين تلقائياً',
    'Identify training opportunities from sentiment data':
      'حدّد فرص التدريب من بيانات المشاعر',
    'Identify upgrade potential in real-time': 'حدّد إمكانية الترقية لحظياً',
    'Improve appointment attendance rates': 'ارفع نسبة حضور المواعيد',
    'Improve CRM data quality': 'حسّن جودة بيانات إدارة العملاء',
    'Improve customer confidence in purchases': 'زوّد ثقة العميل في شرائه',
    'Improve customer delivery experience': 'حسّن تجربة التوصيل للعميل',
    'Improve customer lifetime value': 'ارفع القيمة الدائمة للعميل',
    'Improve customer satisfaction proactively':
      'حسّن رضا العملاء قبل لا يتراجع',
    'Improve customer satisfaction scores': 'ارفع درجات رضا العملاء',
    'Improve enterprise close rates': 'ارفع معدل إقفال صفقات المؤسسات',
    'Improve first-contact resolution rates': 'ارفع معدل الحل من أول اتصال',
    'Improve Intercom data quality': 'حسّن جودة بيانات Intercom',
    'Improve lead-to-customer conversion':
      'ارفع تحويل العميل المحتمل لعميل فعلي',
    'Improve lead-to-opportunity conversion': 'ارفع تحويل العميل المحتمل لفرصة',
    'Improve public review ratings': 'ارفع تقييماتك العامة',
    'Improve renewal rates': 'ارفع معدلات التجديد',
    'Improve reporting accuracy': 'حسّن دقة تقاريرك',
    'Improve resolution speed dramatically': 'سرّع الحل بفارق واضح',
    'Improve review response rates': 'حسّن معدل الرد على المراجعات',
    'Improve review ratings significantly': 'ارفع تقييمات المراجعات',
    'Improve Salesforce data quality': 'حسّن جودة بيانات Salesforce',
    'Improve specialized team utilization': 'استفد أكثر من فريقك المتخصص',
    'Improve team efficiency': 'ارفع كفاءة الفريق',
    'Increase account revenue 2-5x': 'زوّد إيرادات الحساب ٢-٥ أضعاف',
    'Increase average revenue per account': 'ارفع متوسط الإيراد لكل حساب',
    'Increase customer lifetime value without extra effort':
      'ارفع القيمة الدائمة للعميل بدون جهد إضافي',
    'Increase e-commerce revenue without manual work':
      'زوّد إيرادات متجرك بدون شغل يدوي',
    'Increase expansion revenue automatically': 'زوّد إيرادات التوسع تلقائياً',
    'Increase referral program participation':
      'زوّد المشاركة في برنامج الإحالة',
    'Increase review response rates': 'زوّد معدل الرد على المراجعات',
    'Increase survey response rates dramatically':
      'زوّد الردود على الاستبيانات',
    'Increase trial-to-paid conversion 40%+': 'زوّد تحويل التجربة للمدفوع +٤٠٪',
    'Inform product roadmap with revenue data':
      'اربط خارطة طريق المنتج ببيانات الإيرادات',
    'Learn optimal timing from response patterns':
      'تعلّم التوقيت الأمثل من أنماط الاستجابة',
    'Lowest CAC acquisition channel': 'قناة اكتساب العملاء الأقل تكلفة',
    'Maintain consistent brand voice': 'حافظ على نبرة علامتك في كل رد',
    'Maintain customer relationships during collections':
      'حافظ على علاقتك بالعميل وقت التحصيل',
    'Match tickets with the right expert automatically':
      'طابق التذكرة مع الخبير الصح تلقائياً',
    'Native Open integration': 'تكامل أصلي مع Open',
    'Never miss a high-value opportunity': 'ما تفوتك فرصة عالية القيمة',
    'No awkward sales pitches—AI knows the right moment':
      'ما فيه عروض مبيعات محرجة — الـ AI يعرف اللحظة الصح',
    'No manual scheduling required': 'ما يحتاج جدولة يدوية',
    'Only ask happy customers for reviews': 'اسأل بس الراضين عن المراجعات',
    'Optimal call timing based on customer timezone':
      'توقيت مكالمة أمثل حسب المنطقة الزمنية للعميل',
    'Optimal timing based on customer behavior': 'توقيت أمثل حسب سلوك العميل',
    'Optimal timing based on satisfaction': 'توقيت أمثل حسب الرضا',
    'Optimize sales team capacity automatically':
      'استثمر طاقة فريق المبيعات تلقائياً',
    'Personalized conversations at scale': 'محادثات شخصية على نطاق واسع',
    'Personalized conversion paths per user': 'مسارات تحويل شخصية لكل مستخدم',
    'Personalized expansion offers per account': 'عروض توسع شخصية لكل حساب',
    'Personalized outreach across email, SMS, and voice':
      'تواصل شخصي عبر الإيميل وSMS والمكالمة',
    'Personalized retention offers automatically': 'عروض احتفاظ شخصية تلقائياً',
    'Personalized upgrade paths per user': 'مسارات ترقية شخصية لكل مستخدم',
    'Present personalized win-back offers': 'قدّم عروض استرجاع شخصية',
    'Prevent customer churn proactively': 'امنع فقدان العملاء قبل ما يصير',
    'Prevent escalations before they happen': 'امنع التصعيد قبل ما يصير',
    'Prevent issues from sitting in wrong queues':
      'امنع بقاء المشاكل في الطابور الخطأ',
    'Prevent involuntary churn from billing issues':
      'امنع فقدان العملاء بسبب مشاكل الفواتير',
    'Prevent losses to competitors': 'امنع خسارة العملاء للمنافسين',
    'Prevent SLA breaches proactively':
      'امنع خروقات اتفاقية مستوى الخدمة قبل لا تصير',
    'Prioritize at-risk customer conversations':
      'أعطِ الأولوية لمحادثات العملاء المعرّضين للخطر',
    'Prioritize highest-value opportunities': 'أعطِ الأولوية للفرص الأعلى قيمة',
    'Process payment updates immediately': 'عالج تحديثات الدفع فوراً',
    'Process payments 24/7': 'استلم الدفعات ٢٤/٧',
    'Process renewals without manual intervention':
      'عالج التجديدات بدون تدخل يدوي',
    'Protect brand reputation': 'احمِ سمعة علامتك',
    'Provide full context to escalation teams': 'سلّم فرق التصعيد سياق كامل',
    'Provide hands-on onboarding support': 'امسك يد العميل في الإعداد',
    'Provide sales with full conversation context':
      'سلّم المبيعات سياق المحادثة كامل',
    'Qualify leads 24/7 without sales team involvement':
      'أهّل العملاء المحتملين ٢٤/٧ بدون فريق المبيعات',
    'Re-engage churned customers at scale':
      'رجّع العملاء المفقودين على نطاق واسع',
    'Reach thousands of customers personally': 'اوصل لآلاف العملاء، واحد واحد',
    'Recover 60-80% of failed payments': 'استرجع ٦٠-٨٠٪ من الدفعات الفاشلة',
    'Recover abandoned carts automatically': 'استرجع السلات المتروكة تلقائياً',
    'Reduce account manager workload': 'قلّل عبء مدير الحسابات',
    'Reduce case handling time': 'قلّل وقت التعامل مع الحالة',
    'Reduce conversation handling time': 'قلّل وقت التعامل مع المحادثة',
    'Reduce days sales outstanding (DSO)': 'قلّل أيام المبيعات المستحقة (DSO)',
    'Reduce enterprise sales cycle length': 'قصّر دورة مبيعات المؤسسات',
    'Reduce escalation response time': 'قلّل وقت استجابة التصعيد',
    'Reduce failed deliveries significantly': 'قلّل التوصيلات الفاشلة',
    'Reduce feature request to upgrade time':
      'قصّر المسافة من طلب الميزة للترقية',
    'Reduce manual priority triage': 'قلّل الفرز اليدوي للأولويات',
    'Reduce manual QA workload by 90%': 'قلّل عبء ضمان الجودة اليدوي ٩٠٪',
    'Reduce no-shows by 60-80%': 'قلّل عدم الحضور ٦٠-٨٠٪',
    'Reduce order cancellations and buyer remorse':
      'قلّل إلغاء الطلبات وندم المشتري',
    'Reduce passive churn significantly': 'قلّل الفقدان السلبي للعملاء',
    'Reduce resolution time significantly': 'اختصر وقت الحل بفارق واضح',
    'Reduce revenue leakage significantly': 'قلّل تسرب الإيرادات',
    'Reduce task handling time': 'قلّل وقت التعامل مع المهمة',
    'Reduce ticket handling time': 'قلّل وقت التعامل مع التذكرة',
    'Reduce trial drop-off rates': 'قلّل نسبة ترك التجربة',
    'Reduce upgrade friction': 'قلّل عوائق الترقية',
    'Resolve complex issues faster with voice':
      'حلّ المشاكل المعقدة أسرع بمكالمة',
    'Resolve stuck email threads quickly': 'حلّ سلاسل الإيميل العالقة بسرعة',
    'Respond to every review promptly': 'رد على كل مراجعة فوراً',
    'Route alerts to the right team': 'وجّه التنبيه للفريق الصح',
    'Route complex issues to experts automatically':
      'وجّه المشاكل المعقدة للخبراء تلقائياً',
    'Route enterprise leads to best closers':
      'وجّه عملاء المؤسسات لأفضل من يقفل الصفقات',
    'Route hot leads to sales immediately': 'وجّه العميل الساخن للمبيعات فوراً',
    'Route interested customers to sales': 'وجّه العميل المهتم للمبيعات',
    'Route to reps with pricing authority': 'وجّه لممثل عنده صلاحية تسعير',
    'Save account management time': 'وفّر وقت إدارة الحسابات',
    'Save customers from email ping-pong': 'خلّص العملاء من لفّة الإيميلات',
    'Save customers worth 10-100x the intervention cost':
      'أنقذ عملاء بقيمة ١٠-١٠٠ ضعف تكلفة التدخل',
    'Save hours of manual review management':
      'وفّر ساعات من إدارة المراجعات يدوياً',
    'Save logistics team coordination time': 'وفّر وقت تنسيق فريق اللوجستيات',
    'Save massive amounts of calling time': 'وفّر ساعات طويلة من وقت المكالمات',
    'Save staff time on manual reminder calls':
      'وفّر وقت موظفيك من مكالمات التذكير',
    'Seamless handoff to sales team when needed':
      'تسليم سلس لفريق المبيعات عند الحاجة',
    "Show customers you're listening": 'ورّي العملاء إنك تسمعهم',
    'Strike when prospects are deciding':
      'تصرّف لمّا يكون العملاء المحتملون في مرحلة القرار',
    'Strike while usage momentum is high': 'تصرّف وزخم الاستخدام عالي',
    'Test pricing and messaging variations': 'اختبر تنويعات التسعير والرسائل',
    'Test win-back messaging automatically': 'اختبر رسائل الاسترجاع تلقائياً',
    'Track campaign performance in real-time': 'تتبّع أداء الحملة لحظياً',
    'Track cart recovery attribution': 'تتبّع إسناد استرجاع السلة',
    'Track competitive win rates': 'تتبّع معدلات الفوز التنافسي',
    'Track conversion attribution accurately': 'تتبّع إسناد التحويل بدقة',
    'Track escalation patterns and trends': 'تتبّع أنماط التصعيد واتجاهاته',
    'Track expansion win rates and optimize': 'تتبّع معدلات فوز التوسع وحسّنها',
    'Track NPS and CSAT trends automatically':
      'تتبّع اتجاهات NPS وCSAT تلقائياً',
    'Track quality trends across your entire team':
      'تتبّع اتجاهات الجودة في فريقك كامل',
    'Track referral source attribution': 'تتبّع إسناد مصدر الإحالة',
    'Track sentiment trends across your team': 'تتبّع اتجاهات المشاعر في فريقك',
    'Track which support interactions drive revenue':
      'تتبّع أي تفاعل دعم يجيب إيراد',
    'Turn negative reviews into resolution opportunities':
      'حوّل المراجعة السلبية لفرصة حل',
    'Turn support conversations into revenue opportunities':
      'حوّل محادثات الدعم لفرص إيرادات',
    'Understand why customers consider leaving':
      'افهم ليش يفكر العملاء في المغادرة',
    'Understand why customers left': 'افهم ليش غادر العملاء',
    'Verify high-value orders for fraud prevention':
      'تحقّق من الطلبات عالية القيمة لمنع الاحتيال',
    'Win competitive deals proactively': 'اكسب الصفقات التنافسية قبل ما تضيع',
    'Win enterprise contracts faster': 'اكسب عقود المؤسسات أسرع',
    'Works across healthcare, salons, services':
      'يعمل في الرعاية الصحية والصالونات والخدمات',
    'Works with all Flex custom attributes': 'يعمل مع كل سمات Flex المخصصة',
    'Works with all Freshdesk custom fields':
      'يعمل مع كل حقول Freshdesk المخصصة',
    'Works with all HubSpot custom properties':
      'يعمل مع كل خصائص HubSpot المخصصة',
    'Works with all Intercom custom attributes':
      'يعمل مع كل سمات Intercom المخصصة',
    'Works with all Salesforce custom fields':
      'يعمل مع كل حقول Salesforce المخصصة',
    'Works with all Zendesk custom fields': 'يعمل مع كل حقول Zendesk المخصصة',
    'Product-led growth on autopilot': 'نمو مدفوع بالمنتج، يعمل بمفرده',
    'Customizable alert rules and triggers':
      'قواعد ومحفزات تنبيه قابلة للتخصيص',
    'Reduce involuntary churn significantly': 'قلّل الفقدان غير المقصود',
    'Escalate to humans only when necessary': 'صعّد للبشر بس عند الحاجة',
    'Test messaging variations automatically': 'اختبر تنويعات الرسائل تلقائياً',
    'Improve collection rates without adding staff':
      'ارفع معدلات التحصيل بدون توظيف',
    'Optimize competitive positioning automatically':
      'حسّن موقعك التنافسي تلقائياً',
    'Convert customers when they need features most':
      'حوّل العميل في ذروة حاجته للميزة',
    'Review 100% of conversations, not just random samples':
      'راجع ١٠٠٪ من المحادثات، مو بس عينات عشوائية',
  },
};

export default arabic;
